import { Reading } from '../../types';

export const baseReadings: Reading[] = [
  
  {
    "reading_id": "fool_magician",
    "reading_name": "Ново начало с увереност",
    "reading_cards": "Глупак + Магьосник",
    "reading_combination": ["fool", "magician"],
    "reading_meaning": "Иновативен старт",
    "reading_description": "Започваш нещо ново с всички необходими инструменти. Имаш и ентусиазма, и уменията да успееш.",
    "reading_advice": "Довери се на способностите си и скочи смело."
  },
  {
    "reading_id": "fool_high_priestess",
    "reading_name": "Интуитивно начало",
    "reading_cards": "Глупак + Върховна жрица",
    "reading_combination": ["fool", "high_priestess"],
    "reading_meaning": "Воден от вътрешен глас",
    "reading_description": "Новото начало идва не от разума, а от дълбока вътрешна увереност. Слушай интуицията си.",
    "reading_advice": "Ти знаеш повече, отколкото си мислиш. Довери се на вътрешния си глас."
  },
  {
    "reading_id": "fool_empress",
    "reading_name": "Творческо начало",
    "reading_cards": "Глупак + Императрица",
    "reading_combination": ["fool", "empress"],
    "reading_meaning": "Нов проект се ражда",
    "reading_description": "Започваш нещо ново, свързано с творчество, красота или създаване. Идея, която носи плод.",
    "reading_advice": "Отгледай идеята си с любов и търпение."
  },
  {
    "reading_id": "fool_emperor",
    "reading_name": "Структурирано начало",
    "reading_cards": "Глупак + Император",
    "reading_combination": ["fool", "emperor"],
    "reading_meaning": "Ново начало с правила",
    "reading_description": "Започваш нещо ново, но този път имаш план и структура. Не е просто хвърляне в неизвестното.",
    "reading_advice": "Добрата организация е основата на успеха."
  },
  {
    "reading_id": "fool_hierophant",
    "reading_name": "Традиционно начало",
    "reading_cards": "Глупак + Йерофант",
    "reading_combination": ["fool", "hierophant"],
    "reading_meaning": "Ново начало по правилата",
    "reading_description": "Започваш нещо ново, следвайки установени традиции и норми. Учиш се от опита на другите.",
    "reading_advice": "Понякога най-добрият начин да започнеш е да следваш вече утъпкания път."
  },
  {
    "reading_id": "fool_lovers",
    "reading_name": "Любовно начало",
    "reading_cards": "Глупак + Влюбените",
    "reading_combination": ["fool", "lovers"],
    "reading_meaning": "Нова любов",
    "reading_description": "Започваш нова връзка или любовно приключение. Сърцето ти е отворено и готово да рискува.",
    "reading_advice": "Следвай сърцето си, но не забравяй и главата."
  },
  {
    "reading_id": "fool_chariot",
    "reading_name": "Пътешествие",
    "reading_cards": "Глупак + Колесница",
    "reading_combination": ["fool", "chariot"],
    "reading_meaning": "Тръгваш на път",
    "reading_description": "Предстои ти пътуване или преместване. Нови хоризонти, нови места, нови срещи.",
    "reading_advice": "Хвани волана здраво и се наслаждавай на пътешествието."
  },
  {
    "reading_id": "fool_strength",
    "reading_name": "Смело начало",
    "reading_cards": "Глупак + Сила",
    "reading_combination": ["fool", "strength"],
    "reading_meaning": "Започваш със смелост",
    "reading_description": "Новото начало изисква смелост и вътрешна сила. Ти ги имаш. Не се страхувай.",
    "reading_advice": "Смелостта не е липса на страх, а действие въпреки страха."
  },
  {
    "reading_id": "fool_hermit",
    "reading_name": "Самотно начало",
    "reading_cards": "Глупак + Отшелник",
    "reading_combination": ["fool", "hermit"],
    "reading_meaning": "Започваш сам",
    "reading_description": "Новото начало изисква да се оттеглиш и да потърсиш себе си. Самота, която лекува и води напред.",
    "reading_advice": "Понякога трябва да си сам, за да откриеш себе си."
  },
  {
    "reading_id": "fool_wheel",
    "reading_name": "Съдбовно начало",
    "reading_cards": "Глупак + Колело на съдбата",
    "reading_combination": ["fool", "wheel_of_fortune"],
    "reading_meaning": "Съдбата ти дава шанс",
    "reading_description": "Новото начало не е случайно - то е писано в звездите. Съдбовен момент, който не бива да пропускаш.",
    "reading_advice": "Хвани съдбата за ръка и я последвай."
  },
  {
    "reading_id": "fool_justice",
    "reading_name": "Справедливо начало",
    "reading_cards": "Глупак + Справедливост",
    "reading_combination": ["fool", "justice"],
    "reading_meaning": "Започваш с чисто досие",
    "reading_description": "Новото начало идва след като старите сметки са изчистени. Чист лист, справедлив старт.",
    "reading_advice": "Преди да започнеш нещо ново, приключи старото."
  },
  {
    "reading_id": "fool_hanged",
    "reading_name": "Несигурно начало",
    "reading_cards": "Глупак + Обесен",
    "reading_combination": ["fool", "hanged_man"],
    "reading_meaning": "Започваш, без да знаеш посоката",
    "reading_description": "Започваш нещо ново, но не си сигурен накъде отиваш. Предаване на течението.",
    "reading_advice": "Понякога трябва да спреш, за да видиш посоката."
  },
  {
    "reading_id": "fool_temperance",
    "reading_name": "Балансирано начало",
    "reading_cards": "Глупак + Умереност",
    "reading_combination": ["fool", "temperance"],
    "reading_meaning": "Започваш с мярка",
    "reading_description": "Започваш нещо ново, но без да изгаряш мостовете. Баланс между старо и ново.",
    "reading_advice": "Върви напред, но помни откъде идваш."
  },
  {
    "reading_id": "fool_devil",
    "reading_name": "Рисковано начало",
    "reading_cards": "Глупак + Дявол",
    "reading_combination": ["fool", "devil"],
    "reading_meaning": "Започваш нещо опасно",
    "reading_description": "Новото начало е примамливо, но крие рискове от зависимост или изкушение. Внимавай.",
    "reading_advice": "Убеди се, че не скачаш в капан, а в свобода."
  },
 
  {
    "reading_id": "fool_star",
    "reading_name": "Надеждно начало",
    "reading_cards": "Глупак + Звезда",
    "reading_combination": ["fool", "star"],
    "reading_meaning": "Започваш с надежда",
    "reading_description": "Новото начало носи надежда и оптимизъм. Вярваш, че всичко ще се нареди по най-добрия начин.",
    "reading_advice": "Надеждата е компасът в несигурните времена."
  },
  {
    "reading_id": "fool_moon",
    "reading_name": "Неясно начало",
    "reading_cards": "Глупак + Луна",
    "reading_combination": ["fool", "moon"],
    "reading_meaning": "Започваш в мъгла",
    "reading_description": "Започваш нещо ново, без да виждаш ясно пътя. Страхове, илюзии, несигурност.",
    "reading_advice": "Понякога трябва да вървиш, дори когато не виждаш."
  },
  {
    "reading_id": "fool_sun",
    "reading_name": "Слънчево начало",
    "reading_cards": "Глупак + Слънце",
    "reading_combination": ["fool", "sun"],
    "reading_meaning": "Щастливо начало",
    "reading_description": "Започваш нещо ново, изпълнен с радост и оптимизъм. Всичко ти се усмихва.",
    "reading_advice": "Наслаждавай се на момента. Той е специален."
  },
  {
    "reading_id": "fool_judgement",
    "reading_name": "Пробудено начало",
    "reading_cards": "Глупак + Съд",
    "reading_combination": ["fool", "judgement"],
    "reading_meaning": "Започваш след пробуждане",
    "reading_description": "Новото начало идва след дълбоко вътрешно пробуждане. Прераждане, ново себеусещане.",
    "reading_advice": "Чуй зова на душата си и я последвай."
  },
  {
    "reading_id": "fool_world",
    "reading_name": "Завършено начало",
    "reading_cards": "Глупак + Свят",
    "reading_combination": ["fool", "world"],
    "reading_meaning": "Нов цикъл започва",
    "reading_description": "Започваш нов цикъл, след като предишният е завършен. Пълнота и ново начало едновременно.",
    "reading_advice": "Светът е пред теб. Отправи се на път."
  },
  {
    "reading_id": "magician_high_priestess",
    "reading_name": "Сила и мъдрост",
    "reading_cards": "Магьосник + Върховна жрица",
    "reading_combination": ["magician", "high_priestess"],
    "reading_meaning": "Действие и интуиция",
    "reading_description": "Съчетаваш активното действие с дълбока интуиция. Знаеш как да действаш и кога да мълчиш.",
    "reading_advice": "Довери се на вътрешния си глас, докато действаш външно."
  },
  {
    "reading_id": "magician_empress",
    "reading_name": "Творческа сила",
    "reading_cards": "Магьосник + Императрица",
    "reading_combination": ["magician", "empress"],
    "reading_meaning": "Създаване",
    "reading_description": "Имаш всички инструменти да създадеш нещо ново и красиво. Творчество, което носи плод.",
    "reading_advice": "Твори без страх. Светът има нужда от това, което само ти можеш да създадеш."
  },
  {
    "reading_id": "magician_emperor",
    "reading_name": "Власт и умения",
    "reading_cards": "Магьосник + Император",
    "reading_combination": ["magician", "emperor"],
    "reading_meaning": "Лидер с умения",
    "reading_description": "Съчетаваш лидерски качества с умения и знания. Воден от разум и компетентност.",
    "reading_advice": "Води с пример и знание, не само с власт."
  },
  {
    "reading_id": "magician_hierophant",
    "reading_name": "Учител",
    "reading_cards": "Магьосник + Йерофант",
    "reading_combination": ["magician", "hierophant"],
    "reading_meaning": "Предаване на знания",
    "reading_description": "Имаш знания и умения, които можеш да предадеш на другите. Учител, наставник, гид.",
    "reading_advice": "Споделяй щедро. Знанието расте, когато се споделя."
  },
  {
    "reading_id": "magician_lovers",
    "reading_name": "Любовна магия",
    "reading_cards": "Магьосник + Влюбените",
    "reading_combination": ["magician", "lovers"],
    "reading_meaning": "Създаваш любов",
    "reading_description": "Имаш силата да привлечеш любов или да задълбочиш съществуваща връзка. Харизма и увереност.",
    "reading_advice": "Бъди искрен в намеренията си. Истинската магия идва от сърцето."
  },
  {
    "reading_id": "magician_chariot",
    "reading_name": "Контролирано пътуване",
    "reading_cards": "Магьосник + Колесница",
    "reading_combination": ["magician", "chariot"],
    "reading_meaning": "Управляваш посоката",
    "reading_description": "Имаш контрол върху живота си и посоката, в която се движиш. Ти си на волана.",
    "reading_advice": "Дръж волана здраво, но не забравяй да се наслаждаваш на пътя."
  },
  {
    "reading_id": "magician_strength",
    "reading_name": "Вътрешна мощ",
    "reading_cards": "Магьосник + Сила",
    "reading_combination": ["magician", "strength"],
    "reading_meaning": "Сила на духа",
    "reading_description": "Съчетаваш умения с вътрешна сила и смелост. Нищо не може да те спре.",
    "reading_advice": "Вярвай в себе си, дори когато другите се съмняват."
  },
  {
    "reading_id": "magician_hermit",
    "reading_name": "Мъдър самотник",
    "reading_cards": "Магьосник + Отшелник",
    "reading_combination": ["magician", "hermit"],
    "reading_meaning": "Знание в самота",
    "reading_description": "Притежаваш знания и умения, които си развил в самота. Време е да ги споделиш?",
    "reading_advice": "Знанието, което не се споделя, изсъхва."
  },
  {
    "reading_id": "magician_wheel",
    "reading_name": "Късметлия",
    "reading_cards": "Магьосник + Колело на съдбата",
    "reading_combination": ["magician", "wheel_of_fortune"],
    "reading_meaning": "Късмет и умения",
    "reading_description": "Съчетаваш късмет с умения. Това е печеливша комбинация, която носи успех.",
    "reading_advice": "Използвай късмета си, но не разчитай само на него."
  },
  {
    "reading_id": "magician_justice",
    "reading_name": "Справедлив магьосник",
    "reading_cards": "Магьосник + Справедливост",
    "reading_combination": ["magician", "justice"],
    "reading_meaning": "Използваш силата си справедливо",
    "reading_description": "Имаш сила и власт, но ги използваш с чувство за справедливост и морал.",
    "reading_advice": "Силата изисква отговорност. Не я използвай за егоистични цели."
  },
  {
    "reading_id": "magician_hanged",
    "reading_name": "Блокиран магьосник",
    "reading_cards": "Магьосник + Обесен",
    "reading_combination": ["magician", "hanged_man"],
    "reading_meaning": "Имаш сила, но не можеш да действаш",
    "reading_description": "Притежаваш умения и ресурси, но нещо те блокира. Време за предъвкване.",
    "reading_advice": "Понякога трябва да спреш, за да продължиш."
  },
  {
    "reading_id": "magician_death",
    "reading_name": "Трансформация на силата",
    "reading_cards": "Магьосник + Смърт",
    "reading_combination": ["magician", "death"],
    "reading_meaning": "Старите методи отмират",
    "reading_description": "Това, което знаеш и умееш, вече не работи. Трябва да се промениш и обновиш.",
    "reading_advice": "Не се вкопчвай в старите умения. Научи нови."
  },
  {
    "reading_id": "magician_temperance",
    "reading_name": "Балансирана сила",
    "reading_cards": "Магьосник + Умереност",
    "reading_combination": ["magician", "temperance"],
    "reading_meaning": "Използваш силата си с мярка",
    "reading_description": "Умееш да използваш силата и уменията си в точната мярка. Без крайности.",
    "reading_advice": "Всичко с мярка, дори и силата."
  },
  {
    "reading_id": "magician_devil",
    "reading_name": "Черна магия",
    "reading_cards": "Магьосник + Дявол",
    "reading_combination": ["magician", "devil"],
    "reading_meaning": "Използваш силата си за его",
    "reading_description": "Използваш уменията си за манипулация, контрол или егоистични цели. Внимавай - има цена.",
    "reading_advice": "Силата, използвана за зло, винаги се връща при този, който я използва."
  },
  {
    "reading_id": "magician_tower",
    "reading_name": "Срив на илюзиите",
    "reading_cards": "Магьосник + Кула",
    "reading_combination": ["magician", "tower"],
    "reading_meaning": "Силата ти се срива",
    "reading_description": "Всичко, в което си вярвал като свои умения и сила, се срива. Илюзиите падат.",
    "reading_advice": "Понякога трябва да загубиш всичко, за да откриеш истинската си сила."
  },
  {
    "reading_id": "magician_star",
    "reading_name": "Надежда и умения",
    "reading_cards": "Магьосник + Звезда",
    "reading_combination": ["magician", "star"],
    "reading_meaning": "Вдъхновен творец",
    "reading_description": "Съчетаваш умения с вдъхновение и надежда. Твориш с вяра в бъдещето.",
    "reading_advice": "Продължавай да вярваш. Най-доброто тепърва предстои."
  },
  {
    "reading_id": "magician_moon",
    "reading_name": "Магьосник в мъгла",
    "reading_cards": "Магьосник + Луна",
    "reading_combination": ["magician", "moon"],
    "reading_meaning": "Не виждаш ясно",
    "reading_description": "Имаш умения, но не виждаш ясно ситуацията. Страхове и илюзии замъгляват преценката ти.",
    "reading_advice": "Изчакай мъглата да се вдигне, преди да действаш."
  },
  {
    "reading_id": "magician_sun",
    "reading_name": "Блестящ магьосник",
    "reading_cards": "Магьосник + Слънце",
    "reading_combination": ["magician", "sun"],
    "reading_meaning": "Успех и признание",
    "reading_description": "Уменията ти блестят и получават признание. Успех, радост, удовлетворение.",
    "reading_advice": "Наслади се на светлината. Ти я заслужи."
  },
  {
    "reading_id": "magician_judgement",
    "reading_name": "Пробуден магьосник",
    "reading_cards": "Магьосник + Съд",
    "reading_combination": ["magician", "judgement"],
    "reading_meaning": "Ново ниво на умения",
    "reading_description": "Пробуждане на нови способности. Откриваш, че можеш повече, отколкото си мислел.",
    "reading_advice": "Откликни на зова. Новите ти умения чакат да бъдат развити."
  },
  {
    "reading_id": "magician_world",
    "reading_name": "Съвършен магьосник",
    "reading_cards": "Магьосник + Свят",
    "reading_combination": ["magician", "world"],
    "reading_meaning": "Върховно майсторство",
    "reading_description": "Достигнал си върха в своята област. Всичко, което правиш, носи завършеност и хармония.",
    "reading_advice": "Наслади се на върха, но не спирай да се развиваш."
  },
  {
    "reading_id": "high_priestess_empress",
    "reading_name": "Мъдра майка",
    "reading_cards": "Върховна жрица + Императрица",
    "reading_combination": ["high_priestess", "empress"],
    "reading_meaning": "Интуитивно създаване",
    "reading_description": "Съчетаваш дълбока интуиция с творческа сила. Това, което създаваш, носи мъдрост и красота.",
    "reading_advice": "Довери се на интуицията си, докато твориш."
  },
  {
    "reading_id": "high_priestess_emperor",
    "reading_name": "Мъдър владетел",
    "reading_cards": "Върховна жрица + Император",
    "reading_combination": ["high_priestess", "emperor"],
    "reading_meaning": "Интуитивно управление",
    "reading_description": "Управляваш с мъдрост и интуиция, не само с разум и правила. Слушаш вътрешния си глас.",
    "reading_advice": "Най-добрият лидер е този, който слуша и разума, и сърцето."
  },
  {
    "reading_id": "high_priestess_hierophant",
    "reading_name": "Духовен учител",
    "reading_cards": "Върховна жрица + Йерофант",
    "reading_combination": ["high_priestess", "hierophant"],
    "reading_meaning": "Предаване на тайни знания",
    "reading_description": "Ти си пазител на древни тайни и знания. Време е да ги предадеш на достойни ученици.",
    "reading_advice": "Споделяй мъдростта си, но само с тези, които са готови да я приемат."
  },
  {
    "reading_id": "high_priestess_lovers",
    "reading_name": "Интуитивна любов",
    "reading_cards": "Върховна жрица + Влюбените",
    "reading_combination": ["high_priestess", "lovers"],
    "reading_meaning": "Любов, водена от интуиция",
    "reading_description": "Изборът в любовта идва не от разума, а от дълбоко вътрешно познание. Сърцето знае.",
    "reading_advice": "Слушай какво ти казва вътрешният глас за любовта."
  },
  {
    "reading_id": "high_priestess_chariot",
    "reading_name": "Интуитивно пътуване",
    "reading_cards": "Върховна жрица + Колесница",
    "reading_combination": ["high_priestess", "chariot"],
    "reading_meaning": "Воден от вътрешен компас",
    "reading_description": "Дори да не виждаш ясно пътя, интуицията ти знае посоката. Следвай я.",
    "reading_advice": "Понякога най-добрият навигатор е вътрешният ти глас."
  },
  {
    "reading_id": "high_priestess_strength",
    "reading_name": "Вътрешна сила",
    "reading_cards": "Върховна жрица + Сила",
    "reading_combination": ["high_priestess", "strength"],
    "reading_meaning": "Силата на духа",
    "reading_description": "Истинската сила идва отвътре. Ти знаеш това и черпиш от дълбокия си вътрешен извор.",
    "reading_advice": "Най-голямата сила е тази, която не се вижда с просто око."
  },
  {
    "reading_id": "high_priestess_hermit",
    "reading_name": "Дълбока медитация",
    "reading_cards": "Върховна жрица + Отшелник",
    "reading_combination": ["high_priestess", "hermit"],
    "reading_meaning": "Вглъбяване",
    "reading_description": "Оттегляш се в дълбока медитация и самота. Търсиш отговори в себе си.",
    "reading_advice": "В тишината ще намериш най-силните отговори."
  },
  {
    "reading_id": "high_priestess_wheel",
    "reading_name": "Съдбовно прозрение",
    "reading_cards": "Върховна жрица + Колело на съдбата",
    "reading_combination": ["high_priestess", "wheel_of_fortune"],
    "reading_meaning": "Разбираш съдбата",
    "reading_description": "Прозрение за житейския ти път и съдба. Виждаш по-голямата картина.",
    "reading_advice": "Всичко се случва с причина. Сега разбираш защо."
  },
  {
    "reading_id": "high_priestess_justice",
    "reading_name": "Интуитивна справедливост",
    "reading_cards": "Върховна жрица + Справедливост",
    "reading_combination": ["high_priestess", "justice"],
    "reading_meaning": "Знаеш какво е справедливо",
    "reading_description": "Имаш вродено чувство за справедливост, което не се нуждае от закони. Сърцето ти знае.",
    "reading_advice": "Следвай вътрешното си чувство за правилно и грешно."
  },
  {
    "reading_id": "high_priestess_hanged",
    "reading_name": "Интуитивно чакане",
    "reading_cards": "Върховна жрица + Обесен",
    "reading_combination": ["high_priestess", "hanged_man"],
    "reading_meaning": "Знаеш, но чакаш",
    "reading_description": "Интуицията ти казва какво ще се случи, но трябва да изчакаш правилния момент.",
    "reading_advice": "Търпението е част от мъдростта."
  },
  {
    "reading_id": "high_priestess_death",
    "reading_name": "Интуитивен край",
    "reading_cards": "Върховна жрица + Смърт",
    "reading_combination": ["high_priestess", "death"],
    "reading_meaning": "Усещаш края",
    "reading_description": "Усещаш, че нещо приключва, дори преди да се случи. Интуицията те подготвя.",
    "reading_advice": "Довери се на усещането си. То те подготвя за промяна."
  },
  {
    "reading_id": "high_priestess_temperance",
    "reading_name": "Духовен баланс",
    "reading_cards": "Върховна жрица + Умереност",
    "reading_combination": ["high_priestess", "temperance"],
    "reading_meaning": "Хармония на духа",
    "reading_description": "Духовният ти живот е в хармония и баланс. Всичко тече както трябва.",
    "reading_advice": "Пази този баланс. Той е ключът към вътрешния мир."
  },
  {
    "reading_id": "high_priestess_devil",
    "reading_name": "Тъмна интуиция",
    "reading_cards": "Върховна жрица + Дявол",
    "reading_combination": ["high_priestess", "devil"],
    "reading_meaning": "Интуиция, използвана за контрол",
    "reading_description": "Използваш интуицията си да манипулираш или контролираш другите. Тъмната страна на силата.",
    "reading_advice": "Интуицията е дар. Не я използвай за егоистични цели."
  },
  {
    "reading_id": "high_priestess_tower",
    "reading_name": "Срив на интуицията",
    "reading_cards": "Върховна жрица + Кула",
    "reading_combination": ["high_priestess", "tower"],
    "reading_meaning": "Всичко, в което си вярвал, се срива",
    "reading_description": "Интуицията ти се оказва грешна или всичко, което си чувствал като истина, се срива.",
    "reading_advice": "Понякога трябва да загубиш вярата си, за да намериш по-истинска."
  },
  {
    "reading_id": "high_priestess_star",
    "reading_name": "Интуитивна надежда",
    "reading_cards": "Върховна жрица + Звезда",
    "reading_combination": ["high_priestess", "star"],
    "reading_meaning": "Дълбока вяра",
    "reading_description": "Дори когато не виждаш пътя, интуицията ти подсказва, че всичко ще бъде наред.",
    "reading_advice": "Вярвай, дори когато не виждаш."
  },
 
  {
    "reading_id": "high_priestess_sun",
    "reading_name": "Просветлена",
    "reading_cards": "Върховна жрица + Слънце",
    "reading_combination": ["high_priestess", "sun"],
    "reading_meaning": "Интуиция и яснота",
    "reading_description": "Интуицията ти е кристално ясна. Виждаш истината без страхове и илюзии.",
    "reading_advice": "Наслади се на тази яснота. Тя е рядък дар."
  },
  {
    "reading_id": "high_priestess_judgement",
    "reading_name": "Духовно пробуждане",
    "reading_cards": "Върховна жрица + Съд",
    "reading_combination": ["high_priestess", "judgement"],
    "reading_meaning": "Пробуждане на интуицията",
    "reading_description": "Интуитивните ти способности се пробуждат на ново ниво. Чуваш вътрешния си глас по-ясно от всякога.",
    "reading_advice": "Откликни на този зов. Той води към по-висше Аз."
  },
  {
    "reading_id": "high_priestess_world",
    "reading_name": "Вселенска мъдрост",
    "reading_cards": "Върховна жрица + Свят",
    "reading_combination": ["high_priestess", "world"],
    "reading_meaning": "Пълна хармония",
    "reading_description": "Интуицията ти е в хармония с вселената. Знаеш всичко, което трябва да знаеш.",
    "reading_advice": "Ти си в унисон с космоса. Наслаждавай се на този момент на пълнота."
  },
  {
    "reading_id": "empress_emperor",
    "reading_name": "Кралска двойка",
    "reading_cards": "Императрица + Император",
    "reading_combination": ["empress", "emperor"],
    "reading_meaning": "Съвършен съюз",
    "reading_description": "Съчетание на мъжка и женска енергия в хармония. Творчество и структура, грижа и ред.",
    "reading_advice": "Заедно сте по-силни. Ценете различията си."
  },
  {
    "reading_id": "empress_hierophant",
    "reading_name": "Духовна майка",
    "reading_cards": "Императрица + Йерофант",
    "reading_combination": ["empress", "hierophant"],
    "reading_meaning": "Учителка и закрилница",
    "reading_description": "Съчетаваш майчинската грижа с духовното наставничество. Водиш другите с любов и мъдрост.",
    "reading_advice": "Грижи се за духовните си чеда, но им давай свобода."
  },
  {
    "reading_id": "empress_lovers",
    "reading_name": "Любов и плодородие",
    "reading_cards": "Императрица + Влюбените",
    "reading_combination": ["empress", "lovers"],
    "reading_meaning": "Любов, която ражда",
    "reading_description": "Любовта в живота ти носи плодове - деца, творчество, изобилие. Пълнота и радост.",
    "reading_advice": "Наслаждавай се на любовта, която създава живот."
  },
  {
    "reading_id": "empress_chariot",
    "reading_name": "Творческо пътуване",
    "reading_cards": "Императрица + Колесница",
    "reading_combination": ["empress", "chariot"],
    "reading_meaning": "Творчество в движение",
    "reading_description": "Носиш творческата си енергия на път. Вдъхновение, което те води напред.",
    "reading_advice": "Пътувай и твори. Светът е твоето студио."
  },
  {
    "reading_id": "empress_strength",
    "reading_name": "Нежна сила",
    "reading_cards": "Императрица + Сила",
    "reading_combination": ["empress", "strength"],
    "reading_meaning": "Силата на грижата",
    "reading_description": "Истинската ти сила идва от способността да обичаш и да се грижиш. Това не е слабост.",
    "reading_advice": "Бъди нежна, но непоклатима в любовта си."
  },
  {
    "reading_id": "empress_hermit",
    "reading_name": "Самотна майка",
    "reading_cards": "Императрица + Отшелник",
    "reading_combination": ["empress", "hermit"],
    "reading_meaning": "Грижа в самота",
    "reading_description": "Грижиш се за другите, докато самата ти се чувстваш самотна. Време е и за теб.",
    "reading_advice": "Не забравяй да се грижиш и за себе си."
  },
  {
    "reading_id": "empress_wheel",
    "reading_name": "Съдбовно майчинство",
    "reading_cards": "Императрица + Колело на съдбата",
    "reading_combination": ["empress", "wheel_of_fortune"],
    "reading_meaning": "Съдбата води към майчинство",
    "reading_description": "Майчинството или творчеството ти е писано от съдбата. Точното време, точното място.",
    "reading_advice": "Довери се, че всичко идва в точното време."
  },
  {
    "reading_id": "empress_justice",
    "reading_name": "Справедлива майка",
    "reading_cards": "Императрица + Справедливост",
    "reading_combination": ["empress", "justice"],
    "reading_meaning": "Грижа и справедливост",
    "reading_description": "Грижиш се за всички еднакво, без предпочитания. Майка, която съди безпристрастно.",
    "reading_advice": "Любовта изисква и справедливост, не само прошка."
  },
  {
    "reading_id": "empress_hanged",
    "reading_name": "Чакаща майка",
    "reading_cards": "Императрица + Обесен",
    "reading_combination": ["empress", "hanged_man"],
    "reading_meaning": "Творчество в застой",
    "reading_description": "Творческата ти енергия е блокирана или в изчакване. Нещо не позволява да се изявиш.",
    "reading_advice": "Понякога трябва да изчакаш, преди да родиш."
  },
  {
    "reading_id": "empress_death",
    "reading_name": "Край на плодородието",
    "reading_cards": "Императрица + Смърт",
    "reading_combination": ["empress", "death"],
    "reading_meaning": "Край на цикъл",
    "reading_description": "Един творчески цикъл приключва. Менопауза, край на проект, затваряне на врата.",
    "reading_advice": "Приеми края като част от естествения цикъл на живота."
  },
  {
    "reading_id": "empress_temperance",
    "reading_name": "Балансирано творчество",
    "reading_cards": "Императрица + Умереност",
    "reading_combination": ["empress", "temperance"],
    "reading_meaning": "Творчество с мярка",
    "reading_description": "Твориш без да се изтощаваш. Баланс между даване и получаване, между грижа и свобода.",
    "reading_advice": "Пази баланса, за да можеш да твориш дълго."
  },
  {
    "reading_id": "empress_devil",
    "reading_name": "Обсебваща майка",
    "reading_cards": "Императрица + Дявол",
    "reading_combination": ["empress", "devil"],
    "reading_meaning": "Прекалена привързаност",
    "reading_description": "Грижата ти се превръща в контрол и обладаване. Не пускаш децата или проектите си.",
    "reading_advice": "Любовта не е притежание. Пусни, за да расте."
  },
  {
    "reading_id": "empress_tower",
    "reading_name": "Срив в семейството",
    "reading_cards": "Императрица + Кула",
    "reading_combination": ["empress", "tower"],
    "reading_meaning": "Разрушение на дома",
    "reading_description": "Семейството или домът ти преживява внезапен срив. Загуба, болест, раздяла.",
    "reading_advice": "След разрушението идва ново начало."
  },
  {
    "reading_id": "empress_star",
    "reading_name": "Надежда за майката",
    "reading_cards": "Императрица + Звезда",
    "reading_combination": ["empress", "star"],
    "reading_meaning": "Вяра в бъдещето",
    "reading_description": "Вярваш в бъдещето на децата си или на проектите си. Надежда и оптимизъм.",
    "reading_advice": "Надеждата е най-добрият подарък, който можеш да дадеш."
  },
  {
    "reading_id": "empress_moon",
    "reading_name": "Майка и интуиция",
    "reading_cards": "Императрица + Луна",
    "reading_combination": ["empress", "moon"],
    "reading_meaning": "Майчинска интуиция",
    "reading_description": "Интуицията ти като майка е изключително силна. Усещаш какво се случва с близките ти, дори от разстояние.",
    "reading_advice": "Довери се на майчинската си интуиция. Тя рядко греши."
  },
  {
    "reading_id": "empress_sun",
    "reading_name": "Щастлива майка",
    "reading_cards": "Императрица + Слънце",
    "reading_combination": ["empress", "sun"],
    "reading_meaning": "Радост и изобилие",
    "reading_description": "Майчинството или творчеството ти носи огромна радост. Щастие, топлина, изобилие.",
    "reading_advice": "Наслаждавай се на този златен период."
  },
  {
    "reading_id": "empress_judgement",
    "reading_name": "Пробудена майка",
    "reading_cards": "Императрица + Съд",
    "reading_combination": ["empress", "judgement"],
    "reading_meaning": "Ново ниво на майчинство",
    "reading_description": "Пробуждане в ролята ти на майка или творец. Виждаш нещата от нова перспектива.",
    "reading_advice": "Приеми новото си ниво на съзнание."
  },
  {
    "reading_id": "empress_world",
    "reading_name": "Световна майка",
    "reading_cards": "Императрица + Свят",
    "reading_combination": ["empress", "world"],
    "reading_meaning": "Пълнота и завършеност",
    "reading_description": "Творческият ти път е завършен. Постигнала си всичко, за което си мечтала. Пълнота и хармония.",
    "reading_advice": "Наслади се на успеха. Ти завърши цикъла."
  },
  {
    "reading_id": "emperor_hierophant",
    "reading_name": "Духовен водач",
    "reading_cards": "Император + Йерофант",
    "reading_combination": ["emperor", "hierophant"],
    "reading_meaning": "Власт и традиция",
    "reading_description": "Управляваш според традициите и духовните закони. Титла, която носи отговорност.",
    "reading_advice": "Води с мъдростта на вековете."
  },
  {
    "reading_id": "emperor_lovers",
    "reading_name": "Любов и власт",
    "reading_cards": "Император + Влюбените",
    "reading_combination": ["emperor", "lovers"],
    "reading_meaning": "Избор между сърце и дълг",
    "reading_description": "Изправен си пред избор между любовта и отговорностите. Кое ще надделее?",
    "reading_advice": "Най-трудният избор е между това, което искаш, и това, което трябва."
  },
  {
    "reading_id": "emperor_chariot",
    "reading_name": "Водач на път",
    "reading_cards": "Император + Колесница",
    "reading_combination": ["emperor", "chariot"],
    "reading_meaning": "Контрол и посока",
    "reading_description": "Управляваш живота си и този на другите с твърда ръка. Ясна посока, силен контрол.",
    "reading_advice": "Дръж волана, но не забравяй да се наслаждаваш на пътя."
  },
  {
    "reading_id": "emperor_strength",
    "reading_name": "Силен владетел",
    "reading_cards": "Император + Сила",
    "reading_combination": ["emperor", "strength"],
    "reading_meaning": "Управление със сила",
    "reading_description": "Управляваш с вътрешна сила и смелост. Не се страхуваш да вземаш трудни решения.",
    "reading_advice": "Истинската сила е в контрола над себе си, не над другите."
  },
  {
    "reading_id": "emperor_hermit",
    "reading_name": "Мъдър старец",
    "reading_cards": "Император + Отшелник",
    "reading_combination": ["emperor", "hermit"],
    "reading_meaning": "Власт в самота",
    "reading_description": "Управляваш сам, далеч от хората. Мъдрост, извоювана с години самота и размисъл.",
    "reading_advice": "Понякога най-мъдрият владетел е този, който се оттегля."
  },
  {
    "reading_id": "emperor_wheel",
    "reading_name": "Съдбовен владетел",
    "reading_cards": "Император + Колело на съдбата",
    "reading_combination": ["emperor", "wheel_of_fortune"],
    "reading_meaning": "Съдбата те води",
    "reading_description": "Съдбата ти е отредила да управляваш. Приеми я и носи отговорността.",
    "reading_advice": "Властта не е случайна. Ти си избраният."
  },
  {
    "reading_id": "emperor_justice",
    "reading_name": "Справедлив владетел",
    "reading_cards": "Император + Справедливост",
    "reading_combination": ["emperor", "justice"],
    "reading_meaning": "Цар и съдия",
    "reading_description": "Управляваш с чувство за справедливост и равенство. Законът е еднакъв за всички.",
    "reading_advice": "Бъди твърд, но справедлив. Това е белегът на истинския владетел."
  },
  {
    "reading_id": "emperor_hanged",
    "reading_name": "Безсилен владетел",
    "reading_cards": "Император + Обесен",
    "reading_combination": ["emperor", "hanged_man"],
    "reading_meaning": "Властта е блокирана",
    "reading_description": "Имаш титла и власт, но не можеш да действаш. Блокиран, в капан, безпомощен.",
    "reading_advice": "Понякога трябва да спреш, за да преосмислиш посоката."
  },
  {
    "reading_id": "emperor_death",
    "reading_name": "Край на управление",
    "reading_cards": "Император + Смърт",
    "reading_combination": ["emperor", "death"],
    "reading_meaning": "Властта свършва",
    "reading_description": "Цикълът на властта ти приключва. Сваляне, оставка, край на мандат.",
    "reading_advice": "Приеми края с достойнство. Всичко има свое време."
  },
  {
    "reading_id": "emperor_temperance",
    "reading_name": "Балансиран лидер",
    "reading_cards": "Император + Умереност",
    "reading_combination": ["emperor", "temperance"],
    "reading_meaning": "Управление с мярка",
    "reading_description": "Управляваш с баланс и хармония. Без крайности, без пристрастия.",
    "reading_advice": "Златната среда е най-мъдрият път."
  },
  {
    "reading_id": "emperor_devil",
    "reading_name": "Тиран",
    "reading_cards": "Император + Дявол",
    "reading_combination": ["emperor", "devil"],
    "reading_meaning": "Власт, която покварява",
    "reading_description": "Властта те е покварила. Управляваш със страх, контрол и манипулация.",
    "reading_advice": "Власт без морал води до гибел. Смени посоката."
  },
  {
    "reading_id": "emperor_tower",
    "reading_name": "Срив на властта",
    "reading_cards": "Император + Кула",
    "reading_combination": ["emperor", "tower"],
    "reading_meaning": "Царството рухва",
    "reading_description": "Всичко, което си построил, се срива. Загуба на власт, позиция, уважение.",
    "reading_advice": "Понякога трябва да рухнеш, за да се изправиш отново."
  },
  {
    "reading_id": "emperor_star",
    "reading_name": "Надежда за владетеля",
    "reading_cards": "Император + Звезда",
    "reading_combination": ["emperor", "star"],
    "reading_meaning": "Вяра в бъдещето",
    "reading_description": "Дори в трудни времена вярваш, че ще се справиш. Надежда и оптимизъм.",
    "reading_advice": "Надеждата е последното, което умира. Дръж се за нея."
  },
  {
    "reading_id": "emperor_moon",
    "reading_name": "Владетел в мъгла",
    "reading_cards": "Император + Луна",
    "reading_combination": ["emperor", "moon"],
    "reading_meaning": "Несигурно управление",
    "reading_description": "Управляваш в несигурност и объркване. Не виждаш ясно враговете и заплахите.",
    "reading_advice": "Потърси светлина, преди да водиш другите."
  },
  {
    "reading_id": "emperor_sun",
    "reading_name": "Светъл владетел",
    "reading_cards": "Император + Слънце",
    "reading_combination": ["emperor", "sun"],
    "reading_meaning": "Успешен лидер",
    "reading_description": "Управляваш с мъдрост и светлина. Хората те уважават и следват.",
    "reading_advice": "Наслади се на признанието. Ти го заслужи."
  },
  {
    "reading_id": "emperor_judgement",
    "reading_name": "Пробуден владетел",
    "reading_cards": "Император + Съд",
    "reading_combination": ["emperor", "judgement"],
    "reading_meaning": "Ново ниво на власт",
    "reading_description": "Пробуждане в ролята ти на лидер. Виждаш отговорността си в нова светлина.",
    "reading_advice": "Откликни на зова за по-висша цел."
  },
  {
    "reading_id": "emperor_world",
    "reading_name": "Владетел на света",
    "reading_cards": "Император + Свят",
    "reading_combination": ["emperor", "world"],
    "reading_meaning": "Върховна власт",
    "reading_description": "Постигнал си върха в своята област. Власт, признание, завършеност.",
    "reading_advice": "Наслади се на успеха, но не спирай да се развиваш."
  },
  {
    "reading_id": "hierophant_lovers",
    "reading_name": "Свещен съюз",
    "reading_cards": "Йерофант + Влюбените",
    "reading_combination": ["hierophant", "lovers"],
    "reading_meaning": "Брак",
    "reading_description": "Любов, благословена от традицията и обществото. Брак, годеж, официално обвързване.",
    "reading_advice": "Почитайте традициите, но следвайте сърцето си."
  },
  {
    "reading_id": "hierophant_chariot",
    "reading_name": "Духовно пътуване",
    "reading_cards": "Йерофант + Колесница",
    "reading_combination": ["hierophant", "chariot"],
    "reading_meaning": "Поклонничество",
    "reading_description": "Пътуване със spiritual цел - поклонение, ретрийт, търсене на истината.",
    "reading_advice": "Пътят към себе си минава и през физическо пътуване."
  },
  {
    "reading_id": "hierophant_strength",
    "reading_name": "Сила на вярата",
    "reading_cards": "Йерофант + Сила",
    "reading_combination": ["hierophant", "strength"],
    "reading_meaning": "Вяра, която движи планини",
    "reading_description": "Вярата ти дава сила да преодоляваш всяко препятствие. Духовна мощ.",
    "reading_advice": "Вяра без дела е мъртва. Прилагай я в живота си."
  },
  {
    "reading_id": "hierophant_hermit",
    "reading_name": "Отшелник учител",
    "reading_cards": "Йерофант + Отшелник",
    "reading_combination": ["hierophant", "hermit"],
    "reading_meaning": "Мъдрец в планината",
    "reading_description": "Учител, който се е оттеглил от света. Мъдрост, извоювана в самота.",
    "reading_advice": "Търси мъдростта в тишината."
  },
  {
    "reading_id": "hierophant_wheel",
    "reading_name": "Съдбовна среща с учител",
    "reading_cards": "Йерофант + Колело на съдбата",
    "reading_combination": ["hierophant", "wheel_of_fortune"],
    "reading_meaning": "Учителят идва в точното време",
    "reading_description": "Срещаш духовен учител точно когато имаш нужда. Съдбовна среща.",
    "reading_advice": "Когато ученикът е готов, учителят се появява."
  },
  {
    "reading_id": "hierophant_justice",
    "reading_name": "Духовен съдия",
    "reading_cards": "Йерофант + Справедливост",
    "reading_combination": ["hierophant", "justice"],
    "reading_meaning": "Божи съд",
    "reading_description": "Справедливост според висшите закони. Карма, божествена справедливост.",
    "reading_advice": "Каквото посееш, това ще пожънеш."
  },
  {
    "reading_id": "hierophant_hanged",
    "reading_name": "Духовно изпитание",
    "reading_cards": "Йерофант + Обесен",
    "reading_combination": ["hierophant", "hanged_man"],
    "reading_meaning": "Вярата се изпитва",
    "reading_description": "Вярата ти преминава през изпитание. Съмнения, криза, търсене.",
    "reading_advice": "Понякога трябва да загубиш вярата, за да намериш по-истинска."
  },
  {
    "reading_id": "hierophant_death",
    "reading_name": "Край на духовен път",
    "reading_cards": "Йерофант + Смърт",
    "reading_combination": ["hierophant", "death"],
    "reading_meaning": "Трансформация на вярата",
    "reading_description": "Старата ти вяра или духовен път умира. Ново разбиране, ново ниво.",
    "reading_advice": "Отърси се от догмите, намери истината."
  },
  {
    "reading_id": "hierophant_temperance",
    "reading_name": "Духовен баланс",
    "reading_cards": "Йерофант + Умереност",
    "reading_combination": ["hierophant", "temperance"],
    "reading_meaning": "Златна среда във вярата",
    "reading_description": "Вяра без фанатизъм. Духовност, която не отрича реалността.",
    "reading_advice": "Всичко с мярка, дори и вярата."
  },
  {
    "reading_id": "hierophant_devil",
    "reading_name": "Лъжепророк",
    "reading_cards": "Йерофант + Дявол",
    "reading_combination": ["hierophant", "devil"],
    "reading_meaning": "Фалшив учител",
    "reading_description": "Попаднал си на фалшив духовен учител или секта. Манипулация, контрол, измама.",
    "reading_advice": "Разпознай истината от лъжата. Не всичко, което блести, е злато."
  },
  {
    "reading_id": "hierophant_tower",
    "reading_name": "Срив на вярата",
    "reading_cards": "Йерофант + Кула",
    "reading_combination": ["hierophant", "tower"],
    "reading_meaning": "Вярата се срутва",
    "reading_description": "Всичко, в което си вярвал, се оказва лъжа. Духовен срив, криза.",
    "reading_advice": "Понякога трябва да рухнеш, за да откриеш истинската си вяра."
  },
  {
    "reading_id": "hierophant_star",
    "reading_name": "Надежда във вярата",
    "reading_cards": "Йерофант + Звезда",
    "reading_combination": ["hierophant", "star"],
    "reading_meaning": "Духовна надежда",
    "reading_description": "Вярата ти дава надежда дори в най-тъмните моменти. Светлина в тунела.",
    "reading_advice": "Вярвай, дори когато не виждаш."
  },
  {
    "reading_id": "hierophant_moon",
    "reading_name": "Заблудена вяра",
    "reading_cards": "Йерофант + Луна",
    "reading_combination": ["hierophant", "moon"],
    "reading_meaning": "Религиозен страх",
    "reading_description": "Вяра, основана на страх и суеверия, не на любов. Тъмна страна на религията.",
    "reading_advice": "Истинската вяра не се страхува, а обича."
  },
  {
    "reading_id": "hierophant_sun",
    "reading_name": "Просветлен учител",
    "reading_cards": "Йерофант + Слънце",
    "reading_combination": ["hierophant", "sun"],
    "reading_meaning": "Истински духовен водач",
    "reading_description": "Срещаш или ставаш истински духовен учител, който носи светлина на другите.",
    "reading_advice": "Светлината, която носиш, огрява пътя на мнозина."
  },
  {
    "reading_id": "hierophant_judgement",
    "reading_name": "Духовно пробуждане",
    "reading_cards": "Йерофант + Съд",
    "reading_combination": ["hierophant", "judgement"],
    "reading_meaning": "Призив отгоре",
    "reading_description": "Чуваш зов за по-дълбока духовност. Пробуждане, посвещение, призвание.",
    "reading_advice": "Откликни на зова. Той води към истинската ти същност."
  },
  {
    "reading_id": "hierophant_world",
    "reading_name": "Вселенска мъдрост",
    "reading_cards": "Йерофант + Свят",
    "reading_combination": ["hierophant", "world"],
    "reading_meaning": "Завършен духовен път",
    "reading_description": "Духовното ти търсене е завършено. Намерил си отговорите, постигнал си мир.",
    "reading_advice": "Наслади се на пълнотата. Ти завърши кръга."
  },
  {
    "reading_id": "lovers_chariot",
    "reading_name": "Любовно пътуване",
    "reading_cards": "Влюбените + Колесница",
    "reading_combination": ["lovers", "chariot"],
    "reading_meaning": "Пътуване за двама",
    "reading_description": "Предстои ви пътуване заедно. Меден месец, ваканция, приключение като двойка.",
    "reading_advice": "Пътувайте заедно, откривайте света ръка за ръка."
  },
  {
    "reading_id": "lovers_strength",
    "reading_name": "Сила на любовта",
    "reading_cards": "Влюбените + Сила",
    "reading_combination": ["lovers", "strength"],
    "reading_meaning": "Любовта дава сила",
    "reading_description": "Любовта ти дава невероятна сила да преодоляваш препятствия. Заедно сте непобедими.",
    "reading_advice": "Любовта е най-голямата сила във вселената."
  },
  {
    "reading_id": "lovers_hermit",
    "reading_name": "Любов и самота",
    "reading_cards": "Влюбените + Отшелник",
    "reading_combination": ["lovers", "hermit"],
    "reading_meaning": "Любов от разстояние",
    "reading_description": "Обичаш, но сте разделени или единият се чувства самотен във връзката.",
    "reading_advice": "Понякога любовта изисква и време за себе си."
  },
  {
    "reading_id": "lovers_wheel",
    "reading_name": "Съдбовна любов",
    "reading_cards": "Влюбените + Колело на съдбата",
    "reading_combination": ["lovers", "wheel_of_fortune"],
    "reading_meaning": "Любов, писана в звездите",
    "reading_description": "Връзка, която е предопределена. Среща, която не е случайна.",
    "reading_advice": "Съдбата ви събра. Сега зависи от вас."
  },
  {
    "reading_id": "lovers_justice",
    "reading_name": "Любовен договор",
    "reading_cards": "Влюбените + Справедливост",
    "reading_combination": ["lovers", "justice"],
    "reading_meaning": "Брачен договор",
    "reading_description": "Любовта преминава в официална форма - брак, договор, съвместни финанси.",
    "reading_advice": "Любовта има нужда и от правила, за да оцелее."
  },
  {
    "reading_id": "lovers_hanged",
    "reading_name": "Любов в застой",
    "reading_cards": "Влюбените + Обесен",
    "reading_combination": ["lovers", "hanged_man"],
    "reading_meaning": "Връзка, която не мърда",
    "reading_description": "Любовта е в застой. Чакате нещо, но нищо не се случва.",
    "reading_advice": "Понякога трябва да спреш, за да преосмислиш връзката."
  },
  {
    "reading_id": "lovers_death",
    "reading_name": "Край на любовта",
    "reading_cards": "Влюбените + Смърт",
    "reading_combination": ["lovers", "death"],
    "reading_meaning": "Любовта умира",
    "reading_description": "Връзката приключва. Любов, която си отива, за да освободи място за нова.",
    "reading_advice": "Пусни, ако обичаш. Понякога любовта е да освободиш."
  },
  {
    "reading_id": "lovers_temperance",
    "reading_name": "Баланс в любовта",
    "reading_cards": "Влюбените + Умереност",
    "reading_combination": ["lovers", "temperance"],
    "reading_meaning": "Хармонична връзка",
    "reading_description": "Любов, в която има баланс и хармония. Без крайности, без драма.",
    "reading_advice": "Пази този баланс. Той е ключът към дълга връзка."
  },
  {
    "reading_id": "lovers_devil",
    "reading_name": "Обсебваща любов",
    "reading_cards": "Влюбените + Дявол",
    "reading_combination": ["lovers", "devil"],
    "reading_meaning": "Любов-зависимост",
    "reading_description": "Връзка, основана на зависимост, не на любов. Страст, която унищожава.",
    "reading_advice": "Освободи се от веригите. Това не е любов."
  },
  {
    "reading_id": "lovers_tower",
    "reading_name": "Любовен срив",
    "reading_cards": "Влюбените + Кула",
    "reading_combination": ["lovers", "tower"],
    "reading_meaning": "Внезапна раздяла",
    "reading_description": "Любовта се срива внезапно. Изневяра, предателство, скандал, който разрушава всичко.",
    "reading_advice": "След разрухата идва ново начало. Дай си време."
  },
  {
    "reading_id": "lovers_star",
    "reading_name": "Надежда за любовта",
    "reading_cards": "Влюбените + Звезда",
    "reading_combination": ["lovers", "star"],
    "reading_meaning": "Вяра в любовта",
    "reading_description": "Вярваш, че любовта ще се получи. Надежда и оптимизъм за връзката.",
    "reading_advice": "Вярвай, но и работи за любовта."
  },
  {
    "reading_id": "lovers_moon",
    "reading_name": "Любовни илюзии",
    "reading_cards": "Влюбените + Луна",
    "reading_combination": ["lovers", "moon"],
    "reading_meaning": "Не виждаш ясно връзката",
    "reading_description": "Виждаш връзката през розови очила или се страхуваш от нещо, което го няма.",
    "reading_advice": "Свали розовите очила. Истината е важна."
  },
  {
    "reading_id": "lovers_sun",
    "reading_name": "Слънчева любов",
    "reading_cards": "Влюбените + Слънце",
    "reading_combination": ["lovers", "sun"],
    "reading_meaning": "Щастлива любов",
    "reading_description": "Любов, която те кара да се чувстваш жив. Радост, топлина, щастие.",
    "reading_advice": "Наслаждавай се на всеки миг от тази любов."
  },
  {
    "reading_id": "lovers_judgement",
    "reading_name": "Пробуждане в любовта",
    "reading_cards": "Влюбените + Съд",
    "reading_combination": ["lovers", "judgement"],
    "reading_meaning": "Ново ниво във връзката",
    "reading_description": "Връзката достига ново ниво на осъзнатост. Прошка, разбиране, задълбочаване.",
    "reading_advice": "Чуйте зова за по-дълбока връзка."
  },
  {
    "reading_id": "lovers_world",
    "reading_name": "Съвършена любов",
    "reading_cards": "Влюбените + Свят",
    "reading_combination": ["lovers", "world"],
    "reading_meaning": "Любовта е завършена",
    "reading_description": "Намерил си любовта, която те прави цялостен. Пълнота, хармония, завършеност.",
    "reading_advice": "Ти намери своята сродна душа. Цени този дар."
  },
  {
    "reading_id": "chariot_strength",
    "reading_name": "Контролирана сила",
    "reading_cards": "Колесница + Сила",
    "reading_combination": ["chariot", "strength"],
    "reading_meaning": "Управляваш силата си",
    "reading_description": "Имаш сила и контрол едновременно. Управляваш енергията си с ум.",
    "reading_advice": "Най-голямата сила е тази, която умееш да контролираш."
  },
  {
    "reading_id": "chariot_hermit",
    "reading_name": "Самотно пътуване",
    "reading_cards": "Колесница + Отшелник",
    "reading_combination": ["chariot", "hermit"],
    "reading_meaning": "Пътуваш сам",
    "reading_description": "Пътуване, което предприемаш сам. Търсене на себе си през движението.",
    "reading_advice": "Понякога най-добрият спътник си ти самият."
  },
  {
    "reading_id": "chariot_wheel",
    "reading_name": "Съдбовно пътуване",
    "reading_cards": "Колесница + Колело на съдбата",
    "reading_combination": ["chariot", "wheel_of_fortune"],
    "reading_meaning": "Пътуване, което променя съдбата",
    "reading_description": "Пътуване, което ще промени живота ти. Срещи, събития, които не са случайни.",
    "reading_advice": "Отвори се за изненадите на пътя."
  },
  {
    "reading_id": "chariot_justice",
    "reading_name": "Път към справедливост",
    "reading_cards": "Колесница + Справедливост",
    "reading_combination": ["chariot", "justice"],
    "reading_meaning": "Търсиш правда",
    "reading_description": "Пътуване, свързано с правни въпроси. Съд, документи, официални дела.",
    "reading_advice": "Истината ще излезе наяве. Бъди търпелив."
  },
  {
    "reading_id": "chariot_hanged",
    "reading_name": "Блокирано пътуване",
    "reading_cards": "Колесница + Обесен",
    "reading_combination": ["chariot", "hanged_man"],
    "reading_meaning": "Пътуването се отлага",
    "reading_description": "Пътуването ти се отлага или блокира. Забавяне, промяна на планове.",
    "reading_advice": "Понякога забавянето идва, за да те предпази."
  },
  {
    "reading_id": "chariot_death",
    "reading_name": "Край на пътуване",
    "reading_cards": "Колесница + Смърт",
    "reading_combination": ["chariot", "death"],
    "reading_meaning": "Пътуването приключва",
    "reading_description": "Едно пътуване или период на движение приключва. Време за ново начало.",
    "reading_advice": "Приеми края като естествен завършек."
  },
  {
    "reading_id": "chariot_temperance",
    "reading_name": "Балансирано пътуване",
    "reading_cards": "Колесница + Умереност",
    "reading_combination": ["chariot", "temperance"],
    "reading_meaning": "Пътуване с мярка",
    "reading_description": "Пътуваш, без да прекаляваш. Баланс между движение и почивка.",
    "reading_advice": "Наслаждавай се на пътя, не само на дестинацията."
  },
  {
    "reading_id": "chariot_devil",
    "reading_name": "Път към ада",
    "reading_cards": "Колесница + Дявол",
    "reading_combination": ["chariot", "devil"],
    "reading_meaning": "Пътуване, което води към зависимост",
    "reading_description": "Пътуване, свързано с лоши компании, зависимости или рискове. Внимавай.",
    "reading_advice": "Провери добре с кого и накъде пътуваш."
  },
  {
    "reading_id": "chariot_tower",
    "reading_name": "Катастрофа",
    "reading_cards": "Колесница + Кула",
    "reading_combination": ["chariot", "tower"],
    "reading_meaning": "Пътен инцидент",
    "reading_description": "Риск от пътен инцидент или внезапен проблем с пътуване. Внимавай на пътя.",
    "reading_advice": "Карай внимателно и провери техническото състояние на превозното средство."
  },
  {
    "reading_id": "chariot_star",
    "reading_name": "Надеждно пътуване",
    "reading_cards": "Колесница + Звезда",
    "reading_combination": ["chariot", "star"],
    "reading_meaning": "Пътуване с надежда",
    "reading_description": "Пътуване, което носи надежда и нови възможности. Светло бъдеще те очаква.",
    "reading_advice": "Гледай напред с надежда и оптимизъм."
  },
  {
    "reading_id": "chariot_moon",
    "reading_name": "Пътуване в мъгла",
    "reading_cards": "Колесница + Луна",
    "reading_combination": ["chariot", "moon"],
    "reading_meaning": "Несигурно пътуване",
    "reading_description": "Пътуваш, без да знаеш точно накъде. Несигурност, страх, объркване.",
    "reading_advice": "Понякога трябва да вървиш, дори когато не виждаш."
  },
  {
    "reading_id": "chariot_sun",
    "reading_name": "Слънчево пътуване",
    "reading_cards": "Колесница + Слънце",
    "reading_combination": ["chariot", "sun"],
    "reading_meaning": "Прекрасно пътуване",
    "reading_description": "Пътуване, което носи радост и щастие. Ваканция, почивка, приятни преживявания.",
    "reading_advice": "Наслаждавай се на всеки миг."
  },
  {
    "reading_id": "chariot_judgement",
    "reading_name": "Пробудено пътуване",
    "reading_cards": "Колесница + Съд",
    "reading_combination": ["chariot", "judgement"],
    "reading_meaning": "Пътуване към себе си",
    "reading_description": "Пътуване, което води до дълбоко себепознание. Връщане към същността.",
    "reading_advice": "Чуй зова на душата си по пътя."
  },
  {
    "reading_id": "chariot_world",
    "reading_name": "Околосветско пътуване",
    "reading_cards": "Колесница + Свят",
    "reading_combination": ["chariot", "world"],
    "reading_meaning": "Голямо пътуване",
    "reading_description": "Предстои ти голямо пътуване - в чужбина, около света. Нови хоризонти.",
    "reading_advice": "Светът те очаква. Отправи се на път."
  },
  {
    "reading_id": "strength_hermit",
    "reading_name": "Самотна сила",
    "reading_cards": "Сила + Отшелник",
    "reading_combination": ["strength", "hermit"],
    "reading_meaning": "Сила в самота",
    "reading_description": "Черпиш сила от самотата и тишината. Там намираш себе си.",
    "reading_advice": "Не се страхувай да бъдеш сам. Там е силата ти."
  },
  {
    "reading_id": "strength_wheel",
    "reading_name": "Късмет и сила",
    "reading_cards": "Сила + Колело на съдбата",
    "reading_combination": ["strength", "wheel_of_fortune"],
    "reading_meaning": "Силният има късмет",
    "reading_description": "Съчетание на вътрешна сила и благоприятна съдба. Късметът обича смелите.",
    "reading_advice": "Късметът идва при тези, които са готови да го посрещнат."
  },
  {
    "reading_id": "strength_justice",
    "reading_name": "Справедлива сила",
    "reading_cards": "Сила + Справедливост",
    "reading_combination": ["strength", "justice"],
    "reading_meaning": "Сила за справедливост",
    "reading_description": "Използваш силата си, за да възтържествува справедливостта. Борец за правда.",
    "reading_advice": "Силата без справедливост е тирания."
  },
  {
    "reading_id": "strength_hanged",
    "reading_name": "Блокирана сила",
    "reading_cards": "Сила + Обесен",
    "reading_combination": ["strength", "hanged_man"],
    "reading_meaning": "Силата ти е в капан",
    "reading_description": "Имаш сила, но не можеш да я използваш. Блокиран, в капан, безпомощен.",
    "reading_advice": "Понякога трябва да спреш, за да презаредиш."
  },
  {
    "reading_id": "strength_death",
    "reading_name": "Трансформация на силата",
    "reading_cards": "Сила + Смърт",
    "reading_combination": ["strength", "death"],
    "reading_meaning": "Старата сила умира",
    "reading_description": "Начинът, по който използваш силата си, се променя коренно. Ново ниво.",
    "reading_advice": "Позволи на старата сила да умре, за да се роди нова."
  },
  {
    "reading_id": "strength_temperance",
    "reading_name": "Балансирана сила",
    "reading_cards": "Сила + Умереност",
    "reading_combination": ["strength", "temperance"],
    "reading_meaning": "Сила с мярка",
    "reading_description": "Използваш силата си, без да прекаляваш. Контрол и хармония.",
    "reading_advice": "Истинската сила е в баланса."
  },
  {
    "reading_id": "strength_devil",
    "reading_name": "Сила, използвана за зло",
    "reading_cards": "Сила + Дявол",
    "reading_combination": ["strength", "devil"],
    "reading_meaning": "Злоупотреба със сила",
    "reading_description": "Използваш силата си, за да манипулираш и контролираш. Тъмна страна.",
    "reading_advice": "Силата, използвана за его, винаги се връща като бумеранг."
  },
  {
    "reading_id": "strength_tower",
    "reading_name": "Силата се срива",
    "reading_cards": "Сила + Кула",
    "reading_combination": ["strength", "tower"],
    "reading_meaning": "Загуба на сила",
    "reading_description": "Всичко, в което си вярвал като своя сила, се срива. Безпомощност.",
    "reading_advice": "Понякога трябва да загубиш силата, за да откриеш истинската."
  },
  {
    "reading_id": "strength_star",
    "reading_name": "Надеждна сила",
    "reading_cards": "Сила + Звезда",
    "reading_combination": ["strength", "star"],
    "reading_meaning": "Сила и надежда",
    "reading_description": "Силата ти идва от надеждата и вярата в бъдещето. Оптимизъм и мощ.",
    "reading_advice": "Надеждата дава сила. Никога не я губи."
  },
  {
    "reading_id": "strength_moon",
    "reading_name": "Страх и сила",
    "reading_cards": "Сила + Луна",
    "reading_combination": ["strength", "moon"],
    "reading_meaning": "Бориш се със страховете",
    "reading_description": "Използваш силата си, за да преодолееш страховете и илюзиите. Смелост.",
    "reading_advice": "Смелостта не е липса на страх, а действие въпреки него."
  },
  {
    "reading_id": "strength_sun",
    "reading_name": "Сияйна сила",
    "reading_cards": "Сила + Слънце",
    "reading_combination": ["strength", "sun"],
    "reading_meaning": "Триумф на силата",
    "reading_description": "Силата ти блести и получава признание. Успех, радост, удовлетворение.",
    "reading_advice": "Ти си победител. Наслади се на успеха."
  },
  {
    "reading_id": "strength_judgement",
    "reading_name": "Пробудена сила",
    "reading_cards": "Сила + Съд",
    "reading_combination": ["strength", "judgement"],
    "reading_meaning": "Ново ниво на сила",
    "reading_description": "Пробуждане на нови измерения на силата ти. Откриваш, че можеш повече.",
    "reading_advice": "Откликни на зова за по-голяма сила."
  },
  {
    "reading_id": "strength_world",
    "reading_name": "Върховна сила",
    "reading_cards": "Сила + Свят",
    "reading_combination": ["strength", "world"],
    "reading_meaning": "Пълна сила",
    "reading_description": "Постигнал си пълна хармония със силата си. Увереност, завършеност, съвършенство.",
    "reading_advice": "Ти си върхът. Наслади се на постижението."
  },
  {
    "reading_id": "hermit_wheel",
    "reading_name": "Съдбовна самота",
    "reading_cards": "Отшелник + Колело на съдбата",
    "reading_combination": ["hermit", "wheel_of_fortune"],
    "reading_meaning": "Съдбата те води в самота",
    "reading_description": "Съдбата ти е отредила период на самота и уединение. Приеми го.",
    "reading_advice": "В самотата ще намериш отговорите, които търсиш."
  },
  {
    "reading_id": "hermit_justice",
    "reading_name": "Справедлива самота",
    "reading_cards": "Отшелник + Справедливост",
    "reading_combination": ["hermit", "justice"],
    "reading_meaning": "Самота, за да осмислиш",
    "reading_description": "Оттегляш се, за да осмислиш справедливостта на случилото се. Време за равносметка.",
    "reading_advice": "В тишината ще намериш справедливостта, която търсиш."
  },
  {
    "reading_id": "hermit_hanged",
    "reading_name": "Двойна самота",
    "reading_cards": "Отшелник + Обесен",
    "reading_combination": ["hermit", "hanged_man"],
    "reading_meaning": "Дълбоко уединение",
    "reading_description": "Период на много дълбока самота и изолация. Почти пълно оттегляне от света.",
    "reading_advice": "Понякога трябва да слезеш в дълбините, за да се издигнеш."
  },
  {
    "reading_id": "hermit_death",
    "reading_name": "Край на самотата",
    "reading_cards": "Отшелник + Смърт",
    "reading_combination": ["hermit", "death"],
    "reading_meaning": "Самотният период приключва",
    "reading_description": "Периодът на уединение свършва. Време е да се върнеш в света.",
    "reading_advice": "Излезе от пещерата. Светът те очаква."
  },
  {
    "reading_id": "hermit_temperance",
    "reading_name": "Балансирана самота",
    "reading_cards": "Отшелник + Умереност",
    "reading_combination": ["hermit", "temperance"],
    "reading_meaning": "Самота с мярка",
    "reading_description": "Умееш да балансираш между самота и социален живот. Здравословно оттегляне.",
    "reading_advice": "Самотата е добра, но с мярка."
  },
  {
    "reading_id": "hermit_devil",
    "reading_name": "Тъмна самота",
    "reading_cards": "Отшелник + Дявол",
    "reading_combination": ["hermit", "devil"],
    "reading_meaning": "Самота, която те заробва",
    "reading_description": "Самотата се превръща в затвор. Изолация, депресия, тъмнина.",
    "reading_advice": "Потърси помощ. Не е нужно да си сам в тъмнината."
  },
  {
    "reading_id": "hermit_tower",
    "reading_name": "Самота след срив",
    "reading_cards": "Отшелник + Кула",
    "reading_combination": ["hermit", "tower"],
    "reading_meaning": "Оттегляне след разруха",
    "reading_description": "След тежък срив се оттегляш да лекуваш раните си. Необходима самота.",
    "reading_advice": "Лекувай се в тишина, после се върни."
  },
  {
    "reading_id": "hermit_star",
    "reading_name": "Надежда в самота",
    "reading_cards": "Отшелник + Звезда",
    "reading_combination": ["hermit", "star"],
    "reading_meaning": "Самота с надежда",
    "reading_description": "Дори в самотата не губиш надежда. Вярваш, че ще дойдат по-добри дни.",
    "reading_advice": "Звездата свети дори в най-тъмната нощ."
  },
  {
    "reading_id": "hermit_moon",
    "reading_name": "Сам със страховете",
    "reading_cards": "Отшелник + Луна",
    "reading_combination": ["hermit", "moon"],
    "reading_meaning": "Самота и страхове",
    "reading_description": "В самотата страховете и илюзиите стават по-големи. Изправяш се сам с тях.",
    "reading_advice": "Страховете в самота са най-големи. Потърси светлина."
  },
  {
    "reading_id": "hermit_sun",
    "reading_name": "Просветлен в самота",
    "reading_cards": "Отшелник + Слънце",
    "reading_combination": ["hermit", "sun"],
    "reading_meaning": "Самота, която просветлява",
    "reading_description": "В самотата намираш просветление и яснота. Радост от уединението.",
    "reading_advice": "Наслади се на светлината, която намираш в себе си."
  },
  {
    "reading_id": "hermit_judgement",
    "reading_name": "Пробуждане в самота",
    "reading_cards": "Отшелник + Съд",
    "reading_combination": ["hermit", "judgement"],
    "reading_meaning": "Самота, която пробужда",
    "reading_description": "В уединението чуваш зова на душата си. Пробуждане, ново начало.",
    "reading_advice": "Чуй гласа си в тишината."
  },
  {
    "reading_id": "hermit_world",
    "reading_name": "Самота и завършеност",
    "reading_cards": "Отшелник + Свят",
    "reading_combination": ["hermit", "world"],
    "reading_meaning": "Пълнота в самота",
    "reading_description": "В самотата намираш пълнота и хармония. Не ти трябва никой друг, за да си цялостен.",
    "reading_advice": "Ти си цял сам. Това е най-голямата свобода."
  },
  {
    "reading_id": "wheel_justice",
    "reading_name": "Съдбовна справедливост",
    "reading_cards": "Колело на съдбата + Справедливост",
    "reading_combination": ["wheel_of_fortune", "justice"],
    "reading_meaning": "Кармата се връща",
    "reading_description": "Справедливостта идва от съдбата. Кармично възмездие или награда.",
    "reading_advice": "Каквото посееш, това ще пожънеш. Това е закон."
  },
  {
    "reading_id": "wheel_hanged",
    "reading_name": "Съдбовно изчакване",
    "reading_cards": "Колело на съдбата + Обесен",
    "reading_combination": ["wheel_of_fortune", "hanged_man"],
    "reading_meaning": "Съдбата те кара да чакаш",
    "reading_description": "Съдбата ти казва да изчакаш. Не сега, не още. Търпение.",
    "reading_advice": "Когато дойде времето, ще разбереш защо е трябвало да чакаш."
  },
  {
    "reading_id": "wheel_death",
    "reading_name": "Съдбовен край",
    "reading_cards": "Колело на съдбата + Смърт",
    "reading_combination": ["wheel_of_fortune", "death"],
    "reading_meaning": "Краят е предопределен",
    "reading_description": "Този край не е случаен - той е част от по-голям план. Приеми го.",
    "reading_advice": "Всичко, което започва, има и край. Така е писано."
  },
  {
    "reading_id": "wheel_temperance",
    "reading_name": "Баланс на съдбата",
    "reading_cards": "Колело на съдбата + Умереност",
    "reading_combination": ["wheel_of_fortune", "temperance"],
    "reading_meaning": "Съдбата възстановява баланса",
    "reading_description": "Съдбата възстановява баланса в живота ти. Всичко се нарежда.",
    "reading_advice": "Довери се, че вселената знае какво прави."
  },
  {
    "reading_id": "wheel_devil",
    "reading_name": "Съдбовна зависимост",
    "reading_cards": "Колело на съдбата + Дявол",
    "reading_combination": ["wheel_of_fortune", "devil"],
    "reading_meaning": "Съдбата те заробва",
    "reading_description": "Попадаш в капан, който изглежда предопределен. Трудно за разплитане.",
    "reading_advice": "Съдбата може да те води, но ти избираш пътя."
  },
  {
    "reading_id": "wheel_tower",
    "reading_name": "Съдбовен срив",
    "reading_cards": "Колело на съдбата + Кула",
    "reading_combination": ["wheel_of_fortune", "tower"],
    "reading_meaning": "Разруха, писана в звездите",
    "reading_description": "Сривът е неизбежен, предопределен. Трябваше да се случи.",
    "reading_advice": "Приеми разрухата като част от плана. След нея идва ново начало."
  },
  {
    "reading_id": "wheel_star",
    "reading_name": "Съдбовна надежда",
    "reading_cards": "Колело на съдбата + Звезда",
    "reading_combination": ["wheel_of_fortune", "star"],
    "reading_meaning": "Съдбата носи надежда",
    "reading_description": "Звездите ти казват, че всичко ще бъде наред. Съдбата ти се усмихва.",
    "reading_advice": "Вярвай, че най-доброто тепърва предстои."
  },
  {
    "reading_id": "wheel_moon",
    "reading_name": "Съдбовна илюзия",
    "reading_cards": "Колело на съдбата + Луна",
    "reading_combination": ["wheel_of_fortune", "moon"],
    "reading_meaning": "Съдбата е замъглена",
    "reading_description": "Не виждаш ясно съдбата си. Илюзии, страхове, несигурност.",
    "reading_advice": "Понякога трябва да приемеш, че не знаеш."
  },
  {
    "reading_id": "wheel_sun",
    "reading_name": "Щастлива съдба",
    "reading_cards": "Колело на съдбата + Слънце",
    "reading_combination": ["wheel_of_fortune", "sun"],
    "reading_meaning": "Съдбата ти се усмихва",
    "reading_description": "Късмет, щастие, успех - всичко идва от съдбата. Благоприятен момент.",
    "reading_advice": "Хвани вълната на късмета и я язди."
  },
  {
    "reading_id": "wheel_judgement",
    "reading_name": "Съдбовно пробуждане",
    "reading_cards": "Колело на съдбата + Съд",
    "reading_combination": ["wheel_of_fortune", "judgement"],
    "reading_meaning": "Съдбата те буди",
    "reading_description": "Съдбата ти изпраща сигнал, че е време за промяна. Чуй го.",
    "reading_advice": "Откликни на зова на съдбата."
  },
  {
    "reading_id": "wheel_world",
    "reading_name": "Съдбовен завършек",
    "reading_cards": "Колело на съдбата + Свят",
    "reading_combination": ["wheel_of_fortune", "world"],
    "reading_meaning": "Цикълът завършва",
    "reading_description": "Съдбовен момент на завършване. Един цикъл приключва, както е било писано.",
    "reading_advice": "Приеми завършека с благодарност."
  },
  {
    "reading_id": "justice_hanged",
    "reading_name": "Справедливо чакане",
    "reading_cards": "Справедливост + Обесен",
    "reading_combination": ["justice", "hanged_man"],
    "reading_meaning": "Чакаш справедливост",
    "reading_description": "Чакаш правдата да възтържествува, но тя се бави. Търпение.",
    "reading_advice": "Справедливостта идва бавно, но сигурно."
  },
  {
    "reading_id": "justice_death",
    "reading_name": "Край на справедливостта",
    "reading_cards": "Справедливост + Смърт",
    "reading_combination": ["justice", "death"],
    "reading_meaning": "Приключва съдебен процес",
    "reading_description": "Съдебно дело или правен въпрос приключва. Край на дълъг процес.",
    "reading_advice": "Приеми решението и продължи напред."
  },
  {
    "reading_id": "justice_temperance",
    "reading_name": "Балансирана справедливост",
    "reading_cards": "Справедливост + Умереност",
    "reading_combination": ["justice", "temperance"],
    "reading_meaning": "Справедливост с мярка",
    "reading_description": "Търсиш балансирано решение, което да удовлетвори всички страни. Мъдрост.",
    "reading_advice": "Най-добрата справедливост е тази, която възстановява хармонията."
  },
  {
    "reading_id": "justice_devil",
    "reading_name": "Несправедливост",
    "reading_cards": "Справедливост + Дявол",
    "reading_combination": ["justice", "devil"],
    "reading_meaning": "Правосъдието е покварено",
    "reading_description": "Справедливостта е манипулирана. Някой използва властта си нечестно.",
    "reading_advice": "Истината ще излезе наяве, дори и да изглежда, че невинният губи."
  },
  {
    "reading_id": "justice_tower",
    "reading_name": "Срив на справедливостта",
    "reading_cards": "Справедливост + Кула",
    "reading_combination": ["justice", "tower"],
    "reading_meaning": "Съдебна грешка",
    "reading_description": "Справедливостта не възтържествува. Несправедливо решение, грешка, нечестност.",
    "reading_advice": "Понякога трябва да приемеш, че справедливостта на този свят е несъвършена."
  },
  {
    "reading_id": "justice_star",
    "reading_name": "Надежда за справедливост",
    "reading_cards": "Справедливост + Звезда",
    "reading_combination": ["justice", "star"],
    "reading_meaning": "Вярваш, че правдата ще възтържествува",
    "reading_description": "Дори когато изглежда невъзможно, вярваш, че справедливостта ще победи.",
    "reading_advice": "Надеждата за справедливост държи света жив."
  },
  {
    "reading_id": "justice_moon",
    "reading_name": "Неясна справедливост",
    "reading_cards": "Справедливост + Луна",
    "reading_combination": ["justice", "moon"],
    "reading_meaning": "Не знаеш кое е справедливо",
    "reading_description": "Ситуацията е толкова замъглена, че не можеш да прецениш кое е правилно.",
    "reading_advice": "Изчакай мъглата да се вдигне, преди да съдиш."
  },
  {
    "reading_id": "justice_sun",
    "reading_name": "Справедливостта възтържествува",
    "reading_cards": "Справедливост + Слънце",
    "reading_combination": ["justice", "sun"],
    "reading_meaning": "Истината излиза наяве",
    "reading_description": "Правдата най-после възтържествува. Истината излиза на светло.",
    "reading_advice": "Радвай се, че доброто победи."
  },
  {
    "reading_id": "justice_judgement",
    "reading_name": "Пробуждане на справедливостта",
    "reading_cards": "Справедливост + Съд",
    "reading_combination": ["justice", "judgement"],
    "reading_meaning": "Висша справедливост",
    "reading_description": "Справедливост от по-висше ниво. Кармично възмездие, божи съд.",
    "reading_advice": "Има правда отвъд човешките закони."
  },
  {
    "reading_id": "justice_world",
    "reading_name": "Съвършена справедливост",
    "reading_cards": "Справедливост + Свят",
    "reading_combination": ["justice", "world"],
    "reading_meaning": "Справедливост за всички",
    "reading_description": "Постигната е справедливост, която удовлетворява всички. Хармония и баланс.",
    "reading_advice": "Това е моментът, в който всичко си идва на мястото."
  },
  {
    "reading_id": "hanged_death",
    "reading_name": "Чакане на края",
    "reading_cards": "Обесен + Смърт",
    "reading_combination": ["hanged_man", "death"],
    "reading_meaning": "В застой преди край",
    "reading_description": "Чакаш нещо да приключи, но то се бави. Мъчително изчакване.",
    "reading_advice": "Краят ще дойде, когато трябва. Бъди търпелив."
  },
  {
    "reading_id": "hanged_temperance",
    "reading_name": "Балансирано чакане",
    "reading_cards": "Обесен + Умереност",
    "reading_combination": ["hanged_man", "temperance"],
    "reading_meaning": "Чакаш с мярка",
    "reading_description": "Умееш да чакаш, без да се отчайваш. Търпение и хармония.",
    "reading_advice": "Чакането също е изкуство."
  },
  {
    "reading_id": "hanged_devil",
    "reading_name": "Блокиран в зависимост",
    "reading_cards": "Обесен + Дявол",
    "reading_combination": ["hanged_man", "devil"],
    "reading_meaning": "В капан и не можеш да мръднеш",
    "reading_description": "Зависимост или токсична ситуация те държи в плен и не можеш да излезеш.",
    "reading_advice": "Първата стъпка е да осъзнаеш, че си в капан."
  },
  {
    "reading_id": "hanged_tower",
    "reading_name": "Чакането свършва със срив",
    "reading_cards": "Обесен + Кула",
    "reading_combination": ["hanged_man", "tower"],
    "reading_meaning": "Блокът се разрушава",
    "reading_description": "След дълго чакане идва внезапен срив, който слага край на застоя.",
    "reading_advice": "Понякога разрухата е освобождение."
  },
  {
    "reading_id": "hanged_star",
    "reading_name": "Надежда в застоя",
    "reading_cards": "Обесен + Звезда",
    "reading_combination": ["hanged_man", "star"],
    "reading_meaning": "Чакаш с надежда",
    "reading_description": "Дори в застой не губиш надежда. Вярваш, че ще дойде по-добро.",
    "reading_advice": "Надеждата прави чакането поносимо."
  },
  {
    "reading_id": "hanged_moon",
    "reading_name": "Страх в застоя",
    "reading_cards": "Обесен + Луна",
    "reading_combination": ["hanged_man", "moon"],
    "reading_meaning": "Блокиран от страхове",
    "reading_description": "Страховете и илюзиите те държат в застой. Не можеш да мръднеш от тях.",
    "reading_advice": "Страхът е най-големият затвор."
  },
  {
    "reading_id": "hanged_sun",
    "reading_name": "Застоят свършва",
    "reading_cards": "Обесен + Слънце",
    "reading_combination": ["hanged_man", "sun"],
    "reading_meaning": "Край на чакането",
    "reading_description": "Периодът на изчакване най-после приключва. Радост и облекчение.",
    "reading_advice": "Дойде време за действие."
  },
  {
    "reading_id": "hanged_judgement",
    "reading_name": "Пробуждане от застоя",
    "reading_cards": "Обесен + Съд",
    "reading_combination": ["hanged_man", "judgement"],
    "reading_meaning": "Зов сред застоя",
    "reading_description": "Дори в блокажа чуваш зов за промяна. Той те кара да се раздвижиш.",
    "reading_advice": "Чуй гласа, който те буди от застоя."
  },
  {
    "reading_id": "hanged_world",
    "reading_name": "Завършек на застоя",
    "reading_cards": "Обесен + Свят",
    "reading_combination": ["hanged_man", "world"],
    "reading_meaning": "Периодът на чакане завършва",
    "reading_description": "Застоят приключва и всичко си идва на мястото. Завършеност и хармония.",
    "reading_advice": "Чакането си заслужаваше."
  },
  {
    "reading_id": "death_temperance",
    "reading_name": "Балансиран край",
    "reading_cards": "Смърт + Умереност",
    "reading_combination": ["death", "temperance"],
    "reading_meaning": "Край с мярка",
    "reading_description": "Краят идва плавно, без внезапни сътресения. Естествен завършек.",
    "reading_advice": "Приеми края като част от цикъла."
  },
  {
    "reading_id": "death_devil",
    "reading_name": "Край на зависимост",
    "reading_cards": "Смърт + Дявол",
    "reading_combination": ["death", "devil"],
    "reading_meaning": "Освобождение от окови",
    "reading_description": "Зависимост или токсична връзка приключва. Край, който носи свобода.",
    "reading_advice": "Смъртта на зависимостта е раждане на свободата."
  },
  {
    "reading_id": "death_tower",
    "reading_name": "Тотален срив",
    "reading_cards": "Смърт + Кула",
    "reading_combination": ["death", "tower"],
    "reading_meaning": "Пълен край",
    "reading_description": "Всичко се срива напълно. Край, от който няма връщане назад.",
    "reading_advice": "Понякога трябва всичко да рухне, за да започнеш отначало."
  },
  {
    "reading_id": "death_star",
    "reading_name": "Край и ново начало",
    "reading_cards": "Смърт + Звезда",
    "reading_combination": ["death", "star"],
    "reading_meaning": "След края идва надежда",
    "reading_description": "След приключването идва надежда за ново начало. Феникс от пепелта.",
    "reading_advice": "Когато една врата се затваря, друга се отваря."
  },
  {
    "reading_id": "death_moon",
    "reading_name": "Край в мъгла",
    "reading_cards": "Смърт + Луна",
    "reading_combination": ["death", "moon"],
    "reading_meaning": "Краят е неясен",
    "reading_description": "Нещо приключва, но не виждаш ясно какво и защо. Объркване и страх.",
    "reading_advice": "Светлината ще дойде, когато си готов."
  },
  {
    "reading_id": "death_sun",
    "reading_name": "Щастлив край",
    "reading_cards": "Смърт + Слънце",
    "reading_combination": ["death", "sun"],
    "reading_meaning": "Краят носи радост",
    "reading_description": "Приключване, което носи облекчение и радост. Край на тежък период.",
    "reading_advice": "Радвай се, че този цикъл приключи."
  },
  {
    "reading_id": "death_judgement",
    "reading_name": "Смърт и възкресение",
    "reading_cards": "Смърт + Съд",
    "reading_combination": ["death", "judgement"],
    "reading_meaning": "Краят води до ново раждане",
    "reading_description": "След смъртта идва възкресение. Прераждане, ново начало, нова същност.",
    "reading_advice": "Умри за старото, за да се родиш отново."
  },
  {
    "reading_id": "death_world",
    "reading_name": "Пълен завършек",
    "reading_cards": "Смърт + Свят",
    "reading_combination": ["death", "world"],
    "reading_meaning": "Цикълът завършва напълно",
    "reading_description": "Един голям цикъл приключва напълно. Край, който носи завършеност.",
    "reading_advice": "Ти завърши един кръг. Почини си, после започни нов."
  },
  {
    "reading_id": "temperance_devil",
    "reading_name": "Баланс и зависимост",
    "reading_cards": "Умереност + Дявол",
    "reading_combination": ["temperance", "devil"],
    "reading_meaning": "Бориш се със зависимост",
    "reading_description": "Опитваш се да намериш баланс, докато се бориш със зависимост или лош навик.",
    "reading_advice": "Балансът е първата стъпка към свободата."
  },
  {
    "reading_id": "temperance_tower",
    "reading_name": "Балансът се срива",
    "reading_cards": "Умереност + Кула",
    "reading_combination": ["temperance", "tower"],
    "reading_meaning": "Загуба на равновесие",
    "reading_description": "Хармонията и балансът, които си постигнал, се сриват внезапно.",
    "reading_advice": "След срива ще намериш нов баланс."
  },
  {
    "reading_id": "temperance_star",
    "reading_name": "Баланс и надежда",
    "reading_cards": "Умереност + Звезда",
    "reading_combination": ["temperance", "star"],
    "reading_meaning": "Хармонична надежда",
    "reading_description": "Надеждата ти е балансирана и спокойна. Нито прекален оптимизъм, нито песимизъм.",
    "reading_advice": "Вярвай, но с мярка."
  },
  {
    "reading_id": "temperance_moon",
    "reading_name": "Баланс сред илюзии",
    "reading_cards": "Умереност + Луна",
    "reading_combination": ["temperance", "moon"],
    "reading_meaning": "Опитваш се да запазиш баланс сред хаоса",
    "reading_description": "Страховете и илюзиите заплашват да те извадят от равновесие. Държиш се.",
    "reading_advice": "Дръж се за баланса си. Той е спасителен пояс."
  },
  {
    "reading_id": "temperance_sun",
    "reading_name": "Слънчев баланс",
    "reading_cards": "Умереност + Слънце",
    "reading_combination": ["temperance", "sun"],
    "reading_meaning": "Перфектна хармония",
    "reading_description": "Всичко в живота ти е в идеален баланс. Радост и хармония заедно.",
    "reading_advice": "Наслаждавай се на този рядък момент."
  },
  {
    "reading_id": "temperance_judgement",
    "reading_name": "Пробуден баланс",
    "reading_cards": "Умереност + Съд",
    "reading_combination": ["temperance", "judgement"],
    "reading_meaning": "Балансът се пробужда",
    "reading_description": "Осъзнаваш важността на баланса в живота си на ново ниво.",
    "reading_advice": "Чуй зова за по-голяма хармония."
  },
  {
    "reading_id": "temperance_world",
    "reading_name": "Съвършен баланс",
    "reading_cards": "Умереност + Свят",
    "reading_combination": ["temperance", "world"],
    "reading_meaning": "Пълна хармония",
    "reading_description": "Постигнал си съвършен баланс във всички области на живота. Пълнота и завършеност.",
    "reading_advice": "Ти си в хармония с вселената. Наслаждавай се."
  },
  {
    "reading_id": "devil_tower",
    "reading_name": "Срив на зависимост",
    "reading_cards": "Дявол + Кула",
    "reading_combination": ["devil", "tower"],
    "reading_meaning": "Принудително освобождение",
    "reading_description": "Зависимост или токсична ситуация приключва внезапно и насилствено.",
    "reading_advice": "Понякога трябва да рухнеш, за да се освободиш."
  },
  {
    "reading_id": "devil_star",
    "reading_name": "Надежда след зависимост",
    "reading_cards": "Дявол + Звезда",
    "reading_combination": ["devil", "star"],
    "reading_meaning": "Вяра в изцеление",
    "reading_description": "Дори в най-тъмния момент на зависимост има надежда за изцеление.",
    "reading_advice": "Никога не е твърде късно да започнеш отново."
  },
  {
    "reading_id": "devil_moon",
    "reading_name": "Страх и зависимост",
    "reading_cards": "Дявол + Луна",
    "reading_combination": ["devil", "moon"],
    "reading_meaning": "Тъмна нощ на душата",
    "reading_description": "Зависимост, подхранвана от страхове и илюзии. Най-тежката комбинация.",
    "reading_advice": "Потърси светлина. Има я, дори да не я виждаш."
  },
  {
    "reading_id": "devil_sun",
    "reading_name": "Освобождение от зависимост",
    "reading_cards": "Дявол + Слънце",
    "reading_combination": ["devil", "sun"],
    "reading_meaning": "Светлина след тъмнина",
    "reading_description": "Успяваш да се освободиш от зависимост или токсична ситуация. Радост и свобода.",
    "reading_advice": "Ти победи демоните си. Наслади се на свободата."
  },
  {
    "reading_id": "devil_judgement",
    "reading_name": "Пробуждане от зависимост",
    "reading_cards": "Дявол + Съд",
    "reading_combination": ["devil", "judgement"],
    "reading_meaning": "Зов за освобождение",
    "reading_description": "Чуваш вътрешен глас, който те кара да се освободиш от зависимостите.",
    "reading_advice": "Чуй зова. Той идва, за да те спаси."
  },
  {
    "reading_id": "devil_world",
    "reading_name": "Край на зависимост",
    "reading_cards": "Дявол + Свят",
    "reading_combination": ["devil", "world"],
    "reading_meaning": "Цикълът на зависимост приключва",
    "reading_description": "Успяваш да затвориш главата със зависимостите. Завършек и свобода.",
    "reading_advice": "Ти завърши този тежък цикъл. Гордей се."
  },
 
  {
    "reading_id": "tower_moon",
    "reading_name": "Срив сред страхове",
    "reading_cards": "Кула + Луна",
    "reading_combination": ["tower", "moon"],
    "reading_meaning": "Разруха и объркване",
    "reading_description": "Срив, който те оставя объркан и изплашен. Не виждаш изход.",
    "reading_advice": "Страхът е нормален след срив. Дай си време."
  },
  {
    "reading_id": "tower_sun",
    "reading_name": "След срива идва светлина",
    "reading_cards": "Кула + Слънце",
    "reading_combination": ["tower", "sun"],
    "reading_meaning": "Разрушение и ново начало",
    "reading_description": "След като всичко рухва, идва светлина и ново начало. Красиво възраждане.",
    "reading_advice": "Понякога трябва да загубиш всичко, за да получиш всичко."
  },
  {
    "reading_id": "tower_judgement",
    "reading_name": "Срив и пробуждане",
    "reading_cards": "Кула + Съд",
    "reading_combination": ["tower", "judgement"],
    "reading_meaning": "Разруха, която буди",
    "reading_description": "Сривът те събужда от дълъг сън. Виждаш нещата по нов начин.",
    "reading_advice": "Понякога трябва да рухнеш, за да се събудиш."
  },
  {
    "reading_id": "tower_world",
    "reading_name": "Край на един свят",
    "reading_cards": "Кула + Свят",
    "reading_combination": ["tower", "world"],
    "reading_meaning": "Цял свят се срива",
    "reading_description": "Всичко, което познаваш, се срива. Един цял свят приключва.",
    "reading_advice": "Когато един свят свършва, друг започва."
  },
  {
    "reading_id": "star_moon",
    "reading_name": "Надежда сред страхове",
    "reading_cards": "Звезда + Луна",
    "reading_combination": ["star", "moon"],
    "reading_meaning": "Вяра въпреки страха",
    "reading_description": "Дори когато се страхуваш и не виждаш ясно, запазваш надежда.",
    "reading_advice": "Вярата е най-силна, когато не виждаш."
  },
  {
    "reading_id": "star_sun",
    "reading_name": "Надежда и щастие",
    "reading_cards": "Звезда + Слънце",
    "reading_combination": ["star", "sun"],
    "reading_meaning": "Изпълнена надежда",
    "reading_description": "Надеждата ти се сбъдва. Щастие, радост, изцеление.",
    "reading_advice": "Наслади се на светлината. Ти вярва и тя идва."
  },
  {
    "reading_id": "star_judgement",
    "reading_name": "Пробудена надежда",
    "reading_cards": "Звезда + Съд",
    "reading_combination": ["star", "judgement"],
    "reading_meaning": "Надеждата се пробужда",
    "reading_description": "След период без надежда, тя се възражда отново. Ново ниво на вяра.",
    "reading_advice": "Чуй зова на надеждата."
  },
  {
    "reading_id": "star_world",
    "reading_name": "Вселенска надежда",
    "reading_cards": "Звезда + Свят",
    "reading_combination": ["star", "world"],
    "reading_meaning": "Надежда за всичко",
    "reading_description": "Надежда, която обхваща всички аспекти на живота ти. Пълна вяра в бъдещето.",
    "reading_advice": "Вярвай, че всичко ще бъде наред. Вселената е с теб."
  },
  {
    "reading_id": "moon_sun",
    "reading_name": "От мрак към светлина",
    "reading_cards": "Луна + Слънце",
    "reading_combination": ["moon", "sun"],
    "reading_meaning": "Страховете отстъпват",
    "reading_description": "След период на страхове и объркване идва яснота и светлина.",
    "reading_advice": "Светлината винаги побеждава мрака."
  },
  {
    "reading_id": "moon_judgement",
    "reading_name": "Пробуждане от илюзии",
    "reading_cards": "Луна + Съд",
    "reading_combination": ["moon", "judgement"],
    "reading_meaning": "Събуждане от кошмар",
    "reading_description": "Страховете и илюзиите се разсейват. Виждаш истината.",
    "reading_advice": "Събуди се. Страховете бяха само сън."
  },
  {
    "reading_id": "moon_world",
    "reading_name": "Край на илюзиите",
    "reading_cards": "Луна + Свят",
    "reading_combination": ["moon", "world"],
    "reading_meaning": "Завършек на неясен период",
    "reading_description": "Периодът на объркване и страхове приключва. Всичко си идва на мястото.",
    "reading_advice": "Мъглата се вдигна. Виждаш ясно."
  },
  {
    "reading_id": "sun_judgement",
    "reading_name": "Пробудена светлина",
    "reading_cards": "Слънце + Съд",
    "reading_combination": ["sun", "judgement"],
    "reading_meaning": "Просветление",
    "reading_description": "Светлина и пробуждане заедно. Момент на висша яснота и разбиране.",
    "reading_advice": "Ти видя светлината. Следвай я."
  },
  {
    "reading_id": "sun_world",
    "reading_name": "Съвършено щастие",
    "reading_cards": "Слънце + Свят",
    "reading_combination": ["sun", "world"],
    "reading_meaning": "Върховна радост",
    "reading_description": "Пълно щастие и завършеност. Всичко, за което си мечтал, се сбъдва.",
    "reading_advice": "Ти си в рая. Наслаждавай се на всеки миг."
  },
  {
    "reading_id": "judgement_world",
    "reading_name": "Пробуждане и завършек",
    "reading_cards": "Съд + Свят",
    "reading_combination": ["judgement", "world"],
    "reading_meaning": "Краят на търсенето",
    "reading_description": "Пробуждаш се и виждаш, че си завършил дълъг път. Пълнота и разбиране.",
    "reading_advice": "Ти намери себе си. Сега живей."
  },
  {
    "reading_id": "fool_two_wands",
    "reading_name": "Необмислен избор",
    "reading_cards": "Глупак + 2 Жезли",
    "reading_combination": ["fool", "two_wands"],
    "reading_meaning": "Избор без достатъчно информация",
    "reading_description": "Изправен си пред избор, но скачаш без да обмислиш достатъчно. Решенията на глупака са рисковани.",
    "reading_advice": "Спри и помисли, преди да избереш."
  },
  {
    "reading_id": "fool_three_wands",
    "reading_name": "Нетърпеливо чакане",
    "reading_cards": "Глупак + 3 Жезли",
    "reading_combination": ["fool", "three_wands"],
    "reading_meaning": "Трудно ти е да чакаш",
    "reading_description": "Започнал си нещо и сега трябва да чакаш резултати, но нетърпението те изяжда. Искаш всичко веднага.",
    "reading_advice": "Търпението е част от пътя. Научи се да чакаш."
  },
  {
    "reading_id": "fool_four_wands",
    "reading_name": "Спонтанен празник",
    "reading_cards": "Глупак + 4 Жезли",
    "reading_combination": ["fool", "four_wands"],
    "reading_meaning": "Неочакван празник",
    "reading_description": "Изненадващ празник или щастливо събитие, което не си очаквал. Радост, която идва от нищото.",
    "reading_advice": "Празнувай, дори да не си го планирал."
  },
  {
    "reading_id": "fool_five_wands",
    "reading_name": "Неочакван конфликт",
    "reading_cards": "Глупак + 5 Жезли",
    "reading_combination": ["fool", "five_wands"],
    "reading_meaning": "Спор, който не си търсил",
    "reading_description": "Въвличаш се в конфликт, без да искаш. Думи или действия, които предизвикват спорове.",
    "reading_advice": "Понякога е по-добре да преглътнеш, отколкото да спориш."
  },
  {
    "reading_id": "fool_six_wands",
    "reading_name": "Неочакван успех",
    "reading_cards": "Глупак + 6 Жезли",
    "reading_combination": ["fool", "six_wands"],
    "reading_meaning": "Успех без усилия",
    "reading_description": "Постигаш успех, без да си положил много усилия. Късмет, който те изненадва.",
    "reading_advice": "Благодари на късмета, но не разчитай само на него."
  },
  {
    "reading_id": "fool_seven_wands",
    "reading_name": "Наивна защита",
    "reading_cards": "Глупак + 7 Жезли",
    "reading_combination": ["fool", "seven_wands"],
    "reading_meaning": "Защитаваш се, без да знаеш как",
    "reading_description": "Някой те напада и ти се защитаваш, но го правиш наивно и несръчно. Може да загубиш позиция.",
    "reading_advice": "Ако не знаеш как да се защитиш, избери да не влизаш в битка."
  },
  {
    "reading_id": "fool_eight_wands",
    "reading_name": "Бързо, но неподготвено",
    "reading_cards": "Глупак + 8 Жезли",
    "reading_combination": ["fool", "eight_wands"],
    "reading_meaning": "Скорост без подготовка",
    "reading_description": "Всичко се случва много бързо, но ти не си подготвен. Бързаш, без да знаеш накъде.",
    "reading_advice": "Понякога скоростта не е най-важното. По-добре бавно, но сигурно."
  },
  {
    "reading_id": "fool_nine_wands",
    "reading_name": "Упорит глупак",
    "reading_cards": "Глупак + 9 Жезли",
    "reading_combination": ["fool", "nine_wands"],
    "reading_meaning": "Не се предаваш въпреки трудностите",
    "reading_description": "Въпреки че всички ти казват, че не е разумно, ти продължаваш. Упоритост, която граничи с глупост.",
    "reading_advice": "Упоритостта е добродетел, но само когато вървиш в правилната посока."
  },
  {
    "reading_id": "fool_ten_wands",
    "reading_name": "Претоварен глупак",
    "reading_cards": "Глупак + 10 Жезли",
    "reading_combination": ["fool", "ten_wands"],
    "reading_meaning": "Поемаш твърде много",
    "reading_description": "С ентусиазъм си поел твърде много отговорности и сега се давиш в тях. Не си пресметнал силите си.",
    "reading_advice": "Научи се да казваш не. Не можеш да носиш всичко сам."
  },
  {
    "reading_id": "fool_ace_cups",
    "reading_name": "Наивна любов",
    "reading_cards": "Глупак + Асо Чаши",
    "reading_combination": ["fool", "ace_cups"],
    "reading_meaning": "Любов от пръв поглед",
    "reading_description": "Влюбваш се веднага, без да се замисляш. Сърцето ти скача, преди разумът да каже каквото и да е.",
    "reading_advice": "Наслади се на чувството, но не бързай да се обвързваш."
  },
  {
    "reading_id": "fool_two_cups",
    "reading_name": "Спонтанна връзка",
    "reading_cards": "Глупак + 2 Чаши",
    "reading_combination": ["fool", "two_cups"],
    "reading_meaning": "Връзка, която се случва неочаквано",
    "reading_description": "Срещаш някого и веднага усещаш връзка. Нито си го търсил, нито си го очаквал.",
    "reading_advice": "Понякога най-добрите неща идват, когато не ги търсиш."
  },
  {
    "reading_id": "fool_three_cups",
    "reading_name": "Спонтанно празнуване",
    "reading_cards": "Глупак + 3 Чаши",
    "reading_combination": ["fool", "three_cups"],
    "reading_meaning": "Празник без повод",
    "reading_description": "Решаваш да празнуваш, без да имаш конкретна причина. Просто защото си жив и щастлив.",
    "reading_advice": "Животът сам по себе си е повод за празник."
  },
  {
    "reading_id": "fool_four_cups",
    "reading_name": "Пропусната възможност",
    "reading_cards": "Глупак + 4 Чаши",
    "reading_combination": ["fool", "four_cups"],
    "reading_meaning": "Не виждаш какво ти се предлага",
    "reading_description": "Някой ти протяга ръка или ти предлага нещо, но ти си твърде зает с мечтите си, за да го забележиш.",
    "reading_advice": "Вдигни поглед. Може да пропускаш нещо важно."
  },
  {
    "reading_id": "fool_five_cups",
    "reading_name": "Непредвидена загуба",
    "reading_cards": "Глупак + 5 Чаши",
    "reading_combination": ["fool", "five_cups"],
    "reading_meaning": "Загуба, която не си очаквал",
    "reading_description": "Губиш нещо, без да си го предвидил. Удар от нищото, който те събаря.",
    "reading_advice": "Позволи си да скърбиш, после продължи напред."
  },
  {
    "reading_id": "fool_six_cups",
    "reading_name": "Носталгичен глупак",
    "reading_cards": "Глупак + 6 Чаши",
    "reading_combination": ["fool", "six_cups"],
    "reading_meaning": "Връщане към миналото",
    "reading_description": "Идеализираш миналото и искаш да се върнеш там. Но това, което помниш, не е съвсем реално.",
    "reading_advice": "Миналото е хубаво за спомен, но не живей в него."
  },
  {
    "reading_id": "fool_seven_cups",
    "reading_name": "Мечтател",
    "reading_cards": "Глупак + 7 Чаши",
    "reading_combination": ["fool", "seven_cups"],
    "reading_meaning": "Твърде много фантазии",
    "reading_description": "Живееш повече в мечтите, отколкото в реалността. Илюзии, които те отдалечават от истинския живот.",
    "reading_advice": "Слез на земята. Мечтите са хубави, но реалността е там, където живееш."
  },
  {
    "reading_id": "fool_eight_cups",
    "reading_name": "Тръгваш без посока",
    "reading_cards": "Глупак + 8 Чаши",
    "reading_combination": ["fool", "eight_cups"],
    "reading_meaning": "Напускаш, без да знаеш накъде",
    "reading_description": "Решаваш да оставиш всичко и да тръгнеш, но нямаш план. Просто вървиш, без да знаеш накъде.",
    "reading_advice": "Понякога тръгването е по-важно от знанието къде отиваш."
  },
  {
    "reading_id": "fool_nine_cups",
    "reading_name": "Сбъдната мечта",
    "reading_cards": "Глупак + 9 Чаши",
    "reading_combination": ["fool", "nine_cups"],
    "reading_meaning": "Мечтата се сбъдва неочаквано",
    "reading_description": "Това, за което си мечтал, се сбъдва, без да си го очаквал. Щастие, което идва от нищото.",
    "reading_advice": "Наслади се на момента. Ти го заслужаваш."
  },
  {
    "reading_id": "fool_ten_cups",
    "reading_name": "Неочаквано семейно щастие",
    "reading_cards": "Глупак + 10 Чаши",
    "reading_combination": ["fool", "ten_cups"],
    "reading_meaning": "Щастието идва, когато не го търсиш",
    "reading_description": "Семейно щастие и хармония, които не си очаквал. Любов, която те намира, без да я търсиш.",
    "reading_advice": "Бъди благодарен за този дар."
  },
  {
    "reading_id": "fool_ace_swords",
    "reading_name": "Истината изненадва",
    "reading_cards": "Глупак + Асо Мечове",
    "reading_combination": ["fool", "ace_swords"],
    "reading_meaning": "Внезапно прозрение",
    "reading_description": "Изведнъж разбираш истината за нещо важно. Прозрение, което идва от нищото и променя всичко.",
    "reading_advice": "Истината може да е трудна, но винаги е за добро."
  },
  {
    "reading_id": "fool_two_swords",
    "reading_name": "Несигурен глупак",
    "reading_cards": "Глупак + 2 Мечове",
    "reading_combination": ["fool", "two_swords"],
    "reading_meaning": "Не знаеш какво да избереш",
    "reading_description": "Изправен си пред избор, но нямаш достатъчно информация. Чувстваш се объркан и несигурен.",
    "reading_advice": "Понякога е по-добре да не избираш, отколкото да избереш грешно."
  },
  {
    "reading_id": "fool_three_swords",
    "reading_name": "Неочаквана болка",
    "reading_cards": "Глупак + 3 Мечове",
    "reading_combination": ["fool", "three_swords"],
    "reading_meaning": "Болка, която идва от нищото",
    "reading_description": "Някой или нещо те наранява неочаквано. Сърдечна болка, която не си предвидил.",
    "reading_advice": "Болката е част от живота. Дай си време да я преодолееш."
  },
  {
    "reading_id": "fool_four_swords",
    "reading_name": "Принудителна почивка",
    "reading_cards": "Глупак + 4 Мечове",
    "reading_combination": ["fool", "four_swords"],
    "reading_meaning": "Трябва да спреш",
    "reading_description": "Тялото или умът ти казват спри, но ти искаш да продължаваш. Налага се почивка, която не си планирал.",
    "reading_advice": "Спри, когато трябва, не когато искаш."
  },
  {
    "reading_id": "fool_five_swords",
    "reading_name": "Глупава победа",
    "reading_cards": "Глупак + 5 Мечове",
    "reading_combination": ["fool", "five_swords"],
    "reading_meaning": "Печелиш, но губиш",
    "reading_description": "Успяваш да спечелиш конфликт, но по начин, който те кара да се чувстваш зле. Победата не си струваше.",
    "reading_advice": "Понякога е по-добре да загубиш, отколкото да спечелиш по грешен начин."
  },
  {
    "reading_id": "fool_six_swords",
    "reading_name": "Път към неизвестното",
    "reading_cards": "Глупак + 6 Мечове",
    "reading_combination": ["fool", "six_swords"],
    "reading_meaning": "Тръгваш към ново място",
    "reading_description": "Предстои ти пътуване или преместване, но не знаеш какво ще намериш там. Вълнение и страх.",
    "reading_advice": "Понякога най-хубавите неща те чакат там, където не си бил."
  },
  {
    "reading_id": "fool_seven_swords",
    "reading_name": "Наивна измама",
    "reading_cards": "Глупак + 7 Мечове",
    "reading_combination": ["fool", "seven_swords"],
    "reading_meaning": "Лесно те мамят",
    "reading_description": "Попадаш на измама, защото си твърде доверчив. Някой се възползва от наивността ти.",
    "reading_advice": "Доверието е хубаво, но проверката е по-добра."
  },
  {
    "reading_id": "fool_eight_swords",
    "reading_name": "Глупак в капан",
    "reading_cards": "Глупак + 8 Мечове",
    "reading_combination": ["fool", "eight_swords"],
    "reading_meaning": "Сам се вкарваш в капан",
    "reading_description": "Със собствените си решения се озоваваш в ситуация, от която няма изход. Самоизолация.",
    "reading_advice": "Понякога най-големият враг си ти самият."
  },
  {
    "reading_id": "fool_nine_swords",
    "reading_name": "Глупашки тревоги",
    "reading_cards": "Глупак + 9 Мечове",
    "reading_combination": ["fool", "nine_swords"],
    "reading_meaning": "Тревожиш се за неща, които не зависи от теб",
    "reading_description": "Умът ти се върти около проблеми, повечето от които си ги измисляш. Безсъние от глупости.",
    "reading_advice": "Повечето неща, за които се тревожиш, никога не се случват."
  },
  {
    "reading_id": "fool_ten_swords",
    "reading_name": "Глупашки край",
    "reading_cards": "Глупак + 10 Мечове",
    "reading_combination": ["fool", "ten_swords"],
    "reading_meaning": "Край, който сам си причини",
    "reading_description": "Със собствените си грешни решения стигаш до пълен срив. Край, който можеше да се избегне.",
    "reading_advice": "От грешките се учи. Следващият път ще знаеш."
  },
  {
    "reading_id": "fool_ace_pentacles",
    "reading_name": "Неочакван доход",
    "reading_cards": "Глупак + Асо Пентакли",
    "reading_combination": ["fool", "ace_pentacles"],
    "reading_meaning": "Пари идват от нищото",
    "reading_description": "Получаваш неочаквани пари или финансова възможност. Късмет, който не си очаквал.",
    "reading_advice": "Използвай ги разумно, не ги прахосвай."
  },
  {
    "reading_id": "fool_two_pentacles",
    "reading_name": "Финансово жонглиране",
    "reading_cards": "Глупак + 2 Пентакли",
    "reading_combination": ["fool", "two_pentacles"],
    "reading_meaning": "Оцеляваш финансово",
    "reading_description": "Едва свързваш двата края, но някак се справяш. Жонглираш с финанси, без да знаеш точно как.",
    "reading_advice": "Научи се да планираш, не разчитай само на късмет."
  },
  {
    "reading_id": "fool_three_pentacles",
    "reading_name": "Учиш се в движение",
    "reading_cards": "Глупак + 3 Пентакли",
    "reading_combination": ["fool", "three_pentacles"],
    "reading_meaning": "Учиш се докато работиш",
    "reading_description": "Започваш нещо ново, без да имаш нужните умения, но учиш в процеса. Трудно, но възможно.",
    "reading_advice": "Не се страхувай да не знаеш. Важното е да искаш да научиш."
  },
  {
    "reading_id": "fool_four_pentacles",
    "reading_name": "Страх да похарчиш",
    "reading_cards": "Глупак + 4 Пентакли",
    "reading_combination": ["fool", "four_pentacles"],
    "reading_meaning": "Държиш парите, без да знаеш защо",
    "reading_description": "Получаваш пари, но се страхуваш да ги похарчиш. Вкопчваш се в тях от страх, не от разум.",
    "reading_advice": "Парите са за харчене, не за трупане. Намери баланс."
  },
  {
    "reading_id": "fool_five_pentacles",
    "reading_name": "Финансова наивност",
    "reading_cards": "Глупак + 5 Пентакли",
    "reading_combination": ["fool", "five_pentacles"],
    "reading_meaning": "Оставаш без пари",
    "reading_description": "Поради своя наивност или лоши решения оставаш без пари. Финансова криза, която можеше да се избегне.",
    "reading_advice": "Потърси помощ и учи от грешките."
  },
  {
    "reading_id": "fool_six_pentacles",
    "reading_name": "Щедър глупак",
    "reading_cards": "Глупак + 6 Пентакли",
    "reading_combination": ["fool", "six_pentacles"],
    "reading_meaning": "Даваш, без да мислиш",
    "reading_description": "Щедър си до степен, в която това ти вреди. Даваш на другите, без да мислиш за себе си.",
    "reading_advice": "Щедростта е хубаво нещо, но не забравяй себе си."
  },
  {
    "reading_id": "fool_seven_pentacles",
    "reading_name": "Нетърпелив инвеститор",
    "reading_cards": "Глупак + 7 Пентакли",
    "reading_combination": ["fool", "seven_pentacles"],
    "reading_meaning": "Искаш резултати веднага",
    "reading_description": "Инвестирал си време или пари в нещо, но искаш резултати веднага. Нямаш търпение да почакаш.",
    "reading_advice": "Добрите неща идват при тези, които умеят да чакат."
  },
  {
    "reading_id": "fool_eight_pentacles",
    "reading_name": "Учиш занаят",
    "reading_cards": "Глупак + 8 Пентакли",
    "reading_combination": ["fool", "eight_pentacles"],
    "reading_meaning": "Започваш да учиш ново умение",
    "reading_description": "С ентусиазъм се захващаш да учиш нещо ново. Нямаш опит, но имаш желание.",
    "reading_advice": "Постоянството е по-важно от таланта."
  },
  {
    "reading_id": "fool_nine_pentacles",
    "reading_name": "Неочаквана независимост",
    "reading_cards": "Глупак + 9 Пентакли",
    "reading_combination": ["fool", "nine_pentacles"],
    "reading_meaning": "Постигаш свобода без да искаш",
    "reading_description": "Озоваваш се в ситуация на финансова независимост, без да си го планирал. Приятна изненада.",
    "reading_advice": "Наслади се на свободата, но не я приемай за даденост."
  },
  {
    "reading_id": "fool_ten_pentacles",
    "reading_name": "Семейно наследство",
    "reading_cards": "Глупак + 10 Пентакли",
    "reading_combination": ["fool", "ten_pentacles"],
    "reading_meaning": "Получаваш нещо от семейството",
    "reading_description": "Получаваш наследство или семейна помощ, която не си очаквал. Сигурност, която идва от рода.",
    "reading_advice": "Бъди благодарен и предай нататък, когато можеш."
  },
  {
    "reading_id": "magician_ace_wands",
    "reading_name": "Творец с идея",
    "reading_cards": "Магьосник + Асо Жезли",
    "reading_combination": ["magician", "ace_wands"],
    "reading_meaning": "Нова идея и умения",
    "reading_description": "Имаш нова идея и всички умения да я реализираш. Силна комбинация за успех.",
    "reading_advice": "Действай сега, докато имаш и идеята, и силата."
  },
  {
    "reading_id": "magician_two_wands",
    "reading_name": "Умел избор",
    "reading_cards": "Магьосник + 2 Жезли",
    "reading_combination": ["magician", "two_wands"],
    "reading_meaning": "Избираш правилно",
    "reading_description": "Предстои ти избор и имаш всички умения да избереш правилно. Довери се на способностите си.",
    "reading_advice": "Избери с увереност. Ти знаеш какво правиш."
  },
  {
    "reading_id": "magician_three_wands",
    "reading_name": "Търпелив творец",
    "reading_cards": "Магьосник + 3 Жезли",
    "reading_combination": ["magician", "three_wands"],
    "reading_meaning": "Чакаш резултати",
    "reading_description": "Направил си всичко необходимо и сега чакаш резултати. Търпението е част от процеса.",
    "reading_advice": "Ти направи каквото зависи от теб. Останалото идва с времето."
  },
  {
    "reading_id": "magician_four_wands",
    "reading_name": "Празнуващ творец",
    "reading_cards": "Магьосник + 4 Жезли",
    "reading_combination": ["magician", "four_wands"],
    "reading_meaning": "Празнуваш успех",
    "reading_description": "Успяваш в начинанието си и има защо да празнуваш. Радост и удовлетворение.",
    "reading_advice": "Наслади се на успеха, после се захващай с новото."
  },
  {
    "reading_id": "magician_five_wands",
    "reading_name": "Творец в конфликт",
    "reading_cards": "Магьосник + 5 Жезли",
    "reading_combination": ["magician", "five_wands"],
    "reading_meaning": "Бориш се за идеята си",
    "reading_description": "Имаш добра идея, но трябва да се бориш за нея срещу съпротива. Не се предавай.",
    "reading_advice": "Бори се за идеята си, ако вярваш в нея."
  },
  {
    "reading_id": "magician_six_wands",
    "reading_name": "Победител",
    "reading_cards": "Магьосник + 6 Жезли",
    "reading_combination": ["magician", "six_wands"],
    "reading_meaning": "Успех и признание",
    "reading_description": "Идеята ти печели признание и успех. Всички виждат таланта ти.",
    "reading_advice": "Приеми аплодисментите с благодарност и смирение."
  },
  {
    "reading_id": "magician_seven_wands",
    "reading_name": "Защитаваш позиция",
    "reading_cards": "Магьосник + 7 Жезли",
    "reading_combination": ["magician", "seven_wands"],
    "reading_meaning": "Отстояваш постигнатото",
    "reading_description": "След успеха идват тези, които искат да ти го отнемат. Защитавай позицията си.",
    "reading_advice": "Не позволявай на никого да ти отнеме това, което си построил."
  },
  {
    "reading_id": "magician_eight_wands",
    "reading_name": "Бърз успех",
    "reading_cards": "Магьосник + 8 Жезли",
    "reading_combination": ["magician", "eight_wands"],
    "reading_meaning": "Всичко се случва бързо",
    "reading_description": "Успехът идва бързо, почти светкавично. Всичко се нарежда за миг.",
    "reading_advice": "Язди вълната, докато е висока."
  },
  {
    "reading_id": "magician_nine_wands",
    "reading_name": "Упорит творец",
    "reading_cards": "Магьосник + 9 Жезли",
    "reading_combination": ["magician", "nine_wands"],
    "reading_meaning": "Не се предаваш",
    "reading_description": "Въпреки трудностите, продължаваш. Упоритост, която рано или късно ще се отплати.",
    "reading_advice": "Дръж се. Почти си там."
  },
  {
    "reading_id": "magician_ten_wands",
    "reading_name": "Претоварен творец",
    "reading_cards": "Магьосник + 10 Жезли",
    "reading_combination": ["magician", "ten_wands"],
    "reading_meaning": "Носиш твърде много",
    "reading_description": "Успехът ти донесе твърде много отговорности. Претоварен си и имаш нужда от помощ.",
    "reading_advice": "Делегирай. Не можеш да правиш всичко сам."
  },
  {
    "reading_id": "magician_ace_cups",
    "reading_name": "Любовен магьосник",
    "reading_cards": "Магьосник + Асо Чаши",
    "reading_combination": ["magician", "ace_cups"],
    "reading_meaning": "Създаваш любов",
    "reading_description": "Имаш способността да привличаш любов и романтика. Харизма и емоционална интелигентност.",
    "reading_advice": "Използвай този дар с чисто сърце."
  },
  {
    "reading_id": "magician_two_cups",
    "reading_name": "Създаваш връзка",
    "reading_cards": "Магьосник + 2 Чаши",
    "reading_combination": ["magician", "two_cups"],
    "reading_meaning": "Изграждаш връзка",
    "reading_description": "Умееш да създаваш и поддържаш връзки. Умения за комуникация и емпатия.",
    "reading_advice": "Използвай уменията си, за да задълбочаваш връзките."
  },
  {
    "reading_id": "magician_three_cups",
    "reading_name": "Животът на купона",
    "reading_cards": "Магьосник + 3 Чаши",
    "reading_combination": ["magician", "three_cups"],
    "reading_meaning": "Носиш радост на другите",
    "reading_description": "Умееш да създаваш празнично настроение и радост около себе си. Хората обичат да са с теб.",
    "reading_advice": "Споделяй радостта си щедро."
  },
  {
    "reading_id": "magician_four_cups",
    "reading_name": "Творец в скука",
    "reading_cards": "Магьосник + 4 Чаши",
    "reading_combination": ["magician", "four_cups"],
    "reading_meaning": "Не виждаш възможностите",
    "reading_description": "Имаш талант, но не виждаш как да го използваш. Скука и незадоволство въпреки дарбите.",
    "reading_advice": "Погледни наоколо. Възможностите са пред теб."
  },
  {
    "reading_id": "magician_five_cups",
    "reading_name": "Талантлив, но тъжен",
    "reading_cards": "Магьосник + 5 Чаши",
    "reading_combination": ["magician", "five_cups"],
    "reading_meaning": "Успех, помрачен от загуба",
    "reading_description": "Имаш таланти, но скорошна загуба ти пречи да се радваш на тях. Тъга, която замъглява всичко.",
    "reading_advice": "Позволи си да скърбиш, но не забравяй какво имаш."
  },
  {
    "reading_id": "magician_six_cups",
    "reading_name": "Носталгичен творец",
    "reading_cards": "Магьосник + 6 Чаши",
    "reading_combination": ["magician", "six_cups"],
    "reading_meaning": "Черпиш вдъхновение от миналото",
    "reading_description": "Използваш спомени и минал опит като вдъхновение за творчество. Носталгия, която храни таланта.",
    "reading_advice": "Цени миналото, но твори в настоящето."
  },
  {
    "reading_id": "magician_seven_cups",
    "reading_name": "Творец мечтател",
    "reading_cards": "Магьосник + 7 Чаши",
    "reading_combination": ["magician", "seven_cups"],
    "reading_meaning": "Твърде много идеи",
    "reading_description": "Имаш безброй идеи, но ти е трудно да избереш една и да я реализираш. Разпиляваш таланта си.",
    "reading_advice": "Избери една идея и работи по нея докрай."
  },
  {
    "reading_id": "magician_eight_cups",
    "reading_name": "Творецът тръгва",
    "reading_cards": "Магьосник + 8 Чаши",
    "reading_combination": ["magician", "eight_cups"],
    "reading_meaning": "Напускаш, за да търсиш ново вдъхновение",
    "reading_description": "Решаваш да оставиш всичко и да тръгнеш да търсиш ново вдъхновение. Творческа криза.",
    "reading_advice": "Понякога тръгването е най-доброто за таланта."
  },
  {
    "reading_id": "magician_nine_cups",
    "reading_name": "Сбъдната творческа мечта",
    "reading_cards": "Магьосник + 9 Чаши",
    "reading_combination": ["magician", "nine_cups"],
    "reading_meaning": "Постигаш желаното",
    "reading_description": "Творческата ти мечта се сбъдва. Удовлетворение и радост от постигнатото.",
    "reading_advice": "Наслади се на успеха. Ти го заслужи."
  },
  {
    "reading_id": "magician_ten_cups",
    "reading_name": "Семеен творец",
    "reading_cards": "Магьосник + 10 Чаши",
    "reading_combination": ["magician", "ten_cups"],
    "reading_meaning": "Талант, споделен със семейството",
    "reading_description": "Използваш таланта си, за да създаваш щастие за семейството си. Хармония и любов.",
    "reading_advice": "Семейството е най-добрата публика."
  },
  {
    "reading_id": "magician_ace_swords",
    "reading_name": "Истината като оръжие",
    "reading_cards": "Магьосник + Асо Мечове",
    "reading_combination": ["magician", "ace_swords"],
    "reading_meaning": "Използваш истината",
    "reading_description": "Имаш способността да виждаш и казваш истината. Сила, която може да лекува или да наранява.",
    "reading_advice": "Използвай истината с мъдрост и състрадание."
  },
  {
    "reading_id": "magician_two_swords",
    "reading_name": "Ум в застой",
    "reading_cards": "Магьосник + 2 Мечове",
    "reading_combination": ["magician", "two_swords"],
    "reading_meaning": "Имаш умения, но не знаеш какво да избереш",
    "reading_description": "Притежаваш интелект и способности, но си блокиран от нерешителност. Не можеш да избереш посока.",
    "reading_advice": "Понякога всеки избор е по-добър от липсата на избор."
  },
  {
    "reading_id": "magician_three_swords",
    "reading_name": "Болен ум",
    "reading_cards": "Магьосник + 3 Мечове",
    "reading_combination": ["magician", "three_swords"],
    "reading_meaning": "Интелигентност, която носи болка",
    "reading_description": "Твърде много мислиш и анализираш, което ти носи болка и страдание. Умът те измъчва.",
    "reading_advice": "Научи се да спираш ума. Не всичко се нуждае от анализ."
  },
  {
    "reading_id": "magician_four_swords",
    "reading_name": "Умът почива",
    "reading_cards": "Магьосник + 4 Мечове",
    "reading_combination": ["magician", "four_swords"],
    "reading_meaning": "Почивка от мислене",
    "reading_description": "Спираш да мислиш и анализираш, за да си почине умът. Медитация, сън, отпускане.",
    "reading_advice": "Най-добрите идеи идват, когато умът е спокоен."
  },
  {
    "reading_id": "magician_five_swords",
    "reading_name": "Интелектуална победа",
    "reading_cards": "Магьосник + 5 Мечове",
    "reading_combination": ["magician", "five_swords"],
    "reading_meaning": "Побеждаваш с ума си",
    "reading_description": "Използваш интелекта си, за да победиш в конфликт. Но победата може да има горчив вкус.",
    "reading_advice": "Питай се дали си струва да нараниш другите, за да си прав."
  },
  {
    "reading_id": "magician_six_swords",
    "reading_name": "Умът пътува",
    "reading_cards": "Магьосник + 6 Мечове",
    "reading_combination": ["magician", "six_swords"],
    "reading_meaning": "Търсиш нови идеи",
    "reading_description": "Пътуваш или сменяш средата, за да намериш нови идеи и вдъхновение. Умът се обновява.",
    "reading_advice": "Новата среда носи нови мисли."
  },
  {
    "reading_id": "magician_seven_swords",
    "reading_name": "Хитър ум",
    "reading_cards": "Магьосник + 7 Мечове",
    "reading_combination": ["magician", "seven_swords"],
    "reading_meaning": "Използваш ума си за измама",
    "reading_description": "Интелигентност, използвана за манипулация и измама. Можеш да излезеш сух от водата, но с цена.",
    "reading_advice": "Измамата винаги се връща като бумеранг."
  },
  {
    "reading_id": "magician_eight_swords",
    "reading_name": "Ум в капан",
    "reading_cards": "Магьосник + 8 Мечове",
    "reading_combination": ["magician", "eight_swords"],
    "reading_meaning": "Блокиран интелект",
    "reading_description": "Чувстваш, че умът ти е в капан. Не можеш да мислиш ясно, блокиран си от страхове.",
    "reading_advice": "Страхът е най-големият враг на ума."
  },
  {
    "reading_id": "magician_nine_swords",
    "reading_name": "Ум, който не спи",
    "reading_cards": "Магьосник + 9 Мечове",
    "reading_combination": ["magician", "nine_swords"],
    "reading_meaning": "Безсъние от мисли",
    "reading_description": "Умът ти не спира да работи, дори когато трябва да почива. Тревоги, анализи, безсъние.",
    "reading_advice": "Научи се да изключваш. Медитация, дишане, разходка."
  },
  {
    "reading_id": "magician_ten_swords",
    "reading_name": "Умствен срив",
    "reading_cards": "Магьосник + 10 Мечове",
    "reading_combination": ["magician", "ten_swords"],
    "reading_meaning": "Прегаряне на ума",
    "reading_description": "Твърде много мислене и анализ довеждат до пълен умствен срив. Бърнаут, депресия, изтощение.",
    "reading_advice": "Потърси помощ. Не е нужно да се справяш сам."
  },
  {
    "reading_id": "magician_ace_pentacles",
    "reading_name": "Създаваш богатство",
    "reading_cards": "Магьосник + Асо Пентакли",
    "reading_combination": ["magician", "ace_pentacles"],
    "reading_meaning": "Нова финансова възможност",
    "reading_description": "Имаш уменията да създадеш нова финансова възможност. Успех, който зависи от теб.",
    "reading_advice": "Действай сега. Имаш всичко необходимо."
  },
  {
    "reading_id": "magician_two_pentacles",
    "reading_name": "Финансов жонгльор",
    "reading_cards": "Магьосник + 2 Пентакли",
    "reading_combination": ["magician", "two_pentacles"],
    "reading_meaning": "Управляваш финанси",
    "reading_description": "Умееш да управляваш парите си и да жонглираш с различни финансови задължения. Баланс и умение.",
    "reading_advice": "Продължавай да балансираш, но мисли и за бъдещето."
  },
  {
    "reading_id": "magician_three_pentacles",
    "reading_name": "Творец в екип",
    "reading_cards": "Магьосник + 3 Пентакли",
    "reading_combination": ["magician", "three_pentacles"],
    "reading_meaning": "Работиш с други",
    "reading_description": "Използваш уменията си в екипна работа. Сътрудничество, което носи плодове.",
    "reading_advice": "Най-добрите резултати идват от добър екип."
  },
  {
    "reading_id": "magician_four_pentacles",
    "reading_name": "Държиш парите",
    "reading_cards": "Магьосник + 4 Пентакли",
    "reading_combination": ["magician", "four_pentacles"],
    "reading_meaning": "Контрол върху финанси",
    "reading_description": "Умееш да спестяваш и да контролираш парите си. Понякога обаче хватката е прекалено стегната.",
    "reading_advice": "Пази, но не се вкопчвай. Парите са за живот."
  },
  {
    "reading_id": "magician_five_pentacles",
    "reading_name": "Финансови трудности",
    "reading_cards": "Магьосник + 5 Пентакли",
    "reading_combination": ["magician", "five_pentacles"],
    "reading_meaning": "Бориш се финансово",
    "reading_description": "Въпреки уменията си, изпитваш финансови трудности. Нещо не работи както трябва.",
    "reading_advice": "Потърси нов подход. Може би не използваш уменията си правилно."
  },
  {
    "reading_id": "magician_six_pentacles",
    "reading_name": "Щедър творец",
    "reading_cards": "Магьосник + 6 Пентакли",
    "reading_combination": ["magician", "six_pentacles"],
    "reading_meaning": "Споделяш успеха",
    "reading_description": "Успяваш и споделяш успеха си с другите. Щедрост, която се връща многократно.",
    "reading_advice": "Колкото повече даваш, толкова повече получаваш."
  },
  {
    "reading_id": "magician_seven_pentacles",
    "reading_name": "Търпелив инвеститор",
    "reading_cards": "Магьосник + 7 Пентакли",
    "reading_combination": ["magician", "seven_pentacles"],
    "reading_meaning": "Чакаш резултати",
    "reading_description": "Инвестирал си време и усилия и сега чакаш резултати. Търпението е част от стратегията.",
    "reading_advice": "Чакай, но не спирай да се подготвяш за следващата стъпка."
  },
  {
    "reading_id": "magician_eight_pentacles",
    "reading_name": "Усъвършенстваш занаята",
    "reading_cards": "Магьосник + 8 Пентакли",
    "reading_combination": ["magician", "eight_pentacles"],
    "reading_meaning": "Развиваш умения",
    "reading_description": "Работиш върху усъвършенстването на уменията си. Постоянство и отдаденост.",
    "reading_advice": "Практиката прави майстора. Не спирай да учиш."
  },
  {
    "reading_id": "magician_nine_pentacles",
    "reading_name": "Независим творец",
    "reading_cards": "Магьосник + 9 Пентакли",
    "reading_combination": ["magician", "nine_pentacles"],
    "reading_meaning": "Финансова свобода",
    "reading_description": "Постигнал си финансова независимост чрез уменията си. Наслаждаваш се на плодовете на труда си.",
    "reading_advice": "Наслади се на свободата, но не спирай да твориш."
  },
  {
    "reading_id": "magician_ten_pentacles",
    "reading_name": "Семейно богатство",
    "reading_cards": "Магьосник + 10 Пентакли",
    "reading_combination": ["magician", "ten_pentacles"],
    "reading_meaning": "Осигуряваш семейството",
    "reading_description": "Използваш уменията си, за да осигуриш семейството си и да създадеш наследство. Мъдрост и грижа.",
    "reading_advice": "Грижи се за семейството си. То е най-ценното."
  },
  {
    "reading_id": "high_priestess_ace_wands",
    "reading_name": "Интуитивна искра",
    "reading_cards": "Върховна жрица + Асо Жезли",
    "reading_combination": ["high_priestess", "ace_wands"],
    "reading_meaning": "Идея от подсъзнанието",
    "reading_description": "Нова идея или проект идва не от разума, а от дълбока интуиция. Вдъхновение отвътре.",
    "reading_advice": "Довери се на вътрешния си глас, когато избираш нов проект."
  },
  {
    "reading_id": "high_priestess_two_wands",
    "reading_name": "Интуитивен избор",
    "reading_cards": "Върховна жрица + 2 Жезли",
    "reading_combination": ["high_priestess", "two_wands"],
    "reading_meaning": "Избираш с вътрешен глас",
    "reading_description": "Предстои ти избор и интуицията ще ти каже кой е правилният. Слушай я.",
    "reading_advice": "Разумът често греши, интуицията - рядко."
  },
  {
    "reading_id": "high_priestess_three_wands",
    "reading_name": "Интуитивно чакане",
    "reading_cards": "Върховна жрица + 3 Жезли",
    "reading_combination": ["high_priestess", "three_wands"],
    "reading_meaning": "Чакаш с вътрешна увереност",
    "reading_description": "Чакаш резултати, но не с нетърпение, а с дълбока вътрешна увереност, че всичко ще бъде наред.",
    "reading_advice": "Увереността идва отвътре, не отвън."
  },
  {
    "reading_id": "high_priestess_four_wands",
    "reading_name": "Интуитивен празник",
    "reading_cards": "Върховна жрица + 4 Жезли",
    "reading_combination": ["high_priestess", "four_wands"],
    "reading_meaning": "Празнуваш, воден от сърцето",
    "reading_description": "Празник, който идва от сърцето, не от задължение. Истинска радост, която усещаш дълбоко.",
    "reading_advice": "Празнувай, когато душата ти иска, не само когато календарът показва."
  },
  {
    "reading_id": "high_priestess_five_wands",
    "reading_name": "Интуитивен конфликт",
    "reading_cards": "Върховна жрица + 5 Жезли",
    "reading_combination": ["high_priestess", "five_wands"],
    "reading_meaning": "Усещаш конфликта преди да почне",
    "reading_description": "Интуицията ти подсказва, че идва конфликт. Можеш да се подготвиш или да го избегнеш.",
    "reading_advice": "Когато усетиш буря, потърси подслон."
  },
  {
    "reading_id": "high_priestess_six_wands",
    "reading_name": "Интуитивен успех",
    "reading_cards": "Върховна жрица + 6 Жезли",
    "reading_combination": ["high_priestess", "six_wands"],
    "reading_meaning": "Усещаш победата преди да дойде",
    "reading_description": "Знаеш, че ще успееш, още преди да са дошли резултатите. Вътрешна увереност.",
    "reading_advice": "Успехът започва в ума и сърцето."
  },
  {
    "reading_id": "high_priestess_seven_wands",
    "reading_name": "Интуитивна защита",
    "reading_cards": "Върховна жрица + 7 Жезли",
    "reading_combination": ["high_priestess", "seven_wands"],
    "reading_meaning": "Усещаш нападението преди да дойде",
    "reading_description": "Интуицията ти подсказва, че някой ще те атакува. Можеш да се подготвиш.",
    "reading_advice": "Най-добрата защита е да знаеш кога идва нападението."
  },
  {
    "reading_id": "high_priestess_eight_wands",
    "reading_name": "Интуитивна скорост",
    "reading_cards": "Върховна жрица + 8 Жезли",
    "reading_combination": ["high_priestess", "eight_wands"],
    "reading_meaning": "Усещаш бързите промени",
    "reading_description": "Усещаш, че нещата ще се развият бързо. Интуицията ти те подготвя за скоростта.",
    "reading_advice": "Когато усетиш вятъра, разтвори платна."
  },
  {
    "reading_id": "high_priestess_nine_wands",
    "reading_name": "Интуитивна упоритост",
    "reading_cards": "Върховна жрица + 9 Жезли",
    "reading_combination": ["high_priestess", "nine_wands"],
    "reading_meaning": "Знаеш, че трябва да издържиш",
    "reading_description": "Вътрешният ти глас ти казва да не се предаваш, въпреки трудностите. Дръж се.",
    "reading_advice": "Когато интуицията казва още малко, слушай я."
  },
  {
    "reading_id": "high_priestess_ten_wands",
    "reading_name": "Интуитивно претоварване",
    "reading_cards": "Върховна жрица + 10 Жезли",
    "reading_combination": ["high_priestess", "ten_wands"],
    "reading_meaning": "Усещаш, че носиш твърде много",
    "reading_description": "Интуицията ти подсказва, че си претоварен. Тялото и умът ти крещят за почивка.",
    "reading_advice": "Спри и слушай. Тялото ти знае от какво има нужда."
  },
  {
    "reading_id": "high_priestess_ace_cups",
    "reading_name": "Интуитивна любов",
    "reading_cards": "Върховна жрица + Асо Чаши",
    "reading_combination": ["high_priestess", "ace_cups"],
    "reading_meaning": "Усещаш новата любов",
    "reading_description": "Усещаш, че любов идва в живота ти, още преди да се е появила. Готви се да я посрещнеш.",
    "reading_advice": "Когато усетиш любовта с интуицията си, тя вече е на път."
  },
  {
    "reading_id": "high_priestess_two_cups",
    "reading_name": "Интуитивна връзка",
    "reading_cards": "Върховна жрица + 2 Чаши",
    "reading_combination": ["high_priestess", "two_cups"],
    "reading_meaning": "Усещаш сродна душа",
    "reading_description": "Срещаш някого и веднага усещаш дълбока връзка. Интуицията ти казва, че този човек е специален.",
    "reading_advice": "Довери се на първото усещане. То рядко лъже."
  },
  {
    "reading_id": "high_priestess_three_cups",
    "reading_name": "Интуитивна радост",
    "reading_cards": "Върховна жрица + 3 Чаши",
    "reading_combination": ["high_priestess", "three_cups"],
    "reading_meaning": "Усещаш предстоящ празник",
    "reading_description": "Интуицията ти подсказва, че предстои повод за радост и празнуване. Подготвяй се.",
    "reading_advice": "Радостта идва. Отвори сърцето си за нея."
  },
  {
    "reading_id": "high_priestess_four_cups",
    "reading_name": "Интуитивна скука",
    "reading_cards": "Върховна жрица + 4 Чаши",
    "reading_combination": ["high_priestess", "four_cups"],
    "reading_meaning": "Усещаш, че нещо не е наред",
    "reading_description": "Усещаш неудовлетворение, без да разбираш точно защо. Интуицията търси нещо повече.",
    "reading_advice": "Търси в себе си отговора за неудовлетворението."
  },
  {
    "reading_id": "high_priestess_five_cups",
    "reading_name": "Интуитивна тъга",
    "reading_cards": "Върховна жрица + 5 Чаши",
    "reading_combination": ["high_priestess", "five_cups"],
    "reading_meaning": "Усещаш загубата преди да дойде",
    "reading_description": "Интуицията ти подсказва, че предстои загуба или разочарование. Подготви се емоционално.",
    "reading_advice": "Понякога знанието, че болката идва, помага да я посрещнеш по-леко."
  },
  {
    "reading_id": "high_priestess_six_cups",
    "reading_name": "Интуитивна носталгия",
    "reading_cards": "Върховна жрица + 6 Чаши",
    "reading_combination": ["high_priestess", "six_cups"],
    "reading_meaning": "Усещаш връзка с миналото",
    "reading_description": "Интуицията те връща към миналото. Спомени, които носят важни послания за настоящето.",
    "reading_advice": "Слушай какво ти казват спомените. Те имат урок за теб."
  },
  {
    "reading_id": "high_priestess_seven_cups",
    "reading_name": "Интуитивни илюзии",
    "reading_cards": "Върховна жрица + 7 Чаши",
    "reading_combination": ["high_priestess", "seven_cups"],
    "reading_meaning": "Интуицията е замъглена",
    "reading_description": "Интуицията ти е объркана от илюзии и желания. Трудно различаваш истина от фантазия.",
    "reading_advice": "Изчисти ума си от желания, за да чуеш истинския вътрешен глас."
  },
  {
    "reading_id": "high_priestess_eight_cups",
    "reading_name": "Интуитивно тръгване",
    "reading_cards": "Върховна жрица + 8 Чаши",
    "reading_combination": ["high_priestess", "eight_cups"],
    "reading_meaning": "Усещаш, че трябва да тръгнеш",
    "reading_description": "Вътрешният ти глас ти казва, че е време да оставиш нещо и да продължиш напред. Слушай го.",
    "reading_advice": "Когато интуицията казва тръгвай, тръгвай."
  },
  {
    "reading_id": "high_priestess_nine_cups",
    "reading_name": "Интуитивно желание",
    "reading_cards": "Върховна жрица + 9 Чаши",
    "reading_combination": ["high_priestess", "nine_cups"],
    "reading_meaning": "Усещаш, че желанието ще се сбъдне",
    "reading_description": "Интуицията ти подсказва, че мечтата ти е на път да се сбъдне. Вярвай ѝ.",
    "reading_advice": "Когато вътрешният глас казва да, значи е време."
  },
  {
    "reading_id": "high_priestess_ten_cups",
    "reading_name": "Интуитивно щастие",
    "reading_cards": "Върховна жрица + 10 Чаши",
    "reading_combination": ["high_priestess", "ten_cups"],
    "reading_meaning": "Усещаш семейна хармония",
    "reading_description": "Усещаш, че семейството и домът ти са в хармония. Благодарност и мир.",
    "reading_advice": "Цени тези моменти на вътрешен мир. Те са безценни."
  },
  {
    "reading_id": "high_priestess_ace_swords",
    "reading_name": "Интуитивна истина",
    "reading_cards": "Върховна жрица + Асо Мечове",
    "reading_combination": ["high_priestess", "ace_swords"],
    "reading_meaning": "Истината идва отвътре",
    "reading_description": "Прозрение, което идва не от външни източници, а от дълбока вътрешна истина. Пробуждане.",
    "reading_advice": "Най-важната истина е тази, която откриваш сам в себе си."
  },
  {
    "reading_id": "high_priestess_two_swords",
    "reading_name": "Интуитивно съмнение",
    "reading_cards": "Върховна жрица + 2 Мечове",
    "reading_combination": ["high_priestess", "two_swords"],
    "reading_meaning": "Вътрешният глас мълчи",
    "reading_description": "Интуицията ти не дава ясен отговор. Сякаш вътрешният глас мълчи или е замъглен.",
    "reading_advice": "Понякога мълчанието също е отговор."
  },
  {
    "reading_id": "high_priestess_three_swords",
    "reading_name": "Интуитивна болка",
    "reading_cards": "Върховна жрица + 3 Мечове",
    "reading_combination": ["high_priestess", "three_swords"],
    "reading_meaning": "Усещаш болката преди да дойде",
    "reading_description": "Интуицията ти подсказва, че предстои емоционална болка. Сърцето ти се подготвя.",
    "reading_advice": "Понякога знанието за предстояща болка помага да я посрещнеш по-леко."
  },
  {
    "reading_id": "high_priestess_four_swords",
    "reading_name": "Интуитивна почивка",
    "reading_cards": "Върховна жрица + 4 Мечове",
    "reading_combination": ["high_priestess", "four_swords"],
    "reading_meaning": "Знаеш, че трябва да спреш",
    "reading_description": "Вътрешният глас ти казва да спреш и да си починеш. Слушай го, преди да се претовариш.",
    "reading_advice": "Почивката не е лукс, а необходимост."
  },
  {
    "reading_id": "high_priestess_five_swords",
    "reading_name": "Интуитивен конфликт",
    "reading_cards": "Върховна жрица + 5 Мечове",
    "reading_combination": ["high_priestess", "five_swords"],
    "reading_meaning": "Усещаш, че битката не си струва",
    "reading_description": "Интуицията ти подсказва, че този конфликт не си струва да го водиш. Отстъпи.",
    "reading_advice": "Понякога най-добрата победа е да не влизаш в битка."
  },
  {
    "reading_id": "high_priestess_six_swords",
    "reading_name": "Интуитивно пътуване",
    "reading_cards": "Върховна жрица + 6 Мечове",
    "reading_combination": ["high_priestess", "six_swords"],
    "reading_meaning": "Усещаш, че пътят е правилен",
    "reading_description": "Интуицията ти казва, че посоката, в която тръгваш, е правилната. Довери ѝ се.",
    "reading_advice": "Когато вътрешният компас показва посока, следвай го."
  },
  {
    "reading_id": "high_priestess_seven_swords",
    "reading_name": "Интуитивна измама",
    "reading_cards": "Върховна жрица + 7 Мечове",
    "reading_combination": ["high_priestess", "seven_swords"],
    "reading_meaning": "Усещаш, че те мамят",
    "reading_description": "Интуицията ти подсказва, че някой не ти казва истината. Довери се на това усещане.",
    "reading_advice": "Когато нещо ти се струва нередно, най-вероятно е така."
  },
  {
    "reading_id": "high_priestess_eight_swords",
    "reading_name": "Интуитивен капан",
    "reading_cards": "Върховна жрица + 8 Мечове",
    "reading_combination": ["high_priestess", "eight_swords"],
    "reading_meaning": "Усещаш, че си в капан",
    "reading_description": "Интуицията ти подсказва, че си в ситуация, от която трудно ще излезеш. Търси изход.",
    "reading_advice": "Ако усещаш капан, значи той съществува. Потърси вратата."
  },
  {
    "reading_id": "high_priestess_nine_swords",
    "reading_name": "Интуитивна тревога",
    "reading_cards": "Върховна жрица + 9 Мечове",
    "reading_combination": ["high_priestess", "nine_swords"],
    "reading_meaning": "Усещаш тревога, без да знаеш защо",
    "reading_description": "Интуицията ти подсказва, че нещо не е наред, но не можеш да определиш какво. Тревога без обект.",
    "reading_advice": "Понякога тревогата идва отвътре, не отвън. Потърси причината в себе си."
  },
  {
    "reading_id": "high_priestess_ten_swords",
    "reading_name": "Интуитивен край",
    "reading_cards": "Върховна жрица + 10 Мечове",
    "reading_combination": ["high_priestess", "ten_swords"],
    "reading_meaning": "Усещаш, че краят идва",
    "reading_description": "Интуицията ти подсказва, че нещо важно приключва. Подготви се за промяна.",
    "reading_advice": "Когато усетиш края, не се съпротивлявай. Приеми го като ново начало."
  },
  {
    "reading_id": "high_priestess_ace_pentacles",
    "reading_name": "Интуитивен доход",
    "reading_cards": "Върховна жрица + Асо Пентакли",
    "reading_combination": ["high_priestess", "ace_pentacles"],
    "reading_meaning": "Усещаш финансова възможност",
    "reading_description": "Интуицията ти подсказва, че предстои финансова възможност. Бъди готов да я хванеш.",
    "reading_advice": "Когато усетиш възможност с вътрешния си глас, не се колебай."
  },
  {
    "reading_id": "high_priestess_two_pentacles",
    "reading_name": "Интуитивен баланс",
    "reading_cards": "Върховна жрица + 2 Пентакли",
    "reading_combination": ["high_priestess", "two_pentacles"],
    "reading_meaning": "Усещаш кога да жонглираш",
    "reading_description": "Интуицията ти подсказва как да балансираш финансите си. Тя знае кога да даваш и кога да получаваш.",
    "reading_advice": "Довери се на вътрешното чувство за баланс."
  },
  {
    "reading_id": "high_priestess_three_pentacles",
    "reading_name": "Интуитивен екип",
    "reading_cards": "Върховна жрица + 3 Пентакли",
    "reading_combination": ["high_priestess", "three_pentacles"],
    "reading_meaning": "Усещаш на кого да се довериш",
    "reading_description": "Интуицията ти подсказва на кого да се довериш в екипна работа. Тя разпознава искреността.",
    "reading_advice": "Слушай вътрешния си глас, когато избираш партньори."
  },
  {
    "reading_id": "high_priestess_four_pentacles",
    "reading_name": "Интуитивно задържане",
    "reading_cards": "Върховна жрица + 4 Пентакли",
    "reading_combination": ["high_priestess", "four_pentacles"],
    "reading_meaning": "Усещаш кога да задържиш",
    "reading_description": "Интуицията ти подсказва кога е добре да спестяваш и кога да харчиш. Слушай я.",
    "reading_advice": "Вътрешният глас знае кога хватката е прекалено стегната."
  },
  {
    "reading_id": "high_priestess_five_pentacles",
    "reading_name": "Интуитивна загуба",
    "reading_cards": "Върховна жрица + 5 Пентакли",
    "reading_combination": ["high_priestess", "five_pentacles"],
    "reading_meaning": "Усещаш финансови затруднения",
    "reading_description": "Интуицията ти подсказва, че предстоят финансови трудности. Подготви се.",
    "reading_advice": "Когато усетиш икономическа буря, потърси подслон."
  },
  {
    "reading_id": "high_priestess_six_pentacles",
    "reading_name": "Интуитивна щедрост",
    "reading_cards": "Върховна жрица + 6 Пентакли",
    "reading_combination": ["high_priestess", "six_pentacles"],
    "reading_meaning": "Усещаш на кого да помогнеш",
    "reading_description": "Интуицията ти подсказва кой наистина има нужда от помощ и кой се възползва. Довери ѝ се.",
    "reading_advice": "Най-добрата щедрост е тази, която отива при нуждаещите се."
  },
  {
    "reading_id": "high_priestess_seven_pentacles",
    "reading_name": "Интуитивно търпение",
    "reading_cards": "Върховна жрица + 7 Пентакли",
    "reading_combination": ["high_priestess", "seven_pentacles"],
    "reading_meaning": "Усещаш кога да чакаш",
    "reading_description": "Интуицията ти подсказва, че сега е време за търпение, не за действие. Слушай я.",
    "reading_advice": "Когато вътрешният глас казва чакай- чакай."
  },
  {
    "reading_id": "high_priestess_eight_pentacles",
    "reading_name": "Интуитивно учене",
    "reading_cards": "Върховна жрица + 8 Пентакли",
    "reading_combination": ["high_priestess", "eight_pentacles"],
    "reading_meaning": "Усещаш какво да учиш",
    "reading_description": "Интуицията ти подсказва какви умения да развиваш. Тя знае какво ще ти трябва.",
    "reading_advice": "Учи това, към което те води вътрешният глас."
  },
  {
    "reading_id": "high_priestess_nine_pentacles",
    "reading_name": "Интуитивна независимост",
    "reading_cards": "Върховна жрица + 9 Пентакли",
    "reading_combination": ["high_priestess", "nine_pentacles"],
    "reading_meaning": "Усещаш, че си свободен",
    "reading_description": "Интуицията ти подсказва, че си постигнал финансова независимост. Наслаждавай се.",
    "reading_advice": "Свободата се усеща отвътре, не се вижда отвън."
  },
  {
    "reading_id": "high_priestess_ten_pentacles",
    "reading_name": "Интуитивно наследство",
    "reading_cards": "Върховна жрица + 10 Пентакли",
    "reading_combination": ["high_priestess", "ten_pentacles"],
    "reading_meaning": "Усещаш връзка с рода",
    "reading_description": "Интуицията ти подсказва, че си част от нещо по-голямо - семейство, род, традиция.",
    "reading_advice": "Почитай корените си, те носят мъдрост."
  },
  {
    "reading_id": "empress_ace_wands",
    "reading_name": "Творческа искра",
    "reading_cards": "Императрица + Асо Жезли",
    "reading_combination": ["empress", "ace_wands"],
    "reading_meaning": "Нов творчески проект",
    "reading_description": "Заражда се нова творческа идея, която носи потенциал за развитие. Бременност на идеята.",
    "reading_advice": "Отгледай идеята си с любов и търпение."
  },
  {
    "reading_id": "empress_two_wands",
    "reading_name": "Творчески избор",
    "reading_cards": "Императрица + 2 Жезли",
    "reading_combination": ["empress", "two_wands"],
    "reading_meaning": "Избираш творческа посока",
    "reading_description": "Предстои ти избор в творчески проект. Интуицията на Императрицата ще ти помогне.",
    "reading_advice": "Избери това, което носи живот и красота."
  },
  {
    "reading_id": "empress_three_wands",
    "reading_name": "Творческо очакване",
    "reading_cards": "Императрица + 3 Жезли",
    "reading_combination": ["empress", "three_wands"],
    "reading_meaning": "Чакаш проектът да даде плод",
    "reading_description": "Творческият ти проект е започнат и сега чакаш резултати. Търпение, те ще дойдат.",
    "reading_advice": "Както земята има нужда от време да роди, така и идеите."
  },
  {
    "reading_id": "empress_four_wands",
    "reading_name": "Творчески празник",
    "reading_cards": "Императрица + 4 Жезли",
    "reading_combination": ["empress", "four_wands"],
    "reading_meaning": "Празнуваш творчески успех",
    "reading_description": "Творческият ти проект завършва успешно и има повод за празник. Радост и удовлетворение.",
    "reading_advice": "Празнувай с тези, които обичаш."
  },
  {
    "reading_id": "empress_five_wands",
    "reading_name": "Творчески конфликт",
    "reading_cards": "Императрица + 5 Жезли",
    "reading_combination": ["empress", "five_wands"],
    "reading_meaning": "Бориш се за творческата си визия",
    "reading_description": "Някой оспорва творческия ти избор. Защитавай визията си, но бъди отворен за идеи.",
    "reading_advice": "Творчеството не е състезание, но понякога трябва да защитиш идеята си."
  },
  {
    "reading_id": "empress_six_wands",
    "reading_name": "Творчески успех",
    "reading_cards": "Императрица + 6 Жезли",
    "reading_combination": ["empress", "six_wands"],
    "reading_meaning": "Творчеството ти е признато",
    "reading_description": "Творческият ти труд получава признание и успех. Гордост и радост.",
    "reading_advice": "Приеми признанието с благодарност и го сподели."
  },
  {
    "reading_id": "empress_seven_wands",
    "reading_name": "Творческа защита",
    "reading_cards": "Императрица + 7 Жезли",
    "reading_combination": ["empress", "seven_wands"],
    "reading_meaning": "Защитаваш творчеството си",
    "reading_description": "Някой критикува или атакува творчеството ти. Защитавай го, ако вярваш в него.",
    "reading_advice": "Не позволявай на критиката да убие творчеството ти."
  },
  {
    "reading_id": "empress_eight_wands",
    "reading_name": "Бърз творчески процес",
    "reading_cards": "Императрица + 8 Жезли",
    "reading_combination": ["empress", "eight_wands"],
    "reading_meaning": "Всичко се развива бързо",
    "reading_description": "Творческият процес върви неочаквано бързо. Идеите идват една след друга.",
    "reading_advice": "Язди вълната на вдъхновението."
  },
  {
    "reading_id": "empress_nine_wands",
    "reading_name": "Творческа упоритост",
    "reading_cards": "Императрица + 9 Жезли",
    "reading_combination": ["empress", "nine_wands"],
    "reading_meaning": "Не се предаваш въпреки трудностите",
    "reading_description": "Творческият процес е труден, но продължаваш. Упоритост, която ще се отплати.",
    "reading_advice": "Не се отказвай. Великите творби изискват време."
  },
  {
    "reading_id": "empress_ten_wands",
    "reading_name": "Творческо претоварване",
    "reading_cards": "Императрица + 10 Жезли",
    "reading_combination": ["empress", "ten_wands"],
    "reading_meaning": "Твърде много творчески проекти",
    "reading_description": "Поела си твърде много творчески задачи. Претоварване и стрес.",
    "reading_advice": "Приоритизирай. Не можеш да създаваш всичко наведнъж."
  },
  {
    "reading_id": "empress_ace_cups",
    "reading_name": "Нова любов, нов живот",
    "reading_cards": "Императрица + Асо Чаши",
    "reading_combination": ["empress", "ace_cups"],
    "reading_meaning": "Нова любов заражда живот",
    "reading_description": "Нова любов носи потенциал за нов живот - дете, творчество, проект. Плодородие и радост.",
    "reading_advice": "Отвори сърцето си за новото, което идва."
  },
  {
    "reading_id": "empress_two_cups",
    "reading_name": "Плодотворна връзка",
    "reading_cards": "Императрица + 2 Чаши",
    "reading_combination": ["empress", "two_cups"],
    "reading_meaning": "Връзка, която ражда",
    "reading_description": "Връзка, която носи плодове - деца, съвместни проекти, общо творчество. Хармония и изобилие.",
    "reading_advice": "Ценете това, което създавате заедно."
  },
  {
    "reading_id": "empress_three_cups",
    "reading_name": "Творчески празник",
    "reading_cards": "Императрица + 3 Чаши",
    "reading_combination": ["empress", "three_cups"],
    "reading_meaning": "Празнуваш с любими хора",
    "reading_description": "Празник със семейството и приятелите. Радост, смях, споделено щастие.",
    "reading_advice": "Тези моменти са най-ценните. Наслаждавай им се."
  },
  {
    "reading_id": "empress_four_cups",
    "reading_name": "Творческа скука",
    "reading_cards": "Императрица + 4 Чаши",
    "reading_combination": ["empress", "four_cups"],
    "reading_meaning": "Не виждаш творческите възможности",
    "reading_description": "Имаш творчески потенциал, но не виждаш как да го използваш. Скука и незадоволство.",
    "reading_advice": "Погледни наоколо с нови очи. Възможностите са навсякъде."
  },
  {
    "reading_id": "empress_five_cups",
    "reading_name": "Творческа загуба",
    "reading_cards": "Императрица + 5 Чаши",
    "reading_combination": ["empress", "five_cups"],
    "reading_meaning": "Загубила си творчески проект",
    "reading_description": "Творчески проект не успява или губиш нещо, в което си вложила сърце. Тъга и разочарование.",
    "reading_advice": "Позволи си да скърбиш, но не спирай да твориш."
  },
  {
    "reading_id": "empress_six_cups",
    "reading_name": "Творческа носталгия",
    "reading_cards": "Императрица + 6 Чаши",
    "reading_combination": ["empress", "six_cups"],
    "reading_meaning": "Връщаш се към минали творби",
    "reading_description": "Преглеждаш стари творби или проекти. Носталгия и уроци от миналото.",
    "reading_advice": "Миналото може да вдъхнови бъдещето."
  },
  {
    "reading_id": "empress_seven_cups",
    "reading_name": "Творчески мечти",
    "reading_cards": "Императрица + 7 Чаши",
    "reading_combination": ["empress", "seven_cups"],
    "reading_meaning": "Твърде много творчески идеи",
    "reading_description": "Имаш много творчески идеи, но ти е трудно да избереш една. Разпиляване на таланта.",
    "reading_advice": "Избери една идея и я развий докрай."
  },
  {
    "reading_id": "empress_eight_cups",
    "reading_name": "Творческо търсене",
    "reading_cards": "Императрица + 8 Чаши",
    "reading_combination": ["empress", "eight_cups"],
    "reading_meaning": "Търсиш ново вдъхновение",
    "reading_description": "Оставяш старото и тръгваш да търсиш ново творческо вдъхновение. Път на твореца.",
    "reading_advice": "Понякога трябва да оставиш, за да намериш."
  },
  {
    "reading_id": "empress_nine_cups",
    "reading_name": "Творческа мечта се сбъдва",
    "reading_cards": "Императрица + 9 Чаши",
    "reading_combination": ["empress", "nine_cups"],
    "reading_meaning": "Творческата ти мечта се сбъдва",
    "reading_description": "Това, за което си мечтала като творец, се сбъдва. Удовлетворение и радост.",
    "reading_advice": "Наслади се на успеха. Ти го заслужи."
  },
  {
    "reading_id": "empress_ten_cups",
    "reading_name": "Семейно творчество",
    "reading_cards": "Императрица + 10 Чаши",
    "reading_combination": ["empress", "ten_cups"],
    "reading_meaning": "Твориш със семейството",
    "reading_description": "Творчество, споделено със семейството. Деца, партньор, близки - всички заедно създават.",
    "reading_advice": "Най-красивите творби са тези, създадени с любов."
  },
  {
    "reading_id": "empress_ace_swords",
    "reading_name": "Творческа истина",
    "reading_cards": "Императрица + Асо Мечове",
    "reading_combination": ["empress", "ace_swords"],
    "reading_meaning": "Истината за творчеството ти",
    "reading_description": "Прозрение за творческия ти път. Разбираш какво наистина искаш да създаваш.",
    "reading_advice": "Истината за таланта ти е ключът към успеха."
  },
  {
    "reading_id": "empress_two_swords",
    "reading_name": "Творческо съмнение",
    "reading_cards": "Императрица + 2 Мечове",
    "reading_combination": ["empress", "two_swords"],
    "reading_meaning": "Съмняваш се в таланта си",
    "reading_description": "Изпитваш съмнения в творческите си способности. Блокиране и нерешителност.",
    "reading_advice": "Съмненията са част от творческия процес. Не спирай заради тях."
  },
  {
    "reading_id": "empress_three_swords",
    "reading_name": "Творческа болка",
    "reading_cards": "Императрица + 3 Мечове",
    "reading_combination": ["empress", "three_swords"],
    "reading_meaning": "Болката ражда изкуство",
    "reading_description": "Използваш болката си като вдъхновение за творчество. Най-силните творби идват от най-дълбоката болка.",
    "reading_advice": "Превърни болката в изкуство."
  },
  {
    "reading_id": "empress_four_swords",
    "reading_name": "Творческа почивка",
    "reading_cards": "Императрица + 4 Мечове",
    "reading_combination": ["empress", "four_swords"],
    "reading_meaning": "Почивка от творчество",
    "reading_description": "Имаш нужда от почивка от творческия процес. Вдъхновението идва, когато умът е спокоен.",
    "reading_advice": "Позволи си да не твориш. Почивката е част от процеса."
  },
  {
    "reading_id": "empress_five_swords",
    "reading_name": "Творческа битка",
    "reading_cards": "Императрица + 5 Мечове",
    "reading_combination": ["empress", "five_swords"],
    "reading_meaning": "Бориш се за творческата си идея",
    "reading_description": "Конфликт с някого, който не разбира или не цени творчеството ти. Защитавай го.",
    "reading_advice": "Понякога трябва да спечелиш битка, за да запазиш творчеството си."
  },
  {
    "reading_id": "empress_six_swords",
    "reading_name": "Творческо пътуване",
    "reading_cards": "Императрица + 6 Мечове",
    "reading_combination": ["empress", "six_swords"],
    "reading_meaning": "Пътуваш за вдъхновение",
    "reading_description": "Пътуване, което носи ново творческо вдъхновение. Нови места, нови идеи.",
    "reading_advice": "Светът е безкраен източник на вдъхновение."
  },
  {
    "reading_id": "empress_seven_swords",
    "reading_name": "Творческа измама",
    "reading_cards": "Императрица + 7 Мечове",
    "reading_combination": ["empress", "seven_swords"],
    "reading_meaning": "Някой краде идеите ти",
    "reading_description": "Някой присвоява творческите ти идеи или не ти дава заслуженото признание. Бъди внимателна.",
    "reading_advice": "Защитавай интелектуалната си собственост."
  },
  {
    "reading_id": "empress_eight_swords",
    "reading_name": "Творчески блокаж",
    "reading_cards": "Императрица + 8 Мечове",
    "reading_combination": ["empress", "eight_swords"],
    "reading_meaning": "Чувстваш се блокирана",
    "reading_description": "Творчески блокаж, от който не виждаш изход. Чувстваш се в капан.",
    "reading_advice": "Блокажът е временен. Дишай, почини, смени средата."
  },
  {
    "reading_id": "empress_nine_swords",
    "reading_name": "Творческа тревога",
    "reading_cards": "Императрица + 9 Мечове",
    "reading_combination": ["empress", "nine_swords"],
    "reading_meaning": "Тревожиш се за творчеството си",
    "reading_description": "Творчески тревоги и безсъние. Страх, че не си достатъчно добра, че няма да успееш.",
    "reading_advice": "Тревогата убива творчеството. Освободи се от нея."
  },
  {
    "reading_id": "empress_ten_swords",
    "reading_name": "Творчески край",
    "reading_cards": "Императрица + 10 Мечове",
    "reading_combination": ["empress", "ten_swords"],
    "reading_meaning": "Творчески проект приключва",
    "reading_description": "Творчески цикъл приключва. Край на проект, изложба, период. Тъга и облекчение.",
    "reading_advice": "Когато нещо свършва, нещо ново започва."
  },
  {
    "reading_id": "empress_ace_pentacles",
    "reading_name": "Творчески доход",
    "reading_cards": "Императрица + Асо Пентакли",
    "reading_combination": ["empress", "ace_pentacles"],
    "reading_meaning": "Творчеството носи пари",
    "reading_description": "Творчески проект започва да носи финансови плодове. Материализация на идеите.",
    "reading_advice": "Творчеството и парите могат да вървят ръка за ръка."
  },
  {
    "reading_id": "empress_two_pentacles",
    "reading_name": "Творчески баланс",
    "reading_cards": "Императрица + 2 Пентакли",
    "reading_combination": ["empress", "two_pentacles"],
    "reading_meaning": "Баланс между творчество и финанси",
    "reading_description": "Умееш да балансираш между творчески проекти и финансови задължения. Умение и гъвкавост.",
    "reading_advice": "Творчеството и парите не са врагове, а партньори."
  },
  {
    "reading_id": "empress_three_pentacles",
    "reading_name": "Творчески екип",
    "reading_cards": "Императрица + 3 Пентакли",
    "reading_combination": ["empress", "three_pentacles"],
    "reading_meaning": "Работиш с други творци",
    "reading_description": "Сътрудничество с други творци. Обмен на идеи, взаимно вдъхновение, общи проекти.",
    "reading_advice": "Заедно можете да създадете повече."
  },
  {
    "reading_id": "empress_four_pentacles",
    "reading_name": "Творческо задържане",
    "reading_cards": "Императрица + 4 Пентакли",
    "reading_combination": ["empress", "four_pentacles"],
    "reading_meaning": "Държиш на творчеството си",
    "reading_description": "Държиш здраво на творческите си принципи и визия. Понякога прекалено стегнато.",
    "reading_advice": "Бъди отворена за нови идеи, без да губиш себе си."
  },
  {
    "reading_id": "empress_five_pentacles",
    "reading_name": "Творческа криза",
    "reading_cards": "Императрица + 5 Пентакли",
    "reading_combination": ["empress", "five_pentacles"],
    "reading_meaning": "Творчеството не носи пари",
    "reading_description": "Творчеството ти не носи достатъчно финансови средства. Криза и съмнения.",
    "reading_advice": "Не спирай да твориш. Парите ще дойдат, когато дойде времето."
  },
  {
    "reading_id": "empress_six_pentacles",
    "reading_name": "Творческа щедрост",
    "reading_cards": "Императрица + 6 Пентакли",
    "reading_combination": ["empress", "six_pentacles"],
    "reading_meaning": "Споделяш творчеството си",
    "reading_description": "Щедро споделяш творчеството си с другите. Подкрепяш млади творци, даряваш изкуство.",
    "reading_advice": "Колкото повече даваш, толкова повече получаваш."
  },
  {
    "reading_id": "empress_seven_pentacles",
    "reading_name": "Творческо търпение",
    "reading_cards": "Императрица + 7 Пентакли",
    "reading_combination": ["empress", "seven_pentacles"],
    "reading_meaning": "Чакаш творческите плодове",
    "reading_description": "Инвестирала си време в творчество и сега чакаш резултати. Търпение и вяра.",
    "reading_advice": "Творчеството изисква време, за да даде плод."
  },
  {
    "reading_id": "empress_eight_pentacles",
    "reading_name": "Усъвършенстваш занаята",
    "reading_cards": "Императрица + 8 Пентакли",
    "reading_combination": ["empress", "eight_pentacles"],
    "reading_meaning": "Развиваш творчески умения",
    "reading_description": "Работиш върху усъвършенстването на творческите си умения. Учиш се, практикуваш, твориш.",
    "reading_advice": "Майсторството идва с практика."
  },
  {
    "reading_id": "empress_nine_pentacles",
    "reading_name": "Творческа независимост",
    "reading_cards": "Императрица + 9 Пентакли",
    "reading_combination": ["empress", "nine_pentacles"],
    "reading_meaning": "Творчеството носи свобода",
    "reading_description": "Творчеството ти е донесло финансова независимост. Наслаждаваш се на свободата да твориш без ограничения.",
    "reading_advice": "Ти постигна мечтата на всеки творец - свобода."
  },
  {
    "reading_id": "empress_ten_pentacles",
    "reading_name": "Творческо наследство",
    "reading_cards": "Императрица + 10 Пентакли",
    "reading_combination": ["empress", "ten_pentacles"],
    "reading_meaning": "Оставяш творческо наследство",
    "reading_description": "Творчеството ти ще остане след теб. Наследство за децата, за света.",
    "reading_advice": "Твори така, сякаш ще остане вечно."
  },
  {
    "reading_id": "emperor_ace_wands",
    "reading_name": "Власт и нова идея",
    "reading_cards": "Император + Асо Жезли",
    "reading_combination": ["emperor", "ace_wands"],
    "reading_meaning": "Нов проект с власт",
    "reading_description": "Започваш нов проект с авторитет и увереност. Имаш властта да го реализираш.",
    "reading_advice": "Използвай властта си, за да създаваш, не да контролираш."
  },
  {
    "reading_id": "emperor_two_wands",
    "reading_name": "Властен избор",
    "reading_cards": "Император + 2 Жезли",
    "reading_combination": ["emperor", "two_wands"],
    "reading_meaning": "Избираш с власт",
    "reading_description": "Предстои ти важен избор и имаш властта да го направиш. Избери мъдро.",
    "reading_advice": "Властта носи отговорност. Избирай с мисъл за всички."
  },
  {
    "reading_id": "emperor_three_wands",
    "reading_name": "Властно очакване",
    "reading_cards": "Император + 3 Жезли",
    "reading_combination": ["emperor", "three_wands"],
    "reading_meaning": "Чакаш резултати с власт",
    "reading_description": "След като си взел решение, чакаш резултати. Търпението е част от властта.",
    "reading_advice": "Истинската власт умее да чака."
  },
  {
    "reading_id": "emperor_four_wands",
    "reading_name": "Властен празник",
    "reading_cards": "Император + 4 Жезли",
    "reading_combination": ["emperor", "four_wands"],
    "reading_meaning": "Празнуваш успех",
    "reading_description": "Успех, който празнуваш с власт и достойнство. Признание за управлението ти.",
    "reading_advice": "Празнувай, но не забравяй отговорностите си."
  },
  {
    "reading_id": "emperor_five_wands",
    "reading_name": "Властен конфликт",
    "reading_cards": "Император + 5 Жезли",
    "reading_combination": ["emperor", "five_wands"],
    "reading_meaning": "Бориш се за власт",
    "reading_description": "Конфликт за власт и надмощие. Някой оспорва авторитета ти.",
    "reading_advice": "Истинската власт не се нуждае от битки, за да се докаже."
  },
  {
    "reading_id": "emperor_six_wands",
    "reading_name": "Властен успех",
    "reading_cards": "Император + 6 Жезли",
    "reading_combination": ["emperor", "six_wands"],
    "reading_meaning": "Успех и признание",
    "reading_description": "Управлението ти носи успех и признание. Всички виждат твоята власт.",
    "reading_advice": "Приеми успеха с благодарност и смирение."
  },
  {
    "reading_id": "emperor_seven_wands",
    "reading_name": "Защитаваш властта",
    "reading_cards": "Император + 7 Жезли",
    "reading_combination": ["emperor", "seven_wands"],
    "reading_meaning": "Отстояваш позиция",
    "reading_description": "Някой се опитва да отнеме властта ти. Защитавай позицията си.",
    "reading_advice": "Не позволявай на никого да отнеме това, което си построил."
  },
  {
    "reading_id": "emperor_eight_wands",
    "reading_name": "Бързо управление",
    "reading_cards": "Император + 8 Жезли",
    "reading_combination": ["emperor", "eight_wands"],
    "reading_meaning": "Всичко се случва бързо",
    "reading_description": "Нещата се развиват бързо под твое ръководство. Скорост и ефективност.",
    "reading_advice": "Управлявай бързината, не позволявай тя да управлява теб."
  },
  {
    "reading_id": "emperor_nine_wands",
    "reading_name": "Упорит владетел",
    "reading_cards": "Император + 9 Жезли",
    "reading_combination": ["emperor", "nine_wands"],
    "reading_meaning": "Не се предаваш",
    "reading_description": "Въпреки трудностите, продължаваш да управляваш. Упоритост и сила.",
    "reading_advice": "Истинският владетел не се предава."
  },
  {
    "reading_id": "emperor_ten_wands",
    "reading_name": "Претоварен владетел",
    "reading_cards": "Император + 10 Жезли",
    "reading_combination": ["emperor", "ten_wands"],
    "reading_meaning": "Тежестта на властта",
    "reading_description": "Властта носи твърде много отговорности. Претоварен си и имаш нужда от помощ.",
    "reading_advice": "Дори владетелите имат нужда от подкрепа. Делегирай."
  },
  {
    "reading_id": "emperor_ace_cups",
    "reading_name": "Власт и любов",
    "reading_cards": "Император + Асо Чаши",
    "reading_combination": ["emperor", "ace_cups"],
    "reading_meaning": "Нова любов в живота на владетел",
    "reading_description": "Нова любов или емоция влиза в живота ти. Владетелят също има сърце.",
    "reading_advice": "Не позволявай на властта да те лиши от любов."
  },
  {
    "reading_id": "emperor_two_cups",
    "reading_name": "Властна връзка",
    "reading_cards": "Император + 2 Чаши",
    "reading_combination": ["emperor", "two_cups"],
    "reading_meaning": "Съюз на властта",
    "reading_description": "Връзка или партньорство, основано на власт и уважение. Съюз на равни.",
    "reading_advice": "Най-силните връзки са тези, в които и двамата са силни."
  },
  {
    "reading_id": "emperor_three_cups",
    "reading_name": "Властен празник",
    "reading_cards": "Император + 3 Чаши",
    "reading_combination": ["emperor", "three_cups"],
    "reading_meaning": "Празнуваш с достойнство",
    "reading_description": "Празник, организиран с власт и размах. Но не забравяй истинската радост.",
    "reading_advice": "Празнувай, но не позволявай на властта да те лиши от истинската радост."
  },
  {
    "reading_id": "emperor_four_cups",
    "reading_name": "Владетел в скука",
    "reading_cards": "Император + 4 Чаши",
    "reading_combination": ["emperor", "four_cups"],
    "reading_meaning": "Властта не носи щастие",
    "reading_description": "Въпреки властта, чувстваш празнота и неудовлетворение. Нещо липсва.",
    "reading_advice": "Властта без любов е празна."
  },
  {
    "reading_id": "emperor_five_cups",
    "reading_name": "Власт и загуба",
    "reading_cards": "Император + 5 Чаши",
    "reading_combination": ["emperor", "five_cups"],
    "reading_meaning": "Загуба въпреки властта",
    "reading_description": "Дори с цялата си власт, не можеш да избегнеш загубата. Тъга и разочарование.",
    "reading_advice": "Властта не предпазва от болка. Позволи си да чувстваш."
  },
  {
    "reading_id": "emperor_six_cups",
    "reading_name": "Носталгичен владетел",
    "reading_cards": "Император + 6 Чаши",
    "reading_combination": ["emperor", "six_cups"],
    "reading_meaning": "Връщаш се към миналото",
    "reading_description": "Носталгия по времето, когато властта не беше толкова тежка. Спомени за по-леки дни.",
    "reading_advice": "Миналото е хубаво за спомен, но властта изисква да си в настоящето."
  },
  {
    "reading_id": "emperor_seven_cups",
    "reading_name": "Властни мечти",
    "reading_cards": "Император + 7 Чаши",
    "reading_combination": ["emperor", "seven_cups"],
    "reading_meaning": "Фантазии за още власт",
    "reading_description": "Мечтаеш за още повече власт и богатство. Внимавай с илюзиите.",
    "reading_advice": "Колкото повече имаш, толкова повече искаш. Понякога е добре да спреш."
  },
  {
    "reading_id": "emperor_eight_cups",
    "reading_name": "Владетелят тръгва",
    "reading_cards": "Император + 8 Чаши",
    "reading_combination": ["emperor", "eight_cups"],
    "reading_meaning": "Напускаш властта",
    "reading_description": "Решаваш да оставиш властта и да тръгнеш по нов път. Освобождаване.",
    "reading_advice": "Понякога най-властният ход е да се откажеш от властта."
  },
  {
    "reading_id": "emperor_nine_cups",
    "reading_name": "Властна мечта се сбъдва",
    "reading_cards": "Император + 9 Чаши",
    "reading_combination": ["emperor", "nine_cups"],
    "reading_meaning": "Постигаш желаното",
    "reading_description": "Мечтата ти за власт и успех се сбъдва. Удовлетворение и гордост.",
    "reading_advice": "Наслади се на постижението, но не спирай да растеш."
  },
  {
    "reading_id": "emperor_ten_cups",
    "reading_name": "Семеен владетел",
    "reading_cards": "Император + 10 Чаши",
    "reading_combination": ["emperor", "ten_cups"],
    "reading_meaning": "Власт и семейно щастие",
    "reading_description": "Успяваш да съчетаеш властта със семейното щастие. Хармония и удовлетворение.",
    "reading_advice": "Най-големият успех е щастливото семейство."
  },
  {
    "reading_id": "emperor_ace_swords",
    "reading_name": "Властна истина",
    "reading_cards": "Император + Асо Мечове",
    "reading_combination": ["emperor", "ace_swords"],
    "reading_meaning": "Истината за властта",
    "reading_description": "Прозрение за истинската същност на властта. Разбираш отговорността, която носи.",
    "reading_advice": "Истината за властта е, че тя е служение, не привилегия."
  },
  {
    "reading_id": "emperor_two_swords",
    "reading_name": "Властно съмнение",
    "reading_cards": "Император + 2 Мечове",
    "reading_combination": ["emperor", "two_swords"],
    "reading_meaning": "Съмняваш се в решенията си",
    "reading_description": "Въпреки властта, изпитваш съмнения в решенията си. Нерешителност и страх.",
    "reading_advice": "Съмнението е част от мъдростта. Не го отхвърляй."
  },
  {
    "reading_id": "emperor_three_swords",
    "reading_name": "Власт и болка",
    "reading_cards": "Император + 3 Мечове",
    "reading_combination": ["emperor", "three_swords"],
    "reading_meaning": "Властта носи болка",
    "reading_description": "Управлението ти носи болка - твоя или на другите. Трудни решения, тежки последици.",
    "reading_advice": "Властта без състрадание носи само болка."
  },
  {
    "reading_id": "emperor_four_swords",
    "reading_name": "Властна почивка",
    "reading_cards": "Император + 4 Мечове",
    "reading_combination": ["emperor", "four_swords"],
    "reading_meaning": "Почивка от властта",
    "reading_description": "Имаш нужда от почивка от управлението. Дори владетелите спят.",
    "reading_advice": "Почивката не е слабост, а необходимост."
  },
  {
    "reading_id": "emperor_five_swords",
    "reading_name": "Властна битка",
    "reading_cards": "Император + 5 Мечове",
    "reading_combination": ["emperor", "five_swords"],
    "reading_meaning": "Битка за надмощие",
    "reading_description": "Конфликт, в който властта е заложена на карта. Бориш се да запазиш позиция.",
    "reading_advice": "Понякога да отстъпиш е по-мъдро от това да спечелиш с цената на всичко."
  },
  {
    "reading_id": "emperor_six_swords",
    "reading_name": "Властно пътуване",
    "reading_cards": "Император + 6 Мечове",
    "reading_combination": ["emperor", "six_swords"],
    "reading_meaning": "Пътуваш като владетел",
    "reading_description": "Пътуване, свързано с власт и отговорност. Официално посещение, командировка.",
    "reading_advice": "Дори в движение не забравяй отговорностите си."
  },
  {
    "reading_id": "emperor_seven_swords",
    "reading_name": "Властна измама",
    "reading_cards": "Император + 7 Мечове",
    "reading_combination": ["emperor", "seven_swords"],
    "reading_meaning": "Измама за власт",
    "reading_description": "Някой се опитва да те измами, за да вземе властта ти. Бъди внимателен.",
    "reading_advice": "Доверието е хубаво, но проверката е по-добра."
  },
  {
    "reading_id": "emperor_eight_swords",
    "reading_name": "Власт в капан",
    "reading_cards": "Император + 8 Мечове",
    "reading_combination": ["emperor", "eight_swords"],
    "reading_meaning": "Чувстваш се в капан във властта",
    "reading_description": "Властта се е превърнала в затвор. Чувстваш се блокиран и без изход.",
    "reading_advice": "Понякога най-властният ход е да признаеш, че си в капан."
  },
  {
    "reading_id": "emperor_nine_swords",
    "reading_name": "Властни тревоги",
    "reading_cards": "Император + 9 Мечове",
    "reading_combination": ["emperor", "nine_swords"],
    "reading_meaning": "Тревожиш се за властта",
    "reading_description": "Безсъние от притеснения за управлението. Страх да не загубиш контрол.",
    "reading_advice": "Тревогата не помага. Довери се на способностите си."
  },
  {
    "reading_id": "emperor_ten_swords",
    "reading_name": "Край на властта",
    "reading_cards": "Император + 10 Мечове",
    "reading_combination": ["emperor", "ten_swords"],
    "reading_meaning": "Властта свършва",
    "reading_description": "Цикълът на управление приключва. Сваляне, оставка, край на мандат.",
    "reading_advice": "Краят на властта е начало на нещо ново."
  },
  {
    "reading_id": "emperor_ace_pentacles",
    "reading_name": "Власт и богатство",
    "reading_cards": "Император + Асо Пентакли",
    "reading_combination": ["emperor", "ace_pentacles"],
    "reading_meaning": "Нова финансова власт",
    "reading_description": "Нова финансова възможност, която носи власт и контрол. Богатство и управление.",
    "reading_advice": "Използвай богатството си с мъдрост и отговорност."
  },
  {
    "reading_id": "emperor_two_pentacles",
    "reading_name": "Властен баланс",
    "reading_cards": "Император + 2 Пентакли",
    "reading_combination": ["emperor", "two_pentacles"],
    "reading_meaning": "Баланс между власт и пари",
    "reading_description": "Умееш да балансираш между различни финансови отговорности. Управление и гъвкавост.",
    "reading_advice": "Властта изисква добро управление на ресурсите."
  },
  {
    "reading_id": "emperor_three_pentacles",
    "reading_name": "Властен екип",
    "reading_cards": "Император + 3 Пентакли",
    "reading_combination": ["emperor", "three_pentacles"],
    "reading_meaning": "Управляваш с екип",
    "reading_description": "Власт, споделена с други. Екипно управление, съвет, сътрудничество.",
    "reading_advice": "Най-добрите владетели се обграждат с мъдри съветници."
  },
  {
    "reading_id": "emperor_four_pentacles",
    "reading_name": "Държиш властта",
    "reading_cards": "Император + 4 Пентакли",
    "reading_combination": ["emperor", "four_pentacles"],
    "reading_meaning": "Вкопчваш се във властта",
    "reading_description": "Държиш здраво властта и богатството. Страх да не ги загубиш.",
    "reading_advice": "Колкото по-силно държиш, толкова повече се изплъзва."
  },
  {
    "reading_id": "emperor_five_pentacles",
    "reading_name": "Власт и бедност",
    "reading_cards": "Император + 5 Пентакли",
    "reading_combination": ["emperor", "five_pentacles"],
    "reading_meaning": "Власт без пари",
    "reading_description": "Имаш власт, но без финансови средства. Трудно управление без ресурси.",
    "reading_advice": "Истинската власт не зависи от парите."
  },
  {
    "reading_id": "emperor_six_pentacles",
    "reading_name": "Щедър владетел",
    "reading_cards": "Император + 6 Пентакли",
    "reading_combination": ["emperor", "six_pentacles"],
    "reading_meaning": "Споделяш власт и богатство",
    "reading_description": "Използваш властта и богатството си, за да помагаш на другите. Щедрост и справедливост.",
    "reading_advice": "Най-голямата власт е тази, която се използва в полза на другите."
  },
  {
    "reading_id": "emperor_seven_pentacles",
    "reading_name": "Търпелив владетел",
    "reading_cards": "Император + 7 Пентакли",
    "reading_combination": ["emperor", "seven_pentacles"],
    "reading_meaning": "Чакаш резултати от управлението",
    "reading_description": "Инвестирал си време и ресурси и сега чакаш резултати. Търпение и стратегия.",
    "reading_advice": "Великите неща изискват време."
  },
  {
    "reading_id": "emperor_eight_pentacles",
    "reading_name": "Усъвършенстваш управлението",
    "reading_cards": "Император + 8 Пентакли",
    "reading_combination": ["emperor", "eight_pentacles"],
    "reading_meaning": "Учиш се да управляваш",
    "reading_description": "Развиваш уменията си за управление. Постоянство и отдаденост.",
    "reading_advice": "Дори владетелите имат какво да учат."
  },
  {
    "reading_id": "emperor_nine_pentacles",
    "reading_name": "Независим владетел",
    "reading_cards": "Император + 9 Пентакли",
    "reading_combination": ["emperor", "nine_pentacles"],
    "reading_meaning": "Власт и свобода",
    "reading_description": "Постигнал си власт и финансова независимост. Наслаждаваш се на плодовете.",
    "reading_advice": "Истинската власт е свободата да бъдеш себе си."
  },
  {
    "reading_id": "emperor_ten_pentacles",
    "reading_name": "Власт и наследство",
    "reading_cards": "Император + 10 Пентакли",
    "reading_combination": ["emperor", "ten_pentacles"],
    "reading_meaning": "Оставяш власт в наследство",
    "reading_description": "Управлението ти ще остане за поколенията. Наследство, династия, традиция.",
    "reading_advice": "Каквото оставиш след себе си, това си бил."
  },
  {
    "reading_id": "hierophant_ace_wands",
    "reading_name": "Духовна искра",
    "reading_cards": "Йерофант + Асо Жезли",
    "reading_combination": ["hierophant", "ace_wands"],
    "reading_meaning": "Ново духовно начало",
    "reading_description": "Започваш нов духовен път или учение. Искрата на вярата пламва в теб.",
    "reading_advice": "Следвай духовния си път с ентусиазъм, но и с мъдрост."
  },
  {
    "reading_id": "hierophant_two_wands",
    "reading_name": "Духовен избор",
    "reading_cards": "Йерофант + 2 Жезли",
    "reading_combination": ["hierophant", "two_wands"],
    "reading_meaning": "Избор между духовни пътища",
    "reading_description": "Предстои ти избор между различни духовни учения или практики. Кое е правилното за теб?",
    "reading_advice": "Избери този път, който води към мир, не към догми."
  },
  {
    "reading_id": "hierophant_three_wands",
    "reading_name": "Духовно очакване",
    "reading_cards": "Йерофант + 3 Жезли",
    "reading_combination": ["hierophant", "three_wands"],
    "reading_meaning": "Чакаш духовни резултати",
    "reading_description": "След като си поел духовен път, чакаш резултати и прозрения. Търпението е част от вярата.",
    "reading_advice": "Духовните плодове узряват бавно. Не бързай."
  },
  {
    "reading_id": "hierophant_four_wands",
    "reading_name": "Духовен празник",
    "reading_cards": "Йерофант + 4 Жезли",
    "reading_combination": ["hierophant", "four_wands"],
    "reading_meaning": "Празнуваш духовно постижение",
    "reading_description": "Духовно събитие или празник - кръщене, сватба, посвещение. Радост и благословия.",
    "reading_advice": "Празнувай с благодарност към висшите сили."
  },
  {
    "reading_id": "hierophant_five_wands",
    "reading_name": "Духовен конфликт",
    "reading_cards": "Йерофант + 5 Жезли",
    "reading_combination": ["hierophant", "five_wands"],
    "reading_meaning": "Спорове за вярата",
    "reading_description": "Конфликт на религиозна или духовна основа. Различни вярвания, които се сблъскват.",
    "reading_advice": "Вярата не се доказва със спорове, а с дела."
  },
  {
    "reading_id": "hierophant_six_wands",
    "reading_name": "Духовен успех",
    "reading_cards": "Йерофант + 6 Жезли",
    "reading_combination": ["hierophant", "six_wands"],
    "reading_meaning": "Признание за духовен път",
    "reading_description": "Духовните ти търсения получават признание. Ставаш учител, водач, пример.",
    "reading_advice": "Приеми признанието смирено. Ти си само проводник."
  },
  {
    "reading_id": "hierophant_seven_wands",
    "reading_name": "Защитаваш вярата",
    "reading_cards": "Йерофант + 7 Жезли",
    "reading_combination": ["hierophant", "seven_wands"],
    "reading_meaning": "Отстояваш убежденията си",
    "reading_description": "Някой атакува вярата или убежденията ти. Защитавай ги, но с любов, не с агресия.",
    "reading_advice": "Истинската вяра не се нуждае от защита - тя се вижда."
  },
  {
    "reading_id": "hierophant_eight_wands",
    "reading_name": "Бързо духовно развитие",
    "reading_cards": "Йерофант + 8 Жезли",
    "reading_combination": ["hierophant", "eight_wands"],
    "reading_meaning": "Духовният ти път се ускорява",
    "reading_description": "Прозренията идват бързо едно след друго. Духовно ускорение.",
    "reading_advice": "Приемай прозренията, но не бързай да ги обявяваш за истина."
  },
  {
    "reading_id": "hierophant_nine_wands",
    "reading_name": "Упорит в вярата",
    "reading_cards": "Йерофант + 9 Жезли",
    "reading_combination": ["hierophant", "nine_wands"],
    "reading_meaning": "Държиш на вярата въпреки всичко",
    "reading_description": "Въпреки изпитанията, не се отказваш от вярата си. Упоритост и преданост.",
    "reading_advice": "Вярата, която не е изпитана, не е истинска вяра."
  },
  {
    "reading_id": "hierophant_ten_wands",
    "reading_name": "Духовно претоварване",
    "reading_cards": "Йерофант + 10 Жезли",
    "reading_combination": ["hierophant", "ten_wands"],
    "reading_meaning": "Вярата става бреме",
    "reading_description": "Духовните задължения и догми те притискат. Вярата се е превърнала в бреме.",
    "reading_advice": "Истинската вяра освобождава, не заробва. Преосмисли."
  },
  {
    "reading_id": "hierophant_ace_cups",
    "reading_name": "Духовна любов",
    "reading_cards": "Йерофант + Асо Чаши",
    "reading_combination": ["hierophant", "ace_cups"],
    "reading_meaning": "Божествена любов",
    "reading_description": "Изпитваш любов, която надхвърля човешкото - към Бога, към Вселената, към всичко живо.",
    "reading_advice": "Тази любов е най-висшата форма на духовност."
  },
  {
    "reading_id": "hierophant_two_cups",
    "reading_name": "Благословена връзка",
    "reading_cards": "Йерофант + 2 Чаши",
    "reading_combination": ["hierophant", "two_cups"],
    "reading_meaning": "Връзка, благословена отгоре",
    "reading_description": "Любовна връзка, която носи божествена благословия. Брак, съдбовна среща, кармична връзка.",
    "reading_advice": "Благодари за тази връзка. Тя е дар."
  },
  {
    "reading_id": "hierophant_three_cups",
    "reading_name": "Духовен празник",
    "reading_cards": "Йерофант + 3 Чаши",
    "reading_combination": ["hierophant", "three_cups"],
    "reading_meaning": "Празнуваш с духовна общност",
    "reading_description": "Празник с духовни братя и сестри. Споделена вяра, обща радост.",
    "reading_advice": "Общността укрепва вярата."
  },
  {
    "reading_id": "hierophant_four_cups",
    "reading_name": "Духовна скука",
    "reading_cards": "Йерофант + 4 Чаши",
    "reading_combination": ["hierophant", "four_cups"],
    "reading_meaning": "Вярата е загубила смисъл",
    "reading_description": "Духовните практики са станали рутинни и бездушни. Вярата е изгубила искрата си.",
    "reading_advice": "Потърси нов дълбочина в старата вяра."
  },
  {
    "reading_id": "hierophant_five_cups",
    "reading_name": "Духовна загуба",
    "reading_cards": "Йерофант + 5 Чаши",
    "reading_combination": ["hierophant", "five_cups"],
    "reading_meaning": "Загуба на вяра",
    "reading_description": "Преживяваш загуба на вяра или духовна криза. Бог мълчи, светът е празен.",
    "reading_advice": "Понякога трябва да загубиш вярата, за да намериш по-истинска."
  },
  {
    "reading_id": "hierophant_six_cups",
    "reading_name": "Духовна носталгия",
    "reading_cards": "Йерофант + 6 Чаши",
    "reading_combination": ["hierophant", "six_cups"],
    "reading_meaning": "Носталгия по детската вяра",
    "reading_description": "Връщаш се към спомени за детската си вяра, за религията на родителите си.",
    "reading_advice": "Детската вяра има чистота, която може да вдъхнови отново."
  },
  {
    "reading_id": "hierophant_seven_cups",
    "reading_name": "Духовни илюзии",
    "reading_cards": "Йерофант + 7 Чаши",
    "reading_combination": ["hierophant", "seven_cups"],
    "reading_meaning": "Заблуди за вярата",
    "reading_description": "Изпадаш в духовни илюзии или фантазии. Внимавай с фалшивите гурута и учения.",
    "reading_advice": "Истинската духовност е проста. Търси простотата."
  },
  {
    "reading_id": "hierophant_eight_cups",
    "reading_name": "Тръгваш от старата вяра",
    "reading_cards": "Йерофант + 8 Чаши",
    "reading_combination": ["hierophant", "eight_cups"],
    "reading_meaning": "Напускаш традицията",
    "reading_description": "Решаваш да оставиш старата религия или духовен път. Търсиш нещо ново.",
    "reading_advice": "Тръгването не е предателство, а търсене."
  },
  {
    "reading_id": "hierophant_nine_cups",
    "reading_name": "Духовна мечта се сбъдва",
    "reading_cards": "Йерофант + 9 Чаши",
    "reading_combination": ["hierophant", "nine_cups"],
    "reading_meaning": "Постигаш духовно желание",
    "reading_description": "Духовната ти мечта се сбъдва - просветление, мир, връзка с Бога.",
    "reading_advice": "Благодари за този дар. Той е отговор на молитвите ти."
  },
  {
    "reading_id": "hierophant_ten_cups",
    "reading_name": "Духовно семейство",
    "reading_cards": "Йерофант + 10 Чаши",
    "reading_combination": ["hierophant", "ten_cups"],
    "reading_meaning": "Духовна общност",
    "reading_description": "Намираш духовно семейство - общност от хора със сходни вярвания. Топлина и принадлежност.",
    "reading_advice": "Цени тази общност. Тя е твоето духовно убежище."
  },
  {
    "reading_id": "hierophant_ace_swords",
    "reading_name": "Духовна истина",
    "reading_cards": "Йерофант + Асо Мечове",
    "reading_combination": ["hierophant", "ace_swords"],
    "reading_meaning": "Прозрение за вярата",
    "reading_description": "Разбираш дълбока истина за духовния път. Прозрение, което променя вярата ти.",
    "reading_advice": "Истината за Бога е в теб, не в книгите."
  },
  {
    "reading_id": "hierophant_two_swords",
    "reading_name": "Духовно съмнение",
    "reading_cards": "Йерофант + 2 Мечове",
    "reading_combination": ["hierophant", "two_swords"],
    "reading_meaning": "Съмняваш се във вярата",
    "reading_description": "Изпитваш съмнения в духовните си убеждения. Това е нормална част от пътя.",
    "reading_advice": "Съмнението не е враг на вярата, а нейният спътник."
  },
  {
    "reading_id": "hierophant_three_swords",
    "reading_name": "Духовна болка",
    "reading_cards": "Йерофант + 3 Мечове",
    "reading_combination": ["hierophant", "three_swords"],
    "reading_meaning": "Болка от вярата",
    "reading_description": "Религията или духовността ти носят болка - вина, страх, отхвърляне.",
    "reading_advice": "Бог не иска да страдаш. Преосмисли разбирането си за вярата."
  },
  {
    "reading_id": "hierophant_four_swords",
    "reading_name": "Духовна почивка",
    "reading_cards": "Йерофант + 4 Мечове",
    "reading_combination": ["hierophant", "four_swords"],
    "reading_meaning": "Почивка от духовни търсения",
    "reading_description": "Имаш нужда от почивка от духовните практики. Медитация, мълчание, покой.",
    "reading_advice": "Понякога най-добрата духовна практика е да не правиш нищо."
  },
  {
    "reading_id": "hierophant_five_swords",
    "reading_name": "Духовна битка",
    "reading_cards": "Йерофант + 5 Мечове",
    "reading_combination": ["hierophant", "five_swords"],
    "reading_meaning": "Бориш се за вярата",
    "reading_description": "Конфликт на религиозна основа. Кръстоносен поход, свещена война, мисионерство.",
    "reading_advice": "Бог не се нуждае от защита. Любовта е единственото оръжие."
  },
  {
    "reading_id": "hierophant_six_swords",
    "reading_name": "Духовно пътуване",
    "reading_cards": "Йерофант + 6 Мечове",
    "reading_combination": ["hierophant", "six_swords"],
    "reading_meaning": "Поклонничество",
    "reading_description": "Предстои ти духовно пътуване - поклонение, ретрийт, търсене на свещени места.",
    "reading_advice": "Пътят към Бога минава и през физически пътеки."
  },
  {
    "reading_id": "hierophant_seven_swords",
    "reading_name": "Духовна измама",
    "reading_cards": "Йерофант + 7 Мечове",
    "reading_combination": ["hierophant", "seven_swords"],
    "reading_meaning": "Фалшив пророк",
    "reading_description": "Попадаш на фалшив духовен учител или измама. Някой злоупотребява с вярата ти.",
    "reading_advice": "Истинският учител не иска парите ти, а пробуждането ти."
  },
  {
    "reading_id": "wheel_seven_wands",
    "reading_name": "Съдбовна защита",
    "reading_cards": "Колело на съдбата + 7 Жезли",
    "reading_combination": ["wheel_of_fortune", "seven_wands"],
    "reading_meaning": "Защитаваш съдбовна позиция",
    "reading_description": "Защитаваш нещо, което ти е писано да притежаваш. Никой не може да ти го отнеме.",
    "reading_advice": "Дръж позицията си със спокойствие. Съдбата е на твоя страна."
  },
  {
    "reading_id": "wheel_eight_wands",
    "reading_name": "Съдбовна скорост",
    "reading_cards": "Колело на съдбата + 8 Жезли",
    "reading_combination": ["wheel_of_fortune", "eight_wands"],
    "reading_meaning": "Всичко се случва бързо, както е писано",
    "reading_description": "Събитията се развиват светкавично, но всичко е част от плана. Не се страхувай от скоростта.",
    "reading_advice": "Язди вълната на съдбата."
  },
  {
    "reading_id": "wheel_nine_wands",
    "reading_name": "Съдбовна упоритост",
    "reading_cards": "Колело на съдбата + 9 Жезли",
    "reading_combination": ["wheel_of_fortune", "nine_wands"],
    "reading_meaning": "Съдбата иска да издържиш",
    "reading_description": "Трудностите са изпитание от съдбата. Трябва да издържиш, защото така е писано.",
    "reading_advice": "Дръж се. Това изпитание ще те направи по-силен."
  },
  {
    "reading_id": "wheel_ten_wands",
    "reading_name": "Съдбовно бреме",
    "reading_cards": "Колело на съдбата + 10 Жезли",
    "reading_combination": ["wheel_of_fortune", "ten_wands"],
    "reading_meaning": "Носиш тежестта на съдбата",
    "reading_description": "Отговорностите, които носиш, са ти отредени от съдбата. Приеми ги.",
    "reading_advice": "Ти си избраният да носиш това бреме. Носи го с гордост."
  },
  {
    "reading_id": "justice_ace_wands",
    "reading_name": "Справедлива искра",
    "reading_cards": "Справедливост + Асо Жезли",
    "reading_combination": ["justice", "ace_wands"],
    "reading_meaning": "Ново начало със справедливост",
    "reading_description": "Започваш нещо ново, воден от чувство за справедливост. Правилното начало.",
    "reading_advice": "Започни с чиста съвест и открито сърце."
  },
  {
    "reading_id": "justice_two_wands",
    "reading_name": "Справедлив избор",
    "reading_cards": "Справедливост + 2 Жезли",
    "reading_combination": ["justice", "two_wands"],
    "reading_meaning": "Избираш справедливо",
    "reading_description": "Предстои ти избор и ще го направиш справедливо. Всички страни ще бъдат чути.",
    "reading_advice": "Избери това, което е правилно, не това, което е лесно."
  },
  {
    "reading_id": "justice_three_wands",
    "reading_name": "Чакаш справедливост",
    "reading_cards": "Справедливост + 3 Жезли",
    "reading_combination": ["justice", "three_wands"],
    "reading_meaning": "Очакваш справедлив резултат",
    "reading_description": "След като си направил правилния избор, чакаш справедливи резултати. Те ще дойдат.",
    "reading_advice": "Търпение. Справедливостта идва, когато трябва."
  },
  {
    "reading_id": "justice_four_wands",
    "reading_name": "Справедлив празник",
    "reading_cards": "Справедливост + 4 Жезли",
    "reading_combination": ["justice", "four_wands"],
    "reading_meaning": "Празнуваш справедливост",
    "reading_description": "Празнуваш момент, в който справедливостта възтържествува. Правда и радост.",
    "reading_advice": "Празнувай, защото доброто победи."
  },
  {
    "reading_id": "justice_five_wands",
    "reading_name": "Справедлива битка",
    "reading_cards": "Справедливост + 5 Жезли",
    "reading_combination": ["justice", "five_wands"],
    "reading_meaning": "Бориш се за справедливост",
    "reading_description": "Конфликт, в който се бориш за кауза, която е справедлива. Битката си струва.",
    "reading_advice": "Бори се за правдата, но с чисти средства."
  },
  {
    "reading_id": "justice_six_wands",
    "reading_name": "Справедлив успех",
    "reading_cards": "Справедливост + 6 Жезли",
    "reading_combination": ["justice", "six_wands"],
    "reading_meaning": "Успех, който заслужаваш",
    "reading_description": "Успехът идва, защото го заслужаваш. Признание за честния ти труд.",
    "reading_advice": "Приеми успеха с достойнство. Ти го заслужи."
  },
  {
    "reading_id": "justice_seven_wands",
    "reading_name": "Защитаваш справедливостта",
    "reading_cards": "Справедливост + 7 Жезли",
    "reading_combination": ["justice", "seven_wands"],
    "reading_meaning": "Отстояваш правдата",
    "reading_description": "Някой оспорва справедливостта на позицията ти. Защитавай истината.",
    "reading_advice": "Истината е на твоя страна. Не се страхувай."
  },
  {
    "reading_id": "justice_eight_wands",
    "reading_name": "Бърза справедливост",
    "reading_cards": "Справедливост + 8 Жезли",
    "reading_combination": ["justice", "eight_wands"],
    "reading_meaning": "Правдата идва бързо",
    "reading_description": "Справедливостта идва неочаквано бързо. Резултати, които не си очаквал толкова скоро.",
    "reading_advice": "Приеми бързия развой със спокойствие."
  },
  {
    "reading_id": "justice_nine_wands",
    "reading_name": "Упорит за справедливост",
    "reading_cards": "Справедливост + 9 Жезли",
    "reading_combination": ["justice", "nine_wands"],
    "reading_meaning": "Не се предаваш в борбата за правда",
    "reading_description": "Въпреки трудностите, продължаваш да се бориш за справедливост. Упоритост и вяра.",
    "reading_advice": "Дръж се. Истината побеждава винаги."
  },
  {
    "reading_id": "justice_ten_wands",
    "reading_name": "Тежестта на справедливостта",
    "reading_cards": "Справедливост + 10 Жезли",
    "reading_combination": ["justice", "ten_wands"],
    "reading_meaning": "Носиш тежестта на правосъдието",
    "reading_description": "Отговорността да бъдеш справедлив тежи. Съдия, адвокат, арбитър - тежка роля.",
    "reading_advice": "Справедливостта изисква сила. Не спирай."
  },
  {
    "reading_id": "hanged_ace_wands",
    "reading_name": "Блокирана искра",
    "reading_cards": "Обесен + Асо Жезли",
    "reading_combination": ["hanged_man", "ace_wands"],
    "reading_meaning": "Идея, която не може да тръгне",
    "reading_description": "Имаш нова идея, но нещо я блокира. Не можеш да започнеш, колкото и да искаш.",
    "reading_advice": "Понякога трябва да изчакаш, преди да действаш."
  },
  {
    "reading_id": "hanged_two_wands",
    "reading_name": "Блокиран избор",
    "reading_cards": "Обесен + 2 Жезли",
    "reading_combination": ["hanged_man", "two_wands"],
    "reading_meaning": "Не можеш да избереш",
    "reading_description": "Изправен си пред избор, но нещо те блокира. Не можеш да вземеш решение.",
    "reading_advice": "Понякога не избираш, за да можеш да избереш по-добре после."
  },
  {
    "reading_id": "hanged_three_wands",
    "reading_name": "Блокирано чакане",
    "reading_cards": "Обесен + 3 Жезли",
    "reading_combination": ["hanged_man", "three_wands"],
    "reading_meaning": "Чакаш в застой",
    "reading_description": "Чакаш резултати, но времето сякаш е спряло. Застой, който те измъчва.",
    "reading_advice": "Застоят не е бездействие. Той е подготовка."
  },
  {
    "reading_id": "hanged_four_wands",
    "reading_name": "Блокиран празник",
    "reading_cards": "Обесен + 4 Жезли",
    "reading_combination": ["hanged_man", "four_wands"],
    "reading_meaning": "Не можеш да празнуваш",
    "reading_description": "Има повод за празник, но нещо те спира да се радваш. Блокаж на радостта.",
    "reading_advice": "Позволи си да бъдеш щастлив, дори когато не ти се струва подходящо."
  },
  {
    "reading_id": "hanged_five_wands",
    "reading_name": "Блокиран конфликт",
    "reading_cards": "Обесен + 5 Жезли",
    "reading_combination": ["hanged_man", "five_wands"],
    "reading_meaning": "Конфликтът е в застой",
    "reading_description": "Спор, който не напредва. Никой не отстъпва, но никой и не печели.",
    "reading_advice": "Понякога най-добрият начин да спечелиш е да излезеш от битката."
  },
  {
    "reading_id": "hanged_six_wands",
    "reading_name": "Блокиран успех",
    "reading_cards": "Обесен + 6 Жезли",
    "reading_combination": ["hanged_man", "six_wands"],
    "reading_meaning": "Успех, който не идва",
    "reading_description": "Очакваш успех, но той се бави. Победата е блокирана някъде по пътя.",
    "reading_advice": "Не спирай да вярваш. Успехът идва, когато най-малко го очакваш."
  },
  {
    "reading_id": "hanged_seven_wands",
    "reading_name": "Блокирана защита",
    "reading_cards": "Обесен + 7 Жезли",
    "reading_combination": ["hanged_man", "seven_wands"],
    "reading_meaning": "Не можеш да се защитиш",
    "reading_description": "Чувстваш се атакуван, но не можеш да реагираш. Блокирана защита.",
    "reading_advice": "Понякога най-добрата защита е да не реагираш."
  },
  {
    "reading_id": "hanged_eight_wands",
    "reading_name": "Блокирана скорост",
    "reading_cards": "Обесен + 8 Жезли",
    "reading_combination": ["hanged_man", "eight_wands"],
    "reading_meaning": "Всичко спира",
    "reading_description": "Нещата, които се движеха бързо, внезапно спират. Застой след ускорение.",
    "reading_advice": "Спирането не е лошо. Понякога дава време за размисъл."
  },
  {
    "reading_id": "hanged_nine_wands",
    "reading_name": "Блокирана упоритост",
    "reading_cards": "Обесен + 9 Жезли",
    "reading_combination": ["hanged_man", "nine_wands"],
    "reading_meaning": "Упорстваш в застой",
    "reading_description": "Продължаваш да упорстваш, въпреки че нищо не се случва. Застой и изтощение.",
    "reading_advice": "Понякога да спреш означава да продължиш."
  },
  {
    "reading_id": "hanged_ten_wands",
    "reading_name": "Блокирано бреме",
    "reading_cards": "Обесен + 10 Жезли",
    "reading_combination": ["hanged_man", "ten_wands"],
    "reading_meaning": "Носиш бреме, без да мърдаш",
    "reading_description": "Носиш тежко бреме, но не можеш да мръднеш. Парализа под тежест.",
    "reading_advice": "Пусни бремето. Няма срам да спреш."
  },
  {
    "reading_id": "death_ace_wands",
    "reading_name": "Ново начало след край",
    "reading_cards": "Смърт + Асо Жезли",
    "reading_combination": ["death", "ace_wands"],
    "reading_meaning": "Феникс от пепелта",
    "reading_description": "След като нещо приключи, започва нещо ново. Край и начало в едно.",
    "reading_advice": "Позволи на старото да умре, за да се роди новото."
  },
  {
    "reading_id": "death_two_wands",
    "reading_name": "Избор след край",
    "reading_cards": "Смърт + 2 Жезли",
    "reading_combination": ["death", "two_wands"],
    "reading_meaning": "Избираш след приключване",
    "reading_description": "След като нещо приключи, трябва да избереш нова посока. Нов път те очаква.",
    "reading_advice": "Избери смело. Миналото е зад теб."
  },
  {
    "reading_id": "death_three_wands",
    "reading_name": "Очакване след край",
    "reading_cards": "Смърт + 3 Жезли",
    "reading_combination": ["death", "three_wands"],
    "reading_meaning": "Чакаш резултати след трансформация",
    "reading_description": "След като нещо приключи, чакаш да видиш какво ще се появи. Очакване и надежда.",
    "reading_advice": "Търпеливо очаквай новото. То идва."
  },
  {
    "reading_id": "death_four_wands",
    "reading_name": "Празник на новото начало",
    "reading_cards": "Смърт + 4 Жезли",
    "reading_combination": ["death", "four_wands"],
    "reading_meaning": "Празнуваш нов живот",
    "reading_description": "След края идва празник на новото начало. Радост след тъга, светлина след мрак.",
    "reading_advice": "Празнувай прераждането си."
  },
  {
    "reading_id": "death_five_wands",
    "reading_name": "Последна битка",
    "reading_cards": "Смърт + 5 Жезли",
    "reading_combination": ["death", "five_wands"],
    "reading_meaning": "Конфликт в края",
    "reading_description": "Битка, която ще сложи край на нещо. Последен сблъсък преди приключване.",
    "reading_advice": "Бори се достойно, после остави."
  },
  {
    "reading_id": "death_six_wands",
    "reading_name": "Последна победа",
    "reading_cards": "Смърт + 6 Жезли",
    "reading_combination": ["death", "six_wands"],
    "reading_meaning": "Успех преди края",
    "reading_description": "Постигаш успех точно преди нещо да приключи. Победа в последния момент.",
    "reading_advice": "Наслади се на успеха, после продължи напред."
  },
  {
    "reading_id": "death_seven_wands",
    "reading_name": "Последна защита",
    "reading_cards": "Смърт + 7 Жезли",
    "reading_combination": ["death", "seven_wands"],
    "reading_meaning": "Защитаваш се до края",
    "reading_description": "Защитаваш позицията си до последно. Битка до самия край.",
    "reading_advice": "Защитавай това, в което вярваш, но знай кога да спреш."
  },
  {
    "reading_id": "death_eight_wands",
    "reading_name": "Бърз край",
    "reading_cards": "Смърт + 8 Жезли",
    "reading_combination": ["death", "eight_wands"],
    "reading_meaning": "Всичко свършва бързо",
    "reading_description": "Краят идва неочаквано бързо. Внезапна трансформация, светкавична промяна.",
    "reading_advice": "Приеми скоростта на промяната."
  },
  {
    "reading_id": "death_nine_wands",
    "reading_name": "Упоритост до края",
    "reading_cards": "Смърт + 9 Жезли",
    "reading_combination": ["death", "nine_wands"],
    "reading_meaning": "Държиш се до последно",
    "reading_description": "Упорстваш до самия край. Не се предаваш, въпреки че знаеш, че краят идва.",
    "reading_advice": "Понякога трябва да се пуснеш, за да се родиш отново."
  },
  {
    "reading_id": "death_ten_wands",
    "reading_name": "Край на бремето",
    "reading_cards": "Смърт + 10 Жезли",
    "reading_combination": ["death", "ten_wands"],
    "reading_meaning": "Бремето свършва",
    "reading_description": "Тежкият период приключва. Край на това, което те е теглило надолу.",
    "reading_advice": "Освободи се и започни отново."
  },
  {
    "reading_id": "temperance_ace_wands",
    "reading_name": "Балансирано начало",
    "reading_cards": "Умереност + Асо Жезли",
    "reading_combination": ["temperance", "ace_wands"],
    "reading_meaning": "Започваш с мярка",
    "reading_description": "Започваш нещо ново, но без да прекаляваш. Балансиран старт, умерен ентусиазъм.",
    "reading_advice": "Върви напред с мярка и хармония."
  },
  {
    "reading_id": "temperance_two_wands",
    "reading_name": "Балансиран избор",
    "reading_cards": "Умереност + 2 Жезли",
    "reading_combination": ["temperance", "two_wands"],
    "reading_meaning": "Избираш с мярка",
    "reading_description": "Предстои ти избор и ще го направиш балансирано, без крайности. Златна среда.",
    "reading_advice": "Избери пътя, който води към хармония."
  },
  {
    "reading_id": "temperance_three_wands",
    "reading_name": "Търпеливо очакване",
    "reading_cards": "Умереност + 3 Жезли",
    "reading_combination": ["temperance", "three_wands"],
    "reading_meaning": "Чакаш с търпение",
    "reading_description": "Чакаш резултати, но без тревога. Спокойно очакване, вяра в процеса.",
    "reading_advice": "Чакай с мир в сърцето."
  },
  {
    "reading_id": "temperance_four_wands",
    "reading_name": "Балансиран празник",
    "reading_cards": "Умереност + 4 Жезли",
    "reading_combination": ["temperance", "four_wands"],
    "reading_meaning": "Празнуваш с мярка",
    "reading_description": "Празнуваш, но без да прекаляваш. Радост без загуба на контрол.",
    "reading_advice": "Празнувай, но помни златната среда."
  },
  {
    "reading_id": "temperance_five_wands",
    "reading_name": "Балансиран конфликт",
    "reading_cards": "Умереност + 5 Жезли",
    "reading_combination": ["temperance", "five_wands"],
    "reading_meaning": "Конфликт без крайности",
    "reading_description": "Спор, който се води учтиво, без да прекалява. Здравословно несъгласие.",
    "reading_advice": "Спори, но с уважение. Няма нужда от война."
  },
  {
    "reading_id": "temperance_six_wands",
    "reading_name": "Балансиран успех",
    "reading_cards": "Умереност + 6 Жезли",
    "reading_combination": ["temperance", "six_wands"],
    "reading_meaning": "Успех без гордост",
    "reading_description": "Постигаш успех, но запазваш смирение. Победа без високомерие.",
    "reading_advice": "Радвай се на успеха, но не забравяй откъде идваш."
  },
  {
    "reading_id": "temperance_seven_wands",
    "reading_name": "Балансирана защита",
    "reading_cards": "Умереност + 7 Жезли",
    "reading_combination": ["temperance", "seven_wands"],
    "reading_meaning": "Защитаваш се без агресия",
    "reading_description": "Отстояваш позицията си, но без нападки. Твърд, но спокоен.",
    "reading_advice": "Защитавай се с достойнство, не с агресия."
  },
  {
    "reading_id": "temperance_eight_wands",
    "reading_name": "Балансирана скорост",
    "reading_cards": "Умереност + 8 Жезли",
    "reading_combination": ["temperance", "eight_wands"],
    "reading_meaning": "Бързина с мярка",
    "reading_description": "Движиш се бързо, но без да изпускаш контрол. Скорост и хармония.",
    "reading_advice": "Бързай, но с мярка."
  },
  {
    "reading_id": "temperance_nine_wands",
    "reading_name": "Балансирана упоритост",
    "reading_cards": "Умереност + 9 Жезли",
    "reading_combination": ["temperance", "nine_wands"],
    "reading_meaning": "Упорстваш, без да се изтощаваш",
    "reading_description": "Продължаваш напред, но с внимание към себе си. Упоритост без прегаряне.",
    "reading_advice": "Упорствай, но не забравяй да си почиваш."
  },
  {
    "reading_id": "temperance_ten_wands",
    "reading_name": "Балансирано бреме",
    "reading_cards": "Умереност + 10 Жезли",
    "reading_combination": ["temperance", "ten_wands"],
    "reading_meaning": "Носиш бреме с мярка",
    "reading_description": "Носиш отговорности, но знаеш границите си. Баланс между дълг и себе си.",
    "reading_advice": "Носи само това, което можеш. Останалото остави."
  },
  {
    "reading_id": "devil_ace_wands",
    "reading_name": "Зависимост от идея",
    "reading_cards": "Дявол + Асо Жезли",
    "reading_combination": ["devil", "ace_wands"],
    "reading_meaning": "Обсебваща нова страст",
    "reading_description": "Нова идея или проект те обсебва напълно. Страст, която може да стане зависимост.",
    "reading_advice": "Наслаждавай се, но внимавай да не изгубиш себе си."
  },
  {
    "reading_id": "devil_two_wands",
    "reading_name": "Обсебващ избор",
    "reading_cards": "Дявол + 2 Жезли",
    "reading_combination": ["devil", "two_wands"],
    "reading_meaning": "Избор, воден от зависимост",
    "reading_description": "Избираш не със свободна воля, а воден от зависимости или страхове.",
    "reading_advice": "Осъзнай какво наистина движи избора ти."
  },
  {
    "reading_id": "devil_three_wands",
    "reading_name": "Обсебващо очакване",
    "reading_cards": "Дявол + 3 Жезли",
    "reading_combination": ["devil", "three_wands"],
    "reading_meaning": "Чакаш в плен на зависимост",
    "reading_description": "Очакването е измъчващо, защото си зависим от резултата. Нямаш мир.",
    "reading_advice": "Освободи се от привързаността към резултата."
  },
  {
    "reading_id": "devil_four_wands",
    "reading_name": "Празник на зависимостта",
    "reading_cards": "Дявол + 4 Жезли",
    "reading_combination": ["devil", "four_wands"],
    "reading_meaning": "Празнуваш нещо нездраво",
    "reading_description": "Празнуваш постижение, което всъщност те заробва. Илюзорна радост.",
    "reading_advice": "Провери дали празнуваш свобода или нови окови."
  },
  {
    "reading_id": "devil_five_wands",
    "reading_name": "Битка от зависимост",
    "reading_cards": "Дявол + 5 Жезли",
    "reading_combination": ["devil", "five_wands"],
    "reading_meaning": "Конфликт, воден от его",
    "reading_description": "Спорове, които идват от его и зависимост, не от реални различия.",
    "reading_advice": "Излез от битката. Тя не е твоя."
  },
  {
    "reading_id": "devil_six_wands",
    "reading_name": "Успех на егото",
    "reading_cards": "Дявол + 6 Жезли",
    "reading_combination": ["devil", "six_wands"],
    "reading_meaning": "Победа, която храни зависимостта",
    "reading_description": "Успех, който те прави още по-зависим от власт, пари или признание.",
    "reading_advice": "Успехът не трябва да те заробва. Преосмисли."
  },
  {
    "reading_id": "devil_seven_wands",
    "reading_name": "Защита на егото",
    "reading_cards": "Дявол + 7 Жезли",
    "reading_combination": ["devil", "seven_wands"],
    "reading_meaning": "Защитаваш зависимостите си",
    "reading_description": "Бориш се да запазиш нещо, което всъщност ти вреди. Защита на слабостта.",
    "reading_advice": "Понякога трябва да загубиш битка, за да спечелиш войната със себе си."
  },
  {
    "reading_id": "devil_eight_wands",
    "reading_name": "Бърза зависимост",
    "reading_cards": "Дявол + 8 Жезли",
    "reading_combination": ["devil", "eight_wands"],
    "reading_meaning": "Пристрастяването идва бързо",
    "reading_description": "Зависимост, която се развива светкавично. Внимавай какво започваш.",
    "reading_advice": "Бързите удоволствия водят до бавна смърт. Внимавай."
  },
  {
    "reading_id": "devil_nine_wands",
    "reading_name": "Упорита зависимост",
    "reading_cards": "Дявол + 9 Жезли",
    "reading_combination": ["devil", "nine_wands"],
    "reading_meaning": "Не се отказваш от зависимостта",
    "reading_description": "Въпреки че знаеш, че нещо ти вреди, продължаваш. Упоритост в грешката.",
    "reading_advice": "Първата стъпка към свободата е да признаеш, че си в плен."
  },
  {
    "reading_id": "devil_ten_wands",
    "reading_name": "Тежест на зависимостта",
    "reading_cards": "Дявол + 10 Жезли",
    "reading_combination": ["devil", "ten_wands"],
    "reading_meaning": "Носиш тежестта на пороците",
    "reading_description": "Зависимостите са се превърнали в непоносимо бреме. Време за промяна.",
    "reading_advice": "Бремето може да те смаже. Освободи се."
  },
  {
    "reading_id": "tower_ace_wands",
    "reading_name": "Внезапна нова идея",
    "reading_cards": "Кула + Асо Жезли",
    "reading_combination": ["tower", "ace_wands"],
    "reading_meaning": "Прозрение от срив",
    "reading_description": "След внезапен срив получаваш нова идея или прозрение. Светлина след разруха.",
    "reading_advice": "Понякога трябва да рухнеш, за да видиш нов път."
  },
  {
    "reading_id": "tower_two_wands",
    "reading_name": "Избор след срив",
    "reading_cards": "Кула + 2 Жезли",
    "reading_combination": ["tower", "two_wands"],
    "reading_meaning": "Избираш след разруха",
    "reading_description": "След като всичко се срива, трябва да избереш нова посока. Ново начало.",
    "reading_advice": "Избери смело. Няма как да е по-зле от това, което беше."
  },
  {
    "reading_id": "tower_three_wands",
    "reading_name": "Чакане след срив",
    "reading_cards": "Кула + 3 Жезли",
    "reading_combination": ["tower", "three_wands"],
    "reading_meaning": "Очакваш след разруха",
    "reading_description": "След срива чакаш да видиш какво ще се появи. Несигурност и надежда.",
    "reading_advice": "Чакай с търпение. Новото идва."
  },
  {
    "reading_id": "tower_four_wands",
    "reading_name": "Празник след разруха",
    "reading_cards": "Кула + 4 Жезли",
    "reading_combination": ["tower", "four_wands"],
    "reading_meaning": "Радост след срив",
    "reading_description": "След като всичко рухна, най-после идва повод за празник. Облекчение и радост.",
    "reading_advice": "Празнувай новото начало. Ти го заслужи."
  },
  {
    "reading_id": "tower_five_wands",
    "reading_name": "Конфликт след срив",
    "reading_cards": "Кула + 5 Жезли",
    "reading_combination": ["tower", "five_wands"],
    "reading_meaning": "Битка в руините",
    "reading_description": "Дори след като всичко рухна, конфликтите продължават. Още битки.",
    "reading_advice": "Понякога трябва да спреш да се биеш, за да започнеш да градиш."
  },
  {
    "reading_id": "tower_six_wands",
    "reading_name": "Успех след срив",
    "reading_cards": "Кула + 6 Жезли",
    "reading_combination": ["tower", "six_wands"],
    "reading_meaning": "Победа от пепелта",
    "reading_description": "След пълно разрушение идва неочакван успех. Феникс се издига.",
    "reading_advice": "Ти възкръсна от пепелта. Гордей се."
  },
  {
    "reading_id": "tower_seven_wands",
    "reading_name": "Защита след срив",
    "reading_cards": "Кула + 7 Жезли",
    "reading_combination": ["tower", "seven_wands"],
    "reading_meaning": "Бориш се след разруха",
    "reading_description": "Дори след като си загубил почти всичко, продължаваш да се защитаваш. Упоритост.",
    "reading_advice": "Понякога трябва да спреш да се защитаваш и да започнеш да градиш."
  },
  {
    "reading_id": "tower_eight_wands",
    "reading_name": "Бързина след срив",
    "reading_cards": "Кула + 8 Жезли",
    "reading_combination": ["tower", "eight_wands"],
    "reading_meaning": "Всичко се случва бързо след разруха",
    "reading_description": "След срива промените идват светкавично. Няма време за бавно възстановяване.",
    "reading_advice": "Язди скоростта на промяната."
  },
  {
    "reading_id": "tower_nine_wands",
    "reading_name": "Упоритост след срив",
    "reading_cards": "Кула + 9 Жезли",
    "reading_combination": ["tower", "nine_wands"],
    "reading_meaning": "Не се предаваш след разруха",
    "reading_description": "Въпреки че всичко рухна, ти продължаваш. Упоритост, която вдъхновява.",
    "reading_advice": "Дръж се. Новият ден идва."
  },
  {
    "reading_id": "tower_ten_wands",
    "reading_name": "Край на бремето в срив",
    "reading_cards": "Кула + 10 Жезли",
    "reading_combination": ["tower", "ten_wands"],
    "reading_meaning": "Срив, който освобождава",
    "reading_description": "Разрухата сложи край на непоносимо бреме. Свобода в руините.",
    "reading_advice": "Понякога трябва да загубиш всичко, за да спечелиш себе си."
  },
  {
    "reading_id": "star_ace_wands",
    "reading_name": "Надежда и ново начало",
    "reading_cards": "Звезда + Асо Жезли",
    "reading_combination": ["star", "ace_wands"],
    "reading_meaning": "Вдъхновен старт",
    "reading_description": "Започваш нещо ново, изпълнен с надежда и вдъхновение. Звездите те водят.",
    "reading_advice": "Следвай звездата си. Тя води към мечтите."
  },
  {
    "reading_id": "star_two_wands",
    "reading_name": "Надежден избор",
    "reading_cards": "Звезда + 2 Жезли",
    "reading_combination": ["star", "two_wands"],
    "reading_meaning": "Избираш с надежда",
    "reading_description": "Предстои ти избор и го правиш с вяра в бъдещето. Надежда в решението.",
    "reading_advice": "Избери това, което носи светлина в сърцето ти."
  },
  {
    "reading_id": "star_three_wands",
    "reading_name": "Надеждно очакване",
    "reading_cards": "Звезда + 3 Жезли",
    "reading_combination": ["star", "three_wands"],
    "reading_meaning": "Чакаш с вяра",
    "reading_description": "Очакваш резултати, но без тревога. Вярата, че всичко ще бъде наред.",
    "reading_advice": "Чакай с надежда, не с нетърпение."
  },
  {
    "reading_id": "star_four_wands",
    "reading_name": "Надежден празник",
    "reading_cards": "Звезда + 4 Жезли",
    "reading_combination": ["star", "four_wands"],
    "reading_meaning": "Празнуваш с надежда",
    "reading_description": "Празник, изпълнен с надежда за бъдещето. Радост и оптимизъм.",
    "reading_advice": "Празнувай, но гледай напред."
  },
  {
    "reading_id": "star_five_wands",
    "reading_name": "Надежда в конфликта",
    "reading_cards": "Звезда + 5 Жезли",
    "reading_combination": ["star", "five_wands"],
    "reading_meaning": "Вярваш в мир сред битка",
    "reading_description": "Дори в конфликт запазваш надежда за помирение. Светлина в бурята.",
    "reading_advice": "Не спирай да вярваш в мира."
  },
  {
    "reading_id": "star_six_wands",
    "reading_name": "Надежден успех",
    "reading_cards": "Звезда + 6 Жезли",
    "reading_combination": ["star", "six_wands"],
    "reading_meaning": "Успех, в който си вярвал",
    "reading_description": "Успехът идва, защото си вярвал. Надеждата ти се сбъдва.",
    "reading_advice": "Ти вярва и то се случи. Продължавай да вярваш."
  },
  {
    "reading_id": "star_seven_wands",
    "reading_name": "Надеждна защита",
    "reading_cards": "Звезда + 7 Жезли",
    "reading_combination": ["star", "seven_wands"],
    "reading_meaning": "Защитаваш се с вяра",
    "reading_description": "Отстояваш позицията си с надежда, че ще успееш. Вяра в победата.",
    "reading_advice": "Защитавай се с надежда в сърцето."
  },
  {
    "reading_id": "star_eight_wands",
    "reading_name": "Надеждна скорост",
    "reading_cards": "Звезда + 8 Жезли",
    "reading_combination": ["star", "eight_wands"],
    "reading_meaning": "Бързина с надежда",
    "reading_description": "Нещата се случват бързо и ти вярваш, че е за добро. Оптимизъм в движението.",
    "reading_advice": "Довери се на скоростта на съдбата."
  },
  {
    "reading_id": "star_nine_wands",
    "reading_name": "Упорита надежда",
    "reading_cards": "Звезда + 9 Жезли",
    "reading_combination": ["star", "nine_wands"],
    "reading_meaning": "Не спираш да вярваш",
    "reading_description": "Въпреки трудностите, надеждата не умира. Упорита вяра в доброто.",
    "reading_advice": "Надеждата умира последна. Дръж се за нея."
  },
  {
    "reading_id": "star_ten_wands",
    "reading_name": "Надежда под бреме",
    "reading_cards": "Звезда + 10 Жезли",
    "reading_combination": ["star", "ten_wands"],
    "reading_meaning": "Вярваш, че бремето ще свърши",
    "reading_description": "Носиш тежко бреме, но вярваш, че то няма да е вечно. Светлина в тунела.",
    "reading_advice": "Дръж се. Бремето ще се вдигне."
  },
  {
    "reading_id": "moon_ace_wands",
    "reading_name": "Заблудена искра",
    "reading_cards": "Луна + Асо Жезли",
    "reading_combination": ["moon", "ace_wands"],
    "reading_meaning": "Нова идея, помрачена от страх",
    "reading_description": "Нова идея се ражда, но страховете и илюзиите я замъгляват. Не виждаш ясно.",
    "reading_advice": "Изчакай мъглата да се вдигне, преди да действаш."
  },
  {
    "reading_id": "moon_two_wands",
    "reading_name": "Заблуден избор",
    "reading_cards": "Луна + 2 Жезли",
    "reading_combination": ["moon", "two_wands"],
    "reading_meaning": "Избираш в мъгла",
    "reading_description": "Предстои ти избор, но не виждаш ясно опциите. Страхът замъглява преценката.",
    "reading_advice": "Не избирай в мъгла. Изчакай яснота."
  },
  {
    "reading_id": "moon_three_wands",
    "reading_name": "Заблудено очакване",
    "reading_cards": "Луна + 3 Жезли",
    "reading_combination": ["moon", "three_wands"],
    "reading_meaning": "Чакаш, без да знаеш какво",
    "reading_description": "Очакваш нещо, но не знаеш какво. Страх и несигурност в чакането.",
    "reading_advice": "Чакай със спокойствие. Мъглата ще се вдигне."
  },
  {
    "reading_id": "moon_four_wands",
    "reading_name": "Заблуден празник",
    "reading_cards": "Луна + 4 Жезли",
    "reading_combination": ["moon", "four_wands"],
    "reading_meaning": "Празнуваш, без да си сигурен защо",
    "reading_description": "Празник, зад който се крие несигурност или страх. Радост, която не е истинска.",
    "reading_advice": "Провери дали празнуваш истинска радост или бягаш от страха."
  },
  {
    "reading_id": "moon_five_wands",
    "reading_name": "Заблуден конфликт",
    "reading_cards": "Луна + 5 Жезли",
    "reading_combination": ["moon", "five_wands"],
    "reading_meaning": "Бориш се с илюзии",
    "reading_description": "Конфликт, който може да е въображаем. Бориш се с ветрени мелници.",
    "reading_advice": "Провери дали битката ти е реална или в главата ти."
  },
  {
    "reading_id": "moon_six_wands",
    "reading_name": "Заблуден успех",
    "reading_cards": "Луна + 6 Жезли",
    "reading_combination": ["moon", "six_wands"],
    "reading_meaning": "Мислиш, че си успял, но може да е илюзия",
    "reading_description": "Мислиш, че си успял, но може да е илюзия. Провери реалността.",
    "reading_advice": "Празнувай, но с едно око отворено за истината."
  },
  {
    "reading_id": "moon_seven_wands",
    "reading_name": "Заблудена защита",
    "reading_cards": "Луна + 7 Жезли",
    "reading_combination": ["moon", "seven_wands"],
    "reading_meaning": "Защитаваш се от страхове",
    "reading_description": "Защитаваш се от нещо, което може да съществува само в ума ти. Илюзорни врагове.",
    "reading_advice": "Най-големите врагове често са в главата ни."
  },
  {
    "reading_id": "moon_eight_wands",
    "reading_name": "Заблудена скорост",
    "reading_cards": "Луна + 8 Жезли",
    "reading_combination": ["moon", "eight_wands"],
    "reading_meaning": "Бързаш в мъгла",
    "reading_description": "Движиш се бързо, но без да виждаш накъде. Скорост без посока.",
    "reading_advice": "Забави. По-добре бавно в правилната посока."
  },
  {
    "reading_id": "moon_nine_wands",
    "reading_name": "Упорит в страха",
    "reading_cards": "Луна + 9 Жезли",
    "reading_combination": ["moon", "nine_wands"],
    "reading_meaning": "Не се предаваш на страха",
    "reading_description": "Въпреки страховете и илюзиите, продължаваш. Упоритост в мъглата.",
    "reading_advice": "Упорствай, но не затваряй очи за истината."
  },
  {
    "reading_id": "moon_ten_wands",
    "reading_name": "Тежест на страха",
    "reading_cards": "Луна + 10 Жезли",
    "reading_combination": ["moon", "ten_wands"],
    "reading_meaning": "Носиш бреме от страхове",
    "reading_description": "Страховете и илюзиите са се превърнали в непоносимо бреме. Трудно дишаш.",
    "reading_advice": "Освободи се от страховете. Те тежат повече от всичко."
  },
  {
    "reading_id": "sun_ace_wands",
    "reading_name": "Слънчево начало",
    "reading_cards": "Слънце + Асо Жезли",
    "reading_combination": ["sun", "ace_wands"],
    "reading_meaning": "Радостен старт",
    "reading_description": "Започваш нещо ново, изпълнен с радост и светлина. Слънчев ентусиазъм.",
    "reading_advice": "Тръгни със слънце в душата."
  },
  {
    "reading_id": "sun_two_wands",
    "reading_name": "Слънчев избор",
    "reading_cards": "Слънце + 2 Жезли",
    "reading_combination": ["sun", "two_wands"],
    "reading_meaning": "Избираш с радост",
    "reading_description": "Предстои ти избор и го правиш с лекота и радост. Слънчево решение.",
    "reading_advice": "Избери това, което те кара да се усмихваш."
  },
  {
    "reading_id": "sun_three_wands",
    "reading_name": "Слънчево очакване",
    "reading_cards": "Слънце + 3 Жезли",
    "reading_combination": ["sun", "three_wands"],
    "reading_meaning": "Чакаш с радост",
    "reading_description": "Очакваш резултати, но с усмивка. Знаеш, че всичко ще бъде наред.",
    "reading_advice": "Чакай като дете, което очаква подарък."
  },
  {
    "reading_id": "sun_four_wands",
    "reading_name": "Слънчев празник",
    "reading_cards": "Слънце + 4 Жезли",
    "reading_combination": ["sun", "four_wands"],
    "reading_meaning": "Празнуваш с радост",
    "reading_description": "Празник, изпълнен със слънце и светлина. Щастие, което се споделя.",
    "reading_advice": "Празнувай с пълно сърце."
  },
  {
    "reading_id": "sun_five_wands",
    "reading_name": "Слънчев конфликт",
    "reading_cards": "Слънце + 5 Жезли",
    "reading_combination": ["sun", "five_wands"],
    "reading_meaning": "Конфликт без омраза",
    "reading_description": "Спор, който не помрачава радостта. Здравословно несъгласие без злоба.",
    "reading_advice": "Спори, но помни, че всички сте деца на слънцето."
  },
  {
    "reading_id": "sun_six_wands",
    "reading_name": "Триумф",
    "reading_cards": "Слънце + 6 Жезли",
    "reading_combination": ["sun", "six_wands"],
    "reading_meaning": "Велика победа",
    "reading_description": "Успех, който те кара да блестиш. Победа, признание, радост.",
    "reading_advice": "Ти си победител. Наслади се на светлината."
  },
  {
    "reading_id": "sun_seven_wands",
    "reading_name": "Слънчева защита",
    "reading_cards": "Слънце + 7 Жезли",
    "reading_combination": ["sun", "seven_wands"],
    "reading_meaning": "Защитаваш се с усмивка",
    "reading_description": "Отстояваш позицията си, но без да губиш добронамереност. Сила и светлина.",
    "reading_advice": "Защитавай се, но не спирай да светиш."
  },
  {
    "reading_id": "sun_eight_wands",
    "reading_name": "Бърз успех",
    "reading_cards": "Слънце + 8 Жезли",
    "reading_combination": ["sun", "eight_wands"],
    "reading_meaning": "Всичко се случва бързо и добре",
    "reading_description": "Успехът идва светкавично и носи радост. Бързина и щастие.",
    "reading_advice": "Наслаждавай се на бързината."
  },
  {
    "reading_id": "sun_nine_wands",
    "reading_name": "Слънчева упоритост",
    "reading_cards": "Слънце + 9 Жезли",
    "reading_combination": ["sun", "nine_wands"],
    "reading_meaning": "Упорстваш с усмивка",
    "reading_description": "Въпреки трудностите, не губиш оптимизъм. Упоритост и светлина.",
    "reading_advice": "Упорствай, но не спирай да се усмихваш."
  },
  {
    "reading_id": "sun_ten_wands",
    "reading_name": "Щастие под бреме",
    "reading_cards": "Слънце + 10 Жезли",
    "reading_combination": ["sun", "ten_wands"],
    "reading_meaning": "Носиш бреме, но си щастлив",
    "reading_description": "Отговорностите са много, но сърцето ти е леко. Радост въпреки тежестта.",
    "reading_advice": "Щастието не зависи от бремето, а от сърцето."
  },
  {
    "reading_id": "judgement_ace_wands",
    "reading_name": "Пробудено начало",
    "reading_cards": "Съд + Асо Жезли",
    "reading_combination": ["judgement", "ace_wands"],
    "reading_meaning": "Ново начало след пробуждане",
    "reading_description": "Започваш нещо ново, след като си отговорил на вътрешен зов. Пробуден старт.",
    "reading_advice": "Следвай зова. Той води към нов живот."
  },
  {
    "reading_id": "judgement_two_wands",
    "reading_name": "Пробуден избор",
    "reading_cards": "Съд + 2 Жезли",
    "reading_combination": ["judgement", "two_wands"],
    "reading_meaning": "Избираш след пробуждане",
    "reading_description": "Избор, който правиш с ново съзнание. Пробудено решение.",
    "reading_advice": "Избери това, което резонира с новото ти Аз."
  },
  {
    "reading_id": "judgement_three_wands",
    "reading_name": "Пробудено очакване",
    "reading_cards": "Съд + 3 Жезли",
    "reading_combination": ["judgement", "three_wands"],
    "reading_meaning": "Чакаш с ново съзнание",
    "reading_description": "Очакваш резултати, но вече не си същият. Пробудено търпение.",
    "reading_advice": "Чакай с новите си очи."
  },
  {
    "reading_id": "judgement_four_wands",
    "reading_name": "Пробуден празник",
    "reading_cards": "Съд + 4 Жезли",
    "reading_combination": ["judgement", "four_wands"],
    "reading_meaning": "Празнуваш пробуждане",
    "reading_description": "Празник на новото съзнание. Радост от прераждането.",
    "reading_advice": "Празнувай новия си живот."
  },
  {
    "reading_id": "judgement_five_wands",
    "reading_name": "Пробуден конфликт",
    "reading_cards": "Съд + 5 Жезли",
    "reading_combination": ["judgement", "five_wands"],
    "reading_meaning": "Битка за нови истини",
    "reading_description": "Конфликт, воден от новите ти разбирания. Бориш се за истината.",
    "reading_advice": "Бори се за истината, но с любов."
  },
  {
    "reading_id": "judgement_six_wands",
    "reading_name": "Пробуден успех",
    "reading_cards": "Съд + 6 Жезли",
    "reading_combination": ["judgement", "six_wands"],
    "reading_meaning": "Успех след пробуждане",
    "reading_description": "Успехът идва, защото си открил истинския си път. Признание на новото Аз.",
    "reading_advice": "Приеми успеха като потвърждение на пътя ти."
  },
  {
    "reading_id": "judgement_seven_wands",
    "reading_name": "Пробудена защита",
    "reading_cards": "Съд + 7 Жезли",
    "reading_combination": ["judgement", "seven_wands"],
    "reading_meaning": "Защитаваш новото си Аз",
    "reading_description": "Отстояваш новите си убеждения и идентичност. Защита на пробуденото.",
    "reading_advice": "Защитавай новото си Аз с достойнство."
  },
  {
    "reading_id": "judgement_eight_wands",
    "reading_name": "Пробудена скорост",
    "reading_cards": "Съд + 8 Жезли",
    "reading_combination": ["judgement", "eight_wands"],
    "reading_meaning": "Бързо след пробуждане",
    "reading_description": "След пробуждането всичко се случва бързо. Новият живот ускорява.",
    "reading_advice": "Язди скоростта на новото начало."
  },
  {
    "reading_id": "judgement_nine_wands",
    "reading_name": "Пробудена упоритост",
    "reading_cards": "Съд + 9 Жезли",
    "reading_combination": ["judgement", "nine_wands"],
    "reading_meaning": "Упорстваш в новия път",
    "reading_description": "Въпреки трудностите, продължаваш по новия път. Упоритост на пробудения.",
    "reading_advice": "Дръж се. Новият път си струва."
  },
  {
    "reading_id": "judgement_ten_wands",
    "reading_name": "Пробудено бреме",
    "reading_cards": "Съд + 10 Жезли",
    "reading_combination": ["judgement", "ten_wands"],
    "reading_meaning": "Носиш бреме с ново съзнание",
    "reading_description": "Отговорностите са същите, но ти ги носиш по нов начин. Пробудена тежест.",
    "reading_advice": "Бремето е същото, но ти си различен."
  },
  {
    "reading_id": "world_ace_wands",
    "reading_name": "Завършено начало",
    "reading_cards": "Свят + Асо Жезли",
    "reading_combination": ["world", "ace_wands"],
    "reading_meaning": "Нов цикъл започва",
    "reading_description": "След като един цикъл завърши, започва нов. Край и начало в хармония.",
    "reading_advice": "Започни новия цикъл с мъдростта на предишния."
  },
  {
    "reading_id": "world_two_wands",
    "reading_name": "Завършен избор",
    "reading_cards": "Свят + 2 Жезли",
    "reading_combination": ["world", "two_wands"],
    "reading_meaning": "Избираш след завършек",
    "reading_description": "След като нещо приключи, избираш нова посока. Избор с пълно съзнание.",
    "reading_advice": "Избери с мъдростта на завършилия цикъл."
  },
  {
    "reading_id": "world_three_wands",
    "reading_name": "Завършено очакване",
    "reading_cards": "Свят + 3 Жезли",
    "reading_combination": ["world", "three_wands"],
    "reading_meaning": "Чакаш след завършек",
    "reading_description": "Очакваш резултати, знаейки, че един цикъл е приключил. Спокойно чакане.",
    "reading_advice": "Чакай с търпението на завършилия."
  },
  {
    "reading_id": "world_four_wands",
    "reading_name": "Завършен празник",
    "reading_cards": "Свят + 4 Жезли",
    "reading_combination": ["world", "four_wands"],
    "reading_meaning": "Празнуваш завършек",
    "reading_description": "Празнуваш успешното приключване на важен цикъл. Радост и завършеност.",
    "reading_advice": "Празнувай постижението. Ти завърши кръга."
  },
  {
    "reading_id": "world_five_wands",
    "reading_name": "Завършен конфликт",
    "reading_cards": "Свят + 5 Жезли",
    "reading_combination": ["world", "five_wands"],
    "reading_meaning": "Последна битка",
    "reading_description": "Конфликт, който ще приключи цикъл. Последна битка преди мир.",
    "reading_advice": "Бори се достойно, после остави."
  },
  {
    "reading_id": "world_six_wands",
    "reading_name": "Завършен успех",
    "reading_cards": "Свят + 6 Жезли",
    "reading_combination": ["world", "six_wands"],
    "reading_meaning": "Върховно постижение",
    "reading_description": "Успех, който завършва важен цикъл. Най-високото признание.",
    "reading_advice": "Ти стигна върха. Наслади се на гледката."
  },
  {
    "reading_id": "world_seven_wands",
    "reading_name": "Завършена защита",
    "reading_cards": "Свят + 7 Жезли",
    "reading_combination": ["world", "seven_wands"],
    "reading_meaning": "Последна защита",
    "reading_description": "Защитаваш постигнатото до последно. Последна битка за завършека.",
    "reading_advice": "Защити постигнатото, после го пусни."
  },
  {
    "reading_id": "world_eight_wands",
    "reading_name": "Завършена скорост",
    "reading_cards": "Свят + 8 Жезли",
    "reading_combination": ["world", "eight_wands"],
    "reading_meaning": "Бърз завършек",
    "reading_description": "Цикълът приключва неочаквано бързо. Скорост на завършека.",
    "reading_advice": "Приеми бързия край като благословия."
  },
  {
    "reading_id": "world_nine_wands",
    "reading_name": "Упорит до края",
    "reading_cards": "Свят + 9 Жезли",
    "reading_combination": ["world", "nine_wands"],
    "reading_meaning": "Държиш се до завършека",
    "reading_description": "Упорстваш до самия край на цикъла. Не се предаваш, докато не завършиш.",
    "reading_advice": "Дръж се. Краят наближава."
  },
  {
    "reading_id": "world_ten_wands",
    "reading_name": "Край на бремето",
    "reading_cards": "Свят + 10 Жезли",
    "reading_combination": ["world", "ten_wands"],
    "reading_meaning": "Завършек на тежък период",
    "reading_description": "Бремето, което си носил, най-после приключва. Завършек на тежък период.",
    "reading_advice": "Пусни бремето. Ти завърши."
  },
  {
    "reading_id": "jackpot",
    "reading_name": "Джакпот",
    "reading_cards": "Слънце + 10 Чаши + 6 Жезли",
    "reading_combination": ["sun", "ten_cups", "six_wands"],
    "reading_meaning": "Всичко се нарежда",
    "reading_description": "Върхът на щастието. Всичко, което си искал, се сбъдва едновременно.",
    "reading_advice": "Наслаждавай се! Ти заслужаваш този момент. Бъди благодарен."
  },
  {
    "reading_id": "protection",
    "reading_name": "Закрила",
    "reading_cards": "Сила + 6 Жезли + 9 Жезли",
    "reading_combination": ["strength", "six_wands", "nine_wands"],
    "reading_meaning": "Закрила и сила",
    "reading_description": "Въпреки трудностите, ще издържиш. Имаш вътрешна сила и закрила отгоре.",
    "reading_advice": "Дръж се – победата е близо. Вярвай в себе си."
  },
  {
    "reading_id": "love_triangle",
    "reading_name": "Любовен триъгълник",
    "reading_cards": "3 Чаши + 7 Мечове + Дявол",
    "reading_combination": ["three_cups", "seven_swords", "devil"],
    "reading_meaning": "Любовен триъгълник",
    "reading_description": "Трима души в играта. Някой крие нещо. Внимавай – може да си третият, без да знаеш.",
    "reading_advice": "Истината ще излезе. По-добре сега, отколкото после."
  },
  {
    "reading_id": "love_choice",
    "reading_name": "Избор между двама",
    "reading_cards": "3 Чаши + 2 Чаши + 3 Мечове",
    "reading_combination": ["three_cups", "two_cups", "three_swords"],
    "reading_meaning": "Труден избор",
    "reading_description": "Трябва да избереш между двама души. И двамата носят и радост, и болка.",
    "reading_advice": "Слушай сърцето си, не ума. То знае."
  },
  {
    "reading_id": "karmic_love",
    "reading_name": "Кармична любов",
    "reading_cards": "Колело на съдбата + 6 Чаши + 2 Чаши",
    "reading_combination": ["wheel_of_fortune", "six_cups", "two_cups"],
    "reading_meaning": "Кармична среща",
    "reading_description": "Познаваш този човек от минал живот. Имате недовършена работа, която трябва да приключите сега.",
    "reading_advice": "Каквото не научите сега, ще повторите пак. Бъдете внимателни."
  },
  {
    "reading_id": "love_fast",
    "reading_name": "Любов от пръв поглед",
    "reading_cards": "8 Жезли + Асо Чаши",
    "reading_combination": ["eight_wands", "ace_cups"],
    "reading_meaning": "Бърза любов",
    "reading_description": "Всичко се случва светкавично. Страст, която пламва веднага.",
    "reading_advice": "Наслаждавай се, но не изгаряй прекалено бързо."
  },
  {
    "reading_id": "love_slow",
    "reading_name": "Бавно изграждане",
    "reading_cards": "8 Пентакли + 2 Чаши",
    "reading_combination": ["eight_pentacles", "two_cups"],
    "reading_meaning": "Бавен и стабилен растеж",
    "reading_description": "Връзка, която се гради бавно, но стабилно. Търпение.",
    "reading_advice": "Няма нужда да бързаш. Истинското идва с времето."
  },
  {
    "reading_id": "sexual_chemistry",
    "reading_name": "Силна сексуална химия",
    "reading_cards": "Асо Жезли + Дявол",
    "reading_combination": ["ace_wands", "devil"],
    "reading_meaning": "Чисто физическо привличане",
    "reading_description": "Привличането е чисто физическо, почти обсебващо.",
    "reading_advice": "Наслаждавай се, но внимавай да не объркаш страстта с любов."
  },
 
 
  {
    "reading_id": "international_success",
    "reading_name": "Международен успех",
    "reading_cards": "6 Жезли + Асо Пентакли + Светът",
    "reading_combination": ["six_wands", "ace_pentacles", "world"],
    "reading_meaning": "Голям кариерен успех",
    "reading_description": "Голям успех в кариерата – повишение, нова работа, собствен бизнес. Международно признание.",
    "reading_advice": "Приеми наградата – заслужил си я. Сега разширявай хоризонтите."
  },
  {
    "reading_id": "business_start",
    "reading_name": "Успешен старт на бизнес",
    "reading_cards": "Асо Жезли + 8 Пентакли + Император",
    "reading_combination": ["ace_wands", "eight_pentacles", "emperor"],
    "reading_meaning": "Нов бизнес проект",
    "reading_description": "Стартиране на собствен бизнес или проект. Имаш идея, упоритост и структура.",
    "reading_advice": "Действай! Това е моментът. Имаш всичко необходимо."
  },
  {
    "reading_id": "job_change",
    "reading_name": "Промяна на работа",
    "reading_cards": "8 Мечове + 6 Мечове + Колесница",
    "reading_combination": ["eight_swords", "six_swords", "chariot"],
    "reading_meaning": "Освобождение от стара работа",
    "reading_description": "Чувствал си се в капан, но сега намираш изход. Напускаш старата работа и тръгваш към нова.",
    "reading_advice": "Не се обръщай назад – водите те носят към по-добро."
  },
  {
    "reading_id": "inheritance",
    "reading_name": "Наследство",
    "reading_cards": "10 Пентакли + 4 Пентакли + Смърт",
    "reading_combination": ["ten_pentacles", "four_pentacles", "death"],
    "reading_meaning": "Получаване на наследство",
    "reading_description": "Получаване на наследство след смърт на роднина. Пари, имот, ценности.",
    "reading_advice": "Приеми с благодарност, но внимавай за алчност и кавги в семейството."
  },
  {
    "reading_id": "office_politics",
    "reading_name": "Офис политики",
    "reading_cards": "5 Жезли + 7 Мечове",
    "reading_combination": ["five_wands", "seven_swords"],
    "reading_meaning": "Интриги и клюки",
    "reading_description": "Интриги, клюки, борба за власт. Има скрити врагове.",
    "reading_advice": "Пази гърба си. Не се замесвай в клюки. Работи, мълчи и гледай."
  },
  {
    "reading_id": "creative_project",
    "reading_name": "Творчески проект",
    "reading_cards": "Асо Жезли + 3 Чаши",
    "reading_combination": ["ace_wands", "three_cups"],
    "reading_meaning": "Творческа работа",
    "reading_description": "Работа, свързана с изкуство, музика, писане. Твориш с радост.",
    "reading_advice": "Пусни въображението си. Това, което създаваш сега, носи радост на другите."
  },
  {
    "reading_id": "burnout",
    "reading_name": "Прегаряне",
    "reading_cards": "10 Жезли + 4 Мечове",
    "reading_combination": ["ten_wands", "four_swords"],
    "reading_meaning": "Изтощение",
    "reading_description": "Работиш прекалено много – тялото иска почивка.",
    "reading_advice": "Спри! Болничният идва, ако не спреш доброволно. Почивката не е лукс, а нужда."
  },
  {
    "reading_id": "new_home",
    "reading_name": "Нов дом",
    "reading_cards": "Асо Пентакли + 10 Пентакли + 4 Жезли",
    "reading_combination": ["ace_pentacles", "ten_pentacles", "four_wands"],
    "reading_meaning": "Купуване на имот",
    "reading_description": "Купуване на дом, преместване в ново жилище. Стабилност, сигурност.",
    "reading_advice": "Това е добра инвестиция – домът ще ти носи радост дълги години."
  },
  {
    "reading_id": "family_war",
    "reading_name": "Семейна война",
    "reading_cards": "5 Жезли + 3 Мечове + 7 Мечове",
    "reading_combination": ["five_wands", "three_swords", "seven_swords"],
    "reading_meaning": "Тежки семейни конфликти",
    "reading_description": "Тежки кавги в семейството, тайни, лъжи, наранявания. Спорове за пари или имоти.",
    "reading_advice": "Истината ще излезе. Понякога трябва да прекъснеш връзка, за да спасиш себе си."
  },
  {
    "reading_id": "home_celebration",
    "reading_name": "Семеен празник",
    "reading_cards": "3 Чаши + 4 Жезли",
    "reading_combination": ["three_cups", "four_wands"],
    "reading_meaning": "Празник у дома",
    "reading_description": "Рожден ден, годишнина, празник в семейството.",
    "reading_advice": "Събери всички. Тези моменти са безценни."
  },
  {
    "reading_id": "parents",
    "reading_name": "Родители",
    "reading_cards": "Император + Императрица",
    "reading_combination": ["emperor", "empress"],
    "reading_meaning": "Влияние на родителите",
    "reading_description": "Баща и майка, родителите ти играят важна роля.",
    "reading_advice": "Благодари им, докато са тук. Те са твоят корен."
  }, 
  {
    "reading_id": "fool_tower",
    "reading_name": "Риск",
    "reading_cards": "Глупак + Кула",
    "reading_combination": ["fool", "tower"],
    "reading_meaning": "Опасен риск",
    "reading_description": "Поемаш риск, който може да те срине – внимавай.",
    "reading_advice": "Помисли добре, преди да скочиш. Рискът може да е фатален."
  },
  {
    "reading_id": "magician_master",
    "reading_name": "Майстор",
    "reading_cards": "Магьосник + 8 Пентакли",
    "reading_combination": ["magician", "eight_pentacles"],
    "reading_meaning": "Високо майсторство",
    "reading_description": "Владееш занаята си до съвършенство.",
    "reading_advice": "Продължавай да се усъвършенстваш. Ти си майстор."
  },
 
  {
    "reading_id": "chariot_travel",
    "reading_name": "Бързо пътуване",
    "reading_cards": "Колесница + 6 Мечове",
    "reading_combination": ["chariot", "six_swords"],
    "reading_meaning": "Пътуване",
    "reading_description": "Тръгваш на път – кола, влак, самолет.",
    "reading_advice": "Готви се за пътуване. Нови хоризонти те очакват."
  },
  {
    "reading_id": "strength_endurance",
    "reading_name": "Устойчивост",
    "reading_cards": "Сила + 9 Жезли",
    "reading_combination": ["strength", "nine_wands"],
    "reading_meaning": "Последна битка",
    "reading_description": "Издържаш на последното изпитание.",
    "reading_advice": "Дръж се. Почти си там. Силата е в теб."
  },
  {
    "reading_id": "hermit_meditation",
    "reading_name": "Медитация",
    "reading_cards": "Отшелник + 4 Мечове",
    "reading_combination": ["hermit", "four_swords"],
    "reading_meaning": "Уединение и почивка",
    "reading_description": "Време за уединение и почивка.",
    "reading_advice": "Оттегли се за малко. Тишината ще ти даде отговори."
  },
  {
    "reading_id": "wheel_ace",
    "reading_name": "Съдбовно начало",
    "reading_cards": "Колело на съдбата + Асо",
    "reading_combination": ["wheel_of_fortune", "ace_wands"],
    "reading_meaning": "Съдбовен шанс",
    "reading_description": "Съдбата ти дава нов шанс.",
    "reading_advice": "Хвани го с две ръце. Този шанс няма да се повтори."
  },
  {
    "reading_id": "wheel_ten",
    "reading_name": "Край на цикъл",
    "reading_cards": "Колело на съдбата + 10",
    "reading_combination": ["wheel_of_fortune", "ten_wands"],
    "reading_meaning": "Съдбовен край",
    "reading_description": "Съдбовен край – така е трябвало да бъде.",
    "reading_advice": "Приеми края с благодарност. Той носи ново начало."
  },
  {
    "reading_id": "justice_court",
    "reading_name": "Съдебно дело",
    "reading_cards": "Справедливост + 5 Мечове",
    "reading_combination": ["justice", "five_swords"],
    "reading_meaning": "Съдебен процес",
    "reading_description": "Имаш дело в съда – ще има справедлив край.",
    "reading_advice": "Бъди честен и подготвен. Истината ще надделее."
  },
  {
    "reading_id": "hanged_perspective",
    "reading_name": "Нова гледна точка",
    "reading_cards": "Обесен + 6 Мечове",
    "reading_combination": ["hanged_man", "six_swords"],
    "reading_meaning": "Промяна на перспективата",
    "reading_description": "Виждаш нещата от друг ъгъл.",
    "reading_advice": "Погледни отгоре. Има и друг начин."
  },
  {
    "reading_id": "death_rebirth",
    "reading_name": "Прераждане",
    "reading_cards": "Смърт + Асо Жезли",
    "reading_combination": ["death", "ace_wands"],
    "reading_meaning": "Феникс",
    "reading_description": "Феникс – след смъртта идва ново начало.",
    "reading_advice": "Остави старото да умре. Новото вече чука на вратата."
  },
  {
    "reading_id": "temperance_balance",
    "reading_name": "Баланс в любовта",
    "reading_cards": "Умереност + 2 Чаши",
    "reading_combination": ["temperance", "two_cups"],
    "reading_meaning": "Хармонична връзка",
    "reading_description": "Връзка, в която има хармония и търпение.",
    "reading_advice": "Поддържай баланса. Той е ключът към щастието."
  },
  {
    "reading_id": "devil_addiction",
    "reading_name": "Зависимост",
    "reading_cards": "Дявол + 7 Мечове",
    "reading_combination": ["devil", "seven_swords"],
    "reading_meaning": "Пристрастяване",
    "reading_description": "Пристрастяване – алкохол, наркотици, хазарт.",
    "reading_advice": "Признай си зависимостта. Това е първата стъпка към свободата."
  },
  {
    "reading_id": "devil_greed",
    "reading_name": "Алчност",
    "reading_cards": "Дявол + 4 Пентакли",
    "reading_combination": ["devil", "four_pentacles"],
    "reading_meaning": "Зависимост от пари",
    "reading_description": "Зависимост от пари, скъперничество.",
    "reading_advice": "Парите са инструмент, не цел. Отпусни хватката."
  },
 
  {
    "reading_id": "star_healing",
    "reading_name": "Изцеление",
    "reading_cards": "Звезда + Слънце",
    "reading_combination": ["star", "sun"],
    "reading_meaning": "Пълно възстановяване",
    "reading_description": "Напълно се възстановяваш – физически и душевно.",
    "reading_advice": "Раните ти заздравяват. Отвори се за светлината."
  },
  {
    "reading_id": "moon_illusion",
    "reading_name": "Илюзия",
    "reading_cards": "Луна + 7 Чаши",
    "reading_combination": ["moon", "seven_cups"],
    "reading_meaning": "Заблуда",
    "reading_description": "Не виждаш реалността – заблуда, фантазия.",
    "reading_advice": "Слез на земята. Не всичко е каквото изглежда."
  },
  {
    "reading_id": "moon_fears",
    "reading_name": "Страхове",
    "reading_cards": "Луна + 9 Мечове",
    "reading_combination": ["moon", "nine_swords"],
    "reading_meaning": "Кошмари",
    "reading_description": "Нощни кошмари, тревоги, параноя.",
    "reading_advice": "Страховете ти са в главата ти. Потърси помощ."
  },
  {
    "reading_id": "sun_success",
    "reading_name": "Голям успех",
    "reading_cards": "Слънце + 6 Жезли",
    "reading_combination": ["sun", "six_wands"],
    "reading_meaning": "Триумф",
    "reading_description": "Триумф, признание, радост.",
    "reading_advice": "Наслаждавай се на момента. Ти го заслужи."
  },
  {
    "reading_id": "judgement_forgiveness",
    "reading_name": "Прошка",
    "reading_cards": "Съд + 6 Чаши",
    "reading_combination": ["judgement", "six_cups"],
    "reading_meaning": "Освобождение от миналото",
    "reading_description": "Прощаваш на миналото и започваш наново.",
    "reading_advice": "Прости си. Освободи се. Заслужаваш ново начало."
  },
  {
    "reading_id": "world_travel",
    "reading_name": "Пътуване по света",
    "reading_cards": "Свят + 6 Мечове",
    "reading_combination": ["world", "six_swords"],
    "reading_meaning": "Обикаляне на света",
    "reading_description": "Обикаляш света, дълго пътуване.",
    "reading_advice": "Светът е пред теб. Отправи се на път."
  },
  {
    "reading_id": "world_success",
    "reading_name": "Световен успех",
    "reading_cards": "Свят + 10 Пентакли",
    "reading_combination": ["world", "ten_pentacles"],
    "reading_meaning": "Върховно постижение",
    "reading_description": "Имаш всичко – завършек на дълъг път.",
    "reading_advice": "Наслади се на успеха. Ти завърши цикъла."
  },
   {
    "reading_id": "sexual_chemistry",
    "reading_name": "Силна сексуална химия",
    "reading_cards": "Асо Жезли + Дявол",
    "reading_combination": ["ace_wands", "devil"],
    "reading_meaning": "Чисто физическо привличане",
    "reading_description": "Привличането е чисто физическо, почти обсебващо.",
    "reading_advice": "Наслаждавай се, но внимавай да не объркаш страстта с любов."
  },
  
  

  {
    "reading_id": "parents",
    "reading_name": "Родители",
    "reading_cards": "Император + Императрица",
    "reading_combination": ["emperor", "empress"],
    "reading_meaning": "Влияние на родителите",
    "reading_description": "Баща и майка, родителите ти играят важна роля.",
    "reading_advice": "Благодари им, докато са тук. Те са твоят корен."
  },
  
  {
    "reading_id": "fool_death",
    "reading_name": "Ново начало след край",
    "reading_cards": "Глупак + Смърт",
    "reading_combination": ["fool", "death"],
    "reading_meaning": "Трансформация",
    "reading_description": "Тръгваш на нов път, след като нещо старо е приключило.",
    "reading_advice": "Приеми края и започни отначало с чисто сърце."
  },
  {
    "reading_id": "fool_tower",
    "reading_name": "Риск",
    "reading_cards": "Глупак + Кула",
    "reading_combination": ["fool", "tower"],
    "reading_meaning": "Опасен риск",
    "reading_description": "Поемаш риск, който може да те срине – внимавай.",
    "reading_advice": "Помисли добре, преди да скочиш. Рискът може да е фатален."
  },
  {
    "reading_id": "magician_master",
    "reading_name": "Майстор",
    "reading_cards": "Магьосник + 8 Пентакли",
    "reading_combination": ["magician", "eight_pentacles"],
    "reading_meaning": "Високо майсторство",
    "reading_description": "Владееш занаята си до съвършенство.",
    "reading_advice": "Продължавай да се усъвършенстваш. Ти си майстор."
  },
  {
    "reading_id": "priestess_moon",
    "reading_name": "Дълбока интуиция",
    "reading_cards": "Върховна жрица + Луна",
    "reading_combination": ["high_priestess", "moon"],
    "reading_meaning": "Свръхсъзнание",
    "reading_description": "Силна връзка с подсъзнанието – сънища, знаци, прозрения.",
    "reading_advice": "Вярвай на интуицията си. Тя те води правилно."
  },
  {
    "reading_id": "chariot_travel",
    "reading_name": "Бързо пътуване",
    "reading_cards": "Колесница + 6 Мечове",
    "reading_combination": ["chariot", "six_swords"],
    "reading_meaning": "Пътуване",
    "reading_description": "Тръгваш на път – кола, влак, самолет.",
    "reading_advice": "Готви се за пътуване. Нови хоризонти те очакват."
  },
  {
    "reading_id": "strength_endurance",
    "reading_name": "Устойчивост",
    "reading_cards": "Сила + 9 Жезли",
    "reading_combination": ["strength", "nine_wands"],
    "reading_meaning": "Последна битка",
    "reading_description": "Издържаш на последното изпитание.",
    "reading_advice": "Дръж се. Почти си там. Силата е в теб."
  },
  {
    "reading_id": "hermit_meditation",
    "reading_name": "Медитация",
    "reading_cards": "Отшелник + 4 Мечове",
    "reading_combination": ["hermit", "four_swords"],
    "reading_meaning": "Уединение и почивка",
    "reading_description": "Време за уединение и почивка.",
    "reading_advice": "Оттегли се за малко. Тишината ще ти даде отговори."
  },
  {
    "reading_id": "wheel_ace",
    "reading_name": "Съдбовно начало",
    "reading_cards": "Колело на съдбата + Асо",
    "reading_combination": ["wheel_of_fortune", "ace_wands"],
    "reading_meaning": "Съдбовен шанс",
    "reading_description": "Съдбата ти дава нов шанс.",
    "reading_advice": "Хвани го с две ръце. Този шанс няма да се повтори."
  },
  {
    "reading_id": "wheel_ten",
    "reading_name": "Край на цикъл",
    "reading_cards": "Колело на съдбата + 10",
    "reading_combination": ["wheel_of_fortune", "ten_wands"],
    "reading_meaning": "Съдбовен край",
    "reading_description": "Съдбовен край – така е трябвало да бъде.",
    "reading_advice": "Приеми края с благодарност. Той носи ново начало."
  },
  {
    "reading_id": "justice_court",
    "reading_name": "Съдебно дело",
    "reading_cards": "Справедливост + 5 Мечове",
    "reading_combination": ["justice", "five_swords"],
    "reading_meaning": "Съдебен процес",
    "reading_description": "Имаш дело в съда – ще има справедлив край.",
    "reading_advice": "Бъди честен и подготвен. Истината ще надделее."
  },
  {
    "reading_id": "hanged_perspective",
    "reading_name": "Нова гледна точка",
    "reading_cards": "Обесен + 6 Мечове",
    "reading_combination": ["hanged_man", "six_swords"],
    "reading_meaning": "Промяна на перспективата",
    "reading_description": "Виждаш нещата от друг ъгъл.",
    "reading_advice": "Погледни отгоре. Има и друг начин."
  },
  {
    "reading_id": "death_rebirth",
    "reading_name": "Прераждане",
    "reading_cards": "Смърт + Асо Жезли",
    "reading_combination": ["death", "ace_wands"],
    "reading_meaning": "Феникс",
    "reading_description": "Феникс – след смъртта идва ново начало.",
    "reading_advice": "Остави старото да умре. Новото вече чука на вратата."
  },
  {
    "reading_id": "temperance_balance",
    "reading_name": "Баланс в любовта",
    "reading_cards": "Умереност + 2 Чаши",
    "reading_combination": ["temperance", "two_cups"],
    "reading_meaning": "Хармонична връзка",
    "reading_description": "Връзка, в която има хармония и търпение.",
    "reading_advice": "Поддържай баланса. Той е ключът към щастието."
  },
  {
    "reading_id": "devil_addiction",
    "reading_name": "Зависимост",
    "reading_cards": "Дявол + 7 Мечове",
    "reading_combination": ["devil", "seven_swords"],
    "reading_meaning": "Пристрастяване",
    "reading_description": "Пристрастяване – алкохол, наркотици, хазарт.",
    "reading_advice": "Признай си зависимостта. Това е първата стъпка към свободата."
  },
  {
    "reading_id": "devil_greed",
    "reading_name": "Алчност",
    "reading_cards": "Дявол + 4 Пентакли",
    "reading_combination": ["devil", "four_pentacles"],
    "reading_meaning": "Зависимост от пари",
    "reading_description": "Зависимост от пари, скъперничество.",
    "reading_advice": "Парите са инструмент, не цел. Отпусни хватката."
  },
 
  {
    "reading_id": "tower_hope",
    "reading_name": "Срив и надежда",
    "reading_cards": "Кула + Звезда",
    "reading_combination": ["tower", "star"],
    "reading_meaning": "Разрушение и изцеление",
    "reading_description": "Разрушение, но след него идва изцеление.",
    "reading_advice": "След бурята винаги идва слънце. Вярвай."
  },
  {
    "reading_id": "star_healing",
    "reading_name": "Изцеление",
    "reading_cards": "Звезда + Слънце",
    "reading_combination": ["star", "sun"],
    "reading_meaning": "Пълно възстановяване",
    "reading_description": "Напълно се възстановяваш – физически и душевно.",
    "reading_advice": "Раните ти заздравяват. Отвори се за светлината."
  },
  {
    "reading_id": "moon_illusion",
    "reading_name": "Илюзия",
    "reading_cards": "Луна + 7 Чаши",
    "reading_combination": ["moon", "seven_cups"],
    "reading_meaning": "Заблуда",
    "reading_description": "Не виждаш реалността – заблуда, фантазия.",
    "reading_advice": "Слез на земята. Не всичко е каквото изглежда."
  },
  {
    "reading_id": "moon_fears",
    "reading_name": "Страхове",
    "reading_cards": "Луна + 9 Мечове",
    "reading_combination": ["moon", "nine_swords"],
    "reading_meaning": "Кошмари",
    "reading_description": "Нощни кошмари, тревоги, параноя.",
    "reading_advice": "Страховете ти са в главата ти. Потърси помощ."
  },
  {
    "reading_id": "sun_success",
    "reading_name": "Голям успех",
    "reading_cards": "Слънце + 6 Жезли",
    "reading_combination": ["sun", "six_wands"],
    "reading_meaning": "Триумф",
    "reading_description": "Триумф, признание, радост.",
    "reading_advice": "Наслаждавай се на момента. Ти го заслужи."
  },
  {
    "reading_id": "judgement_forgiveness",
    "reading_name": "Прошка",
    "reading_cards": "Съд + 6 Чаши",
    "reading_combination": ["judgement", "six_cups"],
    "reading_meaning": "Освобождение от миналото",
    "reading_description": "Прощаваш на миналото и започваш наново.",
    "reading_advice": "Прости си. Освободи се. Заслужаваш ново начало."
  },
  {
    "reading_id": "world_travel",
    "reading_name": "Пътуване по света",
    "reading_cards": "Свят + 6 Мечове",
    "reading_combination": ["world", "six_swords"],
    "reading_meaning": "Обикаляне на света",
    "reading_description": "Обикаляш света, дълго пътуване.",
    "reading_advice": "Светът е пред теб. Отправи се на път."
  },
  {
    "reading_id": "world_success",
    "reading_name": "Световен успех",
    "reading_cards": "Свят + 10 Пентакли",
    "reading_combination": ["world", "ten_pentacles"],
    "reading_meaning": "Върховно постижение",
    "reading_description": "Имаш всичко – завършек на дълъг път.",
    "reading_advice": "Наслади се на успеха. Ти завърши цикъла."
  },
  
 {
    "reading_id": "all_aces",
    "reading_name": "Четири аса",
    "reading_cards": "Асо Жезли + Асо Чаши + Асо Мечове + Асо Пентакли",
    "reading_combination": ["ace_wands", "ace_cups", "ace_swords", "ace_pentacles"],
    "reading_meaning": "Ново начало във всичко",
    "reading_description": "Чист потенциал във всички посоки. Животът ти дава нов шанс във всички сфери.",
    "reading_advice": "Това е рядък момент – използвай го! Вселената ти казва ДА."
  },
  {
    "reading_id": "all_twos",
    "reading_name": "Четири двойки",
    "reading_cards": "2 Жезли + 2 Чаши + 2 Мечове + 2 Пентакли",
    "reading_combination": ["two_wands", "two_cups", "two_swords", "two_pentacles"],
    "reading_meaning": "Баланс и избор навсякъде",
    "reading_description": "Пред теб са важни избори във всички сфери. Трябва да балансираш – кариера и любов, мисли и чувства, пари и щастие.",
    "reading_advice": "Вземи решение. Балансът не означава да имаш всичко, а да знаеш кое е най-важно сега."
  },
  {
    "reading_id": "all_fives",
    "reading_name": "Четири петици",
    "reading_cards": "5 Жезли + 5 Чаши + 5 Мечове + 5 Пентакли",
    "reading_combination": ["five_wands", "five_cups", "five_swords", "five_pentacles"],
    "reading_meaning": "Криза във всичко",
    "reading_description": "Криза във всички сфери. Конфликти на работа, загуба в любовта, унижение, финансови проблеми. Идеалната буря.",
    "reading_advice": "Това е дъното. Оттук насетне може само нагоре. Потърси помощ – не си сам."
  },
  {
    "reading_id": "all_sixes",
    "reading_name": "Четири шестици",
    "reading_cards": "6 Жезли + 6 Чаши + 6 Мечове + 6 Пентакли",
    "reading_combination": ["six_wands", "six_cups", "six_swords", "six_pentacles"],
    "reading_meaning": "Хармония и помощ",
    "reading_description": "Прекрасна комбинация. Успех, щастливи спомени и прошка, преход към по-добро, получаване на помощ. Всичко се нарежда.",
    "reading_advice": "Приеми помощта, празнувай успеха, прости на миналото. Върви напред."
  },
  {
    "reading_id": "all_tens",
    "reading_name": "Четири десетки",
    "reading_cards": "10 Жезли + 10 Чаши + 10 Мечове + 10 Пентакли",
    "reading_combination": ["ten_wands", "ten_cups", "ten_swords", "ten_pentacles"],
    "reading_meaning": "Край на голям цикъл",
    "reading_description": "Краят на един голям цикъл. Носиш тежест, но имаш семейно щастие, преминал си през болка и имаш материална сигурност. Всичко приключва.",
    "reading_advice": "Затвори тази глава. Почини си. Скоро започва нов цикъл."
  },
  {
    "reading_id": "maybe_balance",
    "reading_name": "Може би",
    "reading_cards": "2 Чаши + 2 Мечове + 2 Жезли + 2 Пентакли",
    "reading_combination": ["two_cups", "two_swords", "two_wands", "two_pentacles"],
    "reading_meaning": "Зависи от теб",
    "reading_description": "Всичко е в баланс. Ти избираш посоката.",
    "reading_advice": "Отговорът не е в картите, а в теб. Вземи решение и следвай сърцето си."
  },
  {
    "reading_id": "fire_all",
    "reading_name": "Само Жезли",
    "reading_cards": "всички Жезли",
    "reading_combination": ["ace_wands", "two_wands", "three_wands", "four_wands", "five_wands", "six_wands", "seven_wands", "eight_wands", "nine_wands", "ten_wands"],
    "reading_meaning": "Чист огън, чисто действие",
    "reading_description": "Животът ти е в период на интензивно действие. Всичко се случва бързо, имаш много енергия, амбиция, страст. Но внимавай – можеш да прегориш.",
    "reading_advice": "Действай, но не забравяй да мислиш и чувстваш. Огънят гори, но и изгаря."
  },
 
  {
    "reading_id": "air_all",
    "reading_name": "Само Мечове",
    "reading_cards": "всички Мечове",
    "reading_combination": ["ace_swords", "two_swords", "three_swords", "four_swords", "five_swords", "six_swords", "seven_swords", "eight_swords", "nine_swords", "ten_swords"],
    "reading_meaning": "Чист въздух, чиста мисъл",
    "reading_description": "Умът ти е прекалено активен. Мислиш, анализираш, тревожиш се, спориш. Истината излиза наяве, но понякога боли.",
    "reading_advice": "Изключи ума за малко. Твърде много мислене води до парализа. Понякога трябва просто да чувстваш."
  },
  {
    "reading_id": "earth_all",
    "reading_name": "Само Пентакли",
    "reading_cards": "всички Пентакли",
    "reading_combination": ["ace_pentacles", "two_pentacles", "three_pentacles", "four_pentacles", "five_pentacles", "six_pentacles", "seven_pentacles", "eight_pentacles", "nine_pentacles", "ten_pentacles"],
    "reading_meaning": "Чиста земя, чиста материя",
    "reading_description": "Фокус върху пари, здраве, работа, дом. Материалната сигурност е важна, но може би пренебрегваш емоциите, връзките, духовното.",
    "reading_advice": "Парите и сигурността са важни, но не са всичко. Отвори сърцето си за хората."
  },
  

 
  {
    "reading_id": "all_aces",
    "reading_name": "Четири аса",
    "reading_cards": "Асо Жезли + Асо Чаши + Асо Мечове + Асо Пентакли",
    "reading_combination": ["ace_wands", "ace_cups", "ace_swords", "ace_pentacles"],
    "reading_meaning": "Ново начало във всичко",
    "reading_description": "Чист потенциал във всички посоки. Животът ти дава нов шанс във всички сфери.",
    "reading_advice": "Това е рядък момент – използвай го! Вселената ти казва ДА."
  },
  {
    "reading_id": "all_twos",
    "reading_name": "Четири двойки",
    "reading_cards": "2 Жезли + 2 Чаши + 2 Мечове + 2 Пентакли",
    "reading_combination": ["two_wands", "two_cups", "two_swords", "two_pentacles"],
    "reading_meaning": "Баланс и избор навсякъде",
    "reading_description": "Пред теб са важни избори във всички сфери. Трябва да балансираш – кариера и любов, мисли и чувства, пари и щастие.",
    "reading_advice": "Вземи решение. Балансът не означава да имаш всичко, а да знаеш кое е най-важно сега."
  },
  {
    "reading_id": "all_fives",
    "reading_name": "Четири петици",
    "reading_cards": "5 Жезли + 5 Чаши + 5 Мечове + 5 Пентакли",
    "reading_combination": ["five_wands", "five_cups", "five_swords", "five_pentacles"],
    "reading_meaning": "Криза във всичко",
    "reading_description": "Криза във всички сфери. Конфликти на работа, загуба в любовта, унижение, финансови проблеми. Идеалната буря.",
    "reading_advice": "Това е дъното. Оттук насетне може само нагоре. Потърси помощ – не си сам."
  },
  {
    "reading_id": "all_sixes",
    "reading_name": "Четири шестици",
    "reading_cards": "6 Жезли + 6 Чаши + 6 Мечове + 6 Пентакли",
    "reading_combination": ["six_wands", "six_cups", "six_swords", "six_pentacles"],
    "reading_meaning": "Хармония и помощ",
    "reading_description": "Прекрасна комбинация. Успех, щастливи спомени и прошка, преход към по-добро, получаване на помощ. Всичко се нарежда.",
    "reading_advice": "Приеми помощта, празнувай успеха, прости на миналото. Върви напред."
  },
  {
    "reading_id": "all_tens",
    "reading_name": "Четири десетки",
    "reading_cards": "10 Жезли + 10 Чаши + 10 Мечове + 10 Пентакли",
    "reading_combination": ["ten_wands", "ten_cups", "ten_swords", "ten_pentacles"],
    "reading_meaning": "Край на голям цикъл",
    "reading_description": "Краят на един голям цикъл. Носиш тежест, но имаш семейно щастие, преминал си през болка и имаш материална сигурност. Всичко приключва.",
    "reading_advice": "Затвори тази глава. Почини си. Скоро започва нов цикъл."
  },
  {
    "reading_id": "maybe_balance",
    "reading_name": "Може би",
    "reading_cards": "2 Чаши + 2 Мечове + 2 Жезли + 2 Пентакли",
    "reading_combination": ["two_cups", "two_swords", "two_wands", "two_pentacles"],
    "reading_meaning": "Зависи от теб",
    "reading_description": "Всичко е в баланс. Ти избираш посоката.",
    "reading_advice": "Отговорът не е в картите, а в теб. Вземи решение и следвай сърцето си."
  },
  {
    "reading_id": "fire_all",
    "reading_name": "Само Жезли",
    "reading_cards": "всички Жезли",
    "reading_combination": ["ace_wands", "two_wands", "three_wands", "four_wands", "five_wands", "six_wands", "seven_wands", "eight_wands", "nine_wands", "ten_wands"],
    "reading_meaning": "Чист огън, чисто действие",
    "reading_description": "Животът ти е в период на интензивно действие. Всичко се случва бързо, имаш много енергия, амбиция, страст. Но внимавай – можеш да прегориш.",
    "reading_advice": "Действай, но не забравяй да мислиш и чувстваш. Огънят гори, но и изгаря."
  },
  {
    "reading_id": "water_all",
    "reading_name": "Само Чаши",
    "reading_cards": "всички Чаши",
    "reading_combination": ["ace_cups", "two_cups", "three_cups", "four_cups", "five_cups", "six_cups", "seven_cups", "eight_cups", "nine_cups", "ten_cups"],
    "reading_meaning": "Чиста вода, чисти емоции",
    "reading_description": "Емоциите ти заливат всичко. Любов, радост, тъга, връзки – това е основната тема. Чувствителен си, интуитивен, но може би твърде емоционален.",
    "reading_advice": "Чувствай, но не се дави. Емоциите са важни, но не са всичко."
  },
  {
    "reading_id": "air_all",
    "reading_name": "Само Мечове",
    "reading_cards": "всички Мечове",
    "reading_combination": ["ace_swords", "two_swords", "three_swords", "four_swords", "five_swords", "six_swords", "seven_swords", "eight_swords", "nine_swords", "ten_swords"],
    "reading_meaning": "Чист въздух, чиста мисъл",
    "reading_description": "Умът ти е прекалено активен. Мислиш, анализираш, тревожиш се, спориш. Истината излиза наяве, но понякога боли.",
    "reading_advice": "Изключи ума за малко. Твърде много мислене води до парализа. Понякога трябва просто да чувстваш."
  },
  {
    "reading_id": "earth_all",
    "reading_name": "Само Пентакли",
    "reading_cards": "всички Пентакли",
    "reading_combination": ["ace_pentacles", "two_pentacles", "three_pentacles", "four_pentacles", "five_pentacles", "six_pentacles", "seven_pentacles", "eight_pentacles", "nine_pentacles", "ten_pentacles"],
    "reading_meaning": "Чиста земя, чиста материя",
    "reading_description": "Фокус върху пари, здраве, работа, дом. Материалната сигурност е важна, но може би пренебрегваш емоциите, връзките, духовното.",
    "reading_advice": "Парите и сигурността са важни, но не са всичко. Отвори сърцето си за хората."
  },

  



  {
    "reading_id": "wedding_proposal",
    "reading_name": "Предложение за брак",
    "reading_cards": "2 Чаши + Йерофант + Слънце",
    "reading_combination": ["two_cups", "hierophant", "sun"],
    "reading_meaning": "Предложение за женитба",
    "reading_description": "Очаквай предложение за брак! Някой ще коленичи пред теб и ще поиска ръката ти. Щастлив момент, който помниш цял живот.",
    "reading_advice": "Кажи 'да' на любовта! Това е моментът, който си чакала."
  },
 
 
  {
    "reading_id": "online_love",
    "reading_name": "Онлайн любов",
    "reading_cards": "8 Жезли + 2 Чаши + Луна",
    "reading_combination": ["eight_wands", "two_cups", "moon"],
    "reading_meaning": "Виртуална връзка",
    "reading_description": "Запознанство в интернет, социални мрежи или приложение. Бързо развитие на чувствата, но внимавай с илюзиите.",
    "reading_advice": "Наслаждавай се на разговорите, но опознай човека и в реалния живот, преди да се отдадеш напълно."
  },
  {
    "reading_id": "career_promotion",
    "reading_name": "Повишение",
    "reading_cards": "6 Жезли + Император + 10 Пентакли",
    "reading_combination": ["six_wands", "emperor", "ten_pentacles"],
    "reading_meaning": "Кариерно израстване",
    "reading_description": "Повишение на работа, нова длъжност, повече отговорности и по-високо заплащане. Признание за труда ти.",
    "reading_advice": "Приеми новото предизвикателство – заслужаваш го. Ще се справиш повече от добре."
  },
  {
    "reading_id": "job_interview",
    "reading_name": "Успешно интервю",
    "reading_cards": "Асо Пентакли + 8 Жезли + Магьосник",
    "reading_combination": ["ace_pentacles", "eight_wands", "magician"],
    "reading_meaning": "Скорошно интервю",
    "reading_description": "Предстои ти интервю за работа или важно делова среща. Ще направиш отлично впечатление и ще получиш предложение.",
    "reading_advice": "Подготви се добре, бъди уверен и покажи какво можеш. Успехът е гарантиран."
  },
  {
    "reading_id": "business_trip",
    "reading_name": "Командировка",
    "reading_cards": "8 Жезли + 6 Мечове + 3 Пентакли",
    "reading_combination": ["eight_wands", "six_swords", "three_pentacles"],
    "reading_meaning": "Пътуване по работа",
    "reading_description": "Очаква те командировка в чужбина или друг град. Възможност за развитие и нови контакти.",
    "reading_advice": "Използвай пътуването за учене и разширяване на мрежата си. Носи подарък за семейството."
  },
  {
    "reading_id": "salary_increase",
    "reading_name": "Увеличение на заплатата",
    "reading_cards": "9 Пентакли + 6 Жезли + Асо Пентакли",
    "reading_combination": ["nine_pentacles", "six_wands", "ace_pentacles"],
    "reading_meaning": "Повишение на заплата",
    "reading_description": "Очаквай увеличение на заплатата, бонус или допълнителен доход. Финансовата ти независимост расте.",
    "reading_advice": "Инвестирай разумно и си позволи малък лукс – заслужил си го."
  },
  {
    "reading_id": "small_business",
    "reading_name": "Малък бизнес",
    "reading_cards": "Асо Пентакли + 8 Пентакли + 3 Пентакли",
    "reading_combination": ["ace_pentacles", "eight_pentacles", "three_pentacles"],
    "reading_meaning": "Старт на собствен бизнес",
    "reading_description": "Започване на собствен бизнес, малка фирма или занаят. Работа с ръце, творчество, усилия, които се отплащат.",
    "reading_advice": "Започни с малко, но бъди постоянен. Качеството ще те изведе напред."
  },
  {
    "reading_id": "health_recovery",
    "reading_name": "Възстановяване",
    "reading_cards": "4 Мечове + Звезда + Слънце",
    "reading_combination": ["four_swords", "star", "sun"],
    "reading_meaning": "Пълно оздравяване",
    "reading_description": "След болест или тежък период идва пълно възстановяване. Здравето се подобрява, енергията се връща.",
    "reading_advice": "Почивай, но започвай да се връщаш към активен живот. Тялото ти казва 'благодаря'."
  },
  {
    "reading_id": "mental_health",
    "reading_name": "Психично здраве",
    "reading_cards": "9 Мечове + 4 Мечове + Върховна жрица",
    "reading_combination": ["nine_swords", "four_swords", "high_priestess"],
    "reading_meaning": "Грижа за душевното здраве",
    "reading_description": "Важно е да обърнеш внимание на психичното си здраве. Тревожност, безсъние, претоварване – време е за почивка и терапия.",
    "reading_advice": "Потърси помощ – психолог, терапевт или духовен учител. Не си сам в това."
  },
  {
    "reading_id": "pregnancy_test",
    "reading_name": "Тест за бременност",
    "reading_cards": "Императрица + Асо Чаши + Луна",
    "reading_combination": ["empress", "ace_cups", "moon"],
    "reading_meaning": "Възможна бременност",
    "reading_description": "Възможно е да си бременна или скоро да забременееш. Тестът може да излезе положителен. Нов живот идва.",
    "reading_advice": "Направи си тест и се подготви за промяна. Тялото ти се готви за чудо."
  },
  {
    "reading_id": "moving_abroad",
    "reading_name": "Заминаване в чужбина",
    "reading_cards": "6 Мечове + Свят + Колесница",
    "reading_combination": ["six_swords", "world", "chariot"],
    "reading_meaning": "Емиграция",
    "reading_description": "Заминаване в чужбина за постоянно или за дълго време. Нова държава, нов език, нов живот.",
    "reading_advice": "Сбогувай се с миналото и отвори обятия за бъдещето. Светът те очаква."
  },
  {
    "reading_id": "buying_house",
    "reading_name": "Купуване на къща",
    "reading_cards": "Асо Пентакли + 10 Пентакли + 4 Жезли",
    "reading_combination": ["ace_pentacles", "ten_pentacles", "four_wands"],
    "reading_meaning": "Покупка на имот",
    "reading_description": "Купуване на къща или апартамент. Инвестиция в недвижим имот, който ще носи сигурност и стабилност.",
    "reading_advice": "Прегледай документите внимателно, но не се колебай – това е добра инвестиция."
  },
  {
    "reading_id": "renovation",
    "reading_name": "Ремонт",
    "reading_cards": "8 Пентакли + 3 Пентакли + 4 Жезли",
    "reading_combination": ["eight_pentacles", "three_pentacles", "four_wands"],
    "reading_meaning": "Обновяване на дома",
    "reading_description": "Предстои ремонт, обновяване или преустройство на дома ти. Ще вложиш много труд, но резултатът ще е прекрасен.",
    "reading_advice": "Планирай добре бюджета и времето. Крайният резултат си заслужава усилията."
  },
  {
    "reading_id": "family_reunion",
    "reading_name": "Семейно събиране",
    "reading_cards": "10 Чаши + 6 Чаши + 3 Чаши",
    "reading_combination": ["ten_cups", "six_cups", "three_cups"],
    "reading_meaning": "Събиране на семейството",
    "reading_description": "Семейно събиране, празник, среща на близки и роднини. Радост, смях, споделени мигове.",
    "reading_advice": "Цени тези моменти – те са най-ценното, което имаш. Обади се на близките си."
  },
  {
    "reading_id": "grandchild",
    "reading_name": "Рожба в семейството",
    "reading_cards": "Императрица + 10 Чаши + Слънце",
    "reading_combination": ["empress", "ten_cups", "sun"],
    "reading_meaning": "Раждане на внук",
    "reading_description": "Раждане на дете в семейството – внук, племенник, нов член. Щастие за всички.",
    "reading_advice": "Радвай се на новия живот. Ти си част от нещо по-голямо."
  },
  {
    "reading_id": "inheritance_dispute",
    "reading_name": "Спор за наследство",
    "reading_cards": "5 Мечове + 5 Жезли + 4 Пентакли",
    "reading_combination": ["five_swords", "five_wands", "four_pentacles"],
    "reading_meaning": "Конфликт за наследство",
    "reading_description": "Спорове за наследство, кавги между роднини за имот или пари. Напрежение и конфликти, които разделят семейството.",
    "reading_advice": "Помни – парите идват и си отиват, а семейството остава. Потърси компромис."
  },
  {
    "reading_id": "lottery_win",
    "reading_name": "Печалба от лотария",
    "reading_cards": "Колело на съдбата + Асо Пентакли + Слънце",
    "reading_combination": ["wheel_of_fortune", "ace_pentacles", "sun"],
    "reading_meaning": "Неочаквана печалба",
    "reading_description": "Късмет в хазарта, печалба от лотария, томбола или конкурс. Съдбата ти се усмихва!",
    "reading_advice": "Пробвай късмета си, но не прекалявай. Вселената ти праща подарък."
  },
  {
    "reading_id": "money_return",
    "reading_name": "Връщане на дълг",
    "reading_cards": "6 Пентакли + 4 Пентакли + Справедливост",
    "reading_combination": ["six_pentacles", "four_pentacles", "justice"],
    "reading_meaning": "Получаване на дължими пари",
    "reading_description": "Някой ще ти върне дълг, ще получиш пари, които са ти обещали. Справедливостта възтържествува.",
    "reading_advice": "Полученото използвай разумно. И помни – да даваш назаем винаги е риск."
  },
  {
    "reading_id": "spiritual_growth",
    "reading_name": "Духовен растеж",
    "reading_cards": "Върховна жрица + Отшелник + Звезда",
    "reading_combination": ["high_priestess", "hermit", "star"],
    "reading_meaning": "Дълбока духовна трансформация",
    "reading_description": "Период на интензивно духовно развитие. Медитация, йога, четене, самота. Откриваш истинската си същност.",
    "reading_advice": "Отдели време за себе си. Душата ти има нужда от храна, точно както тялото."
  },
  {
    "reading_id": "karmic_lesson",
    "reading_name": "Кармичен урок",
    "reading_cards": "Колело на съдбата + Справедливост + 8 Мечове",
    "reading_combination": ["wheel_of_fortune", "justice", "eight_swords"],
    "reading_meaning": "Повтаряща се ситуация",
    "reading_description": "Срещаш се с урок, който не си научил в миналото. Същата ситуация, същият тип хора – докато не научиш урока.",
    "reading_advice": "Задай си въпроса: 'Какво трябва да науча от това?' Отговорът ще те освободи."
  },
  {
    "reading_id": "past_life",
    "reading_name": "Минал живот",
    "reading_cards": "Луна + 6 Чаши + Колело на съдбата",
    "reading_combination": ["moon", "six_cups", "wheel_of_fortune"],
    "reading_meaning": "Спомени от минал живот",
    "reading_description": "Изпитваш дежа вю, странно привличане към определено място или човек. Възможно е да са спомени от минал живот.",
    "reading_advice": "Записвай сънищата и чувствата си. Те носят послания от отвъдното."
  },
  {
    "reading_id": "meditation_practice",
    "reading_name": "Медитация",
    "reading_cards": "Върховна жрица + 4 Мечове + Отшелник",
    "reading_combination": ["high_priestess", "four_swords", "hermit"],
    "reading_meaning": "Задълбочаване в медитация",
    "reading_description": "Време за задълбочена медитация и вътрешно пътешествие. Откриване на вътрешния мир и мъдрост.",
    "reading_advice": "Направи си място за медитация у дома. Дори 10 минути на ден ще променят живота ти."
  },
  {
    "reading_id": "toxic_friend",
    "reading_name": "Токсичен приятел",
    "reading_cards": "5 Чаши + 7 Мечове + Дявол",
    "reading_combination": ["five_cups", "seven_swords", "devil"],
    "reading_meaning": "Фалшив приятел",
    "reading_description": "Някой от обкръжението ти не ти желае доброто. Завист, клюки, предателство. Време е да прекъснеш тази връзка.",
    "reading_advice": "Обкръжи се с хора, които те издигат, не те свалят. Самотата е по-добра от лоша компания."
  },
  {
    "reading_id": "new_friendship",
    "reading_name": "Ново приятелство",
    "reading_cards": "3 Чаши + 6 Чаши + Асо Чаши",
    "reading_combination": ["three_cups", "six_cups", "ace_cups"],
    "reading_meaning": "Начало на нова дружба",
    "reading_description": "Ще срещнеш нов човек, който може да стане важен приятел в живота ти. Споделени интереси, радост, смях.",
    "reading_advice": "Отвори сърцето си за нови хора. Всеки носи нещо ценно в живота ти."
  },
  {
    "reading_id": "court_case",
    "reading_name": "Съдебно дело",
    "reading_cards": "Справедливост + 5 Мечове + 8 Мечове",
    "reading_combination": ["justice", "five_swords", "eight_swords"],
    "reading_meaning": "Съдебен процес",
    "reading_description": "Водиш съдебно дело или си замесен в правен спор. Истината ще излезе наяве, но процесът ще е бавен.",
    "reading_advice": "Бъди търпелив и събери всички документи. Потърси добър адвокат."
  },
  {
    "reading_id": "police_problem",
    "reading_name": "Проблеми с властите",
    "reading_cards": "5 Мечове + Справедливост + 8 Мечове",
    "reading_combination": ["five_swords", "justice", "eight_swords"],
    "reading_meaning": "Правни проблеми",
    "reading_description": "Проблеми с полицията, данъчните или други власти. Възможна глоба, санкция или по-сериозно наказание.",
    "reading_advice": "Не крий нищо и си сътрудничи. Истината е най-добрата защита."
  },
  {
    "reading_id": "exam_success",
    "reading_name": "Успешен изпит",
    "reading_cards": "8 Пентакли + 6 Жезли + Слънце",
    "reading_combination": ["eight_pentacles", "six_wands", "sun"],
    "reading_meaning": "Изпитът е успешен",
    "reading_description": "Положителен резултат на изпит, сертификат, интервю или важна оценка. Ученето ти се отплаща.",
    "reading_advice": "Учи спокойно, знанието е в теб. Ще се представиш отлично."
  },
  {
    "reading_id": "university_admission",
    "reading_name": "Прием в университет",
    "reading_cards": "8 Пентакли + 10 Пентакли + Свят",
    "reading_combination": ["eight_pentacles", "ten_pentacles", "world"],
    "reading_meaning": "Приемане в учебно заведение",
    "reading_description": "Приемане в университет, колеж или курс. Ново образователно начало, което носи дългосрочни ползи.",
    "reading_advice": "Инвестицията в образование винаги се отплаща. Гордей се с постижението си."
  },
  {
    "reading_id": "student_abroad",
    "reading_name": "Следване в чужбина",
    "reading_cards": "8 Жезли + 6 Мечове + Свят",
    "reading_combination": ["eight_wands", "six_swords", "world"],
    "reading_meaning": "Образование в друга държава",
    "reading_description": "Заминаване да следваш в чужбина. Нов език, нова култура, нови възможности за развитие.",
    "reading_advice": "Хвани смело крилата си. Светът е твоята класна стая."
  },
  {
    "reading_id": "writing_project",
    "reading_name": "Писателски проект",
    "reading_cards": "Асо Мечове + 8 Пентакли + 3 Чаши",
    "reading_combination": ["ace_swords", "eight_pentacles", "three_cups"],
    "reading_meaning": "Завършване на книга",
    "reading_description": "Работа по книга, статия, блог или друг творчески текст. Идеите текат, вдъхновението е силно.",
    "reading_advice": "Пиши всеки ден. Думите ти имат сила и могат да променят света."
  },
 
  {
    "reading_id": "music_success",
    "reading_name": "Музикален успех",
    "reading_cards": "6 Жезли + 3 Чаши + Слънце",
    "reading_combination": ["six_wands", "three_cups", "sun"],
    "reading_meaning": "Признание в музиката",
    "reading_description": "Успех в музикалната кариера – концерт, запис, договор. Творчеството ти докосва хората.",
    "reading_advice": "Музиката ти лекува души. Продължавай да твориш и споделяш."
  },
  {
    "reading_id": "loss_of_pet",
    "reading_name": "Загуба на домашен любимец",
    "reading_cards": "5 Чаши + 3 Мечове + Луна",
    "reading_combination": ["five_cups", "three_swords", "moon"],
    "reading_meaning": "Тъга за любимец",
    "reading_description": "Загуба на любим домашен любимец. Скръб, празнота, тъга. Той е бил част от семейството.",
    "reading_advice": "Позволи си да скърбиш. Любимецът ти беше безусловна любов – тази любов остава завинаги."
  },
  {
    "reading_id": "new_pet",
    "reading_name": "Нов домашен любимец",
    "reading_cards": "Асо Чаши + Слънце + 3 Чаши",
    "reading_combination": ["ace_cups", "sun", "three_cups"],
    "reading_meaning": "Осиновяване на животно",
    "reading_description": "В къщи ще има нов член – куче, котка или друго животинче. Радост, игри, безусловна любов.",
    "reading_advice": "Отвори дома и сърцето си за нов приятел. Той ще ти върне любовта стократно."
  },
  {
    "reading_id": "travel_delay",
    "reading_name": "Забавяне на пътуване",
    "reading_cards": "4 Мечове + 8 Жезли + 5 Пентакли",
    "reading_combination": ["four_swords", "eight_wands", "five_pentacles"],
    "reading_meaning": "Отложено пътуване",
    "reading_description": "Пътуването ти може да се забави, отложи или провали поради технически, финансови или други причини.",
    "reading_advice": "Не се отчайвай. Понякога забавянето идва, за да ни предпази от нещо."
  },
  {
    "reading_id": "dream_job",
    "reading_name": "Работата на мечтите",
    "reading_cards": "Асо Пентакли + 6 Жезли + Свят",
    "reading_combination": ["ace_pentacles", "six_wands", "world"],
    "reading_meaning": "Получаване на желана работа",
    "reading_description": "Ще получиш работата, за която си мечтал. Тя носи удовлетворение, добро заплащане и възможност за развитие.",
    "reading_advice": "Ти си на точното място в точното време. Наслаждавай се на успеха."
  },
  {
    "reading_id": "retirement",
    "reading_name": "Пенсиониране",
    "reading_cards": "10 Пентакли + 4 Мечове + Отшелник",
    "reading_combination": ["ten_pentacles", "four_swords", "hermit"],
    "reading_meaning": "Край на трудовия път",
    "reading_description": "Пенсиониране, край на активната трудова дейност. Време за почивка, семейство и занимания по душа.",
    "reading_advice": "Наслади се на заслужената почивка. Сега е време да правиш това, което обичаш."
  },
  {
    "reading_id": "volunteer",
    "reading_name": "Доброволчество",
    "reading_cards": "6 Пентакли + 3 Чаши + Звезда",
    "reading_combination": ["six_pentacles", "three_cups", "star"],
    "reading_meaning": "Помощ на другите",
    "reading_description": "Ще се включиш в доброволческа кауза или ще помагаш на хора в нужда. Това носи смисъл и радост.",
    "reading_advice": "Да даваш е най-висшата форма на получаване. Сърцето ти ще бъде пълно."
  },
  {
    "reading_id": "first_date",
    "reading_name": "Първа среща",
    "reading_cards": "Асо Чаши + 8 Жезли + 2 Чаши",
    "reading_combination": ["ace_cups", "eight_wands", "two_cups"],
    "reading_meaning": "Начало на романтика",
    "reading_description": "Предстои вълнуваща първа среща, която може да прерасне в нещо повече. Химията между вас е силна още от самото начало.",
    "reading_advice": "Бъди себе си и се отпусни. Истинската връзка започва, когато спреш да играеш роли."
  },
  {
    "reading_id": "long_distance",
    "reading_name": "Връзка от разстояние",
    "reading_cards": "8 Чаши + 2 Чаши + 6 Мечове",
    "reading_combination": ["eight_cups", "two_cups", "six_swords"],
    "reading_meaning": "Любов през разстояние",
    "reading_description": "Връзка, разделена от километри. Видео разговори, чатове, копнеж. Любовта ви издържа на изпитанието на разстоянието.",
    "reading_advice": "Комуникацията е ключът. Планирайте следващата среща и вярвайте, че разстоянието е временно."
  },
 
 
 
  {
    "reading_id": "wedding_planning",
    "reading_name": "Планиране на сватба",
    "reading_cards": "4 Жезли + 3 Чаши + 9 Пентакли",
    "reading_combination": ["four_wands", "three_cups", "nine_pentacles"],
    "reading_meaning": "Организация на тържество",
    "reading_description": "Активно планиране на сватба, избор на дата, място, гости. Вълнение, стрес и щастие едновременно.",
    "reading_advice": "Наслаждавай се на процеса, не само на резултата. Това са специални моменти."
  },
  {
    "reading_id": "anniversary",
    "reading_name": "Годишнина от сватбата",
    "reading_cards": "10 Чаши + 4 Жезли + 6 Чаши",
    "reading_combination": ["ten_cups", "four_wands", "six_cups"],
    "reading_meaning": "Празник на любовта",
    "reading_description": "Годишнина от сватбата или от започването на връзката. Време за равносметка и благодарност за споделения път.",
    "reading_advice": "Празнувайте любовта си. Направете нещо специално заедно, далеч от ежедневието."
  },
  {
    "reading_id": "empty_nest",
    "reading_name": "Празно гнездо",
    "reading_cards": "8 Чаши + 10 Чаши + 4 Мечове",
    "reading_combination": ["eight_cups", "ten_cups", "four_swords"],
    "reading_meaning": "Децата напускат дома",
    "reading_description": "Децата порастват и напускат дома. Тъга, но и ново начало за връзката ви като двойка. Отново сте само двамата.",
    "reading_advice": "Открийте се един друг отново. Време е за пътувания, хобита и нови общи преживявания."
  },
  {
    "reading_id": "career_change",
    "reading_name": "Смяна на професията",
    "reading_cards": "Смърт + Асо Пентакли + 8 Жезли",
    "reading_combination": ["death", "ace_pentacles", "eight_wands"],
    "reading_meaning": "Радикална промяна в кариерата",
    "reading_description": "Решителна смяна на професията или кариерния път. Оставяш старото зад гърба си и тръгваш в съвсем нова посока.",
    "reading_advice": "Не се страхувай да започнеш отначало. Опитът ти не е загубен, той ти дава уникална перспектива."
  },
  {
    "reading_id": "work_at_home",
    "reading_name": "Работа от вкъщи",
    "reading_cards": "4 Жезли + 8 Пентакли + 9 Пентакли",
    "reading_combination": ["four_wands", "eight_pentacles", "nine_pentacles"],
    "reading_meaning": "Дистанционна работа",
    "reading_description": "Преминаване към работа от вкъщи или фрийланс. Създаване на домашен офис и баланс между професионално и лично.",
    "reading_advice": "Създай си режим и работно пространство. Дисциплината е ключът към успеха от вкъщи."
  },
  
 
  {
    "reading_id": "public_speaking",
    "reading_name": "Публично говорене",
    "reading_cards": "6 Жезли + Магьосник + Слънце",
    "reading_combination": ["six_wands", "magician", "sun"],
    "reading_meaning": "Успешна презентация",
    "reading_description": "Предстои ти публично изказване, презентация или лекция. Ще се справиш блестящо и ще получиш признание.",
    "reading_advice": "Вярвай в думите си. Това, което казваш, има значение за хората."
  },
  {
    "reading_id": "graduation",
    "reading_name": "Дипломиране",
    "reading_cards": "10 Пентакли + 6 Жезли + Свят",
    "reading_combination": ["ten_pentacles", "six_wands", "world"],
    "reading_meaning": "Завършване на образование",
    "reading_description": "Завършване на училище, университет или курс. Получаване на диплома. Край на един етап и начало на следващ.",
    "reading_advice": "Гордей се с постижението си. Никой не може да ти отнеме образованието и знанията."
  },
  {
    "reading_id": "research",
    "reading_name": "Научно изследване",
    "reading_cards": "8 Пентакли + Асо Мечове + Отшелник",
    "reading_combination": ["eight_pentacles", "ace_swords", "hermit"],
    "reading_meaning": "Задълбочено проучване",
    "reading_description": "Работа по научно изследване, дисертация или задълбочен проект. Самота, концентрация и открития.",
    "reading_advice": "Търпение и постоянство. Истината изисква време, за да бъде открита."
  },
  {
    "reading_id": "language_learning",
    "reading_name": "Изучаване на език",
    "reading_cards": "8 Пентакли + 6 Мечове + Свят",
    "reading_combination": ["eight_pentacles", "six_swords", "world"],
    "reading_meaning": "Нов език",
    "reading_description": "Започваш да учиш нов език или се подготвяш за езиков изпит. Това ще отвори нови врати пред теб.",
    "reading_advice": "Потапяй се в езика – филми, музика, разговори. Тренирай всеки ден."
  },
 
  {
    "reading_id": "car_accident",
    "reading_name": "Пътен инцидент",
    "reading_cards": "Кула + 10 Мечове + 5 Пентакли",
    "reading_combination": ["tower", "ten_swords", "five_pentacles"],
    "reading_meaning": "Катастрофа",
    "reading_description": "Възможен пътен инцидент, повреда на кола или проблем с превозно средство. Бъди внимателен на пътя.",
    "reading_advice": "Провери техническото състояние на колата и шофирай внимателно. Понякога е по-добре да изчакаш."
  },
  {
    "reading_id": "home_birth",
    "reading_name": "Раждане вкъщи",
    "reading_cards": "Императрица + 4 Жезли + Слънце",
    "reading_combination": ["empress", "four_wands", "sun"],
    "reading_meaning": "Домашно раждане",
    "reading_description": "Планиране на раждане в домашни условия или в специална среда. Интимно, спокойно и щастливо събитие.",
    "reading_advice": "Подготви се добре и се обгради с хора, на които имаш доверие. Твоето тяло знае как да прави това."
  },
  {
    "reading_id": "adoption",
    "reading_name": "Осиновяване",
    "reading_cards": "Императрица + 10 Чаши + 6 Чаши",
    "reading_combination": ["empress", "ten_cups", "six_cups"],
    "reading_meaning": "Дете идва в семейството",
    "reading_description": "Осиновяване или приемна грижа. Нов член на семейството идва по нетрадиционен начин, носейки любов и радост.",
    "reading_advice": "Сърцето ти е отворено за любов без условия. Това е най-красивото нещо."
  },
 
  {
    "reading_id": "motherhood",
    "reading_name": "Майчинство",
    "reading_cards": "Императрица + Луна + 9 Пентакли",
    "reading_combination": ["empress", "moon", "nine_pentacles"],
    "reading_meaning": "Пътят на майката",
    "reading_description": "Пътят на майчинството – безсънни нощи, грижи, безкрайна любов. Промяна на идентичността и приоритетите.",
    "reading_advice": "Грижи се и за себе си. Щастливата майка е най-доброто, което можеш да дадеш на детето си."
  },
  {
    "reading_id": "fatherhood",
    "reading_name": "Бащинство",
    "reading_cards": "Император + 4 Жезли + Сила",
    "reading_combination": ["emperor", "four_wands", "strength"],
    "reading_meaning": "Ролята на бащата",
    "reading_description": "Прегръщане на ролята на баща – закрилник, учител, пример. Нова отговорност и нова любов.",
    "reading_advice": "Бъди твърд, но нежен. Децата имат нужда от твоето присъствие повече от твоите подаръци."
  },
  {
    "reading_id": "family_secret",
    "reading_name": "Семейна тайна",
    "reading_cards": "Луна + 7 Мечове + Върховна жрица",
    "reading_combination": ["moon", "seven_swords", "high_priestess"],
    "reading_meaning": "Разкриване на тайна",
    "reading_description": "Семейна тайна излиза наяве. Нещо, което е било скривано с години, най-после се разкрива.",
    "reading_advice": "Истината може да боли, но винаги лекува. Бъди готов да простиш."
  },
  {
    "reading_id": "family_business",
    "reading_name": "Семеен бизнес",
    "reading_cards": "10 Пентакли + 3 Пентакли + Император",
    "reading_combination": ["ten_pentacles", "three_pentacles", "emperor"],
    "reading_meaning": "Работа със семейството",
    "reading_description": "Започване или продължаване на семеен бизнес. Работа с родители, братя, сестри. Предизвикателство и благословия.",
    "reading_advice": "Разделяй професионалното от личното. Установи ясни правила и граници."
  },
  {
    "reading_id": "divorce_settlement",
    "reading_name": "Споразумение за развод",
    "reading_cards": "Справедливост + 4 Пентакли + 5 Мечове",
    "reading_combination": ["justice", "four_pentacles", "five_swords"],
    "reading_meaning": "Разделяне на имущество",
    "reading_description": "Финализиране на развод и разделяне на имущество. Преговори, адвокати, но накрая – свобода.",
    "reading_advice": "Бъди справедлив, но не позволявай да те ограбят. Това е край, от който трябва да започнеш наново."
  },
  {
    "reading_id": "online_dating",
    "reading_name": "Запознанство в интернет",
    "reading_cards": "8 Жезли + 7 Чаши + 2 Чаши",
    "reading_combination": ["eight_wands", "seven_cups", "two_cups"],
    "reading_meaning": "Среща през приложение",
    "reading_description": "Запознанство чрез онлайн платформа или приложение. Много възможности, много избори, но внимавай с илюзиите.",
    "reading_advice": "Бъди честен в профила си и не се влюбвай в снимка. Истинската връзка е в реалния живот."
  },
  {
    "reading_id": "blind_date",
    "reading_name": "Среща на сляпо",
    "reading_cards": "Колело на съдбата + 2 Чаши + 8 Жезли",
    "reading_combination": ["wheel_of_fortune", "two_cups", "eight_wands"],
    "reading_meaning": "Изненадваща среща",
    "reading_description": "Организирана среща на сляпо от приятели. Съдбата може да има изненада за теб – не очаквай нищо, просто се отвори.",
    "reading_advice": "Дай шанс на изненадата. Понякога най-добрите неща идват, когато не ги търсиш."
  },
  {
    "reading_id": "ex_jealous",
    "reading_name": "Ревност от бивш",
    "reading_cards": "7 Мечове + 3 Мечове + Дявол",
    "reading_combination": ["seven_swords", "three_swords", "devil"],
    "reading_meaning": "Бившият не те оставя на мира",
    "reading_description": "Бивш партньор проявява ревност или се опитва да саботира новата ти връзка. Държание, водено от его и притежание.",
    "reading_advice": "Запази дистанция и не влизай в игри. Истинската свобода е, когато спреш да реагираш на миналото."
  },
  {
    "reading_id": "no_contact",
    "reading_name": "Прекъсване на контакт",
    "reading_cards": "8 Мечове + 6 Мечове + Отшелник",
    "reading_combination": ["eight_swords", "six_swords", "hermit"],
    "reading_meaning": "Време без контакт",
    "reading_description": "Решително прекъсване на контакт с бивш или токсичен човек. Блокиране, тишина, движение напред.",
    "reading_advice": "Не се обръщай назад. Тишината е злато, когато пази мира ти."
  },
  {
    "reading_id": "healing_heart",
    "reading_name": "Лекуване на сърцето",
    "reading_cards": "4 Мечове + Звезда + 8 Чаши",
    "reading_combination": ["four_swords", "star", "eight_cups"],
    "reading_meaning": "След раздяла",
    "reading_description": "Процес на възстановяване след тежка раздяла. Плач, самота, но и първите лъчи надежда. Бавно оздравяваш.",
    "reading_advice": "Дай си време. Раните се лекуват, а сърцето ти отново ще обича."
  },
  {
    "reading_id": "fling",
    "reading_name": "Лятна любов",
    "reading_cards": "Асо Жезли + 8 Жезли + 3 Чаши",
    "reading_combination": ["ace_wands", "eight_wands", "three_cups"],
    "reading_meaning": "Кратка, но страстна връзка",
    "reading_description": "Кратка, но интензивна любовна афера – лятна любов, почивка, приключение. Страст, която знае, че има край.",
    "reading_advice": "Наслаждавай се на момента, без очаквания за бъдеще. Понякога точно това го прави специален."
  },
  {
    "reading_id": "friends_with_benefits",
    "reading_name": "Приятели с предимства",
    "reading_cards": "Дявол + 3 Чаши + 2 Чаши",
    "reading_combination": ["devil", "three_cups", "two_cups"],
    "reading_meaning": "Физическа връзка без обвързване",
    "reading_description": "Връзка, основана главно на физическо привличане и приятелство, без романтични обвързвания. Рискувате чувствата.",
    "reading_advice": "Бъдете честни за намеренията си. Някой винаги пострадва, когато има повече от единия."
  },
  {
    "reading_id": "charity",
    "reading_name": "Благотворителност",
    "reading_cards": "6 Пентакли + 3 Чаши + Звезда",
    "reading_combination": ["six_pentacles", "three_cups", "star"],
    "reading_meaning": "Помощ за нуждаещи се",
    "reading_description": "Участие в благотворителна кауза или дарение. Даването без очакване на отплата носи най-голямо удовлетворение.",
    "reading_advice": "Колкото повече даваш, толкова повече получаваш. Вселената възнаграждава щедрите сърца."
  },
  {
    "reading_id": "taxes",
    "reading_name": "Данъци",
    "reading_cards": "4 Пентакли + Справедливост + 8 Мечове",
    "reading_combination": ["four_pentacles", "justice", "eight_swords"],
    "reading_meaning": "Данъчна проверка",
    "reading_description": "Време за данъци, проверка от НАП или финансови задължения към държавата. Бъди внимателен с документите.",
    "reading_advice": "Планирай и не крий нищо. Проблемите с властите не си струват стреса."
  },
  {
    "reading_id": "lottery_ticket",
    "reading_name": "Билет за лотария",
    "reading_cards": "Колело на съдбата + Асо Пентакли + 9 Пентакли",
    "reading_combination": ["wheel_of_fortune", "ace_pentacles", "nine_pentacles"],
    "reading_meaning": "Малък шанс за печалба",
    "reading_description": "Купуване на билет за лотария или участие в томбола. Малък шанс за печалба, но кой знае?",
    "reading_advice": "Забавлявай се, но не влагай повече, отколкото можеш да загубиш. Късметът обича смелите, но не и безразсъдните."
  },
  {
    "reading_id": "inheritance_money",
    "reading_name": "Получаване на наследство",
    "reading_cards": "10 Пентакли + 4 Пентакли + 6 Пентакли",
    "reading_combination": ["ten_pentacles", "four_pentacles", "six_pentacles"],
    "reading_meaning": "Пари от наследство",
    "reading_description": "Получаване на пари или имот от наследство. Финансово облекчение, но и емоционална тежест от загубата.",
    "reading_advice": "Почети паметта на близките, като използваш парите разумно. Инвестирай в бъдещето."
  },
  {
    "reading_id": "money_lent",
    "reading_name": "Даване на заем",
    "reading_cards": "6 Пентакли + 4 Пентакли + 5 Пентакли",
    "reading_combination": ["six_pentacles", "four_pentacles", "five_pentacles"],
    "reading_meaning": "Заем на приятел",
    "reading_description": "Някой близък иска да му заемеш пари. Внимавай – това може да промени динамиката на връзката ви.",
    "reading_advice": "Ако даваш назаем, давай само толкова, колкото си готов да загубиш. И напиши документ."
  },
  {
    "reading_id": "sold_property",
    "reading_name": "Продажба на имот",
    "reading_cards": "Асо Пентакли + 10 Пентакли + 6 Жезли",
    "reading_combination": ["ace_pentacles", "ten_pentacles", "six_wands"],
    "reading_meaning": "Успешна продажба",
    "reading_description": "Продаваш имот или ценна вещ. Успешна сделка, добра цена, доволни купувачи.",
    "reading_advice": "Използвай парите разумно – инвестирай в ново начало или погаси дългове."
  },
  {
    "reading_id": "moving_city",
    "reading_name": "Преместване в друг град",
    "reading_cards": "6 Мечове + 4 Жезли + Колесница",
    "reading_combination": ["six_swords", "four_wands", "chariot"],
    "reading_meaning": "Нов град, нов живот",
    "reading_description": "Смяна на местоживеенето в друг град. Нова среда, нови хора, нови възможности. Вълнуващо и страшно.",
    "reading_advice": "Прегърни промяната. Новият град те очаква с отворени обятия."
  },
  {
    "reading_id": "house_rent",
    "reading_name": "Наемане на жилище",
    "reading_cards": "Асо Пентакли + 2 Пентакли + 4 Жезли",
    "reading_combination": ["ace_pentacles", "two_pentacles", "four_wands"],
    "reading_meaning": "Нов дом под наем",
    "reading_description": "Намиране и наемане на ново жилище. Подписване на договор, депозит, пренасяне. Ново начало.",
    "reading_advice": "Прочети договора внимателно и направи снимки на състоянието при влизане."
  },
  {
    "reading_id": "neighbors",
    "reading_name": "Нови съседи",
    "reading_cards": "3 Чаши + 4 Жезли + 6 Пентакли",
    "reading_combination": ["three_cups", "four_wands", "six_pentacles"],
    "reading_meaning": "Запознанство със съседи",
    "reading_description": "Нови съседи се нанасят или опознаваш старите по-добре. Възможност за нови приятелства и взаимопомощ.",
    "reading_advice": "Бъди добър съсед – усмихни се, представи се и предложи помощ, ако е нужно."
  },
  {
    "reading_id": "twin_flames",
    "reading_name": "Близнашки пламъци",
    "reading_cards": "Влюбените + 2 Чаши + Колело на съдбата",
    "reading_combination": ["lovers", "two_cups", "wheel_of_fortune"],
    "reading_meaning": "Интензивна кармична връзка",
    "reading_description": "Среща с близнашкия пламък – връзка, която едновременно те изпълва и те предизвиква. Огледало на душата ти, което показва всичко, което трябва да излекуваш.",
    "reading_advice": "Това не е обикновена любов – това е духовно пробуждане. Прегърни уроците, дори да болят."
  },
  {
    "reading_id": "love_at_first_sight",
    "reading_name": "Любов от пръв поглед",
    "reading_cards": "Асо Чаши + 8 Жезли + Слънце",
    "reading_combination": ["ace_cups", "eight_wands", "sun"],
    "reading_meaning": "Магическа среща",
    "reading_description": "Ще преживееш любов от пръв поглед – момент, в който светът спира и виждаш само него/нея. Сякаш сте се познавали от винаги.",
    "reading_advice": "Не анализирай – просто усети. Някои неща се случват, за да променят живота ти завинаги."
  },
  {
    "reading_id": "love_ultimatum",
    "reading_name": "Любовен ултиматум",
    "reading_cards": "Справедливост + 5 Мечове + 4 Жезли",
    "reading_combination": ["justice", "five_swords", "four_wands"],
    "reading_meaning": "Изискване за обвързване",
    "reading_description": "Пред теб е поставен ултиматум – време е да се обвържеш или да продължиш напред. Някой иска яснота за бъдещето ви.",
    "reading_advice": "Не отлагай трудния разговор. Истината, колкото и да боли, е по-добра от несигурността."
  },
  {
    "reading_id": "secret_relationship",
    "reading_name": "Тайна връзка",
    "reading_cards": "Луна + 7 Мечове + 2 Чаши",
    "reading_combination": ["moon", "seven_swords", "two_cups"],
    "reading_meaning": "Скрита афера",
    "reading_description": "Връзка, която криете от света. Тайни срещи, скрити съобщения, прикриване. Вълнуващо, но изтощително.",
    "reading_advice": "Попитай се: защо трябва да е тайна? Истинската любов не се страхува от светлината."
  },
  {
    "reading_id": "lavender_marriage",
    "reading_name": "Лавандулов брак",
    "reading_cards": "Йерофант + 4 Жезли + 7 Мечове",
    "reading_combination": ["hierophant", "four_wands", "seven_swords"],
    "reading_meaning": "Брак за удобство",
    "reading_description": "Брак по сметка или за прикритие. Сключвате съюз, който не е основан на любов, а на удобство, семейни очаквания или социален натиск.",
    "reading_advice": "Истинската свобода идва, когато живееш своята истина, а не чужд сценарий."
  },
  {
    "reading_id": "corporate_climb",
    "reading_name": "Корпоративно израстване",
    "reading_cards": "6 Жезли + Император + 10 Пентакли",
    "reading_combination": ["six_wands", "emperor", "ten_pentacles"],
    "reading_meaning": "Кариерен ръст в компания",
    "reading_description": "Изкачване по корпоративната стълбица. Повишение, нова позиция, по-голяма отговорност и по-високо заплащане.",
    "reading_advice": "Бъди стратегичен, но не забравяй човешките взаимоотношения. Мрежата от контакти е също толкова важна."
  },
  {
    "reading_id": "startup_funding",
    "reading_name": "Финансиране на стартъп",
    "reading_cards": "Асо Пентакли + 8 Жезли + 3 Пентакли",
    "reading_combination": ["ace_pentacles", "eight_wands", "three_pentacles"],
    "reading_meaning": "Получаване на инвестиция",
    "reading_description": "Успешно привличане на инвестиции за стартъп или бизнес идея. Инвеститорите вярват в теб и в проекта ти.",
    "reading_advice": "Представи идеята си с увереност. Твоята страст е заразителна и ще убеди хората да те последват."
  },
  {
    "reading_id": "business_merger",
    "reading_name": "Сливане на компании",
    "reading_cards": "2 Пентакли + 3 Пентакли + 4 Пентакли",
    "reading_combination": ["two_pentacles", "three_pentacles", "four_pentacles"],
    "reading_meaning": "Обединение на бизнеси",
    "reading_description": "Предстои сливане или партньорство между две компании. Обединение на ресурси, клиенти и екипи за по-голям успех.",
    "reading_advice": "Провери добре партньора и документите. Доброто партньорство започва с ясни правила."
  },
  {
    "reading_id": "work_burnout",
    "reading_name": "Прегаряне на работа",
    "reading_cards": "10 Жезли + 4 Мечове + 9 Мечове",
    "reading_combination": ["ten_wands", "four_swords", "nine_swords"],
    "reading_meaning": "Физическо и психическо изтощение",
    "reading_description": "Работиш прекалено много, без почивка и баланс. Близо си до пълно изтощение – физическо, емоционално и психическо.",
    "reading_advice": "СПРИ! Болничният не е опция, а необходимост. Никоя работа не струва здравето ти."
  },
  {
    "reading_id": "workplace_gossip",
    "reading_name": "Офис клюки",
    "reading_cards": "7 Мечове + 5 Жезли + 5 Чаши",
    "reading_combination": ["seven_swords", "five_wands", "five_cups"],
    "reading_meaning": "Интриги зад гърба",
    "reading_description": "В офиса се носят клюки и интриги. Някой говори зад гърба ти или разпространява неверни слухове, които могат да навредят.",
    "reading_advice": "Не се замесвай и не храни клюкарите с реакция. Професионализмът е най-добрият ти отговор."
  },
  {
    "reading_id": "job_offer",
    "reading_name": "Получаване на оферта",
    "reading_cards": "Асо Пентакли + 6 Жезли + 8 Жезли",
    "reading_combination": ["ace_pentacles", "six_wands", "eight_wands"],
    "reading_meaning": "Работно предложение",
    "reading_description": "Получаваш неочаквано предложение за работа. Бързо развитие, добри условия и възможност за растеж.",
    "reading_advice": "Претегли плюсовете и минусите, но не се страхувай да приемеш новото предизвикателство."
  },
  {
    "reading_id": "part_time",
    "reading_name": "Работа на половин ден",
    "reading_cards": "2 Пентакли + 8 Пентакли + 9 Пентакли",
    "reading_combination": ["two_pentacles", "eight_pentacles", "nine_pentacles"],
    "reading_meaning": "Допълнителна заетост",
    "reading_description": "Започваш работа на половин ден или допълнителна заетост към основната. Балансиране на време и енергия между два ангажимента.",
    "reading_advice": "Управлявай времето си добре и не позволявай на допълнителната работа да изтощи основната ти енергия."
  },
  {
    "reading_id": "freelance_success",
    "reading_name": "Успех като фрийлансър",
    "reading_cards": "Асо Пентакли + 8 Пентакли + 6 Жезли",
    "reading_combination": ["ace_pentacles", "eight_pentacles", "six_wands"],
    "reading_meaning": "Процъфтяваща свободна практика",
    "reading_description": "Кариерата ти като фрийлансър върви нагоре. Нови клиенти, добри проекти, финансова стабилност и свобода.",
    "reading_advice": "Продължавай да учиш и да се развиваш. Качеството на работата ти е най-добрата ти реклама."
  },
  {
    "reading_id": "career_doubt",
    "reading_name": "Съмнение в кариерата",
    "reading_cards": "5 Мечове + 7 Чаши + 8 Мечове",
    "reading_combination": ["five_swords", "seven_cups", "eight_swords"],
    "reading_meaning": "Въпроси за професионалния път",
    "reading_description": "Чувстваш се изгубен в кариерата си. Съмняваш се дали това е правилният път, дали си на правилното място.",
    "reading_advice": "Позволи си да експериментираш, без натиск. Понякога трябва да опиташ, за да разбереш."
  },
  {
    "reading_id": "retirement_planning",
    "reading_name": "Планиране на пенсия",
    "reading_cards": "4 Пентакли + 9 Пентакли + 10 Пентакли",
    "reading_combination": ["four_pentacles", "nine_pentacles", "ten_pentacles"],
    "reading_meaning": "Грижа за бъдещето",
    "reading_description": "Започваш да мислиш за пенсия и дългосрочна сигурност. Спестявания, инвестиции, осигуровки. Умно решение.",
    "reading_advice": "Колкото по-рано започнеш да планираш, толкова по-спокойна ще бъде старостта ти."
  },
  {
    "reading_id": "early_retirement",
    "reading_name": "Ранно пенсиониране",
    "reading_cards": "4 Мечове + Отшелник + 10 Пентакли",
    "reading_combination": ["four_swords", "hermit", "ten_pentacles"],
    "reading_meaning": "Освобождаване от работа",
    "reading_description": "Излизаш в ранна пенсия или спираш да работиш активно. Време за себе си, пътувания и неща, които отлагаш с години.",
    "reading_advice": "Наслади се на свободата, но намери смисъл в новите си занимания. Човек има нужда да бъде полезен."
  },
  {
    "reading_id": "health_check",
    "reading_name": "Профилактичен преглед",
    "reading_cards": "4 Мечове + 5 Пентакли + 8 Пентакли",
    "reading_combination": ["four_swords", "five_pentacles", "eight_pentacles"],
    "reading_meaning": "Време за преглед",
    "reading_description": "Важно е да си направиш профилактичен преглед. Не отлагай грижата за здравето си – открито навреме се лекува лесно.",
    "reading_advice": "Запиши си час при лекар. Дори да нямаш симптоми, профилактиката е най-добрата инвестиция."
  },
  {
    "reading_id": "surgery",
    "reading_name": "Операция",
    "reading_cards": "4 Мечове + 10 Мечове + Смърт",
    "reading_combination": ["four_swords", "ten_swords", "death"],
    "reading_meaning": "Предстояща хирургическа намеса",
    "reading_description": "Предстои ти операция или медицинска процедура. Страх и притеснение, но тя е необходима за оздравяването ти.",
    "reading_advice": "Довери се на лекарите и се подготви психически. След операцията идва възстановяване и ново здраве."
  },
  {
    "reading_id": "chronic_illness",
    "reading_name": "Хронично заболяване",
    "reading_cards": "5 Пентакли + 10 Мечове + Луна",
    "reading_combination": ["five_pentacles", "ten_swords", "moon"],
    "reading_meaning": "Дългосрочно лечение",
    "reading_description": "Диагностициране или живот с хронично заболяване. Дълъг път на лечение, търпение и приемане на новата реалност.",
    "reading_advice": "Приеми състоянието си, но не позволявай то да те определя. Много хора живеят пълноценно с хронични болести."
  },
  {
    "reading_id": "healing_crisis",
    "reading_name": "Изцелителна криза",
    "reading_cards": "Смърт + 9 Мечове + Звезда",
    "reading_combination": ["death", "nine_swords", "star"],
    "reading_meaning": "Влошаване преди подобрение",
    "reading_description": "Преминаваш през изцелителна криза – става ти по-зле, преди да стане по-добре. Това е знак, че тялото се лекува.",
    "reading_advice": "Издържи. Това е преходен етап. След бурята идва слънце."
  },
   
  {
    "reading_id": "fertility_treatment",
    "reading_name": "Лечение на фертилитет",
    "reading_cards": "Императрица + 8 Пентакли + Луна",
    "reading_combination": ["empress", "eight_pentacles", "moon"],
    "reading_meaning": "Път към забременяване",
    "reading_description": "Започваш или продължаваш лечение за фертилитет. Емоционален влакче, надежда и разочарования, търпение и постоянство.",
    "reading_advice": "Грижи се за емоционалното си здраве. Този път е тежък – потърси подкрепа и не се обвинявай."
  },
  {
    "reading_id": "surrogacy",
    "reading_name": "Сурогатно майчинство",
    "reading_cards": "Императрица + 6 Чаши + Свят",
    "reading_combination": ["empress", "six_cups", "world"],
    "reading_meaning": "Дете чрез сурогат",
    "reading_description": "Пътят към родителството минава през сурогатна майка. Сложен, емоционален и скъп процес, който води до щастлив край.",
    "reading_advice": "Цени жената, която носи твоето дете. Това е акт на безкрайна щедрост и любов."
  },
  {
    "reading_id": "miscarriage_healing",
    "reading_name": "Лекуване след загуба",
    "reading_cards": "5 Чаши + 4 Мечове + Звезда",
    "reading_combination": ["five_cups", "four_swords", "star"],
    "reading_meaning": "Възстановяване след спонтанен аборт",
    "reading_description": "Процес на възстановяване след загуба на бременност. Първо идва тъгата, после бавно надеждата, а после и новото начало.",
    "reading_advice": "Не бързай. Лекуването има своите етапи. Когато си готова, любовта отново ще те намери."
  },
  {
    "reading_id": "empty_womb",
    "reading_name": "Празна утроба",
    "reading_cards": "8 Чаши + 5 Чаши + Луна",
    "reading_combination": ["eight_cups", "five_cups", "moon"],
    "reading_meaning": "Приемане че няма да има деца",
    "reading_description": "Трудно приемане, че може да нямаш деца. Скръб по никога неродените, по майчинството, което няма да дойде.",
    "reading_advice": "Ти си повече от способността да раждаш. Животът има много форми на плодородие и творчество."
  },
  {
    "reading_id": "child_free",
    "reading_name": "Доброволна бездетност",
    "reading_cards": "4 Мечове + 9 Пентакли + Отшелник",
    "reading_combination": ["four_swords", "nine_pentacles", "hermit"],
    "reading_meaning": "Избор да нямаш деца",
    "reading_description": "Съзнателен избор да не създаваш деца. Решение, което обществото често не разбира, но то носи свобода и мир.",
    "reading_advice": "Ти не дължиш деца на никого. Животът ти е твой и има стойност сам по себе си."
  },
  {
    "reading_id": "spiritual_retreat",
    "reading_name": "Духовно уединение",
    "reading_cards": "Отшелник + 4 Мечове + Върховна жрица",
    "reading_combination": ["hermit", "four_swords", "high_priestess"],
    "reading_meaning": "Време за себе си",
    "reading_description": "Оттегляне за духовно уединение – ретрийт, манастир, планина. Време за мълчание, медитация и връзка с вътрешния глас.",
    "reading_advice": "Отдалечи се от шума на света, за да чуеш шепота на душата си."
  },
  {
    "reading_id": "chakra_healing",
    "reading_name": "Лечение на чакри",
    "reading_cards": "Върховна жрица + 4 Мечове + 8 Пентакли",
    "reading_combination": ["high_priestess", "four_swords", "eight_pentacles"],
    "reading_meaning": "Енергийно лечение",
    "reading_description": "Работа по енергийната ти система – чакри, аура, енергийни канали. Възстановяване на баланса и хармонията.",
    "reading_advice": "Потърси опитен лечител или се научи сам да балансираш енергията си. Тялото ти помни всичко."
  },
  {
    "reading_id": "past_life_regression",
    "reading_name": "Регресия в минал живот",
    "reading_cards": "Луна + 6 Чаши + Върховна жрица",
    "reading_combination": ["moon", "six_cups", "high_priestess"],
    "reading_meaning": "Спомени от предишно въплъщение",
    "reading_description": "Преживяване на регресия в минал живот. Виждаш образи, хора, ситуации, които обясняват сегашните ти страхове и модели.",
    "reading_advice": "Записвай всичко, което виждаш. Тези спомени носят ключове за изцеление в настоящето."
  },
  {
    "reading_id": "mediumship",
    "reading_name": "Връзка с отвъдното",
    "reading_cards": "Върховна жрица + 6 Чаши + Луна",
    "reading_combination": ["high_priestess", "six_cups", "moon"],
    "reading_meaning": "Контакт с починали",
    "reading_description": "Развиване на медиумни способности или контакт с починал близък. Той идва да ти каже, че е добре и те обича.",
    "reading_advice": "Не се страхувай. Любовта не умира – тя просто сменя формата си."
  },
  {
    "reading_id": "angel_contact",
    "reading_name": "Контакт с ангели",
    "reading_cards": "Звезда + Умереност + Върховна жрица",
    "reading_combination": ["star", "temperance", "high_priestess"],
    "reading_meaning": "Ангелска закрила",
    "reading_description": "Усещаш присъствието на ангели или духовни водачи около теб. Знаци, синхроничности, вътрешен мир и закрила.",
    "reading_advice": "Благодари и поискай помощ. Ангелите чакат да ги поканиш в живота си."
  },
  {
    "reading_id": "kundalini",
    "reading_name": "Пробуждане на Кундалини",
    "reading_cards": "Смърт + Дявол + Върховна жрица",
    "reading_combination": ["death", "devil", "high_priestess"],
    "reading_meaning": "Духовна енергия се издига",
    "reading_description": "Преживяваш пробуждане на Кундалини – интензивна енергия, която се издига по гръбнака. Промяна в съзнанието, физически усещания, емоционални вълни.",
    "reading_advice": "Потърси опитен учител. Този процес е мощен и може да бъде непосилен без правилно напътствие."
  },
  {
    "reading_id": "dream_interpretation",
    "reading_name": "Тълкуване на сънища",
    "reading_cards": "Луна + Върховна жрица + 9 Мечове",
    "reading_combination": ["moon", "high_priestess", "nine_swords"],
    "reading_meaning": "Сънищата носят послания",
    "reading_description": "Сънищата ти са ярки, странни, повтарящи се. Те носят важни послания от подсъзнанието ти, които сега излизат на повърхността.",
    "reading_advice": "Записвай сънищата веднага след събуждане. Те са мост към вътрешната ти мъдрост."
  },
  {
    "reading_id": "synchronicity",
    "reading_name": "Синхроничности",
    "reading_cards": "Магьосник + Колело на съдбата + 8 Жезли",
    "reading_combination": ["magician", "wheel_of_fortune", "eight_wands"],
    "reading_meaning": "Знаци от Вселената",
    "reading_description": "Забелязваш все повече синхроничности – еднакви числа, случайни срещи, повтарящи се теми. Вселената ти говори.",
    "reading_advice": "Обръщай внимание на знаците. Те не са случайни – те са пътеки към съдбата ти."
  },
  {
    "reading_id": "spiritual_emergency",
    "reading_name": "Духовна криза",
    "reading_cards": "Кула + 9 Мечове + Луна",
    "reading_combination": ["tower", "nine_swords", "moon"],
    "reading_meaning": "Срив на представите",
    "reading_description": "Преживяваш духовна криза – всичко, в което си вярвал, се срива. Чувстваш се изгубен, дезориентиран, сам.",
    "reading_advice": "Това не е лудост, а трансформация. Потърси подкрепа от хора, които разбират духовните процеси."
  },
  {
    "reading_id": "witchcraft",
    "reading_name": "Магическа практика",
    "reading_cards": "Върховна жрица + Магьосник + Луна",
    "reading_combination": ["high_priestess", "magician", "moon"],
    "reading_meaning": "Занимание с магия",
    "reading_description": "Започваш или задълбочаваш магическа практика. Работа с енергии, ритуали, заклинания, луна и природа.",
    "reading_advice": "Практикувай с чисти намерения и уважение. Магията е инструмент, не играчка."
  },
  {
    "reading_id": "sacred_place",
    "reading_name": "Посещение на свещено място",
    "reading_cards": "Йерофант + 6 Мечове + Свят",
    "reading_combination": ["hierophant", "six_swords", "world"],
    "reading_meaning": "Поклонничество",
    "reading_description": "Посещение на свещено място – храм, манастир, древни руини, природно място със специална енергия. Поклоннически път.",
    "reading_advice": "Отвори сърцето си за енергията на мястото. То носи мъдростта на вековете."
  },
  {
    "reading_id": "spiritual_teacher",
    "reading_name": "Среща с духовен учител",
    "reading_cards": "Йерофант + Отшелник + Слънце",
    "reading_combination": ["hierophant", "hermit", "sun"],
    "reading_meaning": "Мъдър водач",
    "reading_description": "Срещаш духовен учител или гуру, който променя живота ти. Думите му резонират дълбоко в душата ти.",
    "reading_advice": "Слушай, учи и прилагай. Истинският учител не ти дава риба, а те учи да ловиш."
  },
  {
    "reading_id": "ascension",
    "reading_name": "Духовно издигане",
    "reading_cards": "Смърт + Звезда + Свят",
    "reading_combination": ["death", "star", "world"],
    "reading_meaning": "Преход към по-високо ниво",
    "reading_description": "Преминаваш през процес на духовно издигане. Оставяш старото, лекуваш дълбоките рани и излизаш на ново ниво на съзнание.",
    "reading_advice": "Ти не си същият човек. Приеми новата си идентичност и сподели светлината си със света."
  },
  {
    "reading_id": "cosmic_connection",
    "reading_name": "Космическа връзка",
    "reading_cards": "Звезда + Свят + Влюбените",
    "reading_combination": ["star", "world", "lovers"],
    "reading_meaning": "Любов от други измерения",
    "reading_description": "Усещаш връзка с някого, който сякаш не е от този свят. Космическа любов, която надхвърля времето и пространството.",
    "reading_advice": "Това е рядка и специална връзка. Цени я, без да се опитваш да я ограничаваш в човешки рамки."
  },
  {
    "reading_id": "galactic_origin",
    "reading_name": "Звезден произход",
    "reading_cards": "Звезда + Луна + Свят",
    "reading_combination": ["star", "moon", "world"],
    "reading_meaning": "Спомен за други светове",
    "reading_description": "Чувстваш, че не си от този свят. Носталгия по звездите, спомени за други планети, усещане за извънземен произход.",
    "reading_advice": "Ти си тук с мисия. Открий каква е и я изпълни. Семената на звездите носят светлина на Земята."
  },
  {
    "reading_id": "love_confession",
    "reading_name": "Признание в любов",
    "reading_cards": "Асо Чаши + 3 Чаши + Слънце",
    "reading_combination": ["ace_cups", "three_cups", "sun"],
    "reading_meaning": "Някой ще ти признае любов",
    "reading_description": "Очаквай неочаквано признание в любов. Някой дълго е крил чувствата си и най-накрая намира смелост да ги разкрие.",
    "reading_advice": "Изслушай с отворено сърце. Дори отговорът ти да е 'не', бъди нежен - признанието изисква смелост."
  },
 
   
  {
    "reading_id": "love_obsession",
    "reading_name": "Обсебваща любов",
    "reading_cards": "Дявол + 7 Мечове + 9 Мечове",
    "reading_combination": ["devil", "seven_swords", "nine_swords"],
    "reading_meaning": "Нездрава привързаност",
    "reading_description": "Любовта ти прилича повече на обсебване. Ревност, контрол, страх от загуба. Това не е любов, а зависимост.",
    "reading_advice": "Освободи се от веригите, дори да боли. Нездравата любов унищожава и двамата."
  },
  {
    "reading_id": "love_rejection",
    "reading_name": "Отхвърляне",
    "reading_cards": "3 Мечове + 5 Чаши + 8 Мечове",
    "reading_combination": ["three_swords", "five_cups", "eight_swords"],
    "reading_meaning": "Чувстваш се нежелан",
    "reading_description": "Чувстваш се отхвърлен и нежелан. Сякаш не си достатъчно добър. Болката те парализира.",
    "reading_advice": "Тяхното 'не' не определя твоята стойност. Някой ден някой ще каже 'да' точно на теб."
  },
  {
    "reading_id": "love_vacation",
    "reading_name": "Ваканционен романс",
    "reading_cards": "8 Жезли + 3 Чаши + 6 Чаши",
    "reading_combination": ["eight_wands", "three_cups", "six_cups"],
    "reading_meaning": "Любов по време на почивка",
    "reading_description": "По време на почивка или пътуване ще преживееш кратък, но интензивен романс. Среща, която остава спомен за цял живот.",
    "reading_advice": "Наслаждавай се на момента, без очаквания за бъдеще. Някои неща са красиви точно защото са кратки."
  },
  {
    "reading_id": "love_home",
    "reading_name": "Домашен уют в любовта",
    "reading_cards": "4 Жезли + 10 Чаши + 9 Пентакли",
    "reading_combination": ["four_wands", "ten_cups", "nine_pentacles"],
    "reading_meaning": "Щастие в ежедневието",
    "reading_description": "Щастието не е в големите жестове, а в малките моменти - закуска заедно, филм в събота, разходка в парка. Това е истинската любов.",
    "reading_advice": "Не търси драма и страст на всяка цена. Тихите води са най-дълбоки."
  },
  {
    "reading_id": "love_distance",
    "reading_name": "Любов през океан",
    "reading_cards": "8 Чаши + 2 Чаши + 6 Мечове",
    "reading_combination": ["eight_cups", "two_cups", "six_swords"],
    "reading_meaning": "Връзка през континенти",
    "reading_description": "Любов, разделена от хиляди километри и часови разлики. Срещите са редки, но емоцията е силна.",
    "reading_advice": "Планирайте следващата среща още щом се разделите. Надеждата е това, което държи връзката жива."
  },
  {
    "reading_id": "love_break_upside",
    "reading_name": "Положителна страна на раздялата",
    "reading_cards": "8 Чаши + Звезда + Асо Чаши",
    "reading_combination": ["eight_cups", "star", "ace_cups"],
    "reading_meaning": "След раздяла идва ново начало",
    "reading_description": "Раздялата, колкото и да боли, ти отваря врата за нещо ново. Освобождаваш място за човек, който наистина те заслужава.",
    "reading_advice": "Благодари на миналото за уроците и отвори сърце за бъдещето. Най-доброто тепърва предстои."
  },
  {
    "reading_id": "love_compromise",
    "reading_name": "Компромис в любовта",
    "reading_cards": "2 Пентакли + 2 Чаши + Умереност",
    "reading_combination": ["two_pentacles", "two_cups", "temperance"],
    "reading_meaning": "Даване и вземане",
    "reading_description": "Връзката изисква компромиси и от двамата. Баланс между 'аз' и 'ние', между твоите и неговите нужди.",
    "reading_advice": "Компромисът не означава да се пречупиш. Означава да намериш средата, в която и двамата сте щастливи."
  },
  {
    "reading_id": "love_fight",
    "reading_name": "Любовна кавга",
    "reading_cards": "5 Жезли + 3 Мечове + 2 Чаши",
    "reading_combination": ["five_wands", "three_swords", "two_cups"],
    "reading_meaning": "Спор с любимия",
    "reading_description": "Предстои ви кавга с любимия човек. Думи, които ще наранят, напрежение, което тежи. Но това е част от връзката.",
    "reading_advice": "Не казвай неща, които после ще съжаляваш. След бурята винаги идва спокойствие."
  },
   
  {
    "reading_id": "love_proposal_reject",
    "reading_name": "Отказ на предложение",
    "reading_cards": "3 Мечове + 5 Чаши + Справедливост",
    "reading_combination": ["three_swords", "five_cups", "justice"],
    "reading_meaning": "Казаха 'не'",
    "reading_description": "Предложението ти за брак или обвързване беше отказано. Болка, унижение, разочарование. Светът ти се срива.",
    "reading_advice": "Това не е край, а пренасочване. Някой ден ще срещнеш човек, който ще каже 'да' без колебание."
  },
  {
    "reading_id": "love_second_chance",
    "reading_name": "Втори шанс",
    "reading_cards": "6 Чаши + 2 Чаши + Умереност",
    "reading_combination": ["six_cups", "two_cups", "temperance"],
    "reading_meaning": "Опитвате отново",
    "reading_description": "Решавате да дадете втори шанс на връзката си. Този път и двамата сте по-зрели, по-мъдри и по-наясно какво искате.",
    "reading_advice": "Простете истински и започнете на чисто. Носенето на стари рани ще убие и втория шанс."
  },
  {
    "reading_id": "love_independence",
    "reading_name": "Независимост в любовта",
    "reading_cards": "9 Пентакли + 2 Чаши + 4 Мечове",
    "reading_combination": ["nine_pentacles", "two_cups", "four_swords"],
    "reading_meaning": "Обичаш, но си свободен",
    "reading_description": "Намерил си баланса между любов и лична свобода. Обичаш, но не си зависим. Това е зрялата любов.",
    "reading_advice": "Цени тази динамика. Тя е рядка и ценна."
  },
  {
    "reading_id": "family_dinner",
    "reading_name": "Семейна вечеря",
    "reading_cards": "3 Чаши + 4 Жезли + 10 Чаши",
    "reading_combination": ["three_cups", "four_wands", "ten_cups"],
    "reading_meaning": "Всички заедно",
    "reading_description": "Семейна вечеря или събиране, на което всички присъстват. Смях, спомени, любими ястия и усещане за принадлежност.",
    "reading_advice": "Остави телефона и бъди истински там. Тези моменти няма да се повторят."
  },
  {
    "reading_id": "family_crisis",
    "reading_name": "Семейна криза",
    "reading_cards": "Кула + 5 Чаши + 3 Мечове",
    "reading_combination": ["tower", "five_cups", "three_swords"],
    "reading_meaning": "Сериозен проблем в семейството",
    "reading_description": "Семейството преминава през тежка криза - болест, загуба, скандал, раздяла. Всичко се променя.",
    "reading_advice": "Дръжте се един за друг. В криза семейството или се разпада, или става по-силно."
  },
  {
    "reading_id": "family_support",
    "reading_name": "Подкрепа от семейството",
    "reading_cards": "6 Пентакли + 10 Чаши + 4 Жезли",
    "reading_combination": ["six_pentacles", "ten_cups", "four_wands"],
    "reading_meaning": "Семейството те подкрепя",
    "reading_description": "В труден момент семейството застава зад теб. Финансова помощ, емоционална подкрепа, подслон - те са там.",
    "reading_advice": "Приеми помощта с благодарност. Някой ден ще имаш възможност да върнеш жеста."
  },
  {
    "reading_id": "family_estrangement",
    "reading_name": "Отчуждение от семейството",
    "reading_cards": "8 Чаши + 5 Чаши + 3 Мечове",
    "reading_combination": ["eight_cups", "five_cups", "three_swords"],
    "reading_meaning": "Прекъсване на връзка с роднини",
    "reading_description": "Решаваш да прекъснеш връзка с част от семейството си. Трудно решение, но необходимо за твоето здраве и мир.",
    "reading_advice": "Не се чувствай виновен. Понякога най-здравословното нещо е да се отдалечиш от токсичните хора, дори да са роднини."
  },
  {
    "reading_id": "sibling_rivalry",
    "reading_name": "Съперничество с брат/сестра",
    "reading_cards": "5 Жезли + 5 Мечове + 7 Мечове",
    "reading_combination": ["five_wands", "five_swords", "seven_swords"],
    "reading_meaning": "Конфликт с брат или сестра",
    "reading_description": "Конфликт с брат или сестра - стари съперничества, ревност, неразрешени спорове от детството излизат на повърхността.",
    "reading_advice": "Опитайте се да говорите като възрастни. Детските съперничества нямат място в зрелия живот."
  },

  {
    "reading_id": "first_date",
    "reading_name": "Първа среща",
    "reading_cards": "Асо Чаши + 8 Жезли + 2 Чаши",
    "reading_combination": ["ace_cups", "eight_wands", "two_cups"],
    "reading_meaning": "Начало на романтика",
    "reading_description": "Предстои вълнуваща първа среща, която може да прерасне в нещо повече. Химията между вас е силна още от самото начало.",
    "reading_advice": "Бъди себе си и се отпусни. Истинската връзка започва, когато спреш да играеш роли."
  },
  {
    "reading_id": "long_distance",
    "reading_name": "Връзка от разстояние",
    "reading_cards": "8 Чаши + 2 Чаши + 6 Мечове",
    "reading_combination": ["eight_cups", "two_cups", "six_swords"],
    "reading_meaning": "Любов през разстояние",
    "reading_description": "Връзка, разделена от километри. Видео разговори, чатове, копнеж. Любовта ви издържа на изпитанието на разстоянието.",
    "reading_advice": "Комуникацията е ключът. Планирайте следващата среща и вярвайте, че разстоянието е временно."
  },
  {
    "reading_id": "love_reconciliation",
    "reading_name": "Помирение в любовта",
    "reading_cards": "2 Чаши + 6 Чаши + Умереност",
    "reading_combination": ["two_cups", "six_cups", "temperance"],
    "reading_meaning": "След кавга идва прошка",
    "reading_description": "След конфликт или недоразумение идва мирен момент. Прошка, прегръдка и ново начало за връзката.",
    "reading_advice": "Прости искрено и започнете на чисто. Носенето на стари обиди тежи само на теб."
  },
  {
    "reading_id": "love_letter",
    "reading_name": "Любовно писмо",
    "reading_cards": "Паж Чаши + 3 Чаши + 6 Чаши",
    "reading_combination": ["page_cups", "three_cups", "six_cups"],
    "reading_meaning": "Романтично послание",
    "reading_description": "Ще получиш любовно писмо, съобщение или изненада от някой, който те обича. Романтиката във въздуха.",
    "reading_advice": "Запази тези мигове. Думите, написани с любов, са безценни."
  },
  {
    "reading_id": "marriage_proposal",
    "reading_name": "Годеж",
    "reading_cards": "2 Чаши + Йерофант + 4 Жезли",
    "reading_combination": ["two_cups", "hierophant", "four_wands"],
    "reading_meaning": "Официален годеж",
    "reading_description": "Очаквай годеж или официално обявяване на връзката пред семейството и приятелите. Следващата стъпка към брака.",
    "reading_advice": "Радвай се и празнувай с близките. Това е началото на ново семейно приключение."
  },
  {
    "reading_id": "wedding_planning",
    "reading_name": "Планиране на сватба",
    "reading_cards": "4 Жезли + 3 Чаши + 9 Пентакли",
    "reading_combination": ["four_wands", "three_cups", "nine_pentacles"],
    "reading_meaning": "Организация на тържество",
    "reading_description": "Активно планиране на сватба, избор на дата, място, гости. Вълнение, стрес и щастие едновременно.",
    "reading_advice": "Наслаждавай се на процеса, не само на резултата. Това са специални моменти."
  },
  {
    "reading_id": "anniversary",
    "reading_name": "Годишнина от сватбата",
    "reading_cards": "10 Чаши + 4 Жезли + 6 Чаши",
    "reading_combination": ["ten_cups", "four_wands", "six_cups"],
    "reading_meaning": "Празник на любовта",
    "reading_description": "Годишнина от сватбата или от започването на връзката. Време за равносметка и благодарност за споделения път.",
    "reading_advice": "Празнувайте любовта си. Направете нещо специално заедно, далеч от ежедневието."
  },
  {
    "reading_id": "empty_nest",
    "reading_name": "Празно гнездо",
    "reading_cards": "8 Чаши + 10 Чаши + 4 Мечове",
    "reading_combination": ["eight_cups", "ten_cups", "four_swords"],
    "reading_meaning": "Децата напускат дома",
    "reading_description": "Децата порастват и напускат дома. Тъга, но и ново начало за връзката ви като двойка. Отново сте само двамата.",
    "reading_advice": "Открийте се един друг отново. Време е за пътувания, хобита и нови общи преживявания."
  },
  {
    "reading_id": "career_change",
    "reading_name": "Смяна на професията",
    "reading_cards": "Смърт + Асо Пентакли + 8 Жезли",
    "reading_combination": ["death", "ace_pentacles", "eight_wands"],
    "reading_meaning": "Радикална промяна в кариерата",
    "reading_description": "Решителна смяна на професията или кариерния път. Оставяш старото зад гърба си и тръгваш в съвсем нова посока.",
    "reading_advice": "Не се страхувай да започнеш отначало. Опитът ти не е загубен, той ти дава уникална перспектива."
  },
  {
    "reading_id": "work_at_home",
    "reading_name": "Работа от вкъщи",
    "reading_cards": "4 Жезли + 8 Пентакли + 9 Пентакли",
    "reading_combination": ["four_wands", "eight_pentacles", "nine_pentacles"],
    "reading_meaning": "Дистанционна работа",
    "reading_description": "Преминаване към работа от вкъщи или фрийланс. Създаване на домашен офис и баланс между професионално и лично.",
    "reading_advice": "Създай си режим и работно пространство. Дисциплината е ключът към успеха от вкъщи."
  },
  {
    "reading_id": "business_failure",
    "reading_name": "Провал на бизнес",
    "reading_cards": "Кула + 5 Пентакли + 10 Мечове",
    "reading_combination": ["tower", "five_pentacles", "ten_swords"],
    "reading_meaning": "Бизнесът не успява",
    "reading_description": "Бизнес проект или начинание не успява. Загуба на инвестиции, разочарование, но и ценен урок.",
    "reading_advice": "Провалът не е край, а учител. Най-успешните хора имат най-много провали зад гърба си."
  },
  {
    "reading_id": "mentor",
    "reading_name": "Поява на ментор",
    "reading_cards": "Йерофант + 8 Пентакли + 3 Пентакли",
    "reading_combination": ["hierophant", "eight_pentacles", "three_pentacles"],
    "reading_meaning": "Мъдър учител",
    "reading_description": "В живота ти влиза ментор или учител, който ти помага да се развиваш професионално или духовно. Ценен съветник.",
    "reading_advice": "Слушай и учи с отворено сърце. Такива хора не идват често в живота ни."
  },
  {
    "reading_id": "public_speaking",
    "reading_name": "Публично говорене",
    "reading_cards": "6 Жезли + Магьосник + Слънце",
    "reading_combination": ["six_wands", "magician", "sun"],
    "reading_meaning": "Успешна презентация",
    "reading_description": "Предстои ти публично изказване, презентация или лекция. Ще се справиш блестящо и ще получиш признание.",
    "reading_advice": "Вярвай в думите си. Това, което казваш, има значение за хората."
  },
  {
    "reading_id": "graduation",
    "reading_name": "Дипломиране",
    "reading_cards": "10 Пентакли + 6 Жезли + Свят",
    "reading_combination": ["ten_pentacles", "six_wands", "world"],
    "reading_meaning": "Завършване на образование",
    "reading_description": "Завършване на училище, университет или курс. Получаване на диплома. Край на един етап и начало на следващ.",
    "reading_advice": "Гордей се с постижението си. Никой не може да ти отнеме образованието и знанията."
  },
  {
    "reading_id": "research",
    "reading_name": "Научно изследване",
    "reading_cards": "8 Пентакли + Асо Мечове + Отшелник",
    "reading_combination": ["eight_pentacles", "ace_swords", "hermit"],
    "reading_meaning": "Задълбочено проучване",
    "reading_description": "Работа по научно изследване, дисертация или задълбочен проект. Самота, концентрация и открития.",
    "reading_advice": "Търпение и постоянство. Истината изисква време, за да бъде открита."
  },
  {
    "reading_id": "language_learning",
    "reading_name": "Изучаване на език",
    "reading_cards": "8 Пентакли + 6 Мечове + Свят",
    "reading_combination": ["eight_pentacles", "six_swords", "world"],
    "reading_meaning": "Нов език",
    "reading_description": "Започваш да учиш нов език или се подготвяш за езиков изпит. Това ще отвори нови врати пред теб.",
    "reading_advice": "Потапяй се в езика – филми, музика, разговори. Тренирай всеки ден."
  },
  {
    "reading_id": "driving_license",
    "reading_name": "Шофьорска книжка",
    "reading_cards": "Колесница + 8 Жезли + 6 Жезли",
    "reading_combination": ["chariot", "eight_wands", "six_wands"],
    "reading_meaning": "Успешен шофьорски изпит",
    "reading_description": "Подготовка и успешно вземане на шофьорски изпит. Нова свобода и независимост на пътя.",
    "reading_advice": "Спокойствие и концентрация. Ще се справиш, дори и да имаш притеснения."
  },
  {
    "reading_id": "car_accident",
    "reading_name": "Пътен инцидент",
    "reading_cards": "Кула + 10 Мечове + 5 Пентакли",
    "reading_combination": ["tower", "ten_swords", "five_pentacles"],
    "reading_meaning": "Катастрофа",
    "reading_description": "Възможен пътен инцидент, повреда на кола или проблем с превозно средство. Бъди внимателен на пътя.",
    "reading_advice": "Провери техническото състояние на колата и шофирай внимателно. Понякога е по-добре да изчакаш."
  },
  {
    "reading_id": "home_birth",
    "reading_name": "Раждане вкъщи",
    "reading_cards": "Императрица + 4 Жезли + Слънце",
    "reading_combination": ["empress", "four_wands", "sun"],
    "reading_meaning": "Домашно раждане",
    "reading_description": "Планиране на раждане в домашни условия или в специална среда. Интимно, спокойно и щастливо събитие.",
    "reading_advice": "Подготви се добре и се обгради с хора, на които имаш доверие. Твоето тяло знае как да прави това."
  },
  {
    "reading_id": "adoption",
    "reading_name": "Осиновяване",
    "reading_cards": "Императрица + 10 Чаши + 6 Чаши",
    "reading_combination": ["empress", "ten_cups", "six_cups"],
    "reading_meaning": "Дете идва в семейството",
    "reading_description": "Осиновяване или приемна грижа. Нов член на семейството идва по нетрадиционен начин, носейки любов и радост.",
    "reading_advice": "Сърцето ти е отворено за любов без условия. Това е най-красивото нещо."
  },
  {
    "reading_id": "twins",
    "reading_name": "Близнаци",
    "reading_cards": "Императрица + 3 Чаши + 2 Чаши",
    "reading_combination": ["empress", "three_cups", "two_cups"],
    "reading_meaning": "Очакване на близнаци",
    "reading_description": "Бременност с близнаци или двойно щастие. Два пъти повече любов, два пъти повече грижи.",
    "reading_advice": "Приготви се за приключение! Ще имаш нужда от подкрепа, но наградата е двойна."
  },
  {
    "reading_id": "motherhood",
    "reading_name": "Майчинство",
    "reading_cards": "Императрица + Луна + 9 Пентакли",
    "reading_combination": ["empress", "moon", "nine_pentacles"],
    "reading_meaning": "Пътят на майката",
    "reading_description": "Пътят на майчинството – безсънни нощи, грижи, безкрайна любов. Промяна на идентичността и приоритетите.",
    "reading_advice": "Грижи се и за себе си. Щастливата майка е най-доброто, което можеш да дадеш на детето си."
  },
  {
    "reading_id": "fatherhood",
    "reading_name": "Бащинство",
    "reading_cards": "Император + 4 Жезли + Сила",
    "reading_combination": ["emperor", "four_wands", "strength"],
    "reading_meaning": "Ролята на бащата",
    "reading_description": "Прегръщане на ролята на баща – закрилник, учител, пример. Нова отговорност и нова любов.",
    "reading_advice": "Бъди твърд, но нежен. Децата имат нужда от твоето присъствие повече от твоите подаръци."
  },
  {
    "reading_id": "family_secret",
    "reading_name": "Семейна тайна",
    "reading_cards": "Луна + 7 Мечове + Върховна жрица",
    "reading_combination": ["moon", "seven_swords", "high_priestess"],
    "reading_meaning": "Разкриване на тайна",
    "reading_description": "Семейна тайна излиза наяве. Нещо, което е било скривано с години, най-после се разкрива.",
    "reading_advice": "Истината може да боли, но винаги лекува. Бъди готов да простиш."
  },
  {
    "reading_id": "family_business",
    "reading_name": "Семеен бизнес",
    "reading_cards": "10 Пентакли + 3 Пентакли + Император",
    "reading_combination": ["ten_pentacles", "three_pentacles", "emperor"],
    "reading_meaning": "Работа със семейството",
    "reading_description": "Започване или продължаване на семеен бизнес. Работа с родители, братя, сестри. Предизвикателство и благословия.",
    "reading_advice": "Разделяй професионалното от личното. Установи ясни правила и граници."
  },
  {
    "reading_id": "divorce_settlement",
    "reading_name": "Споразумение за развод",
    "reading_cards": "Справедливост + 4 Пентакли + 5 Мечове",
    "reading_combination": ["justice", "four_pentacles", "five_swords"],
    "reading_meaning": "Разделяне на имущество",
    "reading_description": "Финализиране на развод и разделяне на имущество. Преговори, адвокати, но накрая – свобода.",
    "reading_advice": "Бъди справедлив, но не позволявай да те ограбят. Това е край, от който трябва да започнеш наново."
  },
  {
    "reading_id": "online_dating",
    "reading_name": "Запознанство в интернет",
    "reading_cards": "8 Жезли + 7 Чаши + 2 Чаши",
    "reading_combination": ["eight_wands", "seven_cups", "two_cups"],
    "reading_meaning": "Среща през приложение",
    "reading_description": "Запознанство чрез онлайн платформа или приложение. Много възможности, много избори, но внимавай с илюзиите.",
    "reading_advice": "Бъди честен в профила си и не се влюбвай в снимка. Истинската връзка е в реалния живот."
  },
  {
    "reading_id": "blind_date",
    "reading_name": "Среща на сляпо",
    "reading_cards": "Колело на съдбата + 2 Чаши + 8 Жезли",
    "reading_combination": ["wheel_of_fortune", "two_cups", "eight_wands"],
    "reading_meaning": "Изненадваща среща",
    "reading_description": "Организирана среща на сляпо от приятели. Съдбата може да има изненада за теб – не очаквай нищо, просто се отвори.",
    "reading_advice": "Дай шанс на изненадата. Понякога най-добрите неща идват, когато не ги търсиш."
  },
  {
    "reading_id": "ex_jealous",
    "reading_name": "Ревност от бивш",
    "reading_cards": "7 Мечове + 3 Мечове + Дявол",
    "reading_combination": ["seven_swords", "three_swords", "devil"],
    "reading_meaning": "Бившият не те оставя на мира",
    "reading_description": "Бивш партньор проявява ревност или се опитва да саботира новата ти връзка. Държание, водено от его и притежание.",
    "reading_advice": "Запази дистанция и не влизай в игри. Истинската свобода е, когато спреш да реагираш на миналото."
  },
  {
    "reading_id": "no_contact",
    "reading_name": "Прекъсване на контакт",
    "reading_cards": "8 Мечове + 6 Мечове + Отшелник",
    "reading_combination": ["eight_swords", "six_swords", "hermit"],
    "reading_meaning": "Време без контакт",
    "reading_description": "Решително прекъсване на контакт с бивш или токсичен човек. Блокиране, тишина, движение напред.",
    "reading_advice": "Не се обръщай назад. Тишината е злато, когато пази мира ти."
  },
  {
    "reading_id": "healing_heart",
    "reading_name": "Лекуване на сърцето",
    "reading_cards": "4 Мечове + Звезда + 8 Чаши",
    "reading_combination": ["four_swords", "star", "eight_cups"],
    "reading_meaning": "След раздяла",
    "reading_description": "Процес на възстановяване след тежка раздяла. Плач, самота, но и първите лъчи надежда. Бавно оздравяваш.",
    "reading_advice": "Дай си време. Раните се лекуват, а сърцето ти отново ще обича."
  },
  {
    "reading_id": "fling",
    "reading_name": "Лятна любов",
    "reading_cards": "Асо Жезли + 8 Жезли + 3 Чаши",
    "reading_combination": ["ace_wands", "eight_wands", "three_cups"],
    "reading_meaning": "Кратка, но страстна връзка",
    "reading_description": "Кратка, но интензивна любовна афера – лятна любов, почивка, приключение. Страст, която знае, че има край.",
    "reading_advice": "Наслаждавай се на момента, без очаквания за бъдеще. Понякога точно това го прави специален."
  },
  {
    "reading_id": "friends_with_benefits",
    "reading_name": "Приятели с предимства",
    "reading_cards": "Дявол + 3 Чаши + 2 Чаши",
    "reading_combination": ["devil", "three_cups", "two_cups"],
    "reading_meaning": "Физическа връзка без обвързване",
    "reading_description": "Връзка, основана главно на физическо привличане и приятелство, без романтични обвързвания. Рискувате чувствата.",
    "reading_advice": "Бъдете честни за намеренията си. Някой винаги пострадва, когато има повече от единия."
  },
  {
    "reading_id": "charity",
    "reading_name": "Благотворителност",
    "reading_cards": "6 Пентакли + 3 Чаши + Звезда",
    "reading_combination": ["six_pentacles", "three_cups", "star"],
    "reading_meaning": "Помощ за нуждаещи се",
    "reading_description": "Участие в благотворителна кауза или дарение. Даването без очакване на отплата носи най-голямо удовлетворение.",
    "reading_advice": "Колкото повече даваш, толкова повече получаваш. Вселената възнаграждава щедрите сърца."
  },
  {
    "reading_id": "taxes",
    "reading_name": "Данъци",
    "reading_cards": "4 Пентакли + Справедливост + 8 Мечове",
    "reading_combination": ["four_pentacles", "justice", "eight_swords"],
    "reading_meaning": "Данъчна проверка",
    "reading_description": "Време за данъци, проверка от НАП или финансови задължения към държавата. Бъди внимателен с документите.",
    "reading_advice": "Планирай и не крий нищо. Проблемите с властите не си струват стреса."
  },
  {
    "reading_id": "lottery_ticket",
    "reading_name": "Билет за лотария",
    "reading_cards": "Колело на съдбата + Асо Пентакли + 9 Пентакли",
    "reading_combination": ["wheel_of_fortune", "ace_pentacles", "nine_pentacles"],
    "reading_meaning": "Малък шанс за печалба",
    "reading_description": "Купуване на билет за лотария или участие в томбола. Малък шанс за печалба, но кой знае?",
    "reading_advice": "Забавлявай се, но не влагай повече, отколкото можеш да загубиш. Късметът обича смелите, но не и безразсъдните."
  },
  {
    "reading_id": "inheritance_money",
    "reading_name": "Получаване на наследство",
    "reading_cards": "10 Пентакли + 4 Пентакли + 6 Пентакли",
    "reading_combination": ["ten_pentacles", "four_pentacles", "six_pentacles"],
    "reading_meaning": "Пари от наследство",
    "reading_description": "Получаване на пари или имот от наследство. Финансово облекчение, но и емоционална тежест от загубата.",
    "reading_advice": "Почети паметта на близките, като използваш парите разумно. Инвестирай в бъдещето."
  },
  {
    "reading_id": "money_lent",
    "reading_name": "Даване на заем",
    "reading_cards": "6 Пентакли + 4 Пентакли + 5 Пентакли",
    "reading_combination": ["six_pentacles", "four_pentacles", "five_pentacles"],
    "reading_meaning": "Заем на приятел",
    "reading_description": "Някой близък иска да му заемеш пари. Внимавай – това може да промени динамиката на връзката ви.",
    "reading_advice": "Ако даваш назаем, давай само толкова, колкото си готов да загубиш. И напиши документ."
  },
  {
    "reading_id": "sold_property",
    "reading_name": "Продажба на имот",
    "reading_cards": "Асо Пентакли + 10 Пентакли + 6 Жезли",
    "reading_combination": ["ace_pentacles", "ten_pentacles", "six_wands"],
    "reading_meaning": "Успешна продажба",
    "reading_description": "Продаваш имот или ценна вещ. Успешна сделка, добра цена, доволни купувачи.",
    "reading_advice": "Използвай парите разумно – инвестирай в ново начало или погаси дългове."
  },
  {
    "reading_id": "moving_city",
    "reading_name": "Преместване в друг град",
    "reading_cards": "6 Мечове + 4 Жезли + Колесница",
    "reading_combination": ["six_swords", "four_wands", "chariot"],
    "reading_meaning": "Нов град, нов живот",
    "reading_description": "Смяна на местоживеенето в друг град. Нова среда, нови хора, нови възможности. Вълнуващо и страшно.",
    "reading_advice": "Прегърни промяната. Новият град те очаква с отворени обятия."
  },
  {
    "reading_id": "house_rent",
    "reading_name": "Наемане на жилище",
    "reading_cards": "Асо Пентакли + 2 Пентакли + 4 Жезли",
    "reading_combination": ["ace_pentacles", "two_pentacles", "four_wands"],
    "reading_meaning": "Нов дом под наем",
    "reading_description": "Намиране и наемане на ново жилище. Подписване на договор, депозит, пренасяне. Ново начало.",
    "reading_advice": "Прочети договора внимателно и направи снимки на състоянието при влизане."
  },
  {
    "reading_id": "neighbors",
    "reading_name": "Нови съседи",
    "reading_cards": "3 Чаши + 4 Жезли + 6 Пентакли",
    "reading_combination": ["three_cups", "four_wands", "six_pentacles"],
    "reading_meaning": "Запознанство със съседи",
    "reading_description": "Нови съседи се нанасят или опознаваш старите по-добре. Възможност за нови приятелства и взаимопомощ.",
    "reading_advice": "Бъди добър съсед – усмихни се, представи се и предложи помощ, ако е нужно."
  },
  {
    "reading_id": "soulmates",
    "reading_name": "Сродни души",
    "reading_cards": "Влюбените + 2 Чаши + 10 Чаши",
    "reading_combination": ["lovers", "two_cups", "ten_cups"],
    "reading_meaning": "Среща на сродни души",
    "reading_description": "Двама души, които са създадени един за друг. Връзка, която надхвърля физическия свят и носи пълно емоционално удовлетворение.",
    "reading_advice": "Когато срещнеш сродната си душа, ще го усетиш. Не се съмнявай – това е истината."
  },
  {
    "reading_id": "wedding_proposal",
    "reading_name": "Предложение за брак",
    "reading_cards": "2 Чаши + Йерофант + Слънце",
    "reading_combination": ["two_cups", "hierophant", "sun"],
    "reading_meaning": "Предложение за женитба",
    "reading_description": "Очаквай предложение за брак! Някой ще коленичи пред теб и ще поиска ръката ти. Щастлив момент, който помниш цял живот.",
    "reading_advice": "Кажи 'да' на любовта! Това е моментът, който си чакала."
  },
  {
    "reading_id": "divorce",
    "reading_name": "Развод",
    "reading_cards": "Справедливост + 3 Мечове + 5 Чаши",
    "reading_combination": ["justice", "three_swords", "five_cups"],
    "reading_meaning": "Край на брака",
    "reading_description": "Официален край на брака – развод, разделяне на имущество, съдебни процедури. Болезнено, но необходимо.",
    "reading_advice": "Позволи си да скърбиш, но знай – това е новото начало, от което се нуждаеш."
  },
  {
    "reading_id": "secret_admirer",
    "reading_name": "Таен почитател",
    "reading_cards": "7 Чаши + Паж Чаши + Луна",
    "reading_combination": ["seven_cups", "page_cups", "moon"],
    "reading_meaning": "Някой те обича тайно",
    "reading_description": "Някой има чувства към теб, но все още не ги е разкрил. Носиш се във въздуха на тайна любов, която тепърва ще излезе наяве.",
    "reading_advice": "Внимавай кого допускаш – не всичко е каквото изглежда. Но бъди отворен за изненади."
  },
  {
    "reading_id": "online_love",
    "reading_name": "Онлайн любов",
    "reading_cards": "8 Жезли + 2 Чаши + Луна",
    "reading_combination": ["eight_wands", "two_cups", "moon"],
    "reading_meaning": "Виртуална връзка",
    "reading_description": "Запознанство в интернет, социални мрежи или приложение. Бързо развитие на чувствата, но внимавай с илюзиите.",
    "reading_advice": "Наслаждавай се на разговорите, но опознай човека и в реалния живот, преди да се отдадеш напълно."
  },
  {
    "reading_id": "career_promotion",
    "reading_name": "Повишение",
    "reading_cards": "6 Жезли + Император + 10 Пентакли",
    "reading_combination": ["six_wands", "emperor", "ten_pentacles"],
    "reading_meaning": "Кариерно израстване",
    "reading_description": "Повишение на работа, нова длъжност, повече отговорности и по-високо заплащане. Признание за труда ти.",
    "reading_advice": "Приеми новото предизвикателство – заслужаваш го. Ще се справиш повече от добре."
  },
  {
    "reading_id": "job_interview",
    "reading_name": "Успешно интервю",
    "reading_cards": "Асо Пентакли + 8 Жезли + Магьосник",
    "reading_combination": ["ace_pentacles", "eight_wands", "magician"],
    "reading_meaning": "Скорошно интервю",
    "reading_description": "Предстои ти интервю за работа или важно делова среща. Ще направиш отлично впечатление и ще получиш предложение.",
    "reading_advice": "Подготви се добре, бъди уверен и покажи какво можеш. Успехът е гарантиран."
  },
  {
    "reading_id": "business_trip",
    "reading_name": "Командировка",
    "reading_cards": "8 Жезли + 6 Мечове + 3 Пентакли",
    "reading_combination": ["eight_wands", "six_swords", "three_pentacles"],
    "reading_meaning": "Пътуване по работа",
    "reading_description": "Очаква те командировка в чужбина или друг град. Възможност за развитие и нови контакти.",
    "reading_advice": "Използвай пътуването за учене и разширяване на мрежата си. Носи подарък за семейството."
  },
  {
    "reading_id": "salary_increase",
    "reading_name": "Увеличение на заплатата",
    "reading_cards": "9 Пентакли + 6 Жезли + Асо Пентакли",
    "reading_combination": ["nine_pentacles", "six_wands", "ace_pentacles"],
    "reading_meaning": "Повишение на заплата",
    "reading_description": "Очаквай увеличение на заплатата, бонус или допълнителен доход. Финансовата ти независимост расте.",
    "reading_advice": "Инвестирай разумно и си позволи малък лукс – заслужил си го."
  },
  {
    "reading_id": "small_business",
    "reading_name": "Малък бизнес",
    "reading_cards": "Асо Пентакли + 8 Пентакли + 3 Пентакли",
    "reading_combination": ["ace_pentacles", "eight_pentacles", "three_pentacles"],
    "reading_meaning": "Старт на собствен бизнес",
    "reading_description": "Започване на собствен бизнес, малка фирма или занаят. Работа с ръце, творчество, усилия, които се отплащат.",
    "reading_advice": "Започни с малко, но бъди постоянен. Качеството ще те изведе напред."
  },
  {
    "reading_id": "health_recovery",
    "reading_name": "Възстановяване",
    "reading_cards": "4 Мечове + Звезда + Слънце",
    "reading_combination": ["four_swords", "star", "sun"],
    "reading_meaning": "Пълно оздравяване",
    "reading_description": "След болест или тежък период идва пълно възстановяване. Здравето се подобрява, енергията се връща.",
    "reading_advice": "Почивай, но започвай да се връщаш към активен живот. Тялото ти казва 'благодаря'."
  },
  {
    "reading_id": "mental_health",
    "reading_name": "Психично здраве",
    "reading_cards": "9 Мечове + 4 Мечове + Върховна жрица",
    "reading_combination": ["nine_swords", "four_swords", "high_priestess"],
    "reading_meaning": "Грижа за душевното здраве",
    "reading_description": "Важно е да обърнеш внимание на психичното си здраве. Тревожност, безсъние, претоварване – време е за почивка и терапия.",
    "reading_advice": "Потърси помощ – психолог, терапевт или духовен учител. Не си сам в това."
  },
  {
    "reading_id": "pregnancy_test",
    "reading_name": "Тест за бременност",
    "reading_cards": "Императрица + Асо Чаши + Луна",
    "reading_combination": ["empress", "ace_cups", "moon"],
    "reading_meaning": "Възможна бременност",
    "reading_description": "Възможно е да си бременна или скоро да забременееш. Тестът може да излезе положителен. Нов живот идва.",
    "reading_advice": "Направи си тест и се подготви за промяна. Тялото ти се готви за чудо."
  },
  {
    "reading_id": "moving_abroad",
    "reading_name": "Заминаване в чужбина",
    "reading_cards": "6 Мечове + Свят + Колесница",
    "reading_combination": ["six_swords", "world", "chariot"],
    "reading_meaning": "Емиграция",
    "reading_description": "Заминаване в чужбина за постоянно или за дълго време. Нова държава, нов език, нов живот.",
    "reading_advice": "Сбогувай се с миналото и отвори обятия за бъдещето. Светът те очаква."
  },
  {
    "reading_id": "buying_house",
    "reading_name": "Купуване на къща",
    "reading_cards": "Асо Пентакли + 10 Пентакли + 4 Жезли",
    "reading_combination": ["ace_pentacles", "ten_pentacles", "four_wands"],
    "reading_meaning": "Покупка на имот",
    "reading_description": "Купуване на къща или апартамент. Инвестиция в недвижим имот, който ще носи сигурност и стабилност.",
    "reading_advice": "Прегледай документите внимателно, но не се колебай – това е добра инвестиция."
  },
  {
    "reading_id": "renovation",
    "reading_name": "Ремонт",
    "reading_cards": "8 Пентакли + 3 Пентакли + 4 Жезли",
    "reading_combination": ["eight_pentacles", "three_pentacles", "four_wands"],
    "reading_meaning": "Обновяване на дома",
    "reading_description": "Предстои ремонт, обновяване или преустройство на дома ти. Ще вложиш много труд, но резултатът ще е прекрасен.",
    "reading_advice": "Планирай добре бюджета и времето. Крайният резултат си заслужава усилията."
  },
  {
    "reading_id": "family_reunion",
    "reading_name": "Семейно събиране",
    "reading_cards": "10 Чаши + 6 Чаши + 3 Чаши",
    "reading_combination": ["ten_cups", "six_cups", "three_cups"],
    "reading_meaning": "Събиране на семейството",
    "reading_description": "Семейно събиране, празник, среща на близки и роднини. Радост, смях, споделени мигове.",
    "reading_advice": "Цени тези моменти – те са най-ценното, което имаш. Обади се на близките си."
  },
  {
    "reading_id": "grandchild",
    "reading_name": "Рожба в семейството",
    "reading_cards": "Императрица + 10 Чаши + Слънце",
    "reading_combination": ["empress", "ten_cups", "sun"],
    "reading_meaning": "Раждане на внук",
    "reading_description": "Раждане на дете в семейството – внук, племенник, нов член. Щастие за всички.",
    "reading_advice": "Радвай се на новия живот. Ти си част от нещо по-голямо."
  },
  {
    "reading_id": "inheritance_dispute",
    "reading_name": "Спор за наследство",
    "reading_cards": "5 Мечове + 5 Жезли + 4 Пентакли",
    "reading_combination": ["five_swords", "five_wands", "four_pentacles"],
    "reading_meaning": "Конфликт за наследство",
    "reading_description": "Спорове за наследство, кавги между роднини за имот или пари. Напрежение и конфликти, които разделят семейството.",
    "reading_advice": "Помни – парите идват и си отиват, а семейството остава. Потърси компромис."
  },
  {
    "reading_id": "lottery_win",
    "reading_name": "Печалба от лотария",
    "reading_cards": "Колело на съдбата + Асо Пентакли + Слънце",
    "reading_combination": ["wheel_of_fortune", "ace_pentacles", "sun"],
    "reading_meaning": "Неочаквана печалба",
    "reading_description": "Късмет в хазарта, печалба от лотария, томбола или конкурс. Съдбата ти се усмихва!",
    "reading_advice": "Пробвай късмета си, но не прекалявай. Вселената ти праща подарък."
  },
  {
    "reading_id": "money_return",
    "reading_name": "Връщане на дълг",
    "reading_cards": "6 Пентакли + 4 Пентакли + Справедливост",
    "reading_combination": ["six_pentacles", "four_pentacles", "justice"],
    "reading_meaning": "Получаване на дължими пари",
    "reading_description": "Някой ще ти върне дълг, ще получиш пари, които са ти обещали. Справедливостта възтържествува.",
    "reading_advice": "Полученото използвай разумно. И помни – да даваш назаем винаги е риск."
  },
  {
    "reading_id": "spiritual_growth",
    "reading_name": "Духовен растеж",
    "reading_cards": "Върховна жрица + Отшелник + Звезда",
    "reading_combination": ["high_priestess", "hermit", "star"],
    "reading_meaning": "Дълбока духовна трансформация",
    "reading_description": "Период на интензивно духовно развитие. Медитация, йога, четене, самота. Откриваш истинската си същност.",
    "reading_advice": "Отдели време за себе си. Душата ти има нужда от храна, точно както тялото."
  },
  {
    "reading_id": "karmic_lesson",
    "reading_name": "Кармичен урок",
    "reading_cards": "Колело на съдбата + Справедливост + 8 Мечове",
    "reading_combination": ["wheel_of_fortune", "justice", "eight_swords"],
    "reading_meaning": "Повтаряща се ситуация",
    "reading_description": "Срещаш се с урок, който не си научил в миналото. Същата ситуация, същият тип хора – докато не научиш урока.",
    "reading_advice": "Задай си въпроса: 'Какво трябва да науча от това?' Отговорът ще те освободи."
  },
  {
    "reading_id": "past_life",
    "reading_name": "Минал живот",
    "reading_cards": "Луна + 6 Чаши + Колело на съдбата",
    "reading_combination": ["moon", "six_cups", "wheel_of_fortune"],
    "reading_meaning": "Спомени от минал живот",
    "reading_description": "Изпитваш дежа вю, странно привличане към определено място или човек. Възможно е да са спомени от минал живот.",
    "reading_advice": "Записвай сънищата и чувствата си. Те носят послания от отвъдното."
  },
  {
    "reading_id": "meditation_practice",
    "reading_name": "Медитация",
    "reading_cards": "Върховна жрица + 4 Мечове + Отшелник",
    "reading_combination": ["high_priestess", "four_swords", "hermit"],
    "reading_meaning": "Задълбочаване в медитация",
    "reading_description": "Време за задълбочена медитация и вътрешно пътешествие. Откриване на вътрешния мир и мъдрост.",
    "reading_advice": "Направи си място за медитация у дома. Дори 10 минути на ден ще променят живота ти."
  },
  {
    "reading_id": "toxic_friend",
    "reading_name": "Токсичен приятел",
    "reading_cards": "5 Чаши + 7 Мечове + Дявол",
    "reading_combination": ["five_cups", "seven_swords", "devil"],
    "reading_meaning": "Фалшив приятел",
    "reading_description": "Някой от обкръжението ти не ти желае доброто. Завист, клюки, предателство. Време е да прекъснеш тази връзка.",
    "reading_advice": "Обкръжи се с хора, които те издигат, не те свалят. Самотата е по-добра от лоша компания."
  },
  {
    "reading_id": "new_friendship",
    "reading_name": "Ново приятелство",
    "reading_cards": "3 Чаши + 6 Чаши + Асо Чаши",
    "reading_combination": ["three_cups", "six_cups", "ace_cups"],
    "reading_meaning": "Начало на нова дружба",
    "reading_description": "Ще срещнеш нов човек, който може да стане важен приятел в живота ти. Споделени интереси, радост, смях.",
    "reading_advice": "Отвори сърцето си за нови хора. Всеки носи нещо ценно в живота ти."
  },
  {
    "reading_id": "court_case",
    "reading_name": "Съдебно дело",
    "reading_cards": "Справедливост + 5 Мечове + 8 Мечове",
    "reading_combination": ["justice", "five_swords", "eight_swords"],
    "reading_meaning": "Съдебен процес",
    "reading_description": "Водиш съдебно дело или си замесен в правен спор. Истината ще излезе наяве, но процесът ще е бавен.",
    "reading_advice": "Бъди търпелив и събери всички документи. Потърси добър адвокат."
  },
  {
    "reading_id": "police_problem",
    "reading_name": "Проблеми с властите",
    "reading_cards": "5 Мечове + Справедливост + 8 Мечове",
    "reading_combination": ["five_swords", "justice", "eight_swords"],
    "reading_meaning": "Правни проблеми",
    "reading_description": "Проблеми с полицията, данъчните или други власти. Възможна глоба, санкция или по-сериозно наказание.",
    "reading_advice": "Не крий нищо и си сътрудничи. Истината е най-добрата защита."
  },
  {
    "reading_id": "exam_success",
    "reading_name": "Успешен изпит",
    "reading_cards": "8 Пентакли + 6 Жезли + Слънце",
    "reading_combination": ["eight_pentacles", "six_wands", "sun"],
    "reading_meaning": "Изпитът е успешен",
    "reading_description": "Положителен резултат на изпит, сертификат, интервю или важна оценка. Ученето ти се отплаща.",
    "reading_advice": "Учи спокойно, знанието е в теб. Ще се представиш отлично."
  },
  {
    "reading_id": "university_admission",
    "reading_name": "Прием в университет",
    "reading_cards": "8 Пентакли + 10 Пентакли + Свят",
    "reading_combination": ["eight_pentacles", "ten_pentacles", "world"],
    "reading_meaning": "Приемане в учебно заведение",
    "reading_description": "Приемане в университет, колеж или курс. Ново образователно начало, което носи дългосрочни ползи.",
    "reading_advice": "Инвестицията в образование винаги се отплаща. Гордей се с постижението си."
  },
  {
    "reading_id": "student_abroad",
    "reading_name": "Следване в чужбина",
    "reading_cards": "8 Жезли + 6 Мечове + Свят",
    "reading_combination": ["eight_wands", "six_swords", "world"],
    "reading_meaning": "Образование в друга държава",
    "reading_description": "Заминаване да следваш в чужбина. Нов език, нова култура, нови възможности за развитие.",
    "reading_advice": "Хвани смело крилата си. Светът е твоята класна стая."
  },
  {
    "reading_id": "writing_project",
    "reading_name": "Писателски проект",
    "reading_cards": "Асо Мечове + 8 Пентакли + 3 Чаши",
    "reading_combination": ["ace_swords", "eight_pentacles", "three_cups"],
    "reading_meaning": "Завършване на книга",
    "reading_description": "Работа по книга, статия, блог или друг творчески текст. Идеите текат, вдъхновението е силно.",
    "reading_advice": "Пиши всеки ден. Думите ти имат сила и могат да променят света."
  },
  {
    "reading_id": "art_exhibition",
    "reading_name": "Художествена изложба",
    "reading_cards": "3 Чаши + 6 Жезли + Слънце",
    "reading_combination": ["three_cups", "six_wands", "sun"],
    "reading_meaning": "Представяне на изкуство",
    "reading_description": "Участие в изложба, концерт или друго творческо събитие. Творчеството ти получава признание.",
    "reading_advice": "Покажи таланта си на света. Хората имат нужда от изкуството ти."
  },
  {
    "reading_id": "music_success",
    "reading_name": "Музикален успех",
    "reading_cards": "6 Жезли + 3 Чаши + Слънце",
    "reading_combination": ["six_wands", "three_cups", "sun"],
    "reading_meaning": "Признание в музиката",
    "reading_description": "Успех в музикалната кариера – концерт, запис, договор. Творчеството ти докосва хората.",
    "reading_advice": "Музиката ти лекува души. Продължавай да твориш и споделяш."
  },
  {
    "reading_id": "loss_of_pet",
    "reading_name": "Загуба на домашен любимец",
    "reading_cards": "5 Чаши + 3 Мечове + Луна",
    "reading_combination": ["five_cups", "three_swords", "moon"],
    "reading_meaning": "Тъга за любимец",
    "reading_description": "Загуба на любим домашен любимец. Скръб, празнота, тъга. Той е бил част от семейството.",
    "reading_advice": "Позволи си да скърбиш. Любимецът ти беше безусловна любов – тази любов остава завинаги."
  },
  {
    "reading_id": "new_pet",
    "reading_name": "Нов домашен любимец",
    "reading_cards": "Асо Чаши + Слънце + 3 Чаши",
    "reading_combination": ["ace_cups", "sun", "three_cups"],
    "reading_meaning": "Осиновяване на животно",
    "reading_description": "В къщи ще има нов член – куче, котка или друго животинче. Радост, игри, безусловна любов.",
    "reading_advice": "Отвори дома и сърцето си за нов приятел. Той ще ти върне любовта стократно."
  },
  {
    "reading_id": "travel_delay",
    "reading_name": "Забавяне на пътуване",
    "reading_cards": "4 Мечове + 8 Жезли + 5 Пентакли",
    "reading_combination": ["four_swords", "eight_wands", "five_pentacles"],
    "reading_meaning": "Отложено пътуване",
    "reading_description": "Пътуването ти може да се забави, отложи или провали поради технически, финансови или други причини.",
    "reading_advice": "Не се отчайвай. Понякога забавянето идва, за да ни предпази от нещо."
  },
  {
    "reading_id": "dream_job",
    "reading_name": "Работата на мечтите",
    "reading_cards": "Асо Пентакли + 6 Жезли + Свят",
    "reading_combination": ["ace_pentacles", "six_wands", "world"],
    "reading_meaning": "Получаване на желана работа",
    "reading_description": "Ще получиш работата, за която си мечтал. Тя носи удовлетворение, добро заплащане и възможност за развитие.",
    "reading_advice": "Ти си на точното място в точното време. Наслаждавай се на успеха."
  },
  {
    "reading_id": "retirement",
    "reading_name": "Пенсиониране",
    "reading_cards": "10 Пентакли + 4 Мечове + Отшелник",
    "reading_combination": ["ten_pentacles", "four_swords", "hermit"],
    "reading_meaning": "Край на трудовия път",
    "reading_description": "Пенсиониране, край на активната трудова дейност. Време за почивка, семейство и занимания по душа.",
    "reading_advice": "Наслади се на заслужената почивка. Сега е време да правиш това, което обичаш."
  },
  {
    "reading_id": "volunteer",
    "reading_name": "Доброволчество",
    "reading_cards": "6 Пентакли + 3 Чаши + Звезда",
    "reading_combination": ["six_pentacles", "three_cups", "star"],
    "reading_meaning": "Помощ на другите",
    "reading_description": "Ще се включиш в доброволческа кауза или ще помагаш на хора в нужда. Това носи смисъл и радост.",
    "reading_advice": "Да даваш е най-висшата форма на получаване. Сърцето ти ще бъде пълно."
  },
  {
    "reading_id": "fated_love",
    "reading_name": "Съдбовна любов",
    "reading_cards": "Влюбените + 2 Чаши + Асо Чаши",
    "reading_combination": ["lovers", "two_cups", "ace_cups"],
    "reading_meaning": "Предопределена връзка",
    "reading_description": "Това не е просто връзка – това е среща, писана в звездите. Двама души, които са предназначени един за друг.",
    "reading_advice": "Не се страхувай да скочиш – съдбата ти подава ръка."
  },
   
  {
    "reading_id": "breakup",
    "reading_name": "Раздяла",
    "reading_cards": "3 Мечове + 5 Чаши + Кула",
    "reading_combination": ["three_swords", "five_cups", "tower"],
    "reading_meaning": "Болезнен край",
    "reading_description": "Тежка раздяла, предателство или загуба, която разрушава всичко, в което си вярвал.",
    "reading_advice": "Позволи си да скърбиш, но знай – след Кулата идва Звездата. Това не е краят, а началото."
  },
  {
    "reading_id": "toxic_relationship",
    "reading_name": "Токсична връзка",
    "reading_cards": "Дявол + 7 Мечове + 3 Мечове",
    "reading_combination": ["devil", "seven_swords", "three_swords"],
    "reading_meaning": "Зависимост и лъжи",
    "reading_description": "Връзка, основана на зависимост, лъжи и изтощение. Единият (или и двамата) е в плен на илюзията.",
    "reading_advice": "Време е да разпознаеш веригите и да ги свалиш. Самотата е по-добра от ада за двама."
  },
  {
    "reading_id": "ex_back",
    "reading_name": "Бивш се връща",
    "reading_cards": "6 Чаши + 2 Чаши",
    "reading_combination": ["six_cups", "two_cups"],
    "reading_meaning": "Възстановена връзка",
    "reading_description": "Някой от миналото се появява отново в живота ти. Носталгията води до нова среща.",
    "reading_advice": "Помни защо свърши. Но ако сърцето ти казва 'да', опитай пак."
  },
  {
    "reading_id": "ex_back_happy",
    "reading_name": "Щастливо завръщане",
    "reading_cards": "6 Чаши + 2 Чаши + Слънце",
    "reading_combination": ["six_cups", "two_cups", "sun"],
    "reading_meaning": "Щастливо завръщане на бивш",
    "reading_description": "Бивш партньор се връща в живота ти, но този път нещата изглеждат по-различно. Истинско щастие.",
    "reading_advice": "Дай шанс – хората се променят, времето лекува."
  },
  {
    "reading_id": "pregnancy",
    "reading_name": "Бременност",
    "reading_cards": "Императрица + 3 Чаши + Слънце",
    "reading_combination": ["empress", "three_cups", "sun"],
    "reading_meaning": "Нов живот",
    "reading_description": "Раждане на дете, нов член в семейството. Нов живот идва.",
    "reading_advice": "Нов живот идва – благословия! Готви се за промяна."
  },
  {
    "reading_id": "new_job",
    "reading_name": "Нова работа",
    "reading_cards": "Асо Пентакли + 6 Жезли",
    "reading_combination": ["ace_pentacles", "six_wands"],
    "reading_meaning": "Успешен старт",
    "reading_description": "Нова работа, повишение, нова финансова възможност. Успехът идва.",
    "reading_advice": "Хвани възможността. Тя няма да чака вечно."
  },
  {
    "reading_id": "unemployment",
    "reading_name": "Уволнение",
    "reading_cards": "10 Мечове + 5 Пентакли",
    "reading_combination": ["ten_swords", "five_pentacles"],
    "reading_meaning": "Загуба на работа",
    "reading_description": "Уволнение, съкращение, фалит. Край на този етап.",
    "reading_advice": "Това е врата, която се затваря, за да се отвори друга. Почини си и започни наново."
  },
  {
    "reading_id": "financial_crisis",
    "reading_name": "Финансова криза",
    "reading_cards": "5 Пентакли + 10 Жезли + Луна",
    "reading_combination": ["five_pentacles", "ten_wands", "moon"],
    "reading_meaning": "Тежък период",
    "reading_description": "Тежък финансов период – загуба на работа, фалит, дългове. Не виждаш ясен изход.",
    "reading_advice": "Потърси помощ – има хора, готови да помогнат. Светлината идва, дори в най-тъмната нощ."
  },
 
  {
    "reading_id": "moving",
    "reading_name": "Преместване",
    "reading_cards": "6 Мечове + 4 Жезли",
    "reading_combination": ["six_swords", "four_wands"],
    "reading_meaning": "Нов дом",
    "reading_description": "Смяна на дома, местене в друг град или държава.",
    "reading_advice": "Ново място, нов живот. Отваряй се за новото."
  },
  {
    "reading_id": "travel",
    "reading_name": "Пътуване",
    "reading_cards": "8 Жезли + 6 Мечове + Колесница",
    "reading_combination": ["eight_wands", "six_swords", "chariot"],
    "reading_meaning": "Бързо пътуване",
    "reading_description": "Пътуване в чужбина, бързо придвижване, полет.",
    "reading_advice": "Хвани вълната – пътуването носи нови възможности."
  },
  {
    "reading_id": "spiritual_awakening",
    "reading_name": "Духовно пробуждане",
    "reading_cards": "Върховна жрица + Луна + Звезда",
    "reading_combination": ["high_priestess", "moon", "star"],
    "reading_meaning": "Интуиция и прозрения",
    "reading_description": "Силна интуиция, психични преживявания, сънища, които се сбъдват. Връзка с подсъзнанието.",
    "reading_advice": "Записвай сънищата си. Медитирай. Воден си отгоре."
  },
  {
    "reading_id": "depression",
    "reading_name": "Депресия",
    "reading_cards": "9 Мечове + Отшелник + Луна",
    "reading_combination": ["nine_swords", "hermit", "moon"],
    "reading_meaning": "Тъмна нощ на душата",
    "reading_description": "Дълбока депресия, духовна криза, безсъние, тревоги. Чувстваш се сам и изгубен.",
    "reading_advice": "Това е преход – нощта е най-тъмна преди зазоряване. Отговорът идва отвътре."
  },
  {
    "reading_id": "insight",
    "reading_name": "Прозрение",
    "reading_cards": "Асо Мечове + Слънце + Магьосник",
    "reading_combination": ["ace_swords", "sun", "magician"],
    "reading_meaning": "Внезапна яснота",
    "reading_description": "Внезапно разбиране – виждаш истината с невероятна яснота. Това прозрение променя всичко.",
    "reading_advice": "Сега знаеш какво трябва да правиш. Действай с увереност."
  },
  {
    "reading_id": "betrayal",
    "reading_name": "Предателство",
    "reading_cards": "7 Мечове + 3 Мечове + Дявол",
    "reading_combination": ["seven_swords", "three_swords", "devil"],
    "reading_meaning": "Някой лъже",
    "reading_description": "Някой ти подготвя предателство. Има тайни, лъжи, измама. Мотивите са егоистични.",
    "reading_advice": "Пази гърба си. Не споделяй тайни. Провери фактите."
  },
  {
    "reading_id": "sibling_bond",
    "reading_name": "Задруга с брат/сестра",
    "reading_cards": "3 Чаши + 6 Чаши + 10 Чаши",
    "reading_combination": ["three_cups", "six_cups", "ten_cups"],
    "reading_meaning": "Силна връзка с брат/сестра",
    "reading_description": "Засилване на връзката с брат или сестра. Споделяне, подкрепа, общи спомени и радостта да имаш човек, който те познава от винаги.",
    "reading_advice": "Ценете тази връзка. Братята и сестрите са единствените хора, които са били с теб през целия ти път."
  },
  {
    "reading_id": "parents_aging",
    "reading_name": "Застаряващи родители",
    "reading_cards": "5 Пентакли + 4 Мечове + 10 Пентакли",
    "reading_combination": ["five_pentacles", "four_swords", "ten_pentacles"],
    "reading_meaning": "Грижа за възрастни родители",
    "reading_description": "Родителите ти застаряват и имат нужда от повече грижи. Обръщане на ролите - ти ставаш родител на своите родители.",
    "reading_advice": "Бъди търпелив и благодарен. Те са се грижили за теб - сега е твой ред."
  },
  {
    "reading_id": "parents_divorce_late",
    "reading_name": "Развод на родители",
    "reading_cards": "Кула + 3 Мечове + 5 Чаши",
    "reading_combination": ["tower", "three_swords", "five_cups"],
    "reading_meaning": "Родителите се разделят",
    "reading_description": "Родителите ти се разделят или развеждат, въпреки че си възрастен. Това разтърсва представата ти за семейство.",
    "reading_advice": "Не заставай на страна. Те остават твои родители, дори вече да не са двойка."
  },
  {
    "reading_id": "family_addiction",
    "reading_name": "Зависимост в семейството",
    "reading_cards": "Дявол + 5 Пентакли + 9 Мечове",
    "reading_combination": ["devil", "five_pentacles", "nine_swords"],
    "reading_meaning": "Проблем с алкохол/наркотици",
    "reading_description": "Някой в семейството има проблем със зависимости - алкохол, хазарт, наркотици. Това засяга всички.",
    "reading_advice": "Потърси помощ - Анонимни алкохолици, терапия, консултации. Не можеш да спасиш човек, който не иска да бъде спасен."
  },
  {
    "reading_id": "family_intervention",
    "reading_name": "Интервенция",
    "reading_cards": "Справедливост + 5 Мечове + 8 Мечове",
    "reading_combination": ["justice", "five_swords", "eight_swords"],
    "reading_meaning": "Семейството се намесва",
    "reading_description": "Семейството организира интервенция за член със зависимости или проблеми. Труден, но необходим разговор.",
    "reading_advice": "Говорете с любов, не с обвинения. Целта е да помогнете, не да накажете."
  },
  {
    "reading_id": "family_secret_revealed",
    "reading_name": "Разкрита семейна тайна",
    "reading_cards": "Луна + 7 Мечове + Съд",
    "reading_combination": ["moon", "seven_swords", "judgement"],
    "reading_meaning": "Тайна излиза наяве",
    "reading_description": "Семейна тайна, пазена с години, най-после излиза наяве. Рождение, осиновяване, изневяра, престъпление - истината вече не може да се крие.",
    "reading_advice": "Истината лекува, дори да боли. След като всичко излезе наяве, можете да започнете да лекувате раните."
  },
  {
    "reading_id": "family_forgiveness",
    "reading_name": "Прошка в семейството",
    "reading_cards": "6 Чаши + Умереност + 10 Чаши",
    "reading_combination": ["six_cups", "temperance", "ten_cups"],
    "reading_meaning": "Помирение след дълго време",
    "reading_description": "След години на отчуждение идва прошката и помирението. Семейството отново се събира, старите рани заздравяват.",
    "reading_advice": "Прости, дори да не забравиш. Носенето на омраза тежи само на теб."
  },
  {
    "reading_id": "child_school",
    "reading_name": "Детето тръгва на училище",
    "reading_cards": "8 Пентакли + 4 Жезли + 6 Жезли",
    "reading_combination": ["eight_pentacles", "four_wands", "six_wands"],
    "reading_meaning": "Първи учебен ден",
    "reading_description": "Детето ти тръгва на училище за първи път. Гордост, тъга, притеснение - емоционален микс от чувства.",
    "reading_advice": "Наслади се на този преход. Той бележи израстването на детето ти и твоето като родител."
  },
  {
    "reading_id": "child_teen",
    "reading_name": "Тийнейджърски години",
    "reading_cards": "5 Жезли + 7 Мечове + Луна",
    "reading_combination": ["five_wands", "seven_swords", "moon"],
    "reading_meaning": "Бунтарски период",
    "reading_description": "Детето ти навлиза в тийнейджърските години - бунт, тайни, промени в настроението. Труден период за цялото семейство.",
    "reading_advice": "Бъди търпелив и присъстващ. Колкото и да се бунтува, той/тя все още има нужда от теб."
  },
  {
    "reading_id": "child_graduate",
    "reading_name": "Завършване на детето",
    "reading_cards": "6 Жезли + 10 Пентакли + Свят",
    "reading_combination": ["six_wands", "ten_pentacles", "world"],
    "reading_meaning": "Гордост от детето",
    "reading_description": "Детето ти завършва образование, постига успех. Гордост, щастие, вълнение - трудът ти се отплаща.",
    "reading_advice": "Празнувай този успех заедно. Това е и твой успех като родител."
  },
  {
    "reading_id": "business_plan",
    "reading_name": "Бизнес план",
    "reading_cards": "Асо Жезли + 8 Пентакли + Император",
    "reading_combination": ["ace_wands", "eight_pentacles", "emperor"],
    "reading_meaning": "Създаване на бизнес план",
    "reading_description": "Разработваш детайлен бизнес план за нова идея или проект. Структура, анализи, прогнози - всичко е на място.",
    "reading_advice": "Добрият план е половината успех. Инвестирай време в детайлите."
  },
  {
    "reading_id": "business_pitch",
    "reading_name": "Представяне на идея",
    "reading_cards": "Магьосник + 6 Жезли + 8 Жезли",
    "reading_combination": ["magician", "six_wands", "eight_wands"],
    "reading_meaning": "Успешно презентиране",
    "reading_description": "Предстои ти представяне на бизнес идея пред инвеститори или партньори. Ще впечатлиш и ще получиш зелена светлина.",
    "reading_advice": "Вярвай в идеята си и говори със страст. Убедеността ти е заразителна."
  },
  {
    "reading_id": "business_competition",
    "reading_name": "Конкуренция",
    "reading_cards": "5 Жезли + 7 Мечове + 5 Мечове",
    "reading_combination": ["five_wands", "seven_swords", "five_swords"],
    "reading_meaning": "Борба с конкуренти",
    "reading_description": "Конкуренцията в бранша се засилва. Някой се опитва да ти вземе клиенти, идеи или пазарен дял.",
    "reading_advice": "Наблюдавай конкурентите, но не се фиксирай върху тях. Фокусирай се върху собственото си развитие."
  },
  {
    "reading_id": "business_innovation",
    "reading_name": "Иновация",
    "reading_cards": "Асо Жезли + Магьосник + Слънце",
    "reading_combination": ["ace_wands", "magician", "sun"],
    "reading_meaning": "Новаторска идея",
    "reading_description": "Хрумва ти иновативна идея, която може да промени бизнеса ти. Творчество, вдъхновение, уникалност.",
    "reading_advice": "Действай бързо, докато идеята е свежа. Иновациите не чакат."
  },
  {
    "reading_id": "business_expansion",
    "reading_name": "Разширяване на бизнес",
    "reading_cards": "8 Жезли + 10 Пентакли + Свят",
    "reading_combination": ["eight_wands", "ten_pentacles", "world"],
    "reading_meaning": "Излизане на нови пазари",
    "reading_description": "Бизнесът ти се разширява - нови локации, нови пазари, нови продукти. Растеж и развитие.",
    "reading_advice": "Разширявай се внимателно и обмислено. Бързият растеж крие рискове."
  },
  {
    "reading_id": "business_downsize",
    "reading_name": "Свиване на бизнес",
    "reading_cards": "5 Пентакли + 8 Мечове + 10 Жезли",
    "reading_combination": ["five_pentacles", "eight_swords", "ten_wands"],
    "reading_meaning": "Намаляване на мащаба",
    "reading_description": "Наложено е да свиеш бизнеса си - съкращения, затваряне на офиси, намаляване на разходи. Труден период.",
    "reading_advice": "Прави каквото трябва, за да оцелееш. По-малкото може да бъде по-добро."
  },
  {
    "reading_id": "business_sale",
    "reading_name": "Продажба на бизнес",
    "reading_cards": "10 Пентакли + 6 Жезли + Свят",
    "reading_combination": ["ten_pentacles", "six_wands", "world"],
    "reading_meaning": "Успешна продажба",
    "reading_description": "Продаваш бизнеса си след години труд. Добра цена, доволни купувачи, чувство на завършеност.",
    "reading_advice": "Наслади се на постижението. Ти построи нещо ценно."
  },
  {
    "reading_id": "business_buy",
    "reading_name": "Закупуване на бизнес",
    "reading_cards": "Асо Пентакли + 4 Пентакли + 10 Пентакли",
    "reading_combination": ["ace_pentacles", "four_pentacles", "ten_pentacles"],
    "reading_meaning": "Придобиване на компания",
    "reading_description": "Закупуваш съществуващ бизнес или дял от компания. Инвестиция в нещо вече изградено.",
    "reading_advice": "Провери добре финансите и дълговете. Купуваш не само активи, но и проблеми."
  },
  {
    "reading_id": "business_franchise",
    "reading_name": "Франчайз",
    "reading_cards": "3 Пентакли + 8 Пентакли + 10 Пентакли",
    "reading_combination": ["three_pentacles", "eight_pentacles", "ten_pentacles"],
    "reading_meaning": "Закупуване на франчайз",
    "reading_description": "Закупуваш франчайз - доказан бизнес модел с подкрепа и обучение. По-сигурен път към предприемачество.",
    "reading_advice": "Следвай системата, но добави и нещо свое. Успехът идва от баланса между правила и индивидуалност."
  },
  {
    "reading_id": "business_network",
    "reading_name": "Мрежа от контакти",
    "reading_cards": "3 Чаши + 6 Пентакли + 8 Жезли",
    "reading_combination": ["three_cups", "six_pentacles", "eight_wands"],
    "reading_meaning": "Разширяване на връзки",
    "reading_description": "Разширяваш професионалната си мрежа - нови контакти, партньорства, възможности. Връзките са злато.",
    "reading_advice": "Инвестирай време в изграждане на истински връзки, не просто в събиране на визитки."
  },
  {
    "reading_id": "business_mentor",
    "reading_name": "Бизнес ментор",
    "reading_cards": "Йерофант + 8 Пентакли + 9 Пентакли",
    "reading_combination": ["hierophant", "eight_pentacles", "nine_pentacles"],
    "reading_meaning": "Среща с наставник",
    "reading_description": "Срещаш бизнес ментор, който ти помага да избегнеш грешки и да се развиваш по-бързо. Безценна помощ.",
    "reading_advice": "Слушай и учи, но не забравяй собствения си глас. Менторът е пътеводител, не господар."
  },
  {
    "reading_id": "business_mistake",
    "reading_name": "Бизнес грешка",
    "reading_cards": "5 Мечове + 7 Мечове + 8 Мечове",
    "reading_combination": ["five_swords", "seven_swords", "eight_swords"],
    "reading_meaning": "Скъпа грешка",
    "reading_description": "Допуснал си грешка в бизнеса, която ти коства пари, време или репутация. Чувстваш се унил и разочарован.",
    "reading_advice": "Грешките са уроци, маскирани като провали. Анализирай, учи и продължавай напред."
  },
  {
    "reading_id": "business_recovery",
    "reading_name": "Възстановяване на бизнес",
    "reading_cards": "8 Пентакли + 6 Жезли + Звезда",
    "reading_combination": ["eight_pentacles", "six_wands", "star"],
    "reading_meaning": "След криза идва възход",
    "reading_description": "След период на криза бизнесът ти започва да се възстановява. Нови клиенти, подобрени финанси, надежда.",
    "reading_advice": "Продължавай да работиш упорито. Възходът изисква постоянство."
  },
  {
    "reading_id": "business_exit",
    "reading_name": "Излизане от бизнес",
    "reading_cards": "8 Чаши + 10 Пентакли + Отшелник",
    "reading_combination": ["eight_cups", "ten_pentacles", "hermit"],
    "reading_meaning": "Напускане на бизнеса",
    "reading_description": "Решаваш да излезеш от бизнеса, който си създал. Продажба, предаване на щафетата, ново начало.",
    "reading_advice": "Тръгни си с гордост. Ти остави следа."
  },
  {
    "reading_id": "business_legacy",
    "reading_name": "Бизнес наследство",
    "reading_cards": "10 Пентакли + 4 Жезли + Император",
    "reading_combination": ["ten_pentacles", "four_wands", "emperor"],
    "reading_meaning": "Предаване на бизнеса",
    "reading_description": "Предаваш бизнеса на следващото поколение - деца, наследници. Осигуряване на бъдещето и продължаване на рода.",
    "reading_advice": "Предай не само активите, но и ценностите, които са те водили."
  },
  {
    "reading_id": "health_diagnosis",
    "reading_name": "Диагноза",
    "reading_cards": "8 Мечове + 5 Пентакли + 10 Мечове",
    "reading_combination": ["eight_swords", "five_pentacles", "ten_swords"],
    "reading_meaning": "Получаване на диагноза",
    "reading_description": "Получаваш медицинска диагноза, която променя живота ти. Шок, страх, объркване - свят се срива.",
    "reading_advice": "Дай си време да приемеш новината. После действай - потърси второ мнение, информирай се, бори се."
  },
  {
    "reading_id": "health_second_opinion",
    "reading_name": "Второ мнение",
    "reading_cards": "Справедливост + 8 Мечове + 4 Мечове",
    "reading_combination": ["justice", "eight_swords", "four_swords"],
    "reading_meaning": "Търсене на друг лекар",
    "reading_description": "Търсиш второ медицинско мнение. Не си сигурен в първоначалната диагноза и искаш да се увериш.",
    "reading_advice": "Винаги търси второ мнение при сериозни заболявания. Различните лекари имат различен опит."
  },
  {
    "reading_id": "health_alternative",
    "reading_name": "Алтернативно лечение",
    "reading_cards": "Върховна жрица + 4 Мечове + 8 Пентакли",
    "reading_combination": ["high_priestess", "four_swords", "eight_pentacles"],
    "reading_meaning": "Неконвенционални методи",
    "reading_description": "Започваш алтернативно лечение - билки, акупунктура, хомеопатия, енергийно лечение. Допълнение към конвенционалната медицина.",
    "reading_advice": "Информирай се добре и не спирай конвенционалното лечение без консултация."
  },
  {
    "reading_id": "health_diet",
    "reading_name": "Диета",
    "reading_cards": "8 Пентакли + 4 Мечове + 9 Пентакли",
    "reading_combination": ["eight_pentacles", "four_swords", "nine_pentacles"],
    "reading_meaning": "Започване на диета",
    "reading_description": "Започваш нова диета или хранителен режим. Грижа за тялото, желание за промяна, подобряване на здравето.",
    "reading_advice": "Бъди търпелив. Здравословните навици се изграждат бавно, но траят дълго."
  },
  {
    "reading_id": "health_exercise",
    "reading_name": "Започване на спорт",
    "reading_cards": "8 Жезли + Сила + Слънце",
    "reading_combination": ["eight_wands", "strength", "sun"],
    "reading_meaning": "Нова спортна дейност",
    "reading_description": "Започваш да спортуваш или се връщаш към активен начин на живот. Енергия, мотивация, грижа за себе си.",
    "reading_advice": "Намери спорт, който наистина ти харесва. Така ще го правиш с удоволствие, а не задължение."
  },
  {
    "reading_id": "health_injury",
    "reading_name": "Контузия",
    "reading_cards": "5 Мечове + 10 Мечове + 4 Мечове",
    "reading_combination": ["five_swords", "ten_swords", "four_swords"],
    "reading_meaning": "Физическо нараняване",
    "reading_description": "Претърпяваш контузия или нараняване, което те ограничава. Болка, спиране на активността, възстановяване.",
    "reading_advice": "Слушай лекарите и не бързай да се връщаш към активност. Възстановяването изисква време."
  },
 
 
  {
    "reading_id": "health_mental_break",
    "reading_name": "Психическа почивка",
    "reading_cards": "4 Мечове + Отшелник + 9 Мечове",
    "reading_combination": ["four_swords", "hermit", "nine_swords"],
    "reading_meaning": "Почивка от стреса",
    "reading_description": "Имаш нужда от психическа почивка - от социални мрежи, новини, задължения. Твърде много информация и стрес те натоварват.",
    "reading_advice": "Направи дигитален детокс. Изключи телефона, излез сред природа, бъди сам със себе си."
  },
  {
    "reading_id": "health_balance",
    "reading_name": "Баланс в живота",
    "reading_cards": "Умереност + 4 Мечове + 10 Чаши",
    "reading_combination": ["temperance", "four_swords", "ten_cups"],
    "reading_meaning": "Хармония между тяло и дух",
    "reading_description": "Намираш баланс между работа, почивка, здраве и семейство. Чувстваш се цялостен и удовлетворен.",
    "reading_advice": "Пази този баланс. Той е ключът към дълъг и щастлив живот."
  },
  {
    "reading_id": "travel_adventure",
    "reading_name": "Екстремно пътуване",
    "reading_cards": "Глупак + 8 Жезли + Колесница",
    "reading_combination": ["fool", "eight_wands", "chariot"],
    "reading_meaning": "Приключенско пътуване",
    "reading_description": "Предстои ти екстремно пътуване - планини, джунгла, пустиня. Приключение, което ще те промени.",
    "reading_advice": "Бъди подготвен, но и отворен за изненади. Истинските приключения идват непланирани."
  },
  {
    "reading_id": "travel_solo",
    "reading_name": "Самотно пътуване",
    "reading_cards": "Отшелник + 6 Мечове + 8 Жезли",
    "reading_combination": ["hermit", "six_swords", "eight_wands"],
    "reading_meaning": "Пътуване сам",
    "reading_description": "Пътуваш сам - доброволно или по необходимост. Време за себе си, опознаване, самота, която не е лоша.",
    "reading_advice": "Наслади се на компанията си. Сам си, но не самотен."
  },
  {
    "reading_id": "travel_group",
    "reading_name": "Групово пътуване",
    "reading_cards": "3 Чаши + 6 Мечове + 4 Жезли",
    "reading_combination": ["three_cups", "six_swords", "four_wands"],
    "reading_meaning": "Екскурзия с приятели",
    "reading_description": "Пътуване с група приятели или организирана група. Веселба, нови приятелства, споделени преживявания.",
    "reading_advice": "Наслаждавай се на компанията, но запази и време за себе си."
  },
  {
    "reading_id": "travel_family",
    "reading_name": "Семейна ваканция",
    "reading_cards": "10 Чаши + 4 Жезли + 6 Мечове",
    "reading_combination": ["ten_cups", "four_wands", "six_swords"],
    "reading_meaning": "Почивка със семейството",
    "reading_description": "Семейна ваканция - деца, родители, баби и дядовци заедно. Спомени за цял живот.",
    "reading_advice": "Остави очакванията за перфектна почивка и просто бъди заедно. Това е най-важното."
  },
  {
    "reading_id": "travel_romantic",
    "reading_name": "Романтично пътуване",
    "reading_cards": "2 Чаши + 6 Мечове + 4 Жезли",
    "reading_combination": ["two_cups", "six_swords", "four_wands"],
    "reading_meaning": "Почивка за двама",
    "reading_description": "Романтично пътуване с любимия човек. Само двамата, далеч от ежедневието, време за любов.",
    "reading_advice": "Наслаждавайте се един на друг. Тези моменти са безценни."
  },
  {
    "reading_id": "travel_business",
    "reading_name": "Бизнес пътуване",
    "reading_cards": "8 Жезли + 3 Пентакли + 6 Мечове",
    "reading_combination": ["eight_wands", "three_pentacles", "six_swords"],
    "reading_meaning": "Командировка",
    "reading_description": "Бизнес пътуване - срещи, конференции, преговори. Работа в движение.",
    "reading_advice": "Опитай да съчетаеш работа и удоволствие. Остани ден-два повече, ако можеш."
  },
  {
    "reading_id": "travel_backpack",
    "reading_name": "Раница на гръб",
    "reading_cards": "Глупак + 8 Жезли + 6 Мечове",
    "reading_combination": ["fool", "eight_wands", "six_swords"],
    "reading_meaning": "Пътуване с раница",
    "reading_description": "Пътуване с раница - хостели, влакове, автостоп. Свобода, приключения, срещи с непознати.",
    "reading_advice": "Бъди отворен за всичко. Най-хубавите спомени идват от непланираните моменти."
  },
  {
    "reading_id": "travel_lost",
    "reading_name": "Изгубен по пътя",
    "reading_cards": "Луна + 7 Мечове + 6 Мечове",
    "reading_combination": ["moon", "seven_swords", "six_swords"],
    "reading_meaning": "Заблуден пътник",
    "reading_description": "Изгубваш се по време на пътуване - физически или метафорично. Не знаеш накъде да продължиш.",
    "reading_advice": "Питай за упътване. Няма срам в това да не знаеш пътя."
  },
  {
    "reading_id": "travel_found",
    "reading_name": "Откритие",
    "reading_cards": "Звезда + 6 Мечове + Слънце",
    "reading_combination": ["star", "six_swords", "sun"],
    "reading_meaning": "Намиране на пътя",
    "reading_description": "Намираш посоката след период на объркване. Пътят се отваря, нещата се изясняват.",
    "reading_advice": "Следвай светлината. Тя те води правилно."
  },
  {
    "reading_id": "travel_return",
    "reading_name": "Завръщане у дома",
    "reading_cards": "6 Мечове + 4 Жезли + 10 Чаши",
    "reading_combination": ["six_swords", "four_wands", "ten_cups"],
    "reading_meaning": "Прибиране след път",
    "reading_description": "Завръщаш се у дома след дълго пътуване. Уют, сигурност, радост от срещата с близките.",
    "reading_advice": "Няма по-хубаво място от дома. Цени го."
  },
  {
    "reading_id": "study_abroad",
    "reading_name": "Следване в чужбина",
    "reading_cards": "6 Мечове + 8 Жезли + Свят",
    "reading_combination": ["six_swords", "eight_wands", "world"],
    "reading_meaning": "Заминаване да учиш",
    "reading_description": "Заминаваш да следваш в чужбина. Нова държава, нов език, нова култура. Страх и вълнение.",
    "reading_advice": "Отвори се за новото, но не забравяй корените си."
  },
  {
    "reading_id": "study_exam_anxiety",
    "reading_name": "Изпитна треска",
    "reading_cards": "9 Мечове + 8 Мечове + 4 Мечове",
    "reading_combination": ["nine_swords", "eight_swords", "four_swords"],
    "reading_meaning": "Страх от изпит",
    "reading_description": "Притесняваш се преди важен изпит. Безсъние, паника, страх от провал. Умът ти блокира.",
    "reading_advice": "Дишай. Знаеш повече, отколкото си мислиш. Спокойствието е ключът."
  },
  {
    "reading_id": "study_course",
    "reading_name": "Курс за квалификация",
    "reading_cards": "8 Пентакли + 3 Пентакли + 6 Жезли",
    "reading_combination": ["eight_pentacles", "three_pentacles", "six_wands"],
    "reading_meaning": "Допълнително обучение",
    "reading_description": "Записваш се на курс за допълнителна квалификация. Инвестиция в себе си и бъдещето си.",
    "reading_advice": "Учи с желание. Знанието е единственото нещо, което никой не може да ти отнеме."
  },
  {
    "reading_id": "study_workshop",
    "reading_name": "Уъркшоп",
    "reading_cards": "3 Чаши + 8 Пентакли + 6 Жезли",
    "reading_combination": ["three_cups", "eight_pentacles", "six_wands"],
    "reading_meaning": "Практическо обучение",
    "reading_description": "Участваш в уъркшоп или практически курс. Учене чрез правене, нови контакти, забавление.",
    "reading_advice": "Задавай въпроси и бъди активен. Така научаваш най-много."
  },
  {
    "reading_id": "study_online",
    "reading_name": "Онлайн обучение",
    "reading_cards": "8 Жезли + 8 Пентакли + Свят",
    "reading_combination": ["eight_wands", "eight_pentacles", "world"],
    "reading_meaning": "Дистанционно учене",
    "reading_description": "Започваш онлайн курс или дистанционно обучение. Учене от вкъщи, собствено темпо, гъвкавост.",
    "reading_advice": "Самодисциплината е ключова. Без нея онлайн обучението е трудно."
  },
  {
    "reading_id": "study_teacher",
    "reading_name": "Вдъхновяващ учител",
    "reading_cards": "Йерофант + Слънце + 8 Пентакли",
    "reading_combination": ["hierophant", "sun", "eight_pentacles"],
    "reading_meaning": "Учител, който променя всичко",
    "reading_description": "Срещаш учител, който променя представата ти за предмета. Той те вдъхновява и запалва искрата.",
    "reading_advice": "Бъди благодарен и учи с отворено сърце. Такива учители са рядкост."
  },
  {
    "reading_id": "study_failure",
    "reading_name": "Провал на изпит",
    "reading_cards": "5 Мечове + 5 Чаши + 10 Мечове",
    "reading_combination": ["five_swords", "five_cups", "ten_swords"],
    "reading_meaning": "Неуспех в ученето",
    "reading_description": "Проваляш се на изпит или не успяваш да завършиш курс. Разочарование, униние, съмнение в себе си.",
    "reading_advice": "Това не е край, а завой. Опитай отново или потърси друг път."
  },
  {
    "reading_id": "study_retake",
    "reading_name": "Поправителен изпит",
    "reading_cards": "8 Пентакли + 6 Жезли + 4 Мечове",
    "reading_combination": ["eight_pentacles", "six_wands", "four_swords"],
    "reading_meaning": "Втори шанс",
    "reading_description": "Получаваш втори шанс да се явиш на изпит или да поправиш оценката си. Този път си подготвен.",
    "reading_advice": "Учи от грешките си и сега ще успееш."
  },
  {
    "reading_id": "study_scholarship",
    "reading_name": "Стипендия",
    "reading_cards": "Асо Пентакли + 6 Жезли + 10 Пентакли",
    "reading_combination": ["ace_pentacles", "six_wands", "ten_pentacles"],
    "reading_meaning": "Получаване на стипендия",
    "reading_description": "Получаваш стипендия или финансова помощ за образование. Признание за труда ти и помощ за бъдещето.",
    "reading_advice": "Гордей се с постижението си. Ти го заслужаваш."
  },
  {
    "reading_id": "study_phd",
    "reading_name": "Докторантура",
    "reading_cards": "8 Пентакли + Отшелник + Свят",
    "reading_combination": ["eight_pentacles", "hermit", "world"],
    "reading_meaning": "Задълбочено изследване",
    "reading_description": "Започваш докторантура или задълбочено научно изследване. Години на учене, изолация, но и открития.",
    "reading_advice": "Бъди търпелив и упорит. Пътят е дълъг, но наградата е голяма."
  },
  {
    "reading_id": "art_block",
    "reading_name": "Творческа блокада",
    "reading_cards": "8 Мечове + 4 Мечове + 9 Мечове",
    "reading_combination": ["eight_swords", "four_swords", "nine_swords"],
    "reading_meaning": "Няма вдъхновение",
    "reading_description": "Изпитваш творческа блокада - няма идеи, вдъхновение, желание за творене. Празнота и фрустрация.",
    "reading_advice": "Не се насилвай. Почини, разходи се, смени средата. Вдъхновението идва, когато не го търсиш."
  },
  {
    "reading_id": "art_inspiration",
    "reading_name": "Внезапно вдъхновение",
    "reading_cards": "Асо Жезли + Слънце + Магьосник",
    "reading_combination": ["ace_wands", "sun", "magician"],
    "reading_meaning": "Идеята идва",
    "reading_description": "Внезапно те залива вълна от вдъхновение. Идеи, които искат да бъдат реализирани веднага.",
    "reading_advice": "Записвай, рисувай, твори веднага. Вдъхновението е нетрайно."
  },
  {
    "reading_id": "art_exhibition_success",
    "reading_name": "Успешна изложба",
    "reading_cards": "6 Жезли + 3 Чаши + Слънце",
    "reading_combination": ["six_wands", "three_cups", "sun"],
    "reading_meaning": "Творчеството е признато",
    "reading_description": "Твоята изложба, концерт или представяне е успешно. Признание, аплодисменти, продажби. Ти си забелязан.",
    "reading_advice": "Наслади се на успеха. Ти го заслужи."
  },
  {
    "reading_id": "art_gallery",
    "reading_name": "Посещение на галерия",
    "reading_cards": "3 Чаши + 6 Чаши + 9 Пентакли",
    "reading_combination": ["three_cups", "six_cups", "nine_pentacles"],
    "reading_meaning": "Ден за изкуство",
    "reading_description": "Прекарваш ден в галерия, музей или на културно събитие. Обогатяване, вдъхновение, нови гледни точки.",
    "reading_advice": "Позволи си този лукс. Изкуството храни душата."
  },
  {
    "reading_id": "art_music",
    "reading_name": "Музикално вдъхновение",
    "reading_cards": "3 Чаши + Асо Жезли + Луна",
    "reading_combination": ["three_cups", "ace_wands", "moon"],
    "reading_meaning": "Нова песен",
    "reading_description": "Създаваш нова музика или песен. Емоциите ти се изливат в ноти и текст. Творчество, което лекува.",
    "reading_advice": "Сподели музиката си. Тя докосва повече хора, отколкото си мислиш."
  },
  {
    "reading_id": "art_writing",
    "reading_name": "Писателско вдъхновение",
    "reading_cards": "Асо Мечове + 3 Чаши + 8 Пентакли",
    "reading_combination": ["ace_swords", "three_cups", "eight_pentacles"],
    "reading_meaning": "Нова книга",
    "reading_description": "Започваш да пишеш - книга, блог, стихове. Думите текат, идеите идват, вдъхновението е силно.",
    "reading_advice": "Пиши всеки ден. Дори да не е много, важното е постоянството."
  },
  {
    "reading_id": "art_photography",
    "reading_name": "Фотография",
    "reading_cards": "Слънце + 6 Мечове + 9 Пентакли",
    "reading_combination": ["sun", "six_swords", "nine_pentacles"],
    "reading_meaning": "Улавяне на момента",
    "reading_description": "Задълбочаваш се във фотографията. Улавяш светлина, емоции, моменти. Творчество през обектива.",
    "reading_advice": "Снимай това, което те вълнува. Най-добрите снимки идват от сърцето."
  },
  {
    "reading_id": "art_painting",
    "reading_name": "Рисуване",
    "reading_cards": "Императрица + 3 Чаши + Слънце",
    "reading_combination": ["empress", "three_cups", "sun"],
    "reading_meaning": "Нова картина",
    "reading_description": "Започваш нова картина или художествен проект. Цветове, форми, емоции на платно.",
    "reading_advice": "Не се страхувай да експериментираш. В изкуството няма грешки."
  },
  {
    "reading_id": "art_craft",
    "reading_name": "Ръчна изработка",
    "reading_cards": "8 Пентакли + 3 Пентакли + 9 Пентакли",
    "reading_combination": ["eight_pentacles", "three_pentacles", "nine_pentacles"],
    "reading_meaning": "Занаятчийство",
    "reading_description": "Занимаваш се с ръчна изработка - бижута, керамика, дърворезба. Творчество с ръце, което носи удовлетворение.",
    "reading_advice": "Твоите ръце създават красота. Цени този дар."
  },
  {
    "reading_id": "art_performance",
    "reading_name": "Сценично изкуство",
    "reading_cards": "6 Жезли + 3 Чаши + Магьосник",
    "reading_combination": ["six_wands", "three_cups", "magician"],
    "reading_meaning": "Представление",
    "reading_description": "Участваш в театрална постановка, танц или друго сценично изкуство. Превъплъщение, емоция, аплодисменти.",
    "reading_advice": "Отдай се на ролята. Сцената е магия."
  },
  {
    "reading_id": "nature_escape",
    "reading_name": "Бягство сред природа",
    "reading_cards": "4 Мечове + 6 Мечове + Слънце",
    "reading_combination": ["four_swords", "six_swords", "sun"],
    "reading_meaning": "Почивка на планина/море",
    "reading_description": "Бягство от града сред природата. Планина, море, гора - място, където душата си почива.",
    "reading_advice": "Прави го по-често. Природата лекува всичко."
  },
  {
    "reading_id": "nature_gardening",
    "reading_name": "Градинарство",
    "reading_cards": "Императрица + 8 Пентакли + 3 Пентакли",
    "reading_combination": ["empress", "eight_pentacles", "three_pentacles"],
    "reading_meaning": "Грижа за градина",
    "reading_description": "Занимаваш се с градинарство - засаждане, гледане, събиране на плодове. Връзка със земята и природата.",
    "reading_advice": "Грижи се за растенията, те ще се грижат за теб."
  },
  {
    "reading_id": "nature_harvest",
    "reading_name": "Реколта",
    "reading_cards": "7 Пентакли + 9 Пентакли + Слънце",
    "reading_combination": ["seven_pentacles", "nine_pentacles", "sun"],
    "reading_meaning": "Събиране на плодовете",
    "reading_description": "Събираш реколтата от градината си - плодове, зеленчуци, билки. Награда за труда ти.",
    "reading_advice": "Наслади се на плодовете на труда си. Те са най-вкусни, когато са отгледани със собствени ръце."
  },
  {
    "reading_id": "nature_animal",
    "reading_name": "Среща с диво животно",
    "reading_cards": "Сила + 6 Мечове + Луна",
    "reading_combination": ["strength", "six_swords", "moon"],
    "reading_meaning": "Вълшебна среща",
    "reading_description": "Срещаш диво животно по време на разходка - елен, лисица, птица. Магически момент, знак от природата.",
    "reading_advice": "Приеми го като знак. Животните носят послания, ако умееш да ги чуеш."
  },
  {
    "reading_id": "nature_storm",
    "reading_name": "Буря",
    "reading_cards": "Кула + 5 Мечове + 8 Жезли",
    "reading_combination": ["tower", "five_swords", "eight_wands"],
    "reading_meaning": "Природно бедствие",
    "reading_description": "Преживяваш буря или природно бедствие. Страх, разрушение, но и осъзнаване на силата на природата.",
    "reading_advice": "Природата е по-силна от всичко. Уважавай я."
  },
  {
    "reading_id": "finance_budget",
    "reading_name": "Бюджетиране",
    "reading_cards": "4 Пентакли + 2 Пентакли + 8 Пентакли",
    "reading_combination": ["four_pentacles", "two_pentacles", "eight_pentacles"],
    "reading_meaning": "Планиране на разходи",
    "reading_description": "Започваш да планираш бюджета си по-сериозно. Записваш разходи, планираш спестявания, мислиш за бъдещето.",
    "reading_advice": "Добрият бюджет не те ограничава, а ти дава свобода."
  },
  {
    "reading_id": "finance_save",
    "reading_name": "Спестяване",
    "reading_cards": "4 Пентакли + 9 Пентакли + 6 Пентакли",
    "reading_combination": ["four_pentacles", "nine_pentacles", "six_pentacles"],
    "reading_meaning": "Трупане на спестявания",
    "reading_description": "Успяваш да спестиш повече пари от обикновено. Дисциплина, отказ от излишни неща, мислене за бъдещето.",
    "reading_advice": "Продължавай в същия дух. Спестяванията носят спокойствие."
  },
  {
    "reading_id": "finance_invest",
    "reading_name": "Инвестиране",
    "reading_cards": "Асо Пентакли + 7 Пентакли + 10 Пентакли",
    "reading_combination": ["ace_pentacles", "seven_pentacles", "ten_pentacles"],
    "reading_meaning": "Пускане на пари в инвестиция",
    "reading_description": "Инвестираш пари в акции, имоти или друг актив. Пускаш парите да работят за теб.",
    "reading_advice": "Инвестирай в това, което разбираш. И не слагай всички яйца в една кошница."
  },
  {
    "reading_id": "finance_cryptocurrency",
    "reading_name": "Криптовалута",
    "reading_cards": "Колело на съдбата + Асо Пентакли + 7 Мечове",
    "reading_combination": ["wheel_of_fortune", "ace_pentacles", "seven_swords"],
    "reading_meaning": "Инвестиция в крипто",
    "reading_description": "Занимаваш се с криптовалути - покупка, търговия, инвестиция. Висок риск, висока печалба (или загуба).",
    "reading_advice": "Инвестирай само толкова, колкото си готов да загубиш. Пазарът е непредсказуем."
  },
  {
    "reading_id": "finance_stock",
    "reading_name": "Борсова търговия",
    "reading_cards": "8 Жезли + 7 Пентакли + 6 Жезли",
    "reading_combination": ["eight_wands", "seven_pentacles", "six_wands"],
    "reading_meaning": "Активна търговия",
    "reading_description": "Търгуваш активно на борсата - покупко-продажба на акции, следене на новини, анализ на графики.",
    "reading_advice": "Не се поддавай на емоции. Борсата наказва алчността и страха."
  },
  {
    "reading_id": "finance_loss",
    "reading_name": "Финансова загуба",
    "reading_cards": "5 Пентакли + 10 Мечове + 3 Мечове",
    "reading_combination": ["five_pentacles", "ten_swords", "three_swords"],
    "reading_meaning": "Губиш пари",
    "reading_description": "Претърпяваш финансова загуба - лоша инвестиция, измама, непредвидени разходи. Болка и притеснение.",
    "reading_advice": "Това е урок, маскиран като загуба. Анализирай какво се обърка и продължавай."
  },
  {
    "reading_id": "finance_debt_pay",
    "reading_name": "Погасяване на дълг",
    "reading_cards": "6 Пентакли + 4 Пентакли + 10 Пентакли",
    "reading_combination": ["six_pentacles", "four_pentacles", "ten_pentacles"],
    "reading_meaning": "Изплащане на заем",
    "reading_description": "Успяваш да погасиш дълг или заем. Облекчение, свобода, чувство на постижение.",
    "reading_advice": "Празнувай този момент. Ти освободи бъдещето си от тежест."
  },
  {
    "reading_id": "finance_credit",
    "reading_name": "Кредит",
    "reading_cards": "5 Пентакли + 4 Пентакли + 2 Пентакли",
    "reading_combination": ["five_pentacles", "four_pentacles", "two_pentacles"],
    "reading_meaning": "Теглене на заем",
    "reading_description": "Теглиш кредит или заем за голяма покупка. Поемаш задължение, което ще тежи месеци напред.",
    "reading_advice": "Прочети дребния шрифт и пресметни дали можеш да си го позволиш."
  },
  {
    "reading_id": "finance_tax_return",
    "reading_name": "Данъчно облекчение",
    "reading_cards": "6 Пентакли + Справедливост + 4 Пентакли",
    "reading_combination": ["six_pentacles", "justice", "four_pentacles"],
    "reading_meaning": "Възстановяване на данъци",
    "reading_description": "Получаваш възстановяване на данъци или данъчно облекчение. Неочаквани пари, които идват в точния момент.",
    "reading_advice": "Използвай ги разумно - за спестявания или погасяване на дългове."
  },
  {
    "reading_id": "finance_rich",
    "reading_name": "Богатство",
    "reading_cards": "10 Пентакли + 9 Пентакли + Слънце",
    "reading_combination": ["ten_pentacles", "nine_pentacles", "sun"],
    "reading_meaning": "Финансово изобилие",
    "reading_description": "Постигаш финансова сигурност и изобилие. Не си само осигурен, а можеш и да помагаш на другите.",
    "reading_advice": "Бъди щедър. Истинското богатство е в споделянето."
  },
  {
    "reading_id": "friend_meet",
    "reading_name": "Среща със стар приятел",
    "reading_cards": "6 Чаши + 3 Чаши + 2 Чаши",
    "reading_combination": ["six_cups", "three_cups", "two_cups"],
    "reading_meaning": "Възстановяване на приятелство",
    "reading_description": "Срещаш стар приятел, с когото отдавна не сте се виждали. Носталгия, спомени, сякаш времето не е минало.",
    "reading_advice": "Цени тези срещи. Истинските приятелства са за цял живот."
  },
  {
    "reading_id": "friend_betrayal",
    "reading_name": "Предателство от приятел",
    "reading_cards": "7 Мечове + 3 Мечове + 5 Чаши",
    "reading_combination": ["seven_swords", "three_swords", "five_cups"],
    "reading_meaning": "Приятел те предава",
    "reading_description": "Приятел те предава или разочарова. Клюка, лъжа, злоупотреба с доверие. Болката е дълбока.",
    "reading_advice": "Понякога хората идват в живота ни, за да ни научат на доверие... или на обратното."
  },
  {
    "reading_id": "friend_help",
    "reading_name": "Приятелска помощ",
    "reading_cards": "6 Пентакли + 3 Чаши + 10 Чаши",
    "reading_combination": ["six_pentacles", "three_cups", "ten_cups"],
    "reading_meaning": "Приятел протяга ръка",
    "reading_description": "В труден момент приятел ти протяга ръка. Без да се колебае, без да иска нищо в замяна.",
    "reading_advice": "Приеми помощта с благодарност. Някой ден ще имаш възможност да върнеш жеста."
  },
  {
    "reading_id": "friend_group",
    "reading_name": "Нова приятелска група",
    "reading_cards": "3 Чаши + 4 Жезли + 6 Чаши",
    "reading_combination": ["three_cups", "four_wands", "six_cups"],
    "reading_meaning": "Влизаш в нов кръг",
    "reading_description": "Влизаш в нова приятелска група или общност. Нови хора, нови интереси, нови преживявания.",
    "reading_advice": "Бъди отворен, но не бързай да се доверяваш напълно. Истинските приятелства се градят с време."
  },
  {
    "reading_id": "friend_drift",
    "reading_name": "Отдалечаване",
    "reading_cards": "8 Чаши + 5 Чаши + 6 Мечове",
    "reading_combination": ["eight_cups", "five_cups", "six_swords"],
    "reading_meaning": "Приятелството изстива",
    "reading_description": "Приятелството ви с някой се отдалечава. Вече нямате общи теми, срещате се все по-рядко, усещате празнота.",
    "reading_advice": "Пусни го с благодарност за времето, което сте споделили. Не всички приятелства са завинаги."
  },
  {
    "reading_id": "friend_argument",
    "reading_name": "Спор с приятел",
    "reading_cards": "5 Жезли + 3 Мечове + 5 Чаши",
    "reading_combination": ["five_wands", "three_swords", "five_cups"],
    "reading_meaning": "Скарване с близък",
    "reading_description": "Скарваш се с близък приятел. Дума по дума, натрупано напрежение, обидени чувства. И двамата сте наранени.",
    "reading_advice": "Оставете времето да успокои духовете. После говорете, не се обвинявайте."
  },
  {
    "reading_id": "friend_reconcile",
    "reading_name": "Помирение с приятел",
    "reading_cards": "2 Чаши + 6 Чаши + 10 Чаши",
    "reading_combination": ["two_cups", "six_cups", "ten_cups"],
    "reading_meaning": "След кавга идва прошка",
    "reading_description": "След дълго отчуждение идва помирението с приятел. Разговор, прегръдка, прошка и приятелството продължава.",
    "reading_advice": "Радвай се, че успяхте да преодолеете различията. Истинското приятелство издържа на всичко."
  },
 
  {
    "reading_id": "friend_success",
    "reading_name": "Успех на приятел",
    "reading_cards": "6 Жезли + 3 Чаши + 10 Чаши",
    "reading_combination": ["six_wands", "three_cups", "ten_cups"],
    "reading_meaning": "Радваш се за приятел",
    "reading_description": "Приятел постига голям успех и ти искрено се радваш. Без завист, без конкуренция - чиста радост.",
    "reading_advice": "Това е знак за зряло приятелство. Цени го."
  },
  {
    "reading_id": "friend_death",
    "reading_name": "Загуба на приятел",
    "reading_cards": "3 Мечове + 5 Чаши + 10 Мечове",
    "reading_combination": ["three_swords", "five_cups", "ten_swords"],
    "reading_meaning": "Приятел си отива",
    "reading_description": "Губиш приятел - чрез смърт, прекъсване или преместване. Празнота, тъга, усещане за загуба.",
    "reading_advice": "Почети паметта му, като носиш наученото в сърцето си. Никой не си отива напълно."
  },
  {
    "reading_id": "spiritual_books",
    "reading_name": "Духовна литература",
    "reading_cards": "Отшелник + 8 Пентакли + Върховна жрица",
    "reading_combination": ["hermit", "eight_pentacles", "high_priestess"],
    "reading_meaning": "Четене на духовни книги",
    "reading_description": "Задълбочаваш се в духовна литература. Книги за източни учения, езотерика, философия. Търсене на истината.",
    "reading_advice": "Чети, но и прилагай. Истинската мъдрост е в преживяването."
  },
  {
    "reading_id": "spiritual_teacher_find",
    "reading_name": "Намиране на учител",
    "reading_cards": "Йерофант + Отшелник + Слънце",
    "reading_combination": ["hierophant", "hermit", "sun"],
    "reading_meaning": "Среща с гуру",
    "reading_description": "Намираш духовен учител, който резонира с теб. Човек, който не ти дава отговори, а те учи да ги търсиш сам.",
    "reading_advice": "Бъди отворен ученик. Истинският учител е този, който те учи да бъдеш свой собствен учител."
  },
  {
    "reading_id": "spiritual_retreat_abroad",
    "reading_name": "Ретрийт в чужбина",
    "reading_cards": "6 Мечове + Отшелник + Свят",
    "reading_combination": ["six_swords", "hermit", "world"],
    "reading_meaning": "Духовно пътуване",
    "reading_description": "Заминаваш на духовен ретрийт в чужбина - Индия, Перу, Тибет. Път към себе си през света.",
    "reading_advice": "Отвори се за преживяването. То ще те промени по начини, които не можеш да предвидиш."
  },
  {
    "reading_id": "spiritual_awakening_sudden",
    "reading_name": "Внезапно пробуждане",
    "reading_cards": "Кула + Слънце + Върховна жрица",
    "reading_combination": ["tower", "sun", "high_priestess"],
    "reading_meaning": "Просветление",
    "reading_description": "Преживяваш внезапно духовно пробуждане. Всичко придобива нов смисъл, виждаш нещата от по-висока перспектива.",
    "reading_advice": "Прегърни промяната. Ти вече не си същият човек."
  },
  {
    "reading_id": "spiritual_practice",
    "reading_name": "Духовна практика",
    "reading_cards": "8 Пентакли + 4 Мечове + Върховна жрица",
    "reading_combination": ["eight_pentacles", "four_swords", "high_priestess"],
    "reading_meaning": "Редовна медитация",
    "reading_description": "Започваш редовна духовна практика - медитация, йога, молитва. Всеки ден отделяш време за връзка с отвъдното.",
    "reading_advice": "Постоянството е ключът. Дори 10 минути на ден правят разлика."
  } ,
  {
    "reading_id": "jackpot",
    "reading_name": "Джакпот",
    "reading_cards": "Слънце + 10 Чаши + 6 Жезли",
    "reading_combination": ["sun", "ten_cups", "six_wands"],
    "reading_meaning": "Всичко се нарежда",
    "reading_description": "Върхът на щастието. Всичко, което си искал, се сбъдва едновременно.",
    "reading_advice": "Наслаждавай се! Ти заслужаваш този момент. Бъди благодарен."
  },
  {
    "reading_id": "protection",
    "reading_name": "Закрила",
    "reading_cards": "Сила + 6 Жезли + 9 Жезли",
    "reading_combination": ["strength", "six_wands", "nine_wands"],
    "reading_meaning": "Закрила и сила",
    "reading_description": "Въпреки трудностите, ще издържиш. Имаш вътрешна сила и закрила отгоре.",
    "reading_advice": "Дръж се – победата е близо. Вярвай в себе си."
  },
  {
    "reading_id": "love_triangle",
    "reading_name": "Любовен триъгълник",
    "reading_cards": "3 Чаши + 7 Мечове + Дявол",
    "reading_combination": ["three_cups", "seven_swords", "devil"],
    "reading_meaning": "Любовен триъгълник",
    "reading_description": "Трима души в играта. Някой крие нещо. Внимавай – може да си третият, без да знаеш.",
    "reading_advice": "Истината ще излезе. По-добре сега, отколкото после."
  },
  {
    "reading_id": "love_choice",
    "reading_name": "Избор между двама",
    "reading_cards": "3 Чаши + 2 Чаши + 3 Мечове",
    "reading_combination": ["three_cups", "two_cups", "three_swords"],
    "reading_meaning": "Труден избор",
    "reading_description": "Трябва да избереш между двама души. И двамата носят и радост, и болка.",
    "reading_advice": "Слушай сърцето си, не ума. То знае."
  },
  {
    "reading_id": "karmic_love",
    "reading_name": "Кармична любов",
    "reading_cards": "Колело на съдбата + 6 Чаши + 2 Чаши",
    "reading_combination": ["wheel_of_fortune", "six_cups", "two_cups"],
    "reading_meaning": "Кармична среща",
    "reading_description": "Познаваш този човек от минал живот. Имате недовършена работа, която трябва да приключите сега.",
    "reading_advice": "Каквото не научите сега, ще повторите пак. Бъдете внимателни."
  },
{
    "reading_id": "international_success",
    "reading_name": "Международен успех",
    "reading_cards": "6 Жезли + Асо Пентакли + Светът",
    "reading_combination": ["six_wands", "ace_pentacles", "world"],
    "reading_meaning": "Голям кариерен успех",
    "reading_description": "Голям успех в кариерата – повишение, нова работа, собствен бизнес. Международно признание.",
    "reading_advice": "Приеми наградата – заслужил си я. Сега разширявай хоризонтите."
  },
  {
    "reading_id": "business_start",
    "reading_name": "Успешен старт на бизнес",
    "reading_cards": "Асо Жезли + 8 Пентакли + Император",
    "reading_combination": ["ace_wands", "eight_pentacles", "emperor"],
    "reading_meaning": "Нов бизнес проект",
    "reading_description": "Стартиране на собствен бизнес или проект. Имаш идея, упоритост и структура.",
    "reading_advice": "Действай! Това е моментът. Имаш всичко необходимо."
  },
  {
    "reading_id": "job_change",
    "reading_name": "Промяна на работа",
    "reading_cards": "8 Мечове + 6 Мечове + Колесница",
    "reading_combination": ["eight_swords", "six_swords", "chariot"],
    "reading_meaning": "Освобождение от стара работа",
    "reading_description": "Чувствал си се в капан, но сега намираш изход. Напускаш старата работа и тръгваш към нова.",
    "reading_advice": "Не се обръщай назад – водите те носят към по-добро."
  },
  {
    "reading_id": "inheritance",
    "reading_name": "Наследство",
    "reading_cards": "10 Пентакли + 4 Пентакли + Смърт",
    "reading_combination": ["ten_pentacles", "four_pentacles", "death"],
    "reading_meaning": "Получаване на наследство",
    "reading_description": "Получаване на наследство след смърт на роднина. Пари, имот, ценности.",
    "reading_advice": "Приеми с благодарност, но внимавай за алчност и кавги в семейството."
  },
 
  {
    "reading_id": "new_home",
    "reading_name": "Нов дом",
    "reading_cards": "Асо Пентакли + 10 Пентакли + 4 Жезли",
    "reading_combination": ["ace_pentacles", "ten_pentacles", "four_wands"],
    "reading_meaning": "Купуване на имот",
    "reading_description": "Купуване на дом, преместване в ново жилище. Стабилност, сигурност.",
    "reading_advice": "Това е добра инвестиция – домът ще ти носи радост дълги години."
  },
  {
    "reading_id": "family_war",
    "reading_name": "Семейна война",
    "reading_cards": "5 Жезли + 3 Мечове + 7 Мечове",
    "reading_combination": ["five_wands", "three_swords", "seven_swords"],
    "reading_meaning": "Тежки семейни конфликти",
    "reading_description": "Тежки кавги в семейството, тайни, лъжи, наранявания. Спорове за пари или имоти.",
    "reading_advice": "Истината ще излезе. Понякога трябва да прекъснеш връзка, за да спасиш себе си."
  },  {
    "reading_id": "twin_flames",
    "reading_name": "Близнашки пламъци",
    "reading_cards": "Влюбените + 2 Чаши + Колело на съдбата",
    "reading_combination": ["lovers", "two_cups", "wheel_of_fortune"],
    "reading_meaning": "Интензивна кармична връзка",
    "reading_description": "Среща с близнашкия пламък – връзка, която едновременно те изпълва и те предизвиква. Огледало на душата ти, което показва всичко, което трябва да излекуваш.",
    "reading_advice": "Това не е обикновена любов – това е духовно пробуждане. Прегърни уроците, дори да болят."
  },
  {
    "reading_id": "love_at_first_sight",
    "reading_name": "Любов от пръв поглед",
    "reading_cards": "Асо Чаши + 8 Жезли + Слънце",
    "reading_combination": ["ace_cups", "eight_wands", "sun"],
    "reading_meaning": "Магическа среща",
    "reading_description": "Ще преживееш любов от пръв поглед – момент, в който светът спира и виждаш само него/нея. Сякаш сте се познавали от винаги.",
    "reading_advice": "Не анализирай – просто усети. Някои неща се случват, за да променят живота ти завинаги."
  },
  {
    "reading_id": "love_ultimatum",
    "reading_name": "Любовен ултиматум",
    "reading_cards": "Справедливост + 5 Мечове + 4 Жезли",
    "reading_combination": ["justice", "five_swords", "four_wands"],
    "reading_meaning": "Изискване за обвързване",
    "reading_description": "Пред теб е поставен ултиматум – време е да се обвържеш или да продължиш напред. Някой иска яснота за бъдещето ви.",
    "reading_advice": "Не отлагай трудния разговор. Истината, колкото и да боли, е по-добра от несигурността."
  },
  {
    "reading_id": "secret_relationship",
    "reading_name": "Тайна връзка",
    "reading_cards": "Луна + 7 Мечове + 2 Чаши",
    "reading_combination": ["moon", "seven_swords", "two_cups"],
    "reading_meaning": "Скрита афера",
    "reading_description": "Връзка, която криете от света. Тайни срещи, скрити съобщения, прикриване. Вълнуващо, но изтощително.",
    "reading_advice": "Попитай се: защо трябва да е тайна? Истинската любов не се страхува от светлината."
  },
  {
    "reading_id": "lavender_marriage",
    "reading_name": "Лавандулов брак",
    "reading_cards": "Йерофант + 4 Жезли + 7 Мечове",
    "reading_combination": ["hierophant", "four_wands", "seven_swords"],
    "reading_meaning": "Брак за удобство",
    "reading_description": "Брак по сметка или за прикритие. Сключвате съюз, който не е основан на любов, а на удобство, семейни очаквания или социален натиск.",
    "reading_advice": "Истинската свобода идва, когато живееш своята истина, а не чужд сценарий."
  },
  {
    "reading_id": "corporate_climb",
    "reading_name": "Корпоративно израстване",
    "reading_cards": "6 Жезли + Император + 10 Пентакли",
    "reading_combination": ["six_wands", "emperor", "ten_pentacles"],
    "reading_meaning": "Кариерен ръст в компания",
    "reading_description": "Изкачване по корпоративната стълбица. Повишение, нова позиция, по-голяма отговорност и по-високо заплащане.",
    "reading_advice": "Бъди стратегичен, но не забравяй човешките взаимоотношения. Мрежата от контакти е също толкова важна."
  },
  {
    "reading_id": "startup_funding",
    "reading_name": "Финансиране на стартъп",
    "reading_cards": "Асо Пентакли + 8 Жезли + 3 Пентакли",
    "reading_combination": ["ace_pentacles", "eight_wands", "three_pentacles"],
    "reading_meaning": "Получаване на инвестиция",
    "reading_description": "Успешно привличане на инвестиции за стартъп или бизнес идея. Инвеститорите вярват в теб и в проекта ти.",
    "reading_advice": "Представи идеята си с увереност. Твоята страст е заразителна и ще убеди хората да те последват."
  },
  {
    "reading_id": "business_merger",
    "reading_name": "Сливане на компании",
    "reading_cards": "2 Пентакли + 3 Пентакли + 4 Пентакли",
    "reading_combination": ["two_pentacles", "three_pentacles", "four_pentacles"],
    "reading_meaning": "Обединение на бизнеси",
    "reading_description": "Предстои сливане или партньорство между две компании. Обединение на ресурси, клиенти и екипи за по-голям успех.",
    "reading_advice": "Провери добре партньора и документите. Доброто партньорство започва с ясни правила."
  },
  {
    "reading_id": "work_burnout",
    "reading_name": "Прегаряне на работа",
    "reading_cards": "10 Жезли + 4 Мечове + 9 Мечове",
    "reading_combination": ["ten_wands", "four_swords", "nine_swords"],
    "reading_meaning": "Физическо и психическо изтощение",
    "reading_description": "Работиш прекалено много, без почивка и баланс. Близо си до пълно изтощение – физическо, емоционално и психическо.",
    "reading_advice": "СПРИ! Болничният не е опция, а необходимост. Никоя работа не струва здравето ти."
  },
  {
    "reading_id": "workplace_gossip",
    "reading_name": "Офис клюки",
    "reading_cards": "7 Мечове + 5 Жезли + 5 Чаши",
    "reading_combination": ["seven_swords", "five_wands", "five_cups"],
    "reading_meaning": "Интриги зад гърба",
    "reading_description": "В офиса се носят клюки и интриги. Някой говори зад гърба ти или разпространява неверни слухове, които могат да навредят.",
    "reading_advice": "Не се замесвай и не храни клюкарите с реакция. Професионализмът е най-добрият ти отговор."
  },
  {
    "reading_id": "job_offer",
    "reading_name": "Получаване на оферта",
    "reading_cards": "Асо Пентакли + 6 Жезли + 8 Жезли",
    "reading_combination": ["ace_pentacles", "six_wands", "eight_wands"],
    "reading_meaning": "Работно предложение",
    "reading_description": "Получаваш неочаквано предложение за работа. Бързо развитие, добри условия и възможност за растеж.",
    "reading_advice": "Претегли плюсовете и минусите, но не се страхувай да приемеш новото предизвикателство."
  },
  {
    "reading_id": "part_time",
    "reading_name": "Работа на половин ден",
    "reading_cards": "2 Пентакли + 8 Пентакли + 9 Пентакли",
    "reading_combination": ["two_pentacles", "eight_pentacles", "nine_pentacles"],
    "reading_meaning": "Допълнителна заетост",
    "reading_description": "Започваш работа на половин ден или допълнителна заетост към основната. Балансиране на време и енергия между два ангажимента.",
    "reading_advice": "Управлявай времето си добре и не позволявай на допълнителната работа да изтощи основната ти енергия."
  },
  {
    "reading_id": "freelance_success",
    "reading_name": "Успех като фрийлансър",
    "reading_cards": "Асо Пентакли + 8 Пентакли + 6 Жезли",
    "reading_combination": ["ace_pentacles", "eight_pentacles", "six_wands"],
    "reading_meaning": "Процъфтяваща свободна практика",
    "reading_description": "Кариерата ти като фрийлансър върви нагоре. Нови клиенти, добри проекти, финансова стабилност и свобода.",
    "reading_advice": "Продължавай да учиш и да се развиваш. Качеството на работата ти е най-добрата ти реклама."
  },
  {
    "reading_id": "career_doubt",
    "reading_name": "Съмнение в кариерата",
    "reading_cards": "5 Мечове + 7 Чаши + 8 Мечове",
    "reading_combination": ["five_swords", "seven_cups", "eight_swords"],
    "reading_meaning": "Въпроси за професионалния път",
    "reading_description": "Чувстваш се изгубен в кариерата си. Съмняваш се дали това е правилният път, дали си на правилното място.",
    "reading_advice": "Позволи си да експериментираш, без натиск. Понякога трябва да опиташ, за да разбереш."
  },
  {
    "reading_id": "retirement_planning",
    "reading_name": "Планиране на пенсия",
    "reading_cards": "4 Пентакли + 9 Пентакли + 10 Пентакли",
    "reading_combination": ["four_pentacles", "nine_pentacles", "ten_pentacles"],
    "reading_meaning": "Грижа за бъдещето",
    "reading_description": "Започваш да мислиш за пенсия и дългосрочна сигурност. Спестявания, инвестиции, осигуровки. Умно решение.",
    "reading_advice": "Колкото по-рано започнеш да планираш, толкова по-спокойна ще бъде старостта ти."
  },
  {
    "reading_id": "early_retirement",
    "reading_name": "Ранно пенсиониране",
    "reading_cards": "4 Мечове + Отшелник + 10 Пентакли",
    "reading_combination": ["four_swords", "hermit", "ten_pentacles"],
    "reading_meaning": "Освобождаване от работа",
    "reading_description": "Излизаш в ранна пенсия или спираш да работиш активно. Време за себе си, пътувания и неща, които отлагаш с години.",
    "reading_advice": "Наслади се на свободата, но намери смисъл в новите си занимания. Човек има нужда да бъде полезен."
  },
  {
    "reading_id": "health_check",
    "reading_name": "Профилактичен преглед",
    "reading_cards": "4 Мечове + 5 Пентакли + 8 Пентакли",
    "reading_combination": ["four_swords", "five_pentacles", "eight_pentacles"],
    "reading_meaning": "Време за преглед",
    "reading_description": "Важно е да си направиш профилактичен преглед. Не отлагай грижата за здравето си – открито навреме се лекува лесно.",
    "reading_advice": "Запиши си час при лекар. Дори да нямаш симптоми, профилактиката е най-добрата инвестиция."
  },
  {
    "reading_id": "surgery",
    "reading_name": "Операция",
    "reading_cards": "4 Мечове + 10 Мечове + Смърт",
    "reading_combination": ["four_swords", "ten_swords", "death"],
    "reading_meaning": "Предстояща хирургическа намеса",
    "reading_description": "Предстои ти операция или медицинска процедура. Страх и притеснение, но тя е необходима за оздравяването ти.",
    "reading_advice": "Довери се на лекарите и се подготви психически. След операцията идва възстановяване и ново здраве."
  },
  {
    "reading_id": "chronic_illness",
    "reading_name": "Хронично заболяване",
    "reading_cards": "5 Пентакли + 10 Мечове + Луна",
    "reading_combination": ["five_pentacles", "ten_swords", "moon"],
    "reading_meaning": "Дългосрочно лечение",
    "reading_description": "Диагностициране или живот с хронично заболяване. Дълъг път на лечение, търпение и приемане на новата реалност.",
    "reading_advice": "Приеми състоянието си, но не позволявай то да те определя. Много хора живеят пълноценно с хронични болести."
  },
  {
    "reading_id": "healing_crisis",
    "reading_name": "Изцелителна криза",
    "reading_cards": "Смърт + 9 Мечове + Звезда",
    "reading_combination": ["death", "nine_swords", "star"],
    "reading_meaning": "Влошаване преди подобрение",
    "reading_description": "Преминаваш през изцелителна криза – става ти по-зле, преди да стане по-добре. Това е знак, че тялото се лекува.",
    "reading_advice": "Издържи. Това е преходен етап. След бурята идва слънце."
  },
 
  {
    "reading_id": "fertility_treatment",
    "reading_name": "Лечение на фертилитет",
    "reading_cards": "Императрица + 8 Пентакли + Луна",
    "reading_combination": ["empress", "eight_pentacles", "moon"],
    "reading_meaning": "Път към забременяване",
    "reading_description": "Започваш или продължаваш лечение за фертилитет. Емоционален влакче, надежда и разочарования, търпение и постоянство.",
    "reading_advice": "Грижи се за емоционалното си здраве. Този път е тежък – потърси подкрепа и не се обвинявай."
  },
  {
    "reading_id": "surrogacy",
    "reading_name": "Сурогатно майчинство",
    "reading_cards": "Императрица + 6 Чаши + Свят",
    "reading_combination": ["empress", "six_cups", "world"],
    "reading_meaning": "Дете чрез сурогат",
    "reading_description": "Пътят към родителството минава през сурогатна майка. Сложен, емоционален и скъп процес, който води до щастлив край.",
    "reading_advice": "Цени жената, която носи твоето дете. Това е акт на безкрайна щедрост и любов."
  },
  {
    "reading_id": "miscarriage_healing",
    "reading_name": "Лекуване след загуба",
    "reading_cards": "5 Чаши + 4 Мечове + Звезда",
    "reading_combination": ["five_cups", "four_swords", "star"],
    "reading_meaning": "Възстановяване след спонтанен аборт",
    "reading_description": "Процес на възстановяване след загуба на бременност. Първо идва тъгата, после бавно надеждата, а после и новото начало.",
    "reading_advice": "Не бързай. Лекуването има своите етапи. Когато си готова, любовта отново ще те намери."
  },
  {
    "reading_id": "empty_womb",
    "reading_name": "Празна утроба",
    "reading_cards": "8 Чаши + 5 Чаши + Луна",
    "reading_combination": ["eight_cups", "five_cups", "moon"],
    "reading_meaning": "Приемане че няма да има деца",
    "reading_description": "Трудно приемане, че може да нямаш деца. Скръб по никога неродените, по майчинството, което няма да дойде.",
    "reading_advice": "Ти си повече от способността да раждаш. Животът има много форми на плодородие и творчество."
  },
  {
    "reading_id": "child_free",
    "reading_name": "Доброволна бездетност",
    "reading_cards": "4 Мечове + 9 Пентакли + Отшелник",
    "reading_combination": ["four_swords", "nine_pentacles", "hermit"],
    "reading_meaning": "Избор да нямаш деца",
    "reading_description": "Съзнателен избор да не създаваш деца. Решение, което обществото често не разбира, но то носи свобода и мир.",
    "reading_advice": "Ти не дължиш деца на никого. Животът ти е твой и има стойност сам по себе си."
  },
  {
    "reading_id": "spiritual_retreat",
    "reading_name": "Духовно уединение",
    "reading_cards": "Отшелник + 4 Мечове + Върховна жрица",
    "reading_combination": ["hermit", "four_swords", "high_priestess"],
    "reading_meaning": "Време за себе си",
    "reading_description": "Оттегляне за духовно уединение – ретрийт, манастир, планина. Време за мълчание, медитация и връзка с вътрешния глас.",
    "reading_advice": "Отдалечи се от шума на света, за да чуеш шепота на душата си."
  },
  {
    "reading_id": "chakra_healing",
    "reading_name": "Лечение на чакри",
    "reading_cards": "Върховна жрица + 4 Мечове + 8 Пентакли",
    "reading_combination": ["high_priestess", "four_swords", "eight_pentacles"],
    "reading_meaning": "Енергийно лечение",
    "reading_description": "Работа по енергийната ти система – чакри, аура, енергийни канали. Възстановяване на баланса и хармонията.",
    "reading_advice": "Потърси опитен лечител или се научи сам да балансираш енергията си. Тялото ти помни всичко."
  },
  {
    "reading_id": "past_life_regression",
    "reading_name": "Регресия в минал живот",
    "reading_cards": "Луна + 6 Чаши + Върховна жрица",
    "reading_combination": ["moon", "six_cups", "high_priestess"],
    "reading_meaning": "Спомени от предишно въплъщение",
    "reading_description": "Преживяване на регресия в минал живот. Виждаш образи, хора, ситуации, които обясняват сегашните ти страхове и модели.",
    "reading_advice": "Записвай всичко, което виждаш. Тези спомени носят ключове за изцеление в настоящето."
  },
  {
    "reading_id": "mediumship",
    "reading_name": "Връзка с отвъдното",
    "reading_cards": "Върховна жрица + 6 Чаши + Луна",
    "reading_combination": ["high_priestess", "six_cups", "moon"],
    "reading_meaning": "Контакт с починали",
    "reading_description": "Развиване на медиумни способности или контакт с починал близък. Той идва да ти каже, че е добре и те обича.",
    "reading_advice": "Не се страхувай. Любовта не умира – тя просто сменя формата си."
  },
  {
    "reading_id": "angel_contact",
    "reading_name": "Контакт с ангели",
    "reading_cards": "Звезда + Умереност + Върховна жрица",
    "reading_combination": ["star", "temperance", "high_priestess"],
    "reading_meaning": "Ангелска закрила",
    "reading_description": "Усещаш присъствието на ангели или духовни водачи около теб. Знаци, синхроничности, вътрешен мир и закрила.",
    "reading_advice": "Благодари и поискай помощ. Ангелите чакат да ги поканиш в живота си."
  },
  {
    "reading_id": "kundalini",
    "reading_name": "Пробуждане на Кундалини",
    "reading_cards": "Смърт + Дявол + Върховна жрица",
    "reading_combination": ["death", "devil", "high_priestess"],
    "reading_meaning": "Духовна енергия се издига",
    "reading_description": "Преживяваш пробуждане на Кундалини – интензивна енергия, която се издига по гръбнака. Промяна в съзнанието, физически усещания, емоционални вълни.",
    "reading_advice": "Потърси опитен учител. Този процес е мощен и може да бъде непосилен без правилно напътствие."
  },
  {
    "reading_id": "dream_interpretation",
    "reading_name": "Тълкуване на сънища",
    "reading_cards": "Луна + Върховна жрица + 9 Мечове",
    "reading_combination": ["moon", "high_priestess", "nine_swords"],
    "reading_meaning": "Сънищата носят послания",
    "reading_description": "Сънищата ти са ярки, странни, повтарящи се. Те носят важни послания от подсъзнанието ти, които сега излизат на повърхността.",
    "reading_advice": "Записвай сънищата веднага след събуждане. Те са мост към вътрешната ти мъдрост."
  },
  {
    "reading_id": "synchronicity",
    "reading_name": "Синхроничности",
    "reading_cards": "Магьосник + Колело на съдбата + 8 Жезли",
    "reading_combination": ["magician", "wheel_of_fortune", "eight_wands"],
    "reading_meaning": "Знаци от Вселената",
    "reading_description": "Забелязваш все повече синхроничности – еднакви числа, случайни срещи, повтарящи се теми. Вселената ти говори.",
    "reading_advice": "Обръщай внимание на знаците. Те не са случайни – те са пътеки към съдбата ти."
  },
  {
    "reading_id": "spiritual_emergency",
    "reading_name": "Духовна криза",
    "reading_cards": "Кула + 9 Мечове + Луна",
    "reading_combination": ["tower", "nine_swords", "moon"],
    "reading_meaning": "Срив на представите",
    "reading_description": "Преживяваш духовна криза – всичко, в което си вярвал, се срива. Чувстваш се изгубен, дезориентиран, сам.",
    "reading_advice": "Това не е лудост, а трансформация. Потърси подкрепа от хора, които разбират духовните процеси."
  },
  {
    "reading_id": "witchcraft",
    "reading_name": "Магическа практика",
    "reading_cards": "Върховна жрица + Магьосник + Луна",
    "reading_combination": ["high_priestess", "magician", "moon"],
    "reading_meaning": "Занимание с магия",
    "reading_description": "Започваш или задълбочаваш магическа практика. Работа с енергии, ритуали, заклинания, луна и природа.",
    "reading_advice": "Практикувай с чисти намерения и уважение. Магията е инструмент, не играчка."
  },
  {
    "reading_id": "sacred_place",
    "reading_name": "Посещение на свещено място",
    "reading_cards": "Йерофант + 6 Мечове + Свят",
    "reading_combination": ["hierophant", "six_swords", "world"],
    "reading_meaning": "Поклонничество",
    "reading_description": "Посещение на свещено място – храм, манастир, древни руини, природно място със специална енергия. Поклоннически път.",
    "reading_advice": "Отвори сърцето си за енергията на мястото. То носи мъдростта на вековете."
  },
  {
    "reading_id": "spiritual_teacher",
    "reading_name": "Среща с духовен учител",
    "reading_cards": "Йерофант + Отшелник + Слънце",
    "reading_combination": ["hierophant", "hermit", "sun"],
    "reading_meaning": "Мъдър водач",
    "reading_description": "Срещаш духовен учител или гуру, който променя живота ти. Думите му резонират дълбоко в душата ти.",
    "reading_advice": "Слушай, учи и прилагай. Истинският учител не ти дава риба, а те учи да ловиш."
  },
  {
    "reading_id": "ascension",
    "reading_name": "Духовно издигане",
    "reading_cards": "Смърт + Звезда + Свят",
    "reading_combination": ["death", "star", "world"],
    "reading_meaning": "Преход към по-високо ниво",
    "reading_description": "Преминаваш през процес на духовно издигане. Оставяш старото, лекуваш дълбоките рани и излизаш на ново ниво на съзнание.",
    "reading_advice": "Ти не си същият човек. Приеми новата си идентичност и сподели светлината си със света."
  },
  {
    "reading_id": "cosmic_connection",
    "reading_name": "Космическа връзка",
    "reading_cards": "Звезда + Свят + Влюбените",
    "reading_combination": ["star", "world", "lovers"],
    "reading_meaning": "Любов от други измерения",
    "reading_description": "Усещаш връзка с някого, който сякаш не е от този свят. Космическа любов, която надхвърля времето и пространството.",
    "reading_advice": "Това е рядка и специална връзка. Цени я, без да се опитваш да я ограничаваш в човешки рамки."
  },
  {
    "reading_id": "galactic_origin",
    "reading_name": "Звезден произход",
    "reading_cards": "Звезда + Луна + Свят",
    "reading_combination": ["star", "moon", "world"],
    "reading_meaning": "Спомен за други светове",
    "reading_description": "Чувстваш, че не си от този свят. Носталгия по звездите, спомени за други планети, усещане за извънземен произход.",
    "reading_advice": "Ти си тук с мисия. Открий каква е и я изпълни. Семената на звездите носят светлина на Земята."
  },
  {
    "reading_id": "love_confession",
    "reading_name": "Признание в любов",
    "reading_cards": "Асо Чаши + 3 Чаши + Слънце",
    "reading_combination": ["ace_cups", "three_cups", "sun"],
    "reading_meaning": "Някой ще ти признае любов",
    "reading_description": "Очаквай неочаквано признание в любов. Някой дълго е крил чувствата си и най-накрая намира смелост да ги разкрие.",
    "reading_advice": "Изслушай с отворено сърце. Дори отговорът ти да е 'не', бъди нежен - признанието изисква смелост."
  },
  {
    "reading_id": "love_failure",
    "reading_name": "Разочарование в любовта",
    "reading_cards": "3 Мечове + 5 Чаши + 8 Чаши",
    "reading_combination": ["three_swords", "five_cups", "eight_cups"],
    "reading_meaning": "Болка от отхвърляне",
    "reading_description": "Чувстваш се отхвърлен, неразбран и самотен. Любовта не се получи така, както си мечтал. Болката е истинска.",
    "reading_advice": "Позволи си да скърбиш, но не се заключвай в тъгата. След всяка загуба идва ново начало."
  },
  {
    "reading_id": "love_maturity",
    "reading_name": "Зряла любов",
    "reading_cards": "2 Чаши + Умереност + 10 Чаши",
    "reading_combination": ["two_cups", "temperance", "ten_cups"],
    "reading_meaning": "Любов след години",
    "reading_description": "Връзка, която е издържала изпитанието на времето. Спокойна, сигурна, задълбочена - любов, която не се нуждае от драма.",
    "reading_advice": "Ценете се един друг. Това, което имате, е рядкост - истинска, зряла любов."
  },
  {
    "reading_id": "love_obsession",
    "reading_name": "Обсебваща любов",
    "reading_cards": "Дявол + 7 Мечове + 9 Мечове",
    "reading_combination": ["devil", "seven_swords", "nine_swords"],
    "reading_meaning": "Нездрава привързаност",
    "reading_description": "Любовта ти прилича повече на обсебване. Ревност, контрол, страх от загуба. Това не е любов, а зависимост.",
    "reading_advice": "Освободи се от веригите, дори да боли. Нездравата любов унищожава и двамата."
  },
  {
    "reading_id": "love_rejection",
    "reading_name": "Отхвърляне",
    "reading_cards": "3 Мечове + 5 Чаши + 8 Мечове",
    "reading_combination": ["three_swords", "five_cups", "eight_swords"],
    "reading_meaning": "Чувстваш се нежелан",
    "reading_description": "Чувстваш се отхвърлен и нежелан. Сякаш не си достатъчно добър. Болката те парализира.",
    "reading_advice": "Тяхното 'не' не определя твоята стойност. Някой ден някой ще каже 'да' точно на теб."
  },
  {
    "reading_id": "love_vacation",
    "reading_name": "Ваканционен романс",
    "reading_cards": "8 Жезли + 3 Чаши + 6 Чаши",
    "reading_combination": ["eight_wands", "three_cups", "six_cups"],
    "reading_meaning": "Любов по време на почивка",
    "reading_description": "По време на почивка или пътуване ще преживееш кратък, но интензивен романс. Среща, която остава спомен за цял живот.",
    "reading_advice": "Наслаждавай се на момента, без очаквания за бъдеще. Някои неща са красиви точно защото са кратки."
  },
  {
    "reading_id": "love_home",
    "reading_name": "Домашен уют в любовта",
    "reading_cards": "4 Жезли + 10 Чаши + 9 Пентакли",
    "reading_combination": ["four_wands", "ten_cups", "nine_pentacles"],
    "reading_meaning": "Щастие в ежедневието",
    "reading_description": "Щастието не е в големите жестове, а в малките моменти - закуска заедно, филм в събота, разходка в парка. Това е истинската любов.",
    "reading_advice": "Не търси драма и страст на всяка цена. Тихите води са най-дълбоки."
  },
  {
    "reading_id": "love_distance",
    "reading_name": "Любов през океан",
    "reading_cards": "8 Чаши + 2 Чаши + 6 Мечове",
    "reading_combination": ["eight_cups", "two_cups", "six_swords"],
    "reading_meaning": "Връзка през континенти",
    "reading_description": "Любов, разделена от хиляди километри и часови разлики. Срещите са редки, но емоцията е силна.",
    "reading_advice": "Планирайте следващата среща още щом се разделите. Надеждата е това, което държи връзката жива."
  },
  {
    "reading_id": "love_break_upside",
    "reading_name": "Положителна страна на раздялата",
    "reading_cards": "8 Чаши + Звезда + Асо Чаши",
    "reading_combination": ["eight_cups", "star", "ace_cups"],
    "reading_meaning": "След раздяла идва ново начало",
    "reading_description": "Раздялата, колкото и да боли, ти отваря врата за нещо ново. Освобождаваш място за човек, който наистина те заслужава.",
    "reading_advice": "Благодари на миналото за уроците и отвори сърце за бъдещето. Най-доброто тепърва предстои."
  },
  {
    "reading_id": "love_compromise",
    "reading_name": "Компромис в любовта",
    "reading_cards": "2 Пентакли + 2 Чаши + Умереност",
    "reading_combination": ["two_pentacles", "two_cups", "temperance"],
    "reading_meaning": "Даване и вземане",
    "reading_description": "Връзката изисква компромиси и от двамата. Баланс между 'аз' и 'ние', между твоите и неговите нужди.",
    "reading_advice": "Компромисът не означава да се пречупиш. Означава да намериш средата, в която и двамата сте щастливи."
  },
  {
    "reading_id": "love_fight",
    "reading_name": "Любовна кавга",
    "reading_cards": "5 Жезли + 3 Мечове + 2 Чаши",
    "reading_combination": ["five_wands", "three_swords", "two_cups"],
    "reading_meaning": "Спор с любимия",
    "reading_description": "Предстои ви кавга с любимия човек. Думи, които ще наранят, напрежение, което тежи. Но това е част от връзката.",
    "reading_advice": "Не казвай неща, които после ще съжаляваш. След бурята винаги идва спокойствие."
  },
  {
    "reading_id": "love_make_up",
    "reading_name": "Помирение след кавга",
    "reading_cards": "2 Чаши + 6 Чаши + Слънце",
    "reading_combination": ["two_cups", "six_cups", "sun"],
    "reading_meaning": "Сладко помирение",
    "reading_description": "След кавгата идва най-сладката част - помирението. Прегръдки, сълзи, разбиране и любов, която е още по-силна.",
    "reading_advice": "Използвайте конфликтите, за да се опознаете по-добре. Всяка преодоляна криза ви прави по-силни."
  },
  {
    "reading_id": "love_proposal_reject",
    "reading_name": "Отказ на предложение",
    "reading_cards": "3 Мечове + 5 Чаши + Справедливост",
    "reading_combination": ["three_swords", "five_cups", "justice"],
    "reading_meaning": "Казаха 'не'",
    "reading_description": "Предложението ти за брак или обвързване беше отказано. Болка, унижение, разочарование. Светът ти се срива.",
    "reading_advice": "Това не е край, а пренасочване. Някой ден ще срещнеш човек, който ще каже 'да' без колебание."
  },
  {
    "reading_id": "love_second_chance",
    "reading_name": "Втори шанс",
    "reading_cards": "6 Чаши + 2 Чаши + Умереност",
    "reading_combination": ["six_cups", "two_cups", "temperance"],
    "reading_meaning": "Опитвате отново",
    "reading_description": "Решавате да дадете втори шанс на връзката си. Този път и двамата сте по-зрели, по-мъдри и по-наясно какво искате.",
    "reading_advice": "Простете истински и започнете на чисто. Носенето на стари рани ще убие и втория шанс."
  },
  {
    "reading_id": "love_independence",
    "reading_name": "Независимост в любовта",
    "reading_cards": "9 Пентакли + 2 Чаши + 4 Мечове",
    "reading_combination": ["nine_pentacles", "two_cups", "four_swords"],
    "reading_meaning": "Обичаш, но си свободен",
    "reading_description": "Намерил си баланса между любов и лична свобода. Обичаш, но не си зависим. Това е зрялата любов.",
    "reading_advice": "Цени тази динамика. Тя е рядка и ценна."
  },
  {
    "reading_id": "family_dinner",
    "reading_name": "Семейна вечеря",
    "reading_cards": "3 Чаши + 4 Жезли + 10 Чаши",
    "reading_combination": ["three_cups", "four_wands", "ten_cups"],
    "reading_meaning": "Всички заедно",
    "reading_description": "Семейна вечеря или събиране, на което всички присъстват. Смях, спомени, любими ястия и усещане за принадлежност.",
    "reading_advice": "Остави телефона и бъди истински там. Тези моменти няма да се повторят."
  },
  {
    "reading_id": "family_crisis",
    "reading_name": "Семейна криза",
    "reading_cards": "Кула + 5 Чаши + 3 Мечове",
    "reading_combination": ["tower", "five_cups", "three_swords"],
    "reading_meaning": "Сериозен проблем в семейството",
    "reading_description": "Семейството преминава през тежка криза - болест, загуба, скандал, раздяла. Всичко се променя.",
    "reading_advice": "Дръжте се един за друг. В криза семейството или се разпада, или става по-силно."
  },
  {
    "reading_id": "family_support",
    "reading_name": "Подкрепа от семейството",
    "reading_cards": "6 Пентакли + 10 Чаши + 4 Жезли",
    "reading_combination": ["six_pentacles", "ten_cups", "four_wands"],
    "reading_meaning": "Семейството те подкрепя",
    "reading_description": "В труден момент семейството застава зад теб. Финансова помощ, емоционална подкрепа, подслон - те са там.",
    "reading_advice": "Приеми помощта с благодарност. Някой ден ще имаш възможност да върнеш жеста."
  },
  {
    "reading_id": "family_estrangement",
    "reading_name": "Отчуждение от семейството",
    "reading_cards": "8 Чаши + 5 Чаши + 3 Мечове",
    "reading_combination": ["eight_cups", "five_cups", "three_swords"],
    "reading_meaning": "Прекъсване на връзка с роднини",
    "reading_description": "Решаваш да прекъснеш връзка с част от семейството си. Трудно решение, но необходимо за твоето здраве и мир.",
    "reading_advice": "Не се чувствай виновен. Понякога най-здравословното нещо е да се отдалечиш от токсичните хора, дори да са роднини."
  },
  {
    "reading_id": "sibling_rivalry",
    "reading_name": "Съперничество с брат/сестра",
    "reading_cards": "5 Жезли + 5 Мечове + 7 Мечове",
    "reading_combination": ["five_wands", "five_swords", "seven_swords"],
    "reading_meaning": "Конфликт с брат или сестра",
    "reading_description": "Конфликт с брат или сестра - стари съперничества, ревност, неразрешени спорове от детството излизат на повърхността.",
    "reading_advice": "Опитайте се да говорите като възрастни. Детските съперничества нямат място в зрелия живот."
  },
  {
    "reading_id": "sibling_bond",
    "reading_name": "Задруга с брат/сестра",
    "reading_cards": "3 Чаши + 6 Чаши + 10 Чаши",
    "reading_combination": ["three_cups", "six_cups", "ten_cups"],
    "reading_meaning": "Силна връзка с брат/сестра",
    "reading_description": "Засилване на връзката с брат или сестра. Споделяне, подкрепа, общи спомени и радостта да имаш човек, който те познава от винаги.",
    "reading_advice": "Ценете тази връзка. Братята и сестрите са единствените хора, които са били с теб през целия ти път."
  },
  {
    "reading_id": "parents_aging",
    "reading_name": "Застаряващи родители",
    "reading_cards": "5 Пентакли + 4 Мечове + 10 Пентакли",
    "reading_combination": ["five_pentacles", "four_swords", "ten_pentacles"],
    "reading_meaning": "Грижа за възрастни родители",
    "reading_description": "Родителите ти застаряват и имат нужда от повече грижи. Обръщане на ролите - ти ставаш родител на своите родители.",
    "reading_advice": "Бъди търпелив и благодарен. Те са се грижили за теб - сега е твой ред."
  },
  {
    "reading_id": "parents_divorce_late",
    "reading_name": "Развод на родители",
    "reading_cards": "Кула + 3 Мечове + 5 Чаши",
    "reading_combination": ["tower", "three_swords", "five_cups"],
    "reading_meaning": "Родителите се разделят",
    "reading_description": "Родителите ти се разделят или развеждат, въпреки че си възрастен. Това разтърсва представата ти за семейство.",
    "reading_advice": "Не заставай на страна. Те остават твои родители, дори вече да не са двойка."
  },
  {
    "reading_id": "family_addiction",
    "reading_name": "Зависимост в семейството",
    "reading_cards": "Дявол + 5 Пентакли + 9 Мечове",
    "reading_combination": ["devil", "five_pentacles", "nine_swords"],
    "reading_meaning": "Проблем с алкохол/наркотици",
    "reading_description": "Някой в семейството има проблем със зависимости - алкохол, хазарт, наркотици. Това засяга всички.",
    "reading_advice": "Потърси помощ - Анонимни алкохолици, терапия, консултации. Не можеш да спасиш човек, който не иска да бъде спасен."
  },
  {
    "reading_id": "family_intervention",
    "reading_name": "Интервенция",
    "reading_cards": "Справедливост + 5 Мечове + 8 Мечове",
    "reading_combination": ["justice", "five_swords", "eight_swords"],
    "reading_meaning": "Семейството се намесва",
    "reading_description": "Семейството организира интервенция за член със зависимости или проблеми. Труден, но необходим разговор.",
    "reading_advice": "Говорете с любов, не с обвинения. Целта е да помогнете, не да накажете."
  },
  {
    "reading_id": "family_secret_revealed",
    "reading_name": "Разкрита семейна тайна",
    "reading_cards": "Луна + 7 Мечове + Съд",
    "reading_combination": ["moon", "seven_swords", "judgement"],
    "reading_meaning": "Тайна излиза наяве",
    "reading_description": "Семейна тайна, пазена с години, най-после излиза наяве. Рождение, осиновяване, изневяра, престъпление - истината вече не може да се крие.",
    "reading_advice": "Истината лекува, дори да боли. След като всичко излезе наяве, можете да започнете да лекувате раните."
  },
  {
    "reading_id": "family_forgiveness",
    "reading_name": "Прошка в семейството",
    "reading_cards": "6 Чаши + Умереност + 10 Чаши",
    "reading_combination": ["six_cups", "temperance", "ten_cups"],
    "reading_meaning": "Помирение след дълго време",
    "reading_description": "След години на отчуждение идва прошката и помирението. Семейството отново се събира, старите рани заздравяват.",
    "reading_advice": "Прости, дори да не забравиш. Носенето на омраза тежи само на теб."
  },
  {
    "reading_id": "child_school",
    "reading_name": "Детето тръгва на училище",
    "reading_cards": "8 Пентакли + 4 Жезли + 6 Жезли",
    "reading_combination": ["eight_pentacles", "four_wands", "six_wands"],
    "reading_meaning": "Първи учебен ден",
    "reading_description": "Детето ти тръгва на училище за първи път. Гордост, тъга, притеснение - емоционален микс от чувства.",
    "reading_advice": "Наслади се на този преход. Той бележи израстването на детето ти и твоето като родител."
  },
  {
    "reading_id": "child_teen",
    "reading_name": "Тийнейджърски години",
    "reading_cards": "5 Жезли + 7 Мечове + Луна",
    "reading_combination": ["five_wands", "seven_swords", "moon"],
    "reading_meaning": "Бунтарски период",
    "reading_description": "Детето ти навлиза в тийнейджърските години - бунт, тайни, промени в настроението. Труден период за цялото семейство.",
    "reading_advice": "Бъди търпелив и присъстващ. Колкото и да се бунтува, той/тя все още има нужда от теб."
  },
  {
    "reading_id": "child_graduate",
    "reading_name": "Завършване на детето",
    "reading_cards": "6 Жезли + 10 Пентакли + Свят",
    "reading_combination": ["six_wands", "ten_pentacles", "world"],
    "reading_meaning": "Гордост от детето",
    "reading_description": "Детето ти завършва образование, постига успех. Гордост, щастие, вълнение - трудът ти се отплаща.",
    "reading_advice": "Празнувай този успех заедно. Това е и твой успех като родител."
  },
  {
    "reading_id": "business_plan",
    "reading_name": "Бизнес план",
    "reading_cards": "Асо Жезли + 8 Пентакли + Император",
    "reading_combination": ["ace_wands", "eight_pentacles", "emperor"],
    "reading_meaning": "Създаване на бизнес план",
    "reading_description": "Разработваш детайлен бизнес план за нова идея или проект. Структура, анализи, прогнози - всичко е на място.",
    "reading_advice": "Добрият план е половината успех. Инвестирай време в детайлите."
  },
  {
    "reading_id": "business_pitch",
    "reading_name": "Представяне на идея",
    "reading_cards": "Магьосник + 6 Жезли + 8 Жезли",
    "reading_combination": ["magician", "six_wands", "eight_wands"],
    "reading_meaning": "Успешно презентиране",
    "reading_description": "Предстои ти представяне на бизнес идея пред инвеститори или партньори. Ще впечатлиш и ще получиш зелена светлина.",
    "reading_advice": "Вярвай в идеята си и говори със страст. Убедеността ти е заразителна."
  },
  {
    "reading_id": "business_competition",
    "reading_name": "Конкуренция",
    "reading_cards": "5 Жезли + 7 Мечове + 5 Мечове",
    "reading_combination": ["five_wands", "seven_swords", "five_swords"],
    "reading_meaning": "Борба с конкуренти",
    "reading_description": "Конкуренцията в бранша се засилва. Някой се опитва да ти вземе клиенти, идеи или пазарен дял.",
    "reading_advice": "Наблюдавай конкурентите, но не се фиксирай върху тях. Фокусирай се върху собственото си развитие."
  },
  {
    "reading_id": "business_innovation",
    "reading_name": "Иновация",
    "reading_cards": "Асо Жезли + Магьосник + Слънце",
    "reading_combination": ["ace_wands", "magician", "sun"],
    "reading_meaning": "Новаторска идея",
    "reading_description": "Хрумва ти иновативна идея, която може да промени бизнеса ти. Творчество, вдъхновение, уникалност.",
    "reading_advice": "Действай бързо, докато идеята е свежа. Иновациите не чакат."
  },
  {
    "reading_id": "business_expansion",
    "reading_name": "Разширяване на бизнес",
    "reading_cards": "8 Жезли + 10 Пентакли + Свят",
    "reading_combination": ["eight_wands", "ten_pentacles", "world"],
    "reading_meaning": "Излизане на нови пазари",
    "reading_description": "Бизнесът ти се разширява - нови локации, нови пазари, нови продукти. Растеж и развитие.",
    "reading_advice": "Разширявай се внимателно и обмислено. Бързият растеж крие рискове."
  },
  {
    "reading_id": "business_downsize",
    "reading_name": "Свиване на бизнес",
    "reading_cards": "5 Пентакли + 8 Мечове + 10 Жезли",
    "reading_combination": ["five_pentacles", "eight_swords", "ten_wands"],
    "reading_meaning": "Намаляване на мащаба",
    "reading_description": "Наложено е да свиеш бизнеса си - съкращения, затваряне на офиси, намаляване на разходи. Труден период.",
    "reading_advice": "Прави каквото трябва, за да оцелееш. По-малкото може да бъде по-добро."
  },
  {
    "reading_id": "business_sale",
    "reading_name": "Продажба на бизнес",
    "reading_cards": "10 Пентакли + 6 Жезли + Свят",
    "reading_combination": ["ten_pentacles", "six_wands", "world"],
    "reading_meaning": "Успешна продажба",
    "reading_description": "Продаваш бизнеса си след години труд. Добра цена, доволни купувачи, чувство на завършеност.",
    "reading_advice": "Наслади се на постижението. Ти построи нещо ценно."
  },
  {
    "reading_id": "business_buy",
    "reading_name": "Закупуване на бизнес",
    "reading_cards": "Асо Пентакли + 4 Пентакли + 10 Пентакли",
    "reading_combination": ["ace_pentacles", "four_pentacles", "ten_pentacles"],
    "reading_meaning": "Придобиване на компания",
    "reading_description": "Закупуваш съществуващ бизнес или дял от компания. Инвестиция в нещо вече изградено.",
    "reading_advice": "Провери добре финансите и дълговете. Купуваш не само активи, но и проблеми."
  },
  {
    "reading_id": "business_franchise",
    "reading_name": "Франчайз",
    "reading_cards": "3 Пентакли + 8 Пентакли + 10 Пентакли",
    "reading_combination": ["three_pentacles", "eight_pentacles", "ten_pentacles"],
    "reading_meaning": "Закупуване на франчайз",
    "reading_description": "Закупуваш франчайз - доказан бизнес модел с подкрепа и обучение. По-сигурен път към предприемачество.",
    "reading_advice": "Следвай системата, но добави и нещо свое. Успехът идва от баланса между правила и индивидуалност."
  },
  {
    "reading_id": "business_network",
    "reading_name": "Мрежа от контакти",
    "reading_cards": "3 Чаши + 6 Пентакли + 8 Жезли",
    "reading_combination": ["three_cups", "six_pentacles", "eight_wands"],
    "reading_meaning": "Разширяване на връзки",
    "reading_description": "Разширяваш професионалната си мрежа - нови контакти, партньорства, възможности. Връзките са злато.",
    "reading_advice": "Инвестирай време в изграждане на истински връзки, не просто в събиране на визитки."
  },
  {
    "reading_id": "business_mentor",
    "reading_name": "Бизнес ментор",
    "reading_cards": "Йерофант + 8 Пентакли + 9 Пентакли",
    "reading_combination": ["hierophant", "eight_pentacles", "nine_pentacles"],
    "reading_meaning": "Среща с наставник",
    "reading_description": "Срещаш бизнес ментор, който ти помага да избегнеш грешки и да се развиваш по-бързо. Безценна помощ.",
    "reading_advice": "Слушай и учи, но не забравяй собствения си глас. Менторът е пътеводител, не господар."
  },
  {
    "reading_id": "business_mistake",
    "reading_name": "Бизнес грешка",
    "reading_cards": "5 Мечове + 7 Мечове + 8 Мечове",
    "reading_combination": ["five_swords", "seven_swords", "eight_swords"],
    "reading_meaning": "Скъпа грешка",
    "reading_description": "Допуснал си грешка в бизнеса, която ти коства пари, време или репутация. Чувстваш се унил и разочарован.",
    "reading_advice": "Грешките са уроци, маскирани като провали. Анализирай, учи и продължавай напред."
  },
  {
    "reading_id": "business_recovery",
    "reading_name": "Възстановяване на бизнес",
    "reading_cards": "8 Пентакли + 6 Жезли + Звезда",
    "reading_combination": ["eight_pentacles", "six_wands", "star"],
    "reading_meaning": "След криза идва възход",
    "reading_description": "След период на криза бизнесът ти започва да се възстановява. Нови клиенти, подобрени финанси, надежда.",
    "reading_advice": "Продължавай да работиш упорито. Възходът изисква постоянство."
  },
  {
    "reading_id": "business_exit",
    "reading_name": "Излизане от бизнес",
    "reading_cards": "8 Чаши + 10 Пентакли + Отшелник",
    "reading_combination": ["eight_cups", "ten_pentacles", "hermit"],
    "reading_meaning": "Напускане на бизнеса",
    "reading_description": "Решаваш да излезеш от бизнеса, който си създал. Продажба, предаване на щафетата, ново начало.",
    "reading_advice": "Тръгни си с гордост. Ти остави следа."
  },
  {
    "reading_id": "business_legacy",
    "reading_name": "Бизнес наследство",
    "reading_cards": "10 Пентакли + 4 Жезли + Император",
    "reading_combination": ["ten_pentacles", "four_wands", "emperor"],
    "reading_meaning": "Предаване на бизнеса",
    "reading_description": "Предаваш бизнеса на следващото поколение - деца, наследници. Осигуряване на бъдещето и продължаване на рода.",
    "reading_advice": "Предай не само активите, но и ценностите, които са те водили."
  },
  {
    "reading_id": "health_diagnosis",
    "reading_name": "Диагноза",
    "reading_cards": "8 Мечове + 5 Пентакли + 10 Мечове",
    "reading_combination": ["eight_swords", "five_pentacles", "ten_swords"],
    "reading_meaning": "Получаване на диагноза",
    "reading_description": "Получаваш медицинска диагноза, която променя живота ти. Шок, страх, объркване - свят се срива.",
    "reading_advice": "Дай си време да приемеш новината. После действай - потърси второ мнение, информирай се, бори се."
  },
  {
    "reading_id": "health_second_opinion",
    "reading_name": "Второ мнение",
    "reading_cards": "Справедливост + 8 Мечове + 4 Мечове",
    "reading_combination": ["justice", "eight_swords", "four_swords"],
    "reading_meaning": "Търсене на друг лекар",
    "reading_description": "Търсиш второ медицинско мнение. Не си сигурен в първоначалната диагноза и искаш да се увериш.",
    "reading_advice": "Винаги търси второ мнение при сериозни заболявания. Различните лекари имат различен опит."
  },
  {
    "reading_id": "health_alternative",
    "reading_name": "Алтернативно лечение",
    "reading_cards": "Върховна жрица + 4 Мечове + 8 Пентакли",
    "reading_combination": ["high_priestess", "four_swords", "eight_pentacles"],
    "reading_meaning": "Неконвенционални методи",
    "reading_description": "Започваш алтернативно лечение - билки, акупунктура, хомеопатия, енергийно лечение. Допълнение към конвенционалната медицина.",
    "reading_advice": "Информирай се добре и не спирай конвенционалното лечение без консултация."
  },
  {
    "reading_id": "health_diet",
    "reading_name": "Диета",
    "reading_cards": "8 Пентакли + 4 Мечове + 9 Пентакли",
    "reading_combination": ["eight_pentacles", "four_swords", "nine_pentacles"],
    "reading_meaning": "Започване на диета",
    "reading_description": "Започваш нова диета или хранителен режим. Грижа за тялото, желание за промяна, подобряване на здравето.",
    "reading_advice": "Бъди търпелив. Здравословните навици се изграждат бавно, но траят дълго."
  },
  {
    "reading_id": "health_exercise",
    "reading_name": "Започване на спорт",
    "reading_cards": "8 Жезли + Сила + Слънце",
    "reading_combination": ["eight_wands", "strength", "sun"],
    "reading_meaning": "Нова спортна дейност",
    "reading_description": "Започваш да спортуваш или се връщаш към активен начин на живот. Енергия, мотивация, грижа за себе си.",
    "reading_advice": "Намери спорт, който наистина ти харесва. Така ще го правиш с удоволствие, а не задължение."
  },
  {
    "reading_id": "health_injury",
    "reading_name": "Контузия",
    "reading_cards": "5 Мечове + 10 Мечове + 4 Мечове",
    "reading_combination": ["five_swords", "ten_swords", "four_swords"],
    "reading_meaning": "Физическо нараняване",
    "reading_description": "Претърпяваш контузия или нараняване, което те ограничава. Болка, спиране на активността, възстановяване.",
    "reading_advice": "Слушай лекарите и не бързай да се връщаш към активност. Възстановяването изисква време."
  },
  {
    "reading_id": "health_physical_therapy",
    "reading_name": "Физиотерапия",
    "reading_cards": "8 Пентакли + 4 Мечове + 6 Пентакли",
    "reading_combination": ["eight_pentacles", "four_swords", "six_pentacles"],
    "reading_meaning": "Рехабилитация",
    "reading_description": "Започваш физиотерапия или рехабилитация след травма или болест. Бавно, но сигурно възстановяване.",
    "reading_advice": "Бъди търпелив и постоянен. Всяко упражнение те приближава към пълното възстановяване."
  },
  {
    "reading_id": "health_massage",
    "reading_name": "Масаж",
    "reading_cards": "4 Мечове + 9 Пентакли + 3 Чаши",
    "reading_combination": ["four_swords", "nine_pentacles", "three_cups"],
    "reading_meaning": "Релакс и възстановяване",
    "reading_description": "Отделяш време за масаж, СПА или релакс. Грижа за тялото, отпускане, зареждане с енергия.",
    "reading_advice": "Прави го редовно. Грижата за тялото не е лукс, а необходимост."
  },
  {
    "reading_id": "health_mental_break",
    "reading_name": "Психическа почивка",
    "reading_cards": "4 Мечове + Отшелник + 9 Мечове",
    "reading_combination": ["four_swords", "hermit", "nine_swords"],
    "reading_meaning": "Почивка от стреса",
    "reading_description": "Имаш нужда от психическа почивка - от социални мрежи, новини, задължения. Твърде много информация и стрес те натоварват.",
    "reading_advice": "Направи дигитален детокс. Изключи телефона, излез сред природа, бъди сам със себе си."
  },
  {
    "reading_id": "health_balance",
    "reading_name": "Баланс в живота",
    "reading_cards": "Умереност + 4 Мечове + 10 Чаши",
    "reading_combination": ["temperance", "four_swords", "ten_cups"],
    "reading_meaning": "Хармония между тяло и дух",
    "reading_description": "Намираш баланс между работа, почивка, здраве и семейство. Чувстваш се цялостен и удовлетворен.",
    "reading_advice": "Пази този баланс. Той е ключът към дълъг и щастлив живот."
  },
  {
    "reading_id": "travel_adventure",
    "reading_name": "Екстремно пътуване",
    "reading_cards": "Глупак + 8 Жезли + Колесница",
    "reading_combination": ["fool", "eight_wands", "chariot"],
    "reading_meaning": "Приключенско пътуване",
    "reading_description": "Предстои ти екстремно пътуване - планини, джунгла, пустиня. Приключение, което ще те промени.",
    "reading_advice": "Бъди подготвен, но и отворен за изненади. Истинските приключения идват непланирани."
  },
  {
    "reading_id": "travel_solo",
    "reading_name": "Самотно пътуване",
    "reading_cards": "Отшелник + 6 Мечове + 8 Жезли",
    "reading_combination": ["hermit", "six_swords", "eight_wands"],
    "reading_meaning": "Пътуване сам",
    "reading_description": "Пътуваш сам - доброволно или по необходимост. Време за себе си, опознаване, самота, която не е лоша.",
    "reading_advice": "Наслади се на компанията си. Сам си, но не самотен."
  },
  {
    "reading_id": "travel_group",
    "reading_name": "Групово пътуване",
    "reading_cards": "3 Чаши + 6 Мечове + 4 Жезли",
    "reading_combination": ["three_cups", "six_swords", "four_wands"],
    "reading_meaning": "Екскурзия с приятели",
    "reading_description": "Пътуване с група приятели или организирана група. Веселба, нови приятелства, споделени преживявания.",
    "reading_advice": "Наслаждавай се на компанията, но запази и време за себе си."
  },
  {
    "reading_id": "travel_family",
    "reading_name": "Семейна ваканция",
    "reading_cards": "10 Чаши + 4 Жезли + 6 Мечове",
    "reading_combination": ["ten_cups", "four_wands", "six_swords"],
    "reading_meaning": "Почивка със семейството",
    "reading_description": "Семейна ваканция - деца, родители, баби и дядовци заедно. Спомени за цял живот.",
    "reading_advice": "Остави очакванията за перфектна почивка и просто бъди заедно. Това е най-важното."
  },
  {
    "reading_id": "travel_romantic",
    "reading_name": "Романтично пътуване",
    "reading_cards": "2 Чаши + 6 Мечове + 4 Жезли",
    "reading_combination": ["two_cups", "six_swords", "four_wands"],
    "reading_meaning": "Почивка за двама",
    "reading_description": "Романтично пътуване с любимия човек. Само двамата, далеч от ежедневието, време за любов.",
    "reading_advice": "Наслаждавайте се един на друг. Тези моменти са безценни."
  },
  {
    "reading_id": "travel_business",
    "reading_name": "Бизнес пътуване",
    "reading_cards": "8 Жезли + 3 Пентакли + 6 Мечове",
    "reading_combination": ["eight_wands", "three_pentacles", "six_swords"],
    "reading_meaning": "Командировка",
    "reading_description": "Бизнес пътуване - срещи, конференции, преговори. Работа в движение.",
    "reading_advice": "Опитай да съчетаеш работа и удоволствие. Остани ден-два повече, ако можеш."
  },
  {
    "reading_id": "travel_backpack",
    "reading_name": "Раница на гръб",
    "reading_cards": "Глупак + 8 Жезли + 6 Мечове",
    "reading_combination": ["fool", "eight_wands", "six_swords"],
    "reading_meaning": "Пътуване с раница",
    "reading_description": "Пътуване с раница - хостели, влакове, автостоп. Свобода, приключения, срещи с непознати.",
    "reading_advice": "Бъди отворен за всичко. Най-хубавите спомени идват от непланираните моменти."
  },
  {
    "reading_id": "travel_lost",
    "reading_name": "Изгубен по пътя",
    "reading_cards": "Луна + 7 Мечове + 6 Мечове",
    "reading_combination": ["moon", "seven_swords", "six_swords"],
    "reading_meaning": "Заблуден пътник",
    "reading_description": "Изгубваш се по време на пътуване - физически или метафорично. Не знаеш накъде да продължиш.",
    "reading_advice": "Питай за упътване. Няма срам в това да не знаеш пътя."
  },
  {
    "reading_id": "travel_found",
    "reading_name": "Откритие",
    "reading_cards": "Звезда + 6 Мечове + Слънце",
    "reading_combination": ["star", "six_swords", "sun"],
    "reading_meaning": "Намиране на пътя",
    "reading_description": "Намираш посоката след период на объркване. Пътят се отваря, нещата се изясняват.",
    "reading_advice": "Следвай светлината. Тя те води правилно."
  },
  {
    "reading_id": "travel_return",
    "reading_name": "Завръщане у дома",
    "reading_cards": "6 Мечове + 4 Жезли + 10 Чаши",
    "reading_combination": ["six_swords", "four_wands", "ten_cups"],
    "reading_meaning": "Прибиране след път",
    "reading_description": "Завръщаш се у дома след дълго пътуване. Уют, сигурност, радост от срещата с близките.",
    "reading_advice": "Няма по-хубаво място от дома. Цени го."
  },
  {
    "reading_id": "study_abroad",
    "reading_name": "Следване в чужбина",
    "reading_cards": "6 Мечове + 8 Жезли + Свят",
    "reading_combination": ["six_swords", "eight_wands", "world"],
    "reading_meaning": "Заминаване да учиш",
    "reading_description": "Заминаваш да следваш в чужбина. Нова държава, нов език, нова култура. Страх и вълнение.",
    "reading_advice": "Отвори се за новото, но не забравяй корените си."
  },
  {
    "reading_id": "study_exam_anxiety",
    "reading_name": "Изпитна треска",
    "reading_cards": "9 Мечове + 8 Мечове + 4 Мечове",
    "reading_combination": ["nine_swords", "eight_swords", "four_swords"],
    "reading_meaning": "Страх от изпит",
    "reading_description": "Притесняваш се преди важен изпит. Безсъние, паника, страх от провал. Умът ти блокира.",
    "reading_advice": "Дишай. Знаеш повече, отколкото си мислиш. Спокойствието е ключът."
  },
  {
    "reading_id": "study_course",
    "reading_name": "Курс за квалификация",
    "reading_cards": "8 Пентакли + 3 Пентакли + 6 Жезли",
    "reading_combination": ["eight_pentacles", "three_pentacles", "six_wands"],
    "reading_meaning": "Допълнително обучение",
    "reading_description": "Записваш се на курс за допълнителна квалификация. Инвестиция в себе си и бъдещето си.",
    "reading_advice": "Учи с желание. Знанието е единственото нещо, което никой не може да ти отнеме."
  },
  {
    "reading_id": "study_workshop",
    "reading_name": "Уъркшоп",
    "reading_cards": "3 Чаши + 8 Пентакли + 6 Жезли",
    "reading_combination": ["three_cups", "eight_pentacles", "six_wands"],
    "reading_meaning": "Практическо обучение",
    "reading_description": "Участваш в уъркшоп или практически курс. Учене чрез правене, нови контакти, забавление.",
    "reading_advice": "Задавай въпроси и бъди активен. Така научаваш най-много."
  },
  {
    "reading_id": "study_online",
    "reading_name": "Онлайн обучение",
    "reading_cards": "8 Жезли + 8 Пентакли + Свят",
    "reading_combination": ["eight_wands", "eight_pentacles", "world"],
    "reading_meaning": "Дистанционно учене",
    "reading_description": "Започваш онлайн курс или дистанционно обучение. Учене от вкъщи, собствено темпо, гъвкавост.",
    "reading_advice": "Самодисциплината е ключова. Без нея онлайн обучението е трудно."
  },
  {
    "reading_id": "study_teacher",
    "reading_name": "Вдъхновяващ учител",
    "reading_cards": "Йерофант + Слънце + 8 Пентакли",
    "reading_combination": ["hierophant", "sun", "eight_pentacles"],
    "reading_meaning": "Учител, който променя всичко",
    "reading_description": "Срещаш учител, който променя представата ти за предмета. Той те вдъхновява и запалва искрата.",
    "reading_advice": "Бъди благодарен и учи с отворено сърце. Такива учители са рядкост."
  },
  {
    "reading_id": "study_failure",
    "reading_name": "Провал на изпит",
    "reading_cards": "5 Мечове + 5 Чаши + 10 Мечове",
    "reading_combination": ["five_swords", "five_cups", "ten_swords"],
    "reading_meaning": "Неуспех в ученето",
    "reading_description": "Проваляш се на изпит или не успяваш да завършиш курс. Разочарование, униние, съмнение в себе си.",
    "reading_advice": "Това не е край, а завой. Опитай отново или потърси друг път."
  },
  {
    "reading_id": "study_retake",
    "reading_name": "Поправителен изпит",
    "reading_cards": "8 Пентакли + 6 Жезли + 4 Мечове",
    "reading_combination": ["eight_pentacles", "six_wands", "four_swords"],
    "reading_meaning": "Втори шанс",
    "reading_description": "Получаваш втори шанс да се явиш на изпит или да поправиш оценката си. Този път си подготвен.",
    "reading_advice": "Учи от грешките си и сега ще успееш."
  },
  {
    "reading_id": "study_scholarship",
    "reading_name": "Стипендия",
    "reading_cards": "Асо Пентакли + 6 Жезли + 10 Пентакли",
    "reading_combination": ["ace_pentacles", "six_wands", "ten_pentacles"],
    "reading_meaning": "Получаване на стипендия",
    "reading_description": "Получаваш стипендия или финансова помощ за образование. Признание за труда ти и помощ за бъдещето.",
    "reading_advice": "Гордей се с постижението си. Ти го заслужаваш."
  },
  {
    "reading_id": "study_phd",
    "reading_name": "Докторантура",
    "reading_cards": "8 Пентакли + Отшелник + Свят",
    "reading_combination": ["eight_pentacles", "hermit", "world"],
    "reading_meaning": "Задълбочено изследване",
    "reading_description": "Започваш докторантура или задълбочено научно изследване. Години на учене, изолация, но и открития.",
    "reading_advice": "Бъди търпелив и упорит. Пътят е дълъг, но наградата е голяма."
  },
  {
    "reading_id": "art_block",
    "reading_name": "Творческа блокада",
    "reading_cards": "8 Мечове + 4 Мечове + 9 Мечове",
    "reading_combination": ["eight_swords", "four_swords", "nine_swords"],
    "reading_meaning": "Няма вдъхновение",
    "reading_description": "Изпитваш творческа блокада - няма идеи, вдъхновение, желание за творене. Празнота и фрустрация.",
    "reading_advice": "Не се насилвай. Почини, разходи се, смени средата. Вдъхновението идва, когато не го търсиш."
  },
  {
    "reading_id": "art_inspiration",
    "reading_name": "Внезапно вдъхновение",
    "reading_cards": "Асо Жезли + Слънце + Магьосник",
    "reading_combination": ["ace_wands", "sun", "magician"],
    "reading_meaning": "Идеята идва",
    "reading_description": "Внезапно те залива вълна от вдъхновение. Идеи, които искат да бъдат реализирани веднага.",
    "reading_advice": "Записвай, рисувай, твори веднага. Вдъхновението е нетрайно."
  },
  {
    "reading_id": "art_exhibition_success",
    "reading_name": "Успешна изложба",
    "reading_cards": "6 Жезли + 3 Чаши + Слънце",
    "reading_combination": ["six_wands", "three_cups", "sun"],
    "reading_meaning": "Творчеството е признато",
    "reading_description": "Твоята изложба, концерт или представяне е успешно. Признание, аплодисменти, продажби. Ти си забелязан.",
    "reading_advice": "Наслади се на успеха. Ти го заслужи."
  },
  {
    "reading_id": "art_gallery",
    "reading_name": "Посещение на галерия",
    "reading_cards": "3 Чаши + 6 Чаши + 9 Пентакли",
    "reading_combination": ["three_cups", "six_cups", "nine_pentacles"],
    "reading_meaning": "Ден за изкуство",
    "reading_description": "Прекарваш ден в галерия, музей или на културно събитие. Обогатяване, вдъхновение, нови гледни точки.",
    "reading_advice": "Позволи си този лукс. Изкуството храни душата."
  },
  {
    "reading_id": "art_music",
    "reading_name": "Музикално вдъхновение",
    "reading_cards": "3 Чаши + Асо Жезли + Луна",
    "reading_combination": ["three_cups", "ace_wands", "moon"],
    "reading_meaning": "Нова песен",
    "reading_description": "Създаваш нова музика или песен. Емоциите ти се изливат в ноти и текст. Творчество, което лекува.",
    "reading_advice": "Сподели музиката си. Тя докосва повече хора, отколкото си мислиш."
  },
  {
    "reading_id": "art_writing",
    "reading_name": "Писателско вдъхновение",
    "reading_cards": "Асо Мечове + 3 Чаши + 8 Пентакли",
    "reading_combination": ["ace_swords", "three_cups", "eight_pentacles"],
    "reading_meaning": "Нова книга",
    "reading_description": "Започваш да пишеш - книга, блог, стихове. Думите текат, идеите идват, вдъхновението е силно.",
    "reading_advice": "Пиши всеки ден. Дори да не е много, важното е постоянството."
  },
  {
    "reading_id": "art_photography",
    "reading_name": "Фотография",
    "reading_cards": "Слънце + 6 Мечове + 9 Пентакли",
    "reading_combination": ["sun", "six_swords", "nine_pentacles"],
    "reading_meaning": "Улавяне на момента",
    "reading_description": "Задълбочаваш се във фотографията. Улавяш светлина, емоции, моменти. Творчество през обектива.",
    "reading_advice": "Снимай това, което те вълнува. Най-добрите снимки идват от сърцето."
  },
  {
    "reading_id": "art_painting",
    "reading_name": "Рисуване",
    "reading_cards": "Императрица + 3 Чаши + Слънце",
    "reading_combination": ["empress", "three_cups", "sun"],
    "reading_meaning": "Нова картина",
    "reading_description": "Започваш нова картина или художествен проект. Цветове, форми, емоции на платно.",
    "reading_advice": "Не се страхувай да експериментираш. В изкуството няма грешки."
  },
  {
    "reading_id": "art_craft",
    "reading_name": "Ръчна изработка",
    "reading_cards": "8 Пентакли + 3 Пентакли + 9 Пентакли",
    "reading_combination": ["eight_pentacles", "three_pentacles", "nine_pentacles"],
    "reading_meaning": "Занаятчийство",
    "reading_description": "Занимаваш се с ръчна изработка - бижута, керамика, дърворезба. Творчество с ръце, което носи удовлетворение.",
    "reading_advice": "Твоите ръце създават красота. Цени този дар."
  },
  {
    "reading_id": "art_performance",
    "reading_name": "Сценично изкуство",
    "reading_cards": "6 Жезли + 3 Чаши + Магьосник",
    "reading_combination": ["six_wands", "three_cups", "magician"],
    "reading_meaning": "Представление",
    "reading_description": "Участваш в театрална постановка, танц или друго сценично изкуство. Превъплъщение, емоция, аплодисменти.",
    "reading_advice": "Отдай се на ролята. Сцената е магия."
  },
  {
    "reading_id": "nature_escape",
    "reading_name": "Бягство сред природа",
    "reading_cards": "4 Мечове + 6 Мечове + Слънце",
    "reading_combination": ["four_swords", "six_swords", "sun"],
    "reading_meaning": "Почивка на планина/море",
    "reading_description": "Бягство от града сред природата. Планина, море, гора - място, където душата си почива.",
    "reading_advice": "Прави го по-често. Природата лекува всичко."
  },
  {
    "reading_id": "nature_gardening",
    "reading_name": "Градинарство",
    "reading_cards": "Императрица + 8 Пентакли + 3 Пентакли",
    "reading_combination": ["empress", "eight_pentacles", "three_pentacles"],
    "reading_meaning": "Грижа за градина",
    "reading_description": "Занимаваш се с градинарство - засаждане, гледане, събиране на плодове. Връзка със земята и природата.",
    "reading_advice": "Грижи се за растенията, те ще се грижат за теб."
  },
  {
    "reading_id": "nature_harvest",
    "reading_name": "Реколта",
    "reading_cards": "7 Пентакли + 9 Пентакли + Слънце",
    "reading_combination": ["seven_pentacles", "nine_pentacles", "sun"],
    "reading_meaning": "Събиране на плодовете",
    "reading_description": "Събираш реколтата от градината си - плодове, зеленчуци, билки. Награда за труда ти.",
    "reading_advice": "Наслади се на плодовете на труда си. Те са най-вкусни, когато са отгледани със собствени ръце."
  },
  {
    "reading_id": "nature_animal",
    "reading_name": "Среща с диво животно",
    "reading_cards": "Сила + 6 Мечове + Луна",
    "reading_combination": ["strength", "six_swords", "moon"],
    "reading_meaning": "Вълшебна среща",
    "reading_description": "Срещаш диво животно по време на разходка - елен, лисица, птица. Магически момент, знак от природата.",
    "reading_advice": "Приеми го като знак. Животните носят послания, ако умееш да ги чуеш."
  },
  {
    "reading_id": "nature_storm",
    "reading_name": "Буря",
    "reading_cards": "Кула + 5 Мечове + 8 Жезли",
    "reading_combination": ["tower", "five_swords", "eight_wands"],
    "reading_meaning": "Природно бедствие",
    "reading_description": "Преживяваш буря или природно бедствие. Страх, разрушение, но и осъзнаване на силата на природата.",
    "reading_advice": "Природата е по-силна от всичко. Уважавай я."
  },
  {
    "reading_id": "finance_budget",
    "reading_name": "Бюджетиране",
    "reading_cards": "4 Пентакли + 2 Пентакли + 8 Пентакли",
    "reading_combination": ["four_pentacles", "two_pentacles", "eight_pentacles"],
    "reading_meaning": "Планиране на разходи",
    "reading_description": "Започваш да планираш бюджета си по-сериозно. Записваш разходи, планираш спестявания, мислиш за бъдещето.",
    "reading_advice": "Добрият бюджет не те ограничава, а ти дава свобода."
  },
  {
    "reading_id": "finance_save",
    "reading_name": "Спестяване",
    "reading_cards": "4 Пентакли + 9 Пентакли + 6 Пентакли",
    "reading_combination": ["four_pentacles", "nine_pentacles", "six_pentacles"],
    "reading_meaning": "Трупане на спестявания",
    "reading_description": "Успяваш да спестиш повече пари от обикновено. Дисциплина, отказ от излишни неща, мислене за бъдещето.",
    "reading_advice": "Продължавай в същия дух. Спестяванията носят спокойствие."
  },
  {
    "reading_id": "finance_invest",
    "reading_name": "Инвестиране",
    "reading_cards": "Асо Пентакли + 7 Пентакли + 10 Пентакли",
    "reading_combination": ["ace_pentacles", "seven_pentacles", "ten_pentacles"],
    "reading_meaning": "Пускане на пари в инвестиция",
    "reading_description": "Инвестираш пари в акции, имоти или друг актив. Пускаш парите да работят за теб.",
    "reading_advice": "Инвестирай в това, което разбираш. И не слагай всички яйца в една кошница."
  },
  {
    "reading_id": "finance_cryptocurrency",
    "reading_name": "Криптовалута",
    "reading_cards": "Колело на съдбата + Асо Пентакли + 7 Мечове",
    "reading_combination": ["wheel_of_fortune", "ace_pentacles", "seven_swords"],
    "reading_meaning": "Инвестиция в крипто",
    "reading_description": "Занимаваш се с криптовалути - покупка, търговия, инвестиция. Висок риск, висока печалба (или загуба).",
    "reading_advice": "Инвестирай само толкова, колкото си готов да загубиш. Пазарът е непредсказуем."
  },
  {
    "reading_id": "finance_stock",
    "reading_name": "Борсова търговия",
    "reading_cards": "8 Жезли + 7 Пентакли + 6 Жезли",
    "reading_combination": ["eight_wands", "seven_pentacles", "six_wands"],
    "reading_meaning": "Активна търговия",
    "reading_description": "Търгуваш активно на борсата - покупко-продажба на акции, следене на новини, анализ на графики.",
    "reading_advice": "Не се поддавай на емоции. Борсата наказва алчността и страха."
  },
  {
    "reading_id": "finance_loss",
    "reading_name": "Финансова загуба",
    "reading_cards": "5 Пентакли + 10 Мечове + 3 Мечове",
    "reading_combination": ["five_pentacles", "ten_swords", "three_swords"],
    "reading_meaning": "Губиш пари",
    "reading_description": "Претърпяваш финансова загуба - лоша инвестиция, измама, непредвидени разходи. Болка и притеснение.",
    "reading_advice": "Това е урок, маскиран като загуба. Анализирай какво се обърка и продължавай."
  },
  {
    "reading_id": "finance_debt_pay",
    "reading_name": "Погасяване на дълг",
    "reading_cards": "6 Пентакли + 4 Пентакли + 10 Пентакли",
    "reading_combination": ["six_pentacles", "four_pentacles", "ten_pentacles"],
    "reading_meaning": "Изплащане на заем",
    "reading_description": "Успяваш да погасиш дълг или заем. Облекчение, свобода, чувство на постижение.",
    "reading_advice": "Празнувай този момент. Ти освободи бъдещето си от тежест."
  },
  {
    "reading_id": "finance_credit",
    "reading_name": "Кредит",
    "reading_cards": "5 Пентакли + 4 Пентакли + 2 Пентакли",
    "reading_combination": ["five_pentacles", "four_pentacles", "two_pentacles"],
    "reading_meaning": "Теглене на заем",
    "reading_description": "Теглиш кредит или заем за голяма покупка. Поемаш задължение, което ще тежи месеци напред.",
    "reading_advice": "Прочети дребния шрифт и пресметни дали можеш да си го позволиш."
  },
  {
    "reading_id": "finance_tax_return",
    "reading_name": "Данъчно облекчение",
    "reading_cards": "6 Пентакли + Справедливост + 4 Пентакли",
    "reading_combination": ["six_pentacles", "justice", "four_pentacles"],
    "reading_meaning": "Възстановяване на данъци",
    "reading_description": "Получаваш възстановяване на данъци или данъчно облекчение. Неочаквани пари, които идват в точния момент.",
    "reading_advice": "Използвай ги разумно - за спестявания или погасяване на дългове."
  },
  {
    "reading_id": "finance_rich",
    "reading_name": "Богатство",
    "reading_cards": "10 Пентакли + 9 Пентакли + Слънце",
    "reading_combination": ["ten_pentacles", "nine_pentacles", "sun"],
    "reading_meaning": "Финансово изобилие",
    "reading_description": "Постигаш финансова сигурност и изобилие. Не си само осигурен, а можеш и да помагаш на другите.",
    "reading_advice": "Бъди щедър. Истинското богатство е в споделянето."
  },
  {
    "reading_id": "friend_meet",
    "reading_name": "Среща със стар приятел",
    "reading_cards": "6 Чаши + 3 Чаши + 2 Чаши",
    "reading_combination": ["six_cups", "three_cups", "two_cups"],
    "reading_meaning": "Възстановяване на приятелство",
    "reading_description": "Срещаш стар приятел, с когото отдавна не сте се виждали. Носталгия, спомени, сякаш времето не е минало.",
    "reading_advice": "Цени тези срещи. Истинските приятелства са за цял живот."
  },
  {
    "reading_id": "friend_betrayal",
    "reading_name": "Предателство от приятел",
    "reading_cards": "7 Мечове + 3 Мечове + 5 Чаши",
    "reading_combination": ["seven_swords", "three_swords", "five_cups"],
    "reading_meaning": "Приятел те предава",
    "reading_description": "Приятел те предава или разочарова. Клюка, лъжа, злоупотреба с доверие. Болката е дълбока.",
    "reading_advice": "Понякога хората идват в живота ни, за да ни научат на доверие... или на обратното."
  },
  {
    "reading_id": "friend_help",
    "reading_name": "Приятелска помощ",
    "reading_cards": "6 Пентакли + 3 Чаши + 10 Чаши",
    "reading_combination": ["six_pentacles", "three_cups", "ten_cups"],
    "reading_meaning": "Приятел протяга ръка",
    "reading_description": "В труден момент приятел ти протяга ръка. Без да се колебае, без да иска нищо в замяна.",
    "reading_advice": "Приеми помощта с благодарност. Някой ден ще имаш възможност да върнеш жеста."
  },
  {
    "reading_id": "friend_group",
    "reading_name": "Нова приятелска група",
    "reading_cards": "3 Чаши + 4 Жезли + 6 Чаши",
    "reading_combination": ["three_cups", "four_wands", "six_cups"],
    "reading_meaning": "Влизаш в нов кръг",
    "reading_description": "Влизаш в нова приятелска група или общност. Нови хора, нови интереси, нови преживявания.",
    "reading_advice": "Бъди отворен, но не бързай да се доверяваш напълно. Истинските приятелства се градят с време."
  },
  {
    "reading_id": "friend_drift",
    "reading_name": "Отдалечаване",
    "reading_cards": "8 Чаши + 5 Чаши + 6 Мечове",
    "reading_combination": ["eight_cups", "five_cups", "six_swords"],
    "reading_meaning": "Приятелството изстива",
    "reading_description": "Приятелството ви с някой се отдалечава. Вече нямате общи теми, срещате се все по-рядко, усещате празнота.",
    "reading_advice": "Пусни го с благодарност за времето, което сте споделили. Не всички приятелства са завинаги."
  },
  {
    "reading_id": "friend_argument",
    "reading_name": "Спор с приятел",
    "reading_cards": "5 Жезли + 3 Мечове + 5 Чаши",
    "reading_combination": ["five_wands", "three_swords", "five_cups"],
    "reading_meaning": "Скарване с близък",
    "reading_description": "Скарваш се с близък приятел. Дума по дума, натрупано напрежение, обидени чувства. И двамата сте наранени.",
    "reading_advice": "Оставете времето да успокои духовете. После говорете, не се обвинявайте."
  },
  {
    "reading_id": "friend_reconcile",
    "reading_name": "Помирение с приятел",
    "reading_cards": "2 Чаши + 6 Чаши + 10 Чаши",
    "reading_combination": ["two_cups", "six_cups", "ten_cups"],
    "reading_meaning": "След кавга идва прошка",
    "reading_description": "След дълго отчуждение идва помирението с приятел. Разговор, прегръдка, прошка и приятелството продължава.",
    "reading_advice": "Радвай се, че успяхте да преодолеете различията. Истинското приятелство издържа на всичко."
  },
  {
    "reading_id": "friend_jealousy",
    "reading_name": "Завист от приятел",
    "reading_cards": "7 Мечове + 5 Чаши + Дявол",
    "reading_combination": ["seven_swords", "five_cups", "devil"],
    "reading_meaning": "Приятел ти завижда",
    "reading_description": "Забелязваш, че приятел ти завижда за успехите, щастието или притежанията. Това променя динамиката ви.",
    "reading_advice": "Бъди внимателен. Завистта може да разруши дори най-старите приятелства."
  },
  {
    "reading_id": "friend_success",
    "reading_name": "Успех на приятел",
    "reading_cards": "6 Жезли + 3 Чаши + 10 Чаши",
    "reading_combination": ["six_wands", "three_cups", "ten_cups"],
    "reading_meaning": "Радваш се за приятел",
    "reading_description": "Приятел постига голям успех и ти искрено се радваш. Без завист, без конкуренция - чиста радост.",
    "reading_advice": "Това е знак за зряло приятелство. Цени го."
  },
  {
    "reading_id": "friend_death",
    "reading_name": "Загуба на приятел",
    "reading_cards": "3 Мечове + 5 Чаши + 10 Мечове",
    "reading_combination": ["three_swords", "five_cups", "ten_swords"],
    "reading_meaning": "Приятел си отива",
    "reading_description": "Губиш приятел - чрез смърт, прекъсване или преместване. Празнота, тъга, усещане за загуба.",
    "reading_advice": "Почети паметта му, като носиш наученото в сърцето си. Никой не си отива напълно."
  },
  {
    "reading_id": "spiritual_books",
    "reading_name": "Духовна литература",
    "reading_cards": "Отшелник + 8 Пентакли + Върховна жрица",
    "reading_combination": ["hermit", "eight_pentacles", "high_priestess"],
    "reading_meaning": "Четене на духовни книги",
    "reading_description": "Задълбочаваш се в духовна литература. Книги за източни учения, езотерика, философия. Търсене на истината.",
    "reading_advice": "Чети, но и прилагай. Истинската мъдрост е в преживяването."
  },
  {
    "reading_id": "spiritual_teacher_find",
    "reading_name": "Намиране на учител",
    "reading_cards": "Йерофант + Отшелник + Слънце",
    "reading_combination": ["hierophant", "hermit", "sun"],
    "reading_meaning": "Среща с гуру",
    "reading_description": "Намираш духовен учител, който резонира с теб. Човек, който не ти дава отговори, а те учи да ги търсиш сам.",
    "reading_advice": "Бъди отворен ученик. Истинският учител е този, който те учи да бъдеш свой собствен учител."
  },
  {
    "reading_id": "spiritual_retreat_abroad",
    "reading_name": "Ретрийт в чужбина",
    "reading_cards": "6 Мечове + Отшелник + Свят",
    "reading_combination": ["six_swords", "hermit", "world"],
    "reading_meaning": "Духовно пътуване",
    "reading_description": "Заминаваш на духовен ретрийт в чужбина - Индия, Перу, Тибет. Път към себе си през света.",
    "reading_advice": "Отвори се за преживяването. То ще те промени по начини, които не можеш да предвидиш."
  },
  {
    "reading_id": "spiritual_awakening_sudden",
    "reading_name": "Внезапно пробуждане",
    "reading_cards": "Кула + Слънце + Върховна жрица",
    "reading_combination": ["tower", "sun", "high_priestess"],
    "reading_meaning": "Просветление",
    "reading_description": "Преживяваш внезапно духовно пробуждане. Всичко придобива нов смисъл, виждаш нещата от по-висока перспектива.",
    "reading_advice": "Прегърни промяната. Ти вече не си същият човек."
  },
  {
    "reading_id": "spiritual_practice",
    "reading_name": "Духовна практика",
    "reading_cards": "8 Пентакли + 4 Мечове + Върховна жрица",
    "reading_combination": ["eight_pentacles", "four_swords", "high_priestess"],
    "reading_meaning": "Редовна медитация",
    "reading_description": "Започваш редовна духовна практика - медитация, йога, молитва. Всеки ден отделяш време за връзка с отвъдното.",
    "reading_advice": "Постоянството е ключът. Дори 10 минути на ден правят разлика."
  }


];
 
